/* eslint-disable @typescript-eslint/no-redeclare */
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Cursor: { input: string; output: string; }
  DateTime: { input: any; output: any; }
  Int64: { input: any; output: any; }
  Map: { input: any; output: any; }
  Time: { input: string; output: string; }
  UUID: { input: any; output: any; }
};

export type ApiKey = {
  ageInDays: Scalars['Int']['output'];
  apiKey: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  generatedBy: Scalars['ID']['output'];
  generator: User;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  maskedApiKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner: Organization;
  ownerId: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type ApiKeyConnection = {
  edges: Array<ApiKeyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApiKeyEdge = {
  cursor: Scalars['String']['output'];
  node: ApiKey;
};

export const ApiKeyEnvironment = {
  Live: 'LIVE',
  Test: 'TEST'
} as const;

export type ApiKeyEnvironment = typeof ApiKeyEnvironment[keyof typeof ApiKeyEnvironment];
export type ApiKeyOrderByInput = {
  direction: SortOrder;
  field: ApiKeyOrderField;
};

export const ApiKeyOrderField = {
  CreatedAt: 'CREATED_AT',
  IsActive: 'IS_ACTIVE',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ApiKeyOrderField = typeof ApiKeyOrderField[keyof typeof ApiKeyOrderField];
/**
 * APIKeyWhereInput is used for filtering APIKey objects.
 * Input was generated by ent.
 */
export type ApiKeyWhereInput = {
  and?: InputMaybe<Array<ApiKeyWhereInput>>;
  /** api_key field predicates */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKeyContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** generated_by_id field predicates */
  generatedByID?: InputMaybe<Scalars['ID']['input']>;
  generatedByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  generatedByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  generatedByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** api_logs edge predicates */
  hasAPILogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPILogsWith?: InputMaybe<Array<ApiLogWhereInput>>;
  /** generated_by edge predicates */
  hasGeneratedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeneratedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ApiKeyWhereInput>;
  or?: InputMaybe<Array<ApiKeyWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiLog = {
  apiKey: Maybe<ApiKey>;
  apiKeyID: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Time']['output'];
  errorCode: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  latencyMs: Scalars['Int64']['output'];
  method: Scalars['String']['output'];
  owner: Organization;
  ownerID: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  queryParams: Maybe<Scalars['String']['output']>;
  requestBody: Maybe<Scalars['String']['output']>;
  requestHeaders: Maybe<Scalars['Map']['output']>;
  requestID: Maybe<Scalars['String']['output']>;
  responseBody: Maybe<Scalars['String']['output']>;
  responseHeaders: Maybe<Scalars['Map']['output']>;
  statusCode: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
  userAgent: Maybe<Scalars['String']['output']>;
};

export type ApiLogConnection = {
  edges: Array<ApiLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApiLogEdge = {
  cursor: Scalars['Cursor']['output'];
  node: ApiLog;
};

export type ApiLogOrderByInput = {
  direction: SortOrder;
  field: ApiLogOrderField;
};

export const ApiLogOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ApiLogOrderField = typeof ApiLogOrderField[keyof typeof ApiLogOrderField];
/**
 * APILogWhereInput is used for filtering APILog objects.
 * Input was generated by ent.
 */
export type ApiLogWhereInput = {
  and?: InputMaybe<Array<ApiLogWhereInput>>;
  /** api_key_id field predicates */
  apiKeyID?: InputMaybe<Scalars['ID']['input']>;
  apiKeyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  apiKeyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  apiKeyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  apiKeyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** error_code field predicates */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorCodeContains?: InputMaybe<Scalars['String']['input']>;
  errorCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorCodeGT?: InputMaybe<Scalars['String']['input']>;
  errorCodeGTE?: InputMaybe<Scalars['String']['input']>;
  errorCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorCodeLT?: InputMaybe<Scalars['String']['input']>;
  errorCodeLTE?: InputMaybe<Scalars['String']['input']>;
  errorCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  errorCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** error_message field predicates */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorMessageContains?: InputMaybe<Scalars['String']['input']>;
  errorMessageContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorMessageEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorMessageGT?: InputMaybe<Scalars['String']['input']>;
  errorMessageGTE?: InputMaybe<Scalars['String']['input']>;
  errorMessageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorMessageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorMessageIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMessageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorMessageLT?: InputMaybe<Scalars['String']['input']>;
  errorMessageLTE?: InputMaybe<Scalars['String']['input']>;
  errorMessageNEQ?: InputMaybe<Scalars['String']['input']>;
  errorMessageNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMessageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_key edge predicates */
  hasAPIKey?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPIKeyWith?: InputMaybe<Array<ApiKeyWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ip_address field predicates */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddressContains?: InputMaybe<Scalars['String']['input']>;
  ipAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressGT?: InputMaybe<Scalars['String']['input']>;
  ipAddressGTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ipAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddressLT?: InputMaybe<Scalars['String']['input']>;
  ipAddressLTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  ipAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** latency_ms field predicates */
  latencyMs?: InputMaybe<Scalars['Int']['input']>;
  latencyMsGT?: InputMaybe<Scalars['Int']['input']>;
  latencyMsGTE?: InputMaybe<Scalars['Int']['input']>;
  latencyMsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  latencyMsLT?: InputMaybe<Scalars['Int']['input']>;
  latencyMsLTE?: InputMaybe<Scalars['Int']['input']>;
  latencyMsNEQ?: InputMaybe<Scalars['Int']['input']>;
  latencyMsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** method field predicates */
  method?: InputMaybe<Scalars['String']['input']>;
  methodContains?: InputMaybe<Scalars['String']['input']>;
  methodContainsFold?: InputMaybe<Scalars['String']['input']>;
  methodEqualFold?: InputMaybe<Scalars['String']['input']>;
  methodGT?: InputMaybe<Scalars['String']['input']>;
  methodGTE?: InputMaybe<Scalars['String']['input']>;
  methodHasPrefix?: InputMaybe<Scalars['String']['input']>;
  methodHasSuffix?: InputMaybe<Scalars['String']['input']>;
  methodIn?: InputMaybe<Array<Scalars['String']['input']>>;
  methodLT?: InputMaybe<Scalars['String']['input']>;
  methodLTE?: InputMaybe<Scalars['String']['input']>;
  methodNEQ?: InputMaybe<Scalars['String']['input']>;
  methodNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ApiLogWhereInput>;
  or?: InputMaybe<Array<ApiLogWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** path field predicates */
  path?: InputMaybe<Scalars['String']['input']>;
  pathContains?: InputMaybe<Scalars['String']['input']>;
  pathContainsFold?: InputMaybe<Scalars['String']['input']>;
  pathEqualFold?: InputMaybe<Scalars['String']['input']>;
  pathGT?: InputMaybe<Scalars['String']['input']>;
  pathGTE?: InputMaybe<Scalars['String']['input']>;
  pathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  pathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  pathIn?: InputMaybe<Array<Scalars['String']['input']>>;
  pathLT?: InputMaybe<Scalars['String']['input']>;
  pathLTE?: InputMaybe<Scalars['String']['input']>;
  pathNEQ?: InputMaybe<Scalars['String']['input']>;
  pathNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** query_params field predicates */
  queryParams?: InputMaybe<Scalars['String']['input']>;
  queryParamsContains?: InputMaybe<Scalars['String']['input']>;
  queryParamsContainsFold?: InputMaybe<Scalars['String']['input']>;
  queryParamsEqualFold?: InputMaybe<Scalars['String']['input']>;
  queryParamsGT?: InputMaybe<Scalars['String']['input']>;
  queryParamsGTE?: InputMaybe<Scalars['String']['input']>;
  queryParamsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  queryParamsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  queryParamsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  queryParamsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  queryParamsLT?: InputMaybe<Scalars['String']['input']>;
  queryParamsLTE?: InputMaybe<Scalars['String']['input']>;
  queryParamsNEQ?: InputMaybe<Scalars['String']['input']>;
  queryParamsNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  queryParamsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_body field predicates */
  requestBody?: InputMaybe<Scalars['String']['input']>;
  requestBodyContains?: InputMaybe<Scalars['String']['input']>;
  requestBodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestBodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestBodyGT?: InputMaybe<Scalars['String']['input']>;
  requestBodyGTE?: InputMaybe<Scalars['String']['input']>;
  requestBodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestBodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestBodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestBodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requestBodyLT?: InputMaybe<Scalars['String']['input']>;
  requestBodyLTE?: InputMaybe<Scalars['String']['input']>;
  requestBodyNEQ?: InputMaybe<Scalars['String']['input']>;
  requestBodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestBodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_id field predicates */
  requestID?: InputMaybe<Scalars['String']['input']>;
  requestIDContains?: InputMaybe<Scalars['String']['input']>;
  requestIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestIDGT?: InputMaybe<Scalars['String']['input']>;
  requestIDGTE?: InputMaybe<Scalars['String']['input']>;
  requestIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requestIDLT?: InputMaybe<Scalars['String']['input']>;
  requestIDLTE?: InputMaybe<Scalars['String']['input']>;
  requestIDNEQ?: InputMaybe<Scalars['String']['input']>;
  requestIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** response_body field predicates */
  responseBody?: InputMaybe<Scalars['String']['input']>;
  responseBodyContains?: InputMaybe<Scalars['String']['input']>;
  responseBodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  responseBodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseBodyGT?: InputMaybe<Scalars['String']['input']>;
  responseBodyGTE?: InputMaybe<Scalars['String']['input']>;
  responseBodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseBodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseBodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseBodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseBodyLT?: InputMaybe<Scalars['String']['input']>;
  responseBodyLTE?: InputMaybe<Scalars['String']['input']>;
  responseBodyNEQ?: InputMaybe<Scalars['String']['input']>;
  responseBodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseBodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status_code field predicates */
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  statusCodeGT?: InputMaybe<Scalars['Int']['input']>;
  statusCodeGTE?: InputMaybe<Scalars['Int']['input']>;
  statusCodeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  statusCodeLT?: InputMaybe<Scalars['Int']['input']>;
  statusCodeLTE?: InputMaybe<Scalars['Int']['input']>;
  statusCodeNEQ?: InputMaybe<Scalars['Int']['input']>;
  statusCodeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_agent field predicates */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userAgentContains?: InputMaybe<Scalars['String']['input']>;
  userAgentContainsFold?: InputMaybe<Scalars['String']['input']>;
  userAgentEqualFold?: InputMaybe<Scalars['String']['input']>;
  userAgentGT?: InputMaybe<Scalars['String']['input']>;
  userAgentGTE?: InputMaybe<Scalars['String']['input']>;
  userAgentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userAgentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userAgentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userAgentLT?: InputMaybe<Scalars['String']['input']>;
  userAgentLTE?: InputMaybe<Scalars['String']['input']>;
  userAgentNEQ?: InputMaybe<Scalars['String']['input']>;
  userAgentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiPayment = {
  accessKey: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  apiKey: Maybe<Scalars['String']['output']>;
  cancelUrl: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Scalars['String']['output'];
  fees: Maybe<Fees>;
  id: Scalars['ID']['output'];
  merchantProcessingFee: Scalars['Float']['output'];
  metadata: Scalars['Map']['output'];
  orderId: Scalars['String']['output'];
  owner: Organization;
  ownerId: Scalars['ID']['output'];
  paymentOptions: Array<PaymentType>;
  refundPolicyTerms: WebPaymentsRefundPolicyTerms;
  responseUrl: Scalars['String']['output'];
  status: ApiPaymentsStatus;
  updatedAt: Scalars['Time']['output'];
};

export type ApiPaymentConnection = {
  edges: Array<ApiPaymentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApiPaymentEdge = {
  cursor: Scalars['String']['output'];
  node: ApiPayment;
};

export type ApiPaymentOrderByInput = {
  direction: SortOrder;
  field: ApiPaymentOrderField;
};

export const ApiPaymentOrderField = {
  Amount: 'AMOUNT',
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ApiPaymentOrderField = typeof ApiPaymentOrderField[keyof typeof ApiPaymentOrderField];
export type ApiPaymentStatistics = {
  averagePaymentAmount: Scalars['Float']['output'];
  cancelledPayments: Scalars['Int']['output'];
  failedPayments: Scalars['Int']['output'];
  pendingPayments: Scalars['Int']['output'];
  successRate: Scalars['Float']['output'];
  successfulPayments: Scalars['Int']['output'];
  totalPayments: Scalars['Int']['output'];
  totalProcessingFees: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
};

/**
 * APIPaymentWhereInput is used for filtering APIPayment objects.
 * Input was generated by ent.
 */
export type ApiPaymentWhereInput = {
  /** access_key field predicates */
  accessKey?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  accessKeyLT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyLTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNEQ?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<ApiPaymentWhereInput>>;
  /** api_key field predicates */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKeyContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cancel_url field predicates */
  cancelURL?: InputMaybe<Scalars['String']['input']>;
  cancelURLContains?: InputMaybe<Scalars['String']['input']>;
  cancelURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  cancelURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  cancelURLGT?: InputMaybe<Scalars['String']['input']>;
  cancelURLGTE?: InputMaybe<Scalars['String']['input']>;
  cancelURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cancelURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cancelURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cancelURLLT?: InputMaybe<Scalars['String']['input']>;
  cancelURLLTE?: InputMaybe<Scalars['String']['input']>;
  cancelURLNEQ?: InputMaybe<Scalars['String']['input']>;
  cancelURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyContains?: InputMaybe<Scalars['String']['input']>;
  currencyContainsFold?: InputMaybe<Scalars['String']['input']>;
  currencyEqualFold?: InputMaybe<Scalars['String']['input']>;
  currencyGT?: InputMaybe<Scalars['String']['input']>;
  currencyGTE?: InputMaybe<Scalars['String']['input']>;
  currencyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  currencyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  currencyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyLT?: InputMaybe<Scalars['String']['input']>;
  currencyLTE?: InputMaybe<Scalars['String']['input']>;
  currencyNEQ?: InputMaybe<Scalars['String']['input']>;
  currencyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  not?: InputMaybe<ApiPaymentWhereInput>;
  or?: InputMaybe<Array<ApiPaymentWhereInput>>;
  /** order_id field predicates */
  orderID?: InputMaybe<Scalars['String']['input']>;
  orderIDContains?: InputMaybe<Scalars['String']['input']>;
  orderIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  orderIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  orderIDGT?: InputMaybe<Scalars['String']['input']>;
  orderIDGTE?: InputMaybe<Scalars['String']['input']>;
  orderIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  orderIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  orderIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  orderIDLT?: InputMaybe<Scalars['String']['input']>;
  orderIDLTE?: InputMaybe<Scalars['String']['input']>;
  orderIDNEQ?: InputMaybe<Scalars['String']['input']>;
  orderIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** paid_at field predicates */
  paidAt?: InputMaybe<Scalars['Time']['input']>;
  paidAtGT?: InputMaybe<Scalars['Time']['input']>;
  paidAtGTE?: InputMaybe<Scalars['Time']['input']>;
  paidAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  paidAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paidAtLT?: InputMaybe<Scalars['Time']['input']>;
  paidAtLTE?: InputMaybe<Scalars['Time']['input']>;
  paidAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  paidAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  paidAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_policy_terms field predicates */
  refundPolicyTerms?: InputMaybe<WebPaymentsRefundPolicyTerms>;
  refundPolicyTermsIn?: InputMaybe<Array<WebPaymentsRefundPolicyTerms>>;
  refundPolicyTermsNEQ?: InputMaybe<WebPaymentsRefundPolicyTerms>;
  refundPolicyTermsNotIn?: InputMaybe<Array<WebPaymentsRefundPolicyTerms>>;
  /** response_url field predicates */
  responseURL?: InputMaybe<Scalars['String']['input']>;
  responseURLContains?: InputMaybe<Scalars['String']['input']>;
  responseURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  responseURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseURLGT?: InputMaybe<Scalars['String']['input']>;
  responseURLGTE?: InputMaybe<Scalars['String']['input']>;
  responseURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseURLLT?: InputMaybe<Scalars['String']['input']>;
  responseURLLTE?: InputMaybe<Scalars['String']['input']>;
  responseURLNEQ?: InputMaybe<Scalars['String']['input']>;
  responseURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** status field predicates */
  status?: InputMaybe<ApiPaymentsStatus>;
  statusIn?: InputMaybe<Array<ApiPaymentsStatus>>;
  statusNEQ?: InputMaybe<ApiPaymentsStatus>;
  statusNotIn?: InputMaybe<Array<ApiPaymentsStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AcceptAllRequiredUserPoliciesPayload = {
  acceptances: Maybe<Array<UserPolicyAcceptance>>;
  errors: Maybe<Array<Error>>;
};

export type AcceptDisputeInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptDisputePayload = {
  dispute: Maybe<Dispute>;
  errors: Maybe<Array<Error>>;
};

export type AcceptInvitationInput = {
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AcceptInvitationPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type AcceptPolicyInput = {
  acceptanceContext: AcceptanceContext;
  bankId?: InputMaybe<Scalars['ID']['input']>;
  policyId: Scalars['ID']['input'];
};

export type AcceptPolicyPayload = {
  acceptance: Maybe<MerchantPolicyAcceptance>;
  errors: Maybe<Array<Error>>;
};

export type AcceptUserPolicyInput = {
  policyId: Scalars['ID']['input'];
};

export type AcceptUserPolicyPayload = {
  acceptance: Maybe<UserPolicyAcceptance>;
  errors: Maybe<Array<Error>>;
};

export const AcceptanceContext = {
  BankAccountAdded: 'BANK_ACCOUNT_ADDED',
  Onboarding: 'ONBOARDING',
  PolicyUpdate: 'POLICY_UPDATE'
} as const;

export type AcceptanceContext = typeof AcceptanceContext[keyof typeof AcceptanceContext];
export type ActivateApiKeyPayload = {
  apiKey: Maybe<ApiKey>;
  errors: Maybe<Array<Error>>;
};

export type ActivateQuickPayPayload = {
  errors: Maybe<Array<Error>>;
  quickPay: Maybe<QuickPay>;
};

export type AddCardTypeInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  paymentProviderId: Scalars['ID']['input'];
  priority: Scalars['Int']['input'];
  type: CardType;
};

export type AddCardTypeToProviderPayload = {
  cardType: PaymentProviderCardType;
  errors: Maybe<Array<Error>>;
};

export type AddLineItemInput = {
  description: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddLineItemPayload = {
  errors: Maybe<Array<Error>>;
  lineItem: Maybe<InvoiceLineItem>;
};

export type AddMerchantBankAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  bankId: Scalars['ID']['input'];
  setAsPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  type: BankAccountType;
};

export type AddMerchantBankAccountPayload = {
  errors: Maybe<Array<Error>>;
  merchantBankAccount: Maybe<MerchantBankAccount>;
  notificationSent: Scalars['Boolean']['output'];
};

export type AddPaymentTypeInput = {
  description?: InputMaybe<Scalars['Map']['input']>;
  enabled: Scalars['Boolean']['input'];
  gatewayFeeType: FeeType;
  gatewayFees: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  paymentProviderId: Scalars['ID']['input'];
  platformFeeType: FeeType;
  platformFees: Scalars['Float']['input'];
  supportedCurrencies: Array<Scalars['String']['input']>;
  type: PaymentType;
};

export type AddPaymentTypeToProviderPayload = {
  errors: Maybe<Array<Error>>;
  paymentType: PaymentProviderPaymentType;
};

export type AddPayoutsToTransferInput = {
  payoutIds: Array<Scalars['ID']['input']>;
  transferId: Scalars['ID']['input'];
};

export type AddPayoutsToTransferPayload = {
  addedPayouts: Maybe<Array<Payout>>;
  errors: Maybe<Array<Error>>;
  failedPayouts: Maybe<Array<PayoutOperationError>>;
  transfer: Maybe<Transfer>;
};

export type AddServiceAccountWebhookSubscriptionsInput = {
  eventTypeIds: Array<Scalars['ID']['input']>;
  webhookId: Scalars['ID']['input'];
};

export type AddServiceAccountWebhookSubscriptionsPayload = {
  errors: Maybe<Array<Error>>;
  subscriptions: Maybe<Array<ServiceAccountWebhookSubscription>>;
};

export type AddWebhookSubscriptionsInput = {
  eventTypeIds: Array<Scalars['ID']['input']>;
  webhookId: Scalars['ID']['input'];
};

export type AddWebhookSubscriptionsPayload = {
  errors: Maybe<Array<Error>>;
  subscriptions: Maybe<Array<MerchantWebhookSubscription>>;
};

export const AnalyticsPeriod = {
  Daily: 'DAILY',
  Monthly: 'MONTHLY',
  Quarterly: 'QUARTERLY',
  Weekly: 'WEEKLY',
  Yearly: 'YEARLY'
} as const;

export type AnalyticsPeriod = typeof AnalyticsPeriod[keyof typeof AnalyticsPeriod];
export type ApiPaymentSuccessResponseUrlPayload = {
  successResponseUrl: Scalars['String']['output'];
};

export const ApiPaymentsStatus = {
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
  Paid: 'PAID',
  PendingAction: 'PENDING_ACTION',
  Processing: 'PROCESSING',
  Unpaid: 'UNPAID'
} as const;

export type ApiPaymentsStatus = typeof ApiPaymentsStatus[keyof typeof ApiPaymentsStatus];
export type ApproveBankAccountPayload = {
  errors: Maybe<Array<Error>>;
  merchantBankAccount: Maybe<MerchantBankAccount>;
  statusChange: Maybe<BankAccountStatusChangeRecord>;
  verificationInitiated: Scalars['Boolean']['output'];
};

export type ApproveRefundInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
  overrideCancellationPolicy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApproveRefundPayload = {
  errors: Maybe<Array<Error>>;
  refund: Maybe<Refund>;
};

export type ArchiveQuickPayPayload = {
  errors: Maybe<Array<Error>>;
  quickPay: Maybe<QuickPay>;
};

export type AssignRoleInput = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type AssignRolePayload = {
  errors: Maybe<Array<Error>>;
  userRole: Maybe<UserRole>;
};

export type AuthContext = {
  serviceAccount: Maybe<ServiceAccount>;
  user: Maybe<User>;
};

export type AuthPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<AuthenticationError>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type AuthenticationError = {
  code: ErrorCode;
  field: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export const BankAccountStatus = {
  Approved: 'APPROVED',
  Closed: 'CLOSED',
  Pending: 'PENDING',
  Rejected: 'REJECTED',
  Suspended: 'SUSPENDED'
} as const;

export type BankAccountStatus = typeof BankAccountStatus[keyof typeof BankAccountStatus];
export type BankAccountStatusChangeRecord = {
  changedAt: Scalars['Time']['output'];
  changedBy: User;
  fromStatus: BankAccountStatus;
  id: Scalars['ID']['output'];
  reason: Maybe<Scalars['String']['output']>;
  toStatus: BankAccountStatus;
};

export const BankAccountType = {
  Btn: 'BTN',
  Fc: 'FC'
} as const;

export type BankAccountType = typeof BankAccountType[keyof typeof BankAccountType];
export type BankApproveRefundInput = {
  id: Scalars['ID']['input'];
};

export type BankApproveRefundPayload = {
  errors: Maybe<Array<Error>>;
  refund: Maybe<Refund>;
};

export type BankDenyRefundInput = {
  bankDeclineReason: Scalars['Map']['input'];
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export type BankDenyRefundPayload = {
  errors: Maybe<Array<Error>>;
  refund: Maybe<Refund>;
  success: Scalars['Boolean']['output'];
};

export type BatchProcessPayoutsInput = {
  batchNotes?: InputMaybe<Scalars['String']['input']>;
  payoutIds: Array<Scalars['ID']['input']>;
};

export type BatchProcessPayoutsPayload = {
  errors: Maybe<Array<Error>>;
  failedPayouts: Maybe<Array<PayoutBatchError>>;
  failureCount: Maybe<Scalars['Int']['output']>;
  successCount: Maybe<Scalars['Int']['output']>;
  successfulPayouts: Maybe<Array<Payout>>;
};

export type BillingAddress = {
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  customer: Customer;
  customerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  invoiceId: Maybe<Scalars['ID']['output']>;
  isDefault: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type BillingAddressConnection = {
  edges: Array<BillingAddressEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BillingAddressEdge = {
  cursor: Scalars['String']['output'];
  node: BillingAddress;
};

export type BillingAddressOrderByInput = {
  direction: SortOrder;
  field: BillingAddressOrderField;
};

export const BillingAddressOrderField = {
  City: 'CITY',
  Country: 'COUNTRY',
  CreatedAt: 'CREATED_AT',
  IsDefault: 'IS_DEFAULT',
  Label: 'LABEL',
  PostalCode: 'POSTAL_CODE',
  State: 'STATE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type BillingAddressOrderField = typeof BillingAddressOrderField[keyof typeof BillingAddressOrderField];
/**
 * BillingAddressWhereInput is used for filtering BillingAddress objects.
 * Input was generated by ent.
 */
export type BillingAddressWhereInput = {
  and?: InputMaybe<Array<BillingAddressWhereInput>>;
  /** city field predicates */
  city?: InputMaybe<Scalars['String']['input']>;
  cityContains?: InputMaybe<Scalars['String']['input']>;
  cityContainsFold?: InputMaybe<Scalars['String']['input']>;
  cityEqualFold?: InputMaybe<Scalars['String']['input']>;
  cityGT?: InputMaybe<Scalars['String']['input']>;
  cityGTE?: InputMaybe<Scalars['String']['input']>;
  cityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityLT?: InputMaybe<Scalars['String']['input']>;
  cityLTE?: InputMaybe<Scalars['String']['input']>;
  cityNEQ?: InputMaybe<Scalars['String']['input']>;
  cityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** country field predicates */
  country?: InputMaybe<Scalars['String']['input']>;
  countryContains?: InputMaybe<Scalars['String']['input']>;
  countryContainsFold?: InputMaybe<Scalars['String']['input']>;
  countryEqualFold?: InputMaybe<Scalars['String']['input']>;
  countryGT?: InputMaybe<Scalars['String']['input']>;
  countryGTE?: InputMaybe<Scalars['String']['input']>;
  countryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  countryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryLT?: InputMaybe<Scalars['String']['input']>;
  countryLTE?: InputMaybe<Scalars['String']['input']>;
  countryNEQ?: InputMaybe<Scalars['String']['input']>;
  countryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** customer_id field predicates */
  customerID?: InputMaybe<Scalars['ID']['input']>;
  customerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  customerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** customer edge predicates */
  hasCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomerWith?: InputMaybe<Array<CustomerWhereInput>>;
  /** invoice edge predicates */
  hasInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoiceWith?: InputMaybe<Array<InvoiceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** invoice_id field predicates */
  invoiceID?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_default field predicates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** line1 field predicates */
  line1?: InputMaybe<Scalars['String']['input']>;
  line1Contains?: InputMaybe<Scalars['String']['input']>;
  line1ContainsFold?: InputMaybe<Scalars['String']['input']>;
  line1EqualFold?: InputMaybe<Scalars['String']['input']>;
  line1GT?: InputMaybe<Scalars['String']['input']>;
  line1GTE?: InputMaybe<Scalars['String']['input']>;
  line1HasPrefix?: InputMaybe<Scalars['String']['input']>;
  line1HasSuffix?: InputMaybe<Scalars['String']['input']>;
  line1In?: InputMaybe<Array<Scalars['String']['input']>>;
  line1LT?: InputMaybe<Scalars['String']['input']>;
  line1LTE?: InputMaybe<Scalars['String']['input']>;
  line1NEQ?: InputMaybe<Scalars['String']['input']>;
  line1NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** line2 field predicates */
  line2?: InputMaybe<Scalars['String']['input']>;
  line2Contains?: InputMaybe<Scalars['String']['input']>;
  line2ContainsFold?: InputMaybe<Scalars['String']['input']>;
  line2EqualFold?: InputMaybe<Scalars['String']['input']>;
  line2GT?: InputMaybe<Scalars['String']['input']>;
  line2GTE?: InputMaybe<Scalars['String']['input']>;
  line2HasPrefix?: InputMaybe<Scalars['String']['input']>;
  line2HasSuffix?: InputMaybe<Scalars['String']['input']>;
  line2In?: InputMaybe<Array<Scalars['String']['input']>>;
  line2IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  line2LT?: InputMaybe<Scalars['String']['input']>;
  line2LTE?: InputMaybe<Scalars['String']['input']>;
  line2NEQ?: InputMaybe<Scalars['String']['input']>;
  line2NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  line2NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BillingAddressWhereInput>;
  or?: InputMaybe<Array<BillingAddressWhereInput>>;
  /** postal_code field predicates */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeContains?: InputMaybe<Scalars['String']['input']>;
  postalCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  postalCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  postalCodeGT?: InputMaybe<Scalars['String']['input']>;
  postalCodeGTE?: InputMaybe<Scalars['String']['input']>;
  postalCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  postalCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  postalCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  postalCodeLT?: InputMaybe<Scalars['String']['input']>;
  postalCodeLTE?: InputMaybe<Scalars['String']['input']>;
  postalCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  postalCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state field predicates */
  state?: InputMaybe<Scalars['String']['input']>;
  stateContains?: InputMaybe<Scalars['String']['input']>;
  stateContainsFold?: InputMaybe<Scalars['String']['input']>;
  stateEqualFold?: InputMaybe<Scalars['String']['input']>;
  stateGT?: InputMaybe<Scalars['String']['input']>;
  stateGTE?: InputMaybe<Scalars['String']['input']>;
  stateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  stateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  stateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateLT?: InputMaybe<Scalars['String']['input']>;
  stateLTE?: InputMaybe<Scalars['String']['input']>;
  stateNEQ?: InputMaybe<Scalars['String']['input']>;
  stateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelApiPaymentPayload = {
  cancelResponseUrl: Scalars['String']['output'];
};

export type CancelPayoutInput = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type CancelPayoutPayload = {
  errors: Maybe<Array<Error>>;
  payout: Maybe<Payout>;
};

export type CancelRecurringPaymentPayload = {
  errors: Maybe<Array<Error>>;
  recurringPayment: Maybe<RecurringPayment>;
};

export type CancelRecurringPaymentSetupInput = {
  checkoutSessionID: Scalars['String']['input'];
};

export type CancelRecurringPaymentSetupPayload = {
  cancelResponseUrl: Scalars['String']['output'];
};

export type CancelRefundInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
  reason: Scalars['Map']['input'];
};

export type CancelRefundPayload = {
  errors: Maybe<Array<Error>>;
  refund: Maybe<Refund>;
};

export const CardType = {
  Amex: 'AMEX',
  DinersClub: 'DINERS_CLUB',
  Discover: 'DISCOVER',
  Jcb: 'JCB',
  Maestro: 'MAESTRO',
  Mastercard: 'MASTERCARD',
  Other: 'OTHER',
  UnionPay: 'UNION_PAY',
  Visa: 'VISA'
} as const;

export type CardType = typeof CardType[keyof typeof CardType];
export type CardTypeFilter = {
  type?: InputMaybe<CardType>;
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ChangePasswordPayload = {
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type CloseBankAccountPayload = {
  errors: Maybe<Array<Error>>;
  merchantBankAccount: Maybe<MerchantBankAccount>;
  newPrimaryAccount: Maybe<MerchantBankAccount>;
  statusChange: Maybe<BankAccountStatusChangeRecord>;
};

export type CompletePayoutInput = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export type CompletePayoutPayload = {
  errors: Maybe<Array<Error>>;
  payouts: Maybe<Array<Maybe<Payout>>>;
};

export type CompleteTransferInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export type CompleteTransferPayload = {
  completedPayouts: Maybe<Array<Payout>>;
  errors: Maybe<Array<Error>>;
  transfer: Maybe<Transfer>;
};

export type ComplianceStatus = {
  acceptedPolicies: Array<MerchantPolicyAcceptance>;
  gracePeriodEnd: Maybe<Scalars['Time']['output']>;
  isCompliant: Scalars['Boolean']['output'];
  pendingPolicies: Array<PolicyDocument>;
};

export type CreateApiPaymentIntentInput = {
  apiPaymentAccessKey: Scalars['String']['input'];
  cardType?: InputMaybe<CardType>;
  /** Client channel originating the payment (defaults to WEB) */
  channel?: InputMaybe<PaymentChannel>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile user ref for saved-card checkout (service-account callers only) */
  customerRef?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey: Scalars['String']['input'];
  paymentType: PaymentType;
  /** Vault the collected card for reuse (service-account callers only) */
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateBillingAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBillingAddressPayload = {
  billingAddress: Maybe<BillingAddress>;
  errors: Maybe<Array<Error>>;
};

export type CreateDisputeInput = {
  disputeAmount: Scalars['Float']['input'];
  disputedAt: Scalars['Time']['input'];
  gatewayDisputeId?: InputMaybe<Scalars['String']['input']>;
  gatewayName?: InputMaybe<Scalars['String']['input']>;
  merchantResponseDueDate: Scalars['Time']['input'];
  paymentId: Scalars['ID']['input'];
  reason: DisputeReason;
};

export type CreateDisputePayload = {
  dispute: Maybe<Dispute>;
  errors: Maybe<Array<Error>>;
};

export type CreateInvoiceInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createBillingAddressInput?: InputMaybe<CreateBillingAddressInput>;
  customFields?: InputMaybe<Scalars['Map']['input']>;
  dueDate?: InputMaybe<Scalars['Time']['input']>;
  lineItems: Array<InvoiceLineItemInput>;
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  paymentOptions: Array<PaymentType>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  refundPolicyTerms: InvoiceRefundPolicyTerms;
};

export type CreateInvoicePayload = {
  errors: Maybe<Array<Error>>;
  invoice: Maybe<Invoice>;
};

export type CreateMediaInput = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<MediaEntityType>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateMerchantWebhookInput = {
  Name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type CreateMerchantWebhookPayload = {
  errors: Maybe<Array<Error>>;
  merchantWebhook: Maybe<MerchantWebhook>;
};

export type CreateMobileCardSetupIntentInput = {
  customerEmail: Scalars['String']['input'];
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile backend's user UUID — asserted by the service caller */
  customerRef: Scalars['ID']['input'];
  /** Redirect landing for the SDK; defaults to the platform return page */
  returnURL?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMobileCardSetupIntentPayload = {
  clientSecret: Scalars['String']['output'];
  errors: Maybe<Array<Error>>;
  providerCustomerId: Scalars['String']['output'];
  providerSlug: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
};

export type CreateOrganizationInput = {
  address: Scalars['Map']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['Map']['input']>;
  email: Scalars['String']['input'];
  industry?: InputMaybe<OrganizationIndustry>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  mccCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  otherIndustry?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  type: OrganizationType;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationPayload = {
  errors: Maybe<Array<Error>>;
  organization: Maybe<Organization>;
};

export type CreateOrganizationPaymentTypeInput = {
  enabled: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  paymentContext: OrganizationPaymentTypeContext;
  paymentProviderPaymentTypeId: Scalars['ID']['input'];
};

export type CreateOrganizationPaymentTypePayload = {
  errors: Maybe<Array<Error>>;
  organizationPaymentType: Maybe<OrganizationPaymentType>;
};

export type CreatePaymentIntentInput = {
  cardType?: InputMaybe<CardType>;
  /** Client channel originating the payment (defaults to WEB) */
  channel?: InputMaybe<PaymentChannel>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile user ref for saved-card checkout (service-account callers only) */
  customerRef?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey: Scalars['String']['input'];
  invoiceAccessKey: Scalars['String']['input'];
  paymentType: PaymentType;
  /** Vault the collected card for reuse (service-account callers only) */
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePaymentIntentPayload = {
  amount: Scalars['Float']['output'];
  clientSecret: Scalars['String']['output'];
  currency: Currency;
  errors: Maybe<Array<Error>>;
  feeBreakdown: Maybe<PaymentFeeBreakdown>;
  /** The merchant organization receiving this payment (set for QuickPay intents) */
  merchantId: Maybe<Scalars['ID']['output']>;
  /** The pre-created payment record's ID (set for QuickPay intents) — callers use it to link their own records */
  paymentId: Maybe<Scalars['ID']['output']>;
  paymentIntentId: Scalars['String']['output'];
  /** Slug of the provider that will process the payment (e.g. stripe, hyperswitch) - tells the client which SDK to load */
  providerSlug: Maybe<Scalars['String']['output']>;
  publishableKey: Scalars['String']['output'];
};

export type CreatePaymentMethodUpdateSessionInput = {
  /** Recurring payment ID */
  recurringPaymentId: Scalars['ID']['input'];
};

export type CreatePaymentMethodUpdateSessionPayload = {
  errors: Maybe<Array<Error>>;
  /** When the session expires */
  expiresAt: Scalars['Time']['output'];
  /** URL the customer should visit to update their payment method */
  updateURL: Scalars['String']['output'];
};

export type CreatePaymentProviderInput = {
  configProfile: Scalars['String']['input'];
  description?: InputMaybe<Scalars['Map']['input']>;
  environment: PaymentEnvironment;
  logoMediaId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
  status: ProviderStatus;
  /** Defaults to [WEB] when omitted */
  supportedChannels?: InputMaybe<Array<PaymentChannel>>;
  supportedCurrencies: Array<Scalars['String']['input']>;
};

export type CreatePaymentProviderPayload = {
  errors: Maybe<Array<Error>>;
  paymentProvider: PaymentProvider;
};

export type CreatePolicyDocumentInput = {
  content: Scalars['Map']['input'];
  effectiveDate: Scalars['Time']['input'];
  policyType: PolicyType;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type CreatePolicyDocumentPayload = {
  errors: Maybe<Array<Error>>;
  policy: Maybe<PolicyDocument>;
};

export type CreatePolicyDocumentVersionInput = {
  content: Scalars['Map']['input'];
  effectiveDate: Scalars['Time']['input'];
  policyId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};

export type CreatePolicyDocumentVersionPayload = {
  errors: Maybe<Array<Error>>;
  oldPolicy: Maybe<PolicyDocument>;
  policy: Maybe<PolicyDocument>;
};

export type CreatePolicyTemplateInput = {
  content: Scalars['Map']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  policyType: PolicyType;
};

export type CreatePolicyTemplatePayload = {
  errors: Maybe<Array<Error>>;
  template: Maybe<PolicyTemplate>;
};

export type CreateQuickPayInput = {
  amountType: QuickPayAmountType;
  currency: Currency;
  customFields?: InputMaybe<Scalars['Map']['input']>;
  description?: InputMaybe<Scalars['Map']['input']>;
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Optional sale basket for dynamic QRs, stored verbatim ([{description, unitPrice, quantity}]); client validates */
  lineItems?: InputMaybe<Array<Scalars['Map']['input']>>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentOptions?: InputMaybe<Array<PaymentType>>;
  presetAmounts?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundPolicyTerms?: InputMaybe<QuickPayRefundPolicyTerms>;
  title: Scalars['String']['input'];
};

export type CreateQuickPayPayload = {
  errors: Maybe<Array<Error>>;
  quickPay: Maybe<QuickPay>;
};

export type CreateQuickPayPaymentIntentInput = {
  amount: Scalars['Float']['input'];
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<CardType>;
  /** Client channel originating the payment (defaults to WEB) */
  channel?: InputMaybe<PaymentChannel>;
  customerEmail: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Mobile user ref for saved-card checkout (service-account callers only) */
  customerRef?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey: Scalars['String']['input'];
  /** Optional sale basket, stored verbatim (convention: [{description, unitPrice, quantity}]); client validates */
  lineItems?: InputMaybe<Array<Scalars['Map']['input']>>;
  paymentType: PaymentType;
  quickPayAccessKey: Scalars['String']['input'];
  /** Vault the collected card for reuse (service-account callers only) */
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateRecurringPaymentInput = {
  amount: Scalars['Int64']['input'];
  chargeImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  currency: Currency;
  customerEmail: Scalars['String']['input'];
  customerExternalID?: InputMaybe<Scalars['String']['input']>;
  customerMetadata?: InputMaybe<Scalars['Map']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['Time']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  interval: RecurringInterval;
  intervalCount: Scalars['Int']['input'];
  maxCharges?: InputMaybe<Scalars['Int']['input']>;
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  merchantProcessingFee: Scalars['Float']['input'];
  metadata?: InputMaybe<Scalars['Map']['input']>;
  paymentOptions?: InputMaybe<Array<PaymentType>>;
  refundPolicyTerms?: InputMaybe<RecurringPaymentRefundPolicyTerms>;
  startsAt?: InputMaybe<Scalars['Time']['input']>;
};

export type CreateRecurringPaymentPayload = {
  errors: Maybe<Array<Error>>;
  recurringPayment: Maybe<RecurringPayment>;
};

export type CreateRefundInput = {
  amount: Scalars['Float']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
  paymentId: Scalars['ID']['input'];
  pointOfContact?: InputMaybe<RefundPointOfContact>;
  reason: Scalars['Map']['input'];
  subReason?: InputMaybe<Scalars['Map']['input']>;
};

export type CreateRefundPayload = {
  errors: Maybe<Array<Error>>;
  refund: Maybe<Refund>;
};

export type CreateRoleInput = {
  description?: InputMaybe<Scalars['Map']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  permissionIds: Array<Scalars['ID']['input']>;
};

export type CreateRolePayload = {
  errors: Maybe<Array<Error>>;
  role: Maybe<Role>;
};

export type CreateServiceAccountWebhookInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serviceAccountId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export type CreateServiceAccountWebhookPayload = {
  errors: Maybe<Array<Error>>;
  /** The signing secret. Returned only here — store it now, it cannot be read again. */
  secret: Maybe<Scalars['String']['output']>;
  serviceAccountWebhook: Maybe<ServiceAccountWebhook>;
};

export type CreateSetupIntentInput = {
  checkoutSessionID: Scalars['String']['input'];
  paymentProviderId: Scalars['ID']['input'];
  paymentType: PaymentType;
  returnURL?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSetupIntentPayload = {
  clientSecret: Scalars['String']['output'];
  errors: Maybe<Array<Error>>;
  publishableKey: Maybe<Scalars['String']['output']>;
};

export type CreateTransferInput = {
  currency: Currency;
  notes?: InputMaybe<Scalars['Map']['input']>;
  payoutIds: Array<Scalars['ID']['input']>;
  transferredToBankId: Scalars['ID']['input'];
};

export type CreateTransferPayload = {
  errors: Maybe<Array<Error>>;
  transfer: Maybe<Transfer>;
};

export type CreateUpdateSetupIntentInput = {
  paymentProviderId: Scalars['ID']['input'];
  paymentType: PaymentType;
  /** The update session ID (from the URL) */
  updateSessionID: Scalars['String']['input'];
};

export const Currency = {
  Aud: 'AUD',
  Btn: 'BTN',
  Cad: 'CAD',
  Eur: 'EUR',
  Gbp: 'GBP',
  Inr: 'INR',
  Jpy: 'JPY',
  Sgd: 'SGD',
  Usd: 'USD'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];
export type Customer = {
  createdAt: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  externalID: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: Scalars['Map']['output'];
  name: Maybe<Scalars['String']['output']>;
  owner: Organization;
  paymentMethods: Array<PaymentMethod>;
  payments: Array<Payment>;
  phone: Maybe<Scalars['String']['output']>;
  recurringPayments: Array<RecurringPayment>;
  updatedAt: Scalars['Time']['output'];
};

export type CustomerConnection = {
  edges: Array<CustomerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomerEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Customer;
};

export type CustomerOrderBy = {
  direction: SortOrder;
  field: CustomerOrderField;
};

export const CustomerOrderField = {
  CreatedAt: 'CREATED_AT',
  Email: 'EMAIL',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CustomerOrderField = typeof CustomerOrderField[keyof typeof CustomerOrderField];
export type CustomerPaymentHistory = {
  averagePayment: Scalars['Float']['output'];
  customerEmail: Scalars['String']['output'];
  customerName: Maybe<Scalars['String']['output']>;
  failedPayments: Scalars['Int']['output'];
  firstPaymentDate: Maybe<Scalars['Time']['output']>;
  lastPaymentDate: Maybe<Scalars['Time']['output']>;
  payments: Maybe<PaymentConnection>;
  successfulPayments: Scalars['Int']['output'];
  totalPayments: Scalars['Int']['output'];
  totalSpent: Scalars['Float']['output'];
};

/**
 * CustomerWhereInput is used for filtering Customer objects.
 * Input was generated by ent.
 */
export type CustomerWhereInput = {
  and?: InputMaybe<Array<CustomerWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_addresses edge predicates */
  hasBillingAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  hasBillingAddressesWith?: InputMaybe<Array<BillingAddressWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** payment_methods edge predicates */
  hasPaymentMethods?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentMethodsWith?: InputMaybe<Array<PaymentMethodWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** recurring_payments edge predicates */
  hasRecurringPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecurringPaymentsWith?: InputMaybe<Array<RecurringPaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CustomerWhereInput>;
  or?: InputMaybe<Array<CustomerWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** phone field predicates */
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneContains?: InputMaybe<Scalars['String']['input']>;
  phoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  phoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  phoneGT?: InputMaybe<Scalars['String']['input']>;
  phoneGTE?: InputMaybe<Scalars['String']['input']>;
  phoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  phoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  phoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  phoneLT?: InputMaybe<Scalars['String']['input']>;
  phoneLTE?: InputMaybe<Scalars['String']['input']>;
  phoneNEQ?: InputMaybe<Scalars['String']['input']>;
  phoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateRange = {
  endDate: Maybe<Scalars['Time']['output']>;
  startDate: Maybe<Scalars['Time']['output']>;
};

export type DateRangeInput = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
};

export type DeactivateApiKeyPayload = {
  apiKey: Maybe<ApiKey>;
  errors: Maybe<Array<Error>>;
};

export type DefaultQuickPayPayload = {
  errors: Maybe<Array<Error>>;
  quickPay: Maybe<QuickPay>;
};

export type DeleteApiKeyPayload = {
  deletedKeyId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBankAccountPayload = {
  deletedAccountId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  newPrimaryAccount: Maybe<MerchantBankAccount>;
  success: Scalars['Boolean']['output'];
};

export type DeleteCardTypePayload = {
  deletedCardTypeId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteInvoicePayload = {
  deletedInvoiceId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLineItemPayload = {
  deletedLineItemId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOrganizationPayload = {
  deletedOrganizationId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteOrganizationPaymentTypePayload = {
  deletedOrganizationPaymentTypeId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type DeletePaymentProviderPayload = {
  deletedPaymentProviderId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type DeletePaymentTypePayload = {
  deletedPaymentTypeId: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeletePayoutPayload = {
  deletedPayoutId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type DeletePolicyDocumentPayload = {
  deletedPolicyId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePolicyTemplatePayload = {
  deletedTemplateId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRolePayload = {
  deletedRoleId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteTransferPayload = {
  deletedTransferId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteUserPayload = {
  deletedUserId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type DenyRefundInput = {
  id: Scalars['ID']['input'];
  merchantDeclineReason: Scalars['Map']['input'];
};

export type DenyRefundPayload = {
  errors: Maybe<Array<Error>>;
  refund: Maybe<Refund>;
};

export type DeprecatePolicyDocumentPayload = {
  errors: Maybe<Array<Error>>;
  policy: Maybe<PolicyDocument>;
};

export type Dispute = {
  additionalInformation: Maybe<Scalars['String']['output']>;
  cancellationDelayDate: Maybe<Scalars['Time']['output']>;
  cancellationDelayDescription: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  creditVoucherAmount: Maybe<Scalars['Float']['output']>;
  creditVoucherDescription: Maybe<Scalars['String']['output']>;
  creditVoucherGivenDate: Maybe<Scalars['Time']['output']>;
  currency: Scalars['String']['output'];
  customerAlreadyRefunded: Scalars['Boolean']['output'];
  disputeAmount: Scalars['Float']['output'];
  disputedAt: Scalars['Time']['output'];
  environment: PaymentEnvironment;
  evidenceDocumentUrl: Maybe<Array<DownloadUrl>>;
  evidenceReason: Maybe<DisputeEvidenceReason>;
  gatewayDisputeId: Maybe<Scalars['String']['output']>;
  gatewayName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  merchant: Organization;
  merchantResponseDueDate: Scalars['Time']['output'];
  otherReasonDescription: Maybe<Scalars['String']['output']>;
  payment: Payment;
  productOrServiceDetails: Maybe<Scalars['String']['output']>;
  productServiceType: Maybe<ProductServiceType>;
  progressStatus: DisputeProgressStatus;
  providerDocs: Maybe<Array<ProviderDoc>>;
  reason: DisputeReason;
  refund: Maybe<Refund>;
  refundAmount: Maybe<Scalars['Float']['output']>;
  refundDate: Maybe<Scalars['Time']['output']>;
  refundDescription: Maybe<Scalars['String']['output']>;
  resolutionDate: Maybe<Scalars['Time']['output']>;
  status: DisputeStatus;
  statusUpdatedAt: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  withdrawalDateByCustomer: Maybe<Scalars['Time']['output']>;
};

export type DisputeConnection = {
  edges: Array<DisputeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DisputeEdge = {
  cursor: Scalars['String']['output'];
  node: Dispute;
};

export const DisputeEvidenceReason = {
  BookingCancelledDelayedDueToGovtOrder: 'BOOKING_CANCELLED_DELAYED_DUE_TO_GOVT_ORDER',
  CancellationDelayed: 'CANCELLATION_DELAYED',
  CreditVoucherProvided: 'CREDIT_VOUCHER_PROVIDED',
  CustomerAlreadyRefunded: 'CUSTOMER_ALREADY_REFUNDED',
  CustomerReceivedCreditVoucherOutsidePg: 'CUSTOMER_RECEIVED_CREDIT_VOUCHER_OUTSIDE_PG',
  CustomerWithdrew: 'CUSTOMER_WITHDREW',
  Other: 'OTHER',
  ProductServiceDelivered: 'PRODUCT_SERVICE_DELIVERED',
  RequestMadeAfterDateOfTerms: 'REQUEST_MADE_AFTER_DATE_OF_TERMS',
  TransactionNonRefundable: 'TRANSACTION_NON_REFUNDABLE'
} as const;

export type DisputeEvidenceReason = typeof DisputeEvidenceReason[keyof typeof DisputeEvidenceReason];
export type DisputeOrderByInput = {
  direction: SortOrder;
  field: DisputeSortField;
};

export const DisputeProgressStatus = {
  AwaitingFinalDecision: 'AWAITING_FINAL_DECISION',
  EvidenceRequested: 'EVIDENCE_REQUESTED',
  EvidenceSubmitted: 'EVIDENCE_SUBMITTED',
  MerchantNotified: 'MERCHANT_NOTIFIED',
  Received: 'RECEIVED',
  Resolved: 'RESOLVED',
  UnderGatewayReview: 'UNDER_GATEWAY_REVIEW'
} as const;

export type DisputeProgressStatus = typeof DisputeProgressStatus[keyof typeof DisputeProgressStatus];
export const DisputeReason = {
  CreditNotProcessed: 'CREDIT_NOT_PROCESSED',
  Duplicate: 'DUPLICATE',
  Fraudulent: 'FRAUDULENT',
  General: 'GENERAL',
  IncorrectAmount: 'INCORRECT_AMOUNT',
  ProductNotReceived: 'PRODUCT_NOT_RECEIVED',
  ProductUnacceptable: 'PRODUCT_UNACCEPTABLE',
  SubscriptionCanceled: 'SUBSCRIPTION_CANCELED',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type DisputeReason = typeof DisputeReason[keyof typeof DisputeReason];
export const DisputeReportField = {
  AdditionalInformation: 'ADDITIONAL_INFORMATION',
  CancellationDelayDate: 'CANCELLATION_DELAY_DATE',
  CancellationDelayDescription: 'CANCELLATION_DELAY_DESCRIPTION',
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  CreditVoucherAmount: 'CREDIT_VOUCHER_AMOUNT',
  CreditVoucherDescription: 'CREDIT_VOUCHER_DESCRIPTION',
  CreditVoucherGivenDate: 'CREDIT_VOUCHER_GIVEN_DATE',
  Currency: 'CURRENCY',
  CustomerAlreadyRefunded: 'CUSTOMER_ALREADY_REFUNDED',
  DisputedAt: 'DISPUTED_AT',
  DisputeAmount: 'DISPUTE_AMOUNT',
  Environment: 'ENVIRONMENT',
  EvidenceReason: 'EVIDENCE_REASON',
  GatewayDisputeId: 'GATEWAY_DISPUTE_ID',
  GatewayName: 'GATEWAY_NAME',
  MerchantId: 'MERCHANT_ID',
  MerchantResponseDueDate: 'MERCHANT_RESPONSE_DUE_DATE',
  OtherReasonDescription: 'OTHER_REASON_DESCRIPTION',
  PaymentId: 'PAYMENT_ID',
  ProductOrServiceDetails: 'PRODUCT_OR_SERVICE_DETAILS',
  ProductServiceType: 'PRODUCT_SERVICE_TYPE',
  ProgressStatus: 'PROGRESS_STATUS',
  Reason: 'REASON',
  RefundAmount: 'REFUND_AMOUNT',
  RefundDate: 'REFUND_DATE',
  RefundDescription: 'REFUND_DESCRIPTION',
  RefundId: 'REFUND_ID',
  ResolutionDate: 'RESOLUTION_DATE',
  Status: 'STATUS',
  StatusUpdatedAt: 'STATUS_UPDATED_AT',
  WithdrawalDateByCustomer: 'WITHDRAWAL_DATE_BY_CUSTOMER'
} as const;

export type DisputeReportField = typeof DisputeReportField[keyof typeof DisputeReportField];
export const DisputeSortField = {
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  DisputedAt: 'DISPUTED_AT',
  DisputeAmount: 'DISPUTE_AMOUNT',
  MerchantResponseDueDate: 'MERCHANT_RESPONSE_DUE_DATE',
  ProgressStatus: 'PROGRESS_STATUS',
  ResolutionDate: 'RESOLUTION_DATE',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type DisputeSortField = typeof DisputeSortField[keyof typeof DisputeSortField];
export const DisputeStatus = {
  Accepted: 'ACCEPTED',
  Expired: 'EXPIRED',
  Lost: 'LOST',
  Open: 'OPEN',
  UnderReview: 'UNDER_REVIEW',
  Withdrawn: 'WITHDRAWN',
  Won: 'WON'
} as const;

export type DisputeStatus = typeof DisputeStatus[keyof typeof DisputeStatus];
/**
 * DisputeWhereInput is used for filtering Dispute objects.
 * Input was generated by ent.
 */
export type DisputeWhereInput = {
  /** additional_information field predicates */
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  additionalInformationContains?: InputMaybe<Scalars['String']['input']>;
  additionalInformationContainsFold?: InputMaybe<Scalars['String']['input']>;
  additionalInformationEqualFold?: InputMaybe<Scalars['String']['input']>;
  additionalInformationGT?: InputMaybe<Scalars['String']['input']>;
  additionalInformationGTE?: InputMaybe<Scalars['String']['input']>;
  additionalInformationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  additionalInformationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  additionalInformationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalInformationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  additionalInformationLT?: InputMaybe<Scalars['String']['input']>;
  additionalInformationLTE?: InputMaybe<Scalars['String']['input']>;
  additionalInformationNEQ?: InputMaybe<Scalars['String']['input']>;
  additionalInformationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalInformationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<DisputeWhereInput>>;
  /** cancellation_delay_date field predicates */
  cancellationDelayDate?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateGT?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateGTE?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  cancellationDelayDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationDelayDateLT?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateLTE?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  cancellationDelayDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cancellation_delay_description field predicates */
  cancellationDelayDescription?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cancellationDelayDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationDelayDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cancellationDelayDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** credit_voucher_amount field predicates */
  creditVoucherAmount?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountGT?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  creditVoucherAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  creditVoucherAmountLT?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  creditVoucherAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** credit_voucher_description field predicates */
  creditVoucherDescription?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  creditVoucherDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  creditVoucherDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  creditVoucherDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** credit_voucher_given_date field predicates */
  creditVoucherGivenDate?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateGT?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateGTE?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  creditVoucherGivenDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  creditVoucherGivenDateLT?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateLTE?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  creditVoucherGivenDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** currency field predicates */
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyContains?: InputMaybe<Scalars['String']['input']>;
  currencyContainsFold?: InputMaybe<Scalars['String']['input']>;
  currencyEqualFold?: InputMaybe<Scalars['String']['input']>;
  currencyGT?: InputMaybe<Scalars['String']['input']>;
  currencyGTE?: InputMaybe<Scalars['String']['input']>;
  currencyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  currencyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  currencyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyLT?: InputMaybe<Scalars['String']['input']>;
  currencyLTE?: InputMaybe<Scalars['String']['input']>;
  currencyNEQ?: InputMaybe<Scalars['String']['input']>;
  currencyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** customer_already_refunded field predicates */
  customerAlreadyRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  customerAlreadyRefundedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** dispute_amount field predicates */
  disputeAmount?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountGT?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  disputeAmountLT?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** disputed_at field predicates */
  disputedAt?: InputMaybe<Scalars['Time']['input']>;
  disputedAtGT?: InputMaybe<Scalars['Time']['input']>;
  disputedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  disputedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  disputedAtLT?: InputMaybe<Scalars['Time']['input']>;
  disputedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  disputedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  disputedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** environment field predicates */
  environment?: InputMaybe<EnvironmentType>;
  environmentIn?: InputMaybe<Array<EnvironmentType>>;
  environmentNEQ?: InputMaybe<EnvironmentType>;
  environmentNotIn?: InputMaybe<Array<EnvironmentType>>;
  /** evidence_reason field predicates */
  evidenceReason?: InputMaybe<DisputeEvidenceReason>;
  evidenceReasonIn?: InputMaybe<Array<DisputeEvidenceReason>>;
  evidenceReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  evidenceReasonNEQ?: InputMaybe<DisputeEvidenceReason>;
  evidenceReasonNotIn?: InputMaybe<Array<DisputeEvidenceReason>>;
  evidenceReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gateway_dispute_id field predicates */
  gatewayDisputeID?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDContains?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDGT?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDGTE?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayDisputeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayDisputeIDLT?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDLTE?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDNEQ?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayDisputeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gateway_name field predicates */
  gatewayName?: InputMaybe<Scalars['String']['input']>;
  gatewayNameContains?: InputMaybe<Scalars['String']['input']>;
  gatewayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  gatewayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  gatewayNameGT?: InputMaybe<Scalars['String']['input']>;
  gatewayNameGTE?: InputMaybe<Scalars['String']['input']>;
  gatewayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  gatewayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  gatewayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayNameLT?: InputMaybe<Scalars['String']['input']>;
  gatewayNameLTE?: InputMaybe<Scalars['String']['input']>;
  gatewayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  gatewayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant edge predicates */
  hasMerchant?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** payment edge predicates */
  hasPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<PayoutWhereInput>>;
  /** refund edge predicates */
  hasRefund?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefundWith?: InputMaybe<Array<RefundWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** merchant_id field predicates */
  merchantID?: InputMaybe<Scalars['ID']['input']>;
  merchantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  merchantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** merchant_response_due_date field predicates */
  merchantResponseDueDate?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateGT?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateGTE?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  merchantResponseDueDateLT?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateLTE?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  not?: InputMaybe<DisputeWhereInput>;
  or?: InputMaybe<Array<DisputeWhereInput>>;
  /** other_reason_description field predicates */
  otherReasonDescription?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  otherReasonDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  otherReasonDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  otherReasonDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** payment_id field predicates */
  paymentID?: InputMaybe<Scalars['ID']['input']>;
  paymentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** product_or_service_details field predicates */
  productOrServiceDetails?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsContains?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsContainsFold?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsEqualFold?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsGT?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsGTE?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  productOrServiceDetailsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  productOrServiceDetailsLT?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsLTE?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsNEQ?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  productOrServiceDetailsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** product_service_type field predicates */
  productServiceType?: InputMaybe<ProductServiceType>;
  productServiceTypeIn?: InputMaybe<Array<ProductServiceType>>;
  productServiceTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  productServiceTypeNEQ?: InputMaybe<ProductServiceType>;
  productServiceTypeNotIn?: InputMaybe<Array<ProductServiceType>>;
  productServiceTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** progress_status field predicates */
  progressStatus?: InputMaybe<DisputeProgressStatus>;
  progressStatusIn?: InputMaybe<Array<DisputeProgressStatus>>;
  progressStatusNEQ?: InputMaybe<DisputeProgressStatus>;
  progressStatusNotIn?: InputMaybe<Array<DisputeProgressStatus>>;
  /** reason field predicates */
  reason?: InputMaybe<DisputeReason>;
  reasonIn?: InputMaybe<Array<DisputeReason>>;
  reasonNEQ?: InputMaybe<DisputeReason>;
  reasonNotIn?: InputMaybe<Array<DisputeReason>>;
  /** refund_amount field predicates */
  refundAmount?: InputMaybe<Scalars['Float']['input']>;
  refundAmountGT?: InputMaybe<Scalars['Float']['input']>;
  refundAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  refundAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundAmountLT?: InputMaybe<Scalars['Float']['input']>;
  refundAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  refundAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  refundAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_date field predicates */
  refundDate?: InputMaybe<Scalars['Time']['input']>;
  refundDateGT?: InputMaybe<Scalars['Time']['input']>;
  refundDateGTE?: InputMaybe<Scalars['Time']['input']>;
  refundDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  refundDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundDateLT?: InputMaybe<Scalars['Time']['input']>;
  refundDateLTE?: InputMaybe<Scalars['Time']['input']>;
  refundDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  refundDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  refundDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_description field predicates */
  refundDescription?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  refundDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  refundDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_id field predicates */
  refundID?: InputMaybe<Scalars['ID']['input']>;
  refundIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  refundIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  refundIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  refundIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** resolution_date field predicates */
  resolutionDate?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateGT?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateGTE?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  resolutionDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  resolutionDateLT?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateLTE?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  resolutionDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<DisputeStatus>;
  statusIn?: InputMaybe<Array<DisputeStatus>>;
  statusNEQ?: InputMaybe<DisputeStatus>;
  statusNotIn?: InputMaybe<Array<DisputeStatus>>;
  /** status_updated_at field predicates */
  statusUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusUpdatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** withdrawal_date_by_customer field predicates */
  withdrawalDateByCustomer?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerGT?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerGTE?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  withdrawalDateByCustomerIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  withdrawalDateByCustomerLT?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerLTE?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerNEQ?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  withdrawalDateByCustomerNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DownloadDailyReportPayload = {
  errors: Maybe<Array<Error>>;
  failureBase64: Maybe<Scalars['String']['output']>;
  failureFileName: Maybe<Scalars['String']['output']>;
  successBase64: Maybe<Scalars['String']['output']>;
  successFileName: Maybe<Scalars['String']['output']>;
};

export type DownloadDisputeReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadMerchantReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Maybe<Error>>>;
};

export type DownloadPaidApiPaymentReceipt = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadPaidInvoiceReceipt = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadPaymentReceiptPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadPaymentReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadPayoutReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadRefundReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadTransferReceipt = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadTransferReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadUnpaidApiPaymentReceipt = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadUnpaidInvoiceReceipt = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type DownloadUrl = {
  expiresIn: Scalars['Int64']['output'];
  url: Scalars['String']['output'];
};

export const EnvironmentType = {
  Live: 'LIVE',
  Test: 'TEST'
} as const;

export type EnvironmentType = typeof EnvironmentType[keyof typeof EnvironmentType];
export type Error = {
  code: ErrorCode;
  field: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export const ErrorCode = {
  AlreadyExists: 'ALREADY_EXISTS',
  InternalServerError: 'INTERNAL_SERVER_ERROR',
  InvalidCredentials: 'INVALID_CREDENTIALS',
  InvalidInput: 'INVALID_INPUT',
  JwtTokenExpired: 'JWT_TOKEN_EXPIRED',
  NotFound: 'NOT_FOUND',
  PermissionDenied: 'PERMISSION_DENIED',
  Unauthorized: 'UNAUTHORIZED'
} as const;

export type ErrorCode = typeof ErrorCode[keyof typeof ErrorCode];
export type Event = {
  createdAt: Scalars['Time']['output'];
  entityId: Scalars['ID']['output'];
  entityType: Scalars['String']['output'];
  eventAction: EventAction;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['Map']['output']>;
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  user: Maybe<User>;
  userAgent: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['ID']['output']>;
};

export const EventAction = {
  Created: 'CREATED',
  Deleted: 'DELETED',
  StatusChanged: 'STATUS_CHANGED',
  Updated: 'UPDATED'
} as const;

export type EventAction = typeof EventAction[keyof typeof EventAction];
export type EventConnection = {
  edges: Array<EventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventEdge = {
  cursor: Scalars['String']['output'];
  node: Event;
};

export type EventOrderByInput = {
  direction: SortOrder;
  field: EventOrderField;
};

export const EventOrderField = {
  CreatedAt: 'CREATED_AT',
  EntityType: 'ENTITY_TYPE',
  EventAction: 'EVENT_ACTION',
  EventType: 'EVENT_TYPE'
} as const;

export type EventOrderField = typeof EventOrderField[keyof typeof EventOrderField];
/**
 * EventWhereInput is used for filtering Event objects.
 * Input was generated by ent.
 */
export type EventWhereInput = {
  and?: InputMaybe<Array<EventWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** entity_id field predicates */
  entityID?: InputMaybe<Scalars['UUID']['input']>;
  entityIDGT?: InputMaybe<Scalars['UUID']['input']>;
  entityIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  entityIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  entityIDLT?: InputMaybe<Scalars['UUID']['input']>;
  entityIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  entityIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  entityIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** entity_type field predicates */
  entityType?: InputMaybe<Scalars['String']['input']>;
  entityTypeContains?: InputMaybe<Scalars['String']['input']>;
  entityTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  entityTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  entityTypeGT?: InputMaybe<Scalars['String']['input']>;
  entityTypeGTE?: InputMaybe<Scalars['String']['input']>;
  entityTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  entityTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  entityTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  entityTypeLT?: InputMaybe<Scalars['String']['input']>;
  entityTypeLTE?: InputMaybe<Scalars['String']['input']>;
  entityTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  entityTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** event_action field predicates */
  eventAction?: InputMaybe<EventAction>;
  eventActionIn?: InputMaybe<Array<EventAction>>;
  eventActionNEQ?: InputMaybe<EventAction>;
  eventActionNotIn?: InputMaybe<Array<EventAction>>;
  /** event_type field predicates */
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventTypeContains?: InputMaybe<Scalars['String']['input']>;
  eventTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeGT?: InputMaybe<Scalars['String']['input']>;
  eventTypeGTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventTypeLT?: InputMaybe<Scalars['String']['input']>;
  eventTypeLTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  eventTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ip_address field predicates */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddressContains?: InputMaybe<Scalars['String']['input']>;
  ipAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressGT?: InputMaybe<Scalars['String']['input']>;
  ipAddressGTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ipAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddressLT?: InputMaybe<Scalars['String']['input']>;
  ipAddressLTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  ipAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<EventWhereInput>;
  or?: InputMaybe<Array<EventWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_agent field predicates */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userAgentContains?: InputMaybe<Scalars['String']['input']>;
  userAgentContainsFold?: InputMaybe<Scalars['String']['input']>;
  userAgentEqualFold?: InputMaybe<Scalars['String']['input']>;
  userAgentGT?: InputMaybe<Scalars['String']['input']>;
  userAgentGTE?: InputMaybe<Scalars['String']['input']>;
  userAgentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userAgentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userAgentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userAgentLT?: InputMaybe<Scalars['String']['input']>;
  userAgentLTE?: InputMaybe<Scalars['String']['input']>;
  userAgentNEQ?: InputMaybe<Scalars['String']['input']>;
  userAgentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpireDisputeInput = {
  id: Scalars['ID']['input'];
};

export type ExpireDisputePayload = {
  dispute: Maybe<Dispute>;
  errors: Maybe<Array<Error>>;
};

export const FeeType = {
  Flat: 'FLAT',
  Percentage: 'PERCENTAGE'
} as const;

export type FeeType = typeof FeeType[keyof typeof FeeType];
export type Fees = {
  customerProcessingFee: Maybe<Scalars['Float']['output']>;
  merchantProcessingFee: Maybe<Scalars['Float']['output']>;
  paymentType: Maybe<PaymentType>;
  processingFees: Maybe<Scalars['Float']['output']>;
};

export type FlagPaymentInput = {
  flagReason: Scalars['Map']['input'];
  paymentId: Scalars['ID']['input'];
};

export type FlagPaymentPayload = {
  errors: Maybe<Array<Error>>;
  payment: Maybe<Payment>;
};

export type GenerateApiKeyInput = {
  name: Scalars['String']['input'];
};

export type GenerateApiKeyPayload = {
  apiKey: Maybe<ApiKey>;
  errors: Maybe<Array<Error>>;
  secretKey: Maybe<Scalars['String']['output']>;
};

export type GenerateInvoicePdfPayload = {
  errors: Maybe<Array<Error>>;
  media: Maybe<Media>;
};

export type GenerateTransferPdfPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
};

export type GenerateUploadUrlInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int64']['input'];
};

export type GrantPermissionInput = {
  permissionId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type GrantPermissionPayload = {
  errors: Maybe<Array<Error>>;
  permissionRole: Maybe<PermissionRole>;
};

export type GrantPermissionsInput = {
  permissionIds: Array<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
};

export type GrantPermissionsPayload = {
  errors: Maybe<Array<Error>>;
  permissionRoles: Maybe<Array<PermissionRole>>;
};

export type ImgixOptions = {
  auto?: InputMaybe<Scalars['String']['input']>;
  fit?: InputMaybe<Scalars['String']['input']>;
  h?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['Int']['input']>;
  w?: InputMaybe<Scalars['Int']['input']>;
};

export type InitQuickPaymentInput = {
  accessKey: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<CardType>;
  customerEmail: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  paymentType: PaymentType;
};

export type InitQuickPaymentPayload = {
  amount: Scalars['Float']['output'];
  clientSecret: Scalars['String']['output'];
  currency: Currency;
  errors: Maybe<Array<Error>>;
  feeBreakdown: Maybe<PaymentFeeBreakdown>;
  paymentIntentId: Scalars['String']['output'];
  publishableKey: Maybe<Scalars['String']['output']>;
};

export type IntrospectTokenInput = {
  token: Scalars['String']['input'];
};

export type IntrospectTokenPayload = {
  active: Scalars['Boolean']['output'];
  expiresAt: Maybe<Scalars['Time']['output']>;
  orgId: Maybe<Scalars['ID']['output']>;
  orgType: Maybe<OrganizationType>;
  userId: Maybe<Scalars['ID']['output']>;
};

export type InviteBankUserInput = {
  bankId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Roles must belong to the target bank organization */
  roleIds: Array<Scalars['ID']['input']>;
};

export type InviteUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  roledIds: Array<Scalars['ID']['input']>;
};

export type InviteUserPayload = {
  errors: Maybe<Array<Error>>;
  invitationSent: Scalars['Boolean']['output'];
  user: Maybe<User>;
};

export type Invoice = {
  accessKey: Scalars['String']['output'];
  billingAddresses: Maybe<Array<Maybe<BillingAddress>>>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Maybe<User>;
  createdById: Scalars['ID']['output'];
  customFields: Scalars['Map']['output'];
  dueDate: Maybe<Scalars['Time']['output']>;
  fees: Maybe<Fees>;
  guestAccessUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<InvoiceLineItem>;
  merchantProcessingFee: Scalars['Float']['output'];
  owner: Organization;
  ownerId: Scalars['ID']['output'];
  paymentOptions: Array<PaymentType>;
  payoutAmount: Scalars['Float']['output'];
  previousStatus: InvoiceStatus;
  receipt: Maybe<DownloadUrl>;
  recipientEmail: Maybe<Scalars['String']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  refundPolicyTerms: InvoiceRefundPolicyTerms;
  status: InvoiceStatus;
  subtotal: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type InvoiceConnection = {
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceEdge = {
  cursor: Scalars['String']['output'];
  node: Invoice;
};

export type InvoiceLineItem = {
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceId: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  subtotal: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type InvoiceLineItemInput = {
  description: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * InvoiceLineItemWhereInput is used for filtering InvoiceLineItem objects.
 * Input was generated by ent.
 */
export type InvoiceLineItemWhereInput = {
  and?: InputMaybe<Array<InvoiceLineItemWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** invoice edge predicates */
  hasInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoiceWith?: InputMaybe<Array<InvoiceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** invoice_id field predicates */
  invoiceID?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<InvoiceLineItemWhereInput>;
  or?: InputMaybe<Array<InvoiceLineItemWhereInput>>;
  /** price field predicates */
  price?: InputMaybe<Scalars['Float']['input']>;
  priceGT?: InputMaybe<Scalars['Float']['input']>;
  priceGTE?: InputMaybe<Scalars['Float']['input']>;
  priceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  priceLT?: InputMaybe<Scalars['Float']['input']>;
  priceLTE?: InputMaybe<Scalars['Float']['input']>;
  priceNEQ?: InputMaybe<Scalars['Float']['input']>;
  priceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** quantity field predicates */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityGT?: InputMaybe<Scalars['Int']['input']>;
  quantityGTE?: InputMaybe<Scalars['Int']['input']>;
  quantityIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  quantityLT?: InputMaybe<Scalars['Int']['input']>;
  quantityLTE?: InputMaybe<Scalars['Int']['input']>;
  quantityNEQ?: InputMaybe<Scalars['Int']['input']>;
  quantityNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** sort field predicates */
  sort?: InputMaybe<Scalars['Int']['input']>;
  sortGT?: InputMaybe<Scalars['Int']['input']>;
  sortGTE?: InputMaybe<Scalars['Int']['input']>;
  sortIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortLT?: InputMaybe<Scalars['Int']['input']>;
  sortLTE?: InputMaybe<Scalars['Int']['input']>;
  sortNEQ?: InputMaybe<Scalars['Int']['input']>;
  sortNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceOrderByField = {
  direction: SortOrder;
  field: InvoiceOrderField;
};

export type InvoiceOrderByInput = {
  orderBy: Array<InvoiceOrderByField>;
};

export const InvoiceOrderField = {
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  DueDate: 'DUE_DATE',
  Status: 'STATUS',
  TotalAmount: 'TOTAL_AMOUNT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type InvoiceOrderField = typeof InvoiceOrderField[keyof typeof InvoiceOrderField];
export const InvoiceRefundPolicyTerms = {
  FullRefund: 'FULL_REFUND',
  ProcessingFeeNotRefunded: 'PROCESSING_FEE_NOT_REFUNDED'
} as const;

export type InvoiceRefundPolicyTerms = typeof InvoiceRefundPolicyTerms[keyof typeof InvoiceRefundPolicyTerms];
export const InvoiceStatus = {
  Paid: 'PAID',
  PendingAction: 'PENDING_ACTION',
  Processing: 'PROCESSING',
  Unpaid: 'UNPAID',
  Void: 'VOID'
} as const;

export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];
export type InvoiceSummary = {
  overdueCount: Scalars['Int']['output'];
  paidCount: Scalars['Int']['output'];
  totalInvoices: Scalars['Int']['output'];
  totalPaidAmount: Scalars['Float']['output'];
  totalUnpaidAmount: Scalars['Float']['output'];
  unpaidCount: Scalars['Int']['output'];
  voidCount: Scalars['Int']['output'];
};

/**
 * InvoiceWhereInput is used for filtering Invoice objects.
 * Input was generated by ent.
 */
export type InvoiceWhereInput = {
  /** access_key field predicates */
  accessKey?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  accessKeyLT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyLTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNEQ?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  and?: InputMaybe<Array<InvoiceWhereInput>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_id field predicates */
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  createdByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** currency field predicates */
  currency?: InputMaybe<Currency>;
  currencyIn?: InputMaybe<Array<Currency>>;
  currencyNEQ?: InputMaybe<Currency>;
  currencyNotIn?: InputMaybe<Array<Currency>>;
  /** due_date field predicates */
  dueDate?: InputMaybe<Scalars['Time']['input']>;
  dueDateGT?: InputMaybe<Scalars['Time']['input']>;
  dueDateGTE?: InputMaybe<Scalars['Time']['input']>;
  dueDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dueDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dueDateLT?: InputMaybe<Scalars['Time']['input']>;
  dueDateLTE?: InputMaybe<Scalars['Time']['input']>;
  dueDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  dueDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dueDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** billing_addresses edge predicates */
  hasBillingAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  hasBillingAddressesWith?: InputMaybe<Array<BillingAddressWhereInput>>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** items edge predicates */
  hasItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasItemsWith?: InputMaybe<Array<InvoiceLineItemWhereInput>>;
  /** manually_approved_by edge predicates */
  hasManuallyApprovedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasManuallyApprovedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_manually_paid field predicates */
  isManuallyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  isManuallyPaidNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** manually_approved_at field predicates */
  manuallyApprovedAt?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtGT?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  manuallyApprovedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  manuallyApprovedAtLT?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  manuallyApprovedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** manually_approved_by_id field predicates */
  manuallyApprovedByID?: InputMaybe<Scalars['ID']['input']>;
  manuallyApprovedByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  manuallyApprovedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  manuallyApprovedByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  manuallyApprovedByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  manuallyApprovedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  not?: InputMaybe<InvoiceWhereInput>;
  or?: InputMaybe<Array<InvoiceWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** paid_at field predicates */
  paidAt?: InputMaybe<Scalars['Time']['input']>;
  paidAtGT?: InputMaybe<Scalars['Time']['input']>;
  paidAtGTE?: InputMaybe<Scalars['Time']['input']>;
  paidAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  paidAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paidAtLT?: InputMaybe<Scalars['Time']['input']>;
  paidAtLTE?: InputMaybe<Scalars['Time']['input']>;
  paidAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  paidAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  paidAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter invoices that contain this specific payment option */
  paymentOptionsContains?: InputMaybe<PaymentType>;
  /** Filter invoices that contain ALL of the specified payment options */
  paymentOptionsHasAll?: InputMaybe<Array<PaymentType>>;
  /** Filter invoices that contain ANY of the specified payment options */
  paymentOptionsHasAny?: InputMaybe<Array<PaymentType>>;
  /** Filter invoices that do NOT contain this specific payment option */
  paymentOptionsNotContains?: InputMaybe<PaymentType>;
  /** previous_status field predicates */
  previousStatus?: InputMaybe<InvoiceStatus>;
  previousStatusIn?: InputMaybe<Array<InvoiceStatus>>;
  previousStatusNEQ?: InputMaybe<InvoiceStatus>;
  previousStatusNotIn?: InputMaybe<Array<InvoiceStatus>>;
  /** recipient_email field predicates */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientEmailContains?: InputMaybe<Scalars['String']['input']>;
  recipientEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  recipientEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  recipientEmailGT?: InputMaybe<Scalars['String']['input']>;
  recipientEmailGTE?: InputMaybe<Scalars['String']['input']>;
  recipientEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  recipientEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  recipientEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recipientEmailLT?: InputMaybe<Scalars['String']['input']>;
  recipientEmailLTE?: InputMaybe<Scalars['String']['input']>;
  recipientEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  recipientEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** recipient_name field predicates */
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientNameContains?: InputMaybe<Scalars['String']['input']>;
  recipientNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  recipientNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  recipientNameGT?: InputMaybe<Scalars['String']['input']>;
  recipientNameGTE?: InputMaybe<Scalars['String']['input']>;
  recipientNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  recipientNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  recipientNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recipientNameLT?: InputMaybe<Scalars['String']['input']>;
  recipientNameLTE?: InputMaybe<Scalars['String']['input']>;
  recipientNameNEQ?: InputMaybe<Scalars['String']['input']>;
  recipientNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_policy_terms field predicates */
  refundPolicyTerms?: InputMaybe<InvoiceRefundPolicyTerms>;
  refundPolicyTermsIn?: InputMaybe<Array<InvoiceRefundPolicyTerms>>;
  refundPolicyTermsNEQ?: InputMaybe<InvoiceRefundPolicyTerms>;
  refundPolicyTermsNotIn?: InputMaybe<Array<InvoiceRefundPolicyTerms>>;
  /** status field predicates */
  status?: InputMaybe<InvoiceStatus>;
  statusIn?: InputMaybe<Array<InvoiceStatus>>;
  statusNEQ?: InputMaybe<InvoiceStatus>;
  statusNotIn?: InputMaybe<Array<InvoiceStatus>>;
  /** transfer_id field predicates */
  transferID?: InputMaybe<Scalars['UUID']['input']>;
  transferIDGT?: InputMaybe<Scalars['UUID']['input']>;
  transferIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  transferIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  transferIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  transferIDLT?: InputMaybe<Scalars['UUID']['input']>;
  transferIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  transferIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  transferIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  transferIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<AuthenticationError>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type ManualProcessRefundInput = {
  id: Scalars['ID']['input'];
  providerRefundID: Scalars['String']['input'];
};

export type ManualProcessRefundPayload = {
  errors: Maybe<Array<Error>>;
  refund: Maybe<Refund>;
};

export type ManuallyApproveInvoiceInput = {
  invoiceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paidAmount: Scalars['Float']['input'];
  paymentMethod: PaymentType;
  transactionReference?: InputMaybe<Scalars['String']['input']>;
};

export type ManuallyApproveInvoicePayload = {
  errors: Maybe<Array<Error>>;
  invoice: Maybe<Invoice>;
  payment: Maybe<Payment>;
  payout: Maybe<Payout>;
};

export type Media = {
  cloudFrontUrl: DownloadUrl;
  createdAt: Scalars['Time']['output'];
  createdBy: Maybe<User>;
  entityId: Maybe<Scalars['ID']['output']>;
  entityType: Maybe<MediaEntityType>;
  id: Scalars['ID']['output'];
  imgixUrl: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  url: DownloadUrl;
};


export type MediaImgixUrlArgs = {
  options?: InputMaybe<ImgixOptions>;
};

export const MediaEntityType = {
  Dispute: 'DISPUTE',
  Invoice: 'INVOICE',
  Organization: 'ORGANIZATION',
  Payment: 'PAYMENT',
  Payout: 'PAYOUT',
  Refund: 'REFUND',
  User: 'USER'
} as const;

export type MediaEntityType = typeof MediaEntityType[keyof typeof MediaEntityType];
export const MediaType = {
  Avatar: 'AVATAR',
  CreditAdvice: 'CREDIT_ADVICE',
  DisputeCreditVoucherProof: 'DISPUTE_CREDIT_VOUCHER_PROOF',
  DisputeProviderDocument: 'DISPUTE_PROVIDER_DOCUMENT',
  DisputeRefundProof: 'DISPUTE_REFUND_PROOF',
  DisputeSupportingDocument: 'DISPUTE_SUPPORTING_DOCUMENT',
  DoiDocument: 'DOI_DOCUMENT',
  HotelInvoice: 'HOTEL_INVOICE',
  InvoicePdf: 'INVOICE_PDF',
  Logo: 'LOGO',
  QrCode: 'QR_CODE',
  RefundProof: 'REFUND_PROOF',
  RefundSupportingDocument: 'REFUND_SUPPORTING_DOCUMENT'
} as const;

export type MediaType = typeof MediaType[keyof typeof MediaType];
/**
 * MediaWhereInput is used for filtering Media objects.
 * Input was generated by ent.
 */
export type MediaWhereInput = {
  and?: InputMaybe<Array<MediaWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_id field predicates */
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  createdByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_id field predicates */
  entityID?: InputMaybe<Scalars['UUID']['input']>;
  entityIDGT?: InputMaybe<Scalars['UUID']['input']>;
  entityIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  entityIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  entityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entityIDLT?: InputMaybe<Scalars['UUID']['input']>;
  entityIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  entityIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  entityIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  entityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_type field predicates */
  entityType?: InputMaybe<MediaEntityType>;
  entityTypeIn?: InputMaybe<Array<MediaEntityType>>;
  entityTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entityTypeNEQ?: InputMaybe<MediaEntityType>;
  entityTypeNotIn?: InputMaybe<Array<MediaEntityType>>;
  entityTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** mime_type field predicates */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  mimeTypeContains?: InputMaybe<Scalars['String']['input']>;
  mimeTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  mimeTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  mimeTypeGT?: InputMaybe<Scalars['String']['input']>;
  mimeTypeGTE?: InputMaybe<Scalars['String']['input']>;
  mimeTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  mimeTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  mimeTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mimeTypeLT?: InputMaybe<Scalars['String']['input']>;
  mimeTypeLTE?: InputMaybe<Scalars['String']['input']>;
  mimeTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  mimeTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<MediaWhereInput>;
  or?: InputMaybe<Array<MediaWhereInput>>;
  /** path field predicates */
  path?: InputMaybe<Scalars['String']['input']>;
  pathContains?: InputMaybe<Scalars['String']['input']>;
  pathContainsFold?: InputMaybe<Scalars['String']['input']>;
  pathEqualFold?: InputMaybe<Scalars['String']['input']>;
  pathGT?: InputMaybe<Scalars['String']['input']>;
  pathGTE?: InputMaybe<Scalars['String']['input']>;
  pathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  pathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  pathIn?: InputMaybe<Array<Scalars['String']['input']>>;
  pathLT?: InputMaybe<Scalars['String']['input']>;
  pathLTE?: InputMaybe<Scalars['String']['input']>;
  pathNEQ?: InputMaybe<Scalars['String']['input']>;
  pathNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** type field predicates */
  type?: InputMaybe<Scalars['String']['input']>;
  typeContains?: InputMaybe<Scalars['String']['input']>;
  typeContainsFold?: InputMaybe<Scalars['String']['input']>;
  typeEqualFold?: InputMaybe<Scalars['String']['input']>;
  typeGT?: InputMaybe<Scalars['String']['input']>;
  typeGTE?: InputMaybe<Scalars['String']['input']>;
  typeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  typeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  typeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  typeLT?: InputMaybe<Scalars['String']['input']>;
  typeLTE?: InputMaybe<Scalars['String']['input']>;
  typeNEQ?: InputMaybe<Scalars['String']['input']>;
  typeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MerchantBankAccount = {
  accountHolderName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountNumberMasked: Scalars['String']['output'];
  bank: Organization;
  bankId: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  rejectReason: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  type: BankAccountType;
  updatedAt: Scalars['Time']['output'];
};

export type MerchantBankAccountConnection = {
  edges: Array<MerchantBankAccountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MerchantBankAccountEdge = {
  cursor: Scalars['String']['output'];
  node: MerchantBankAccount;
};

export type MerchantBankAccountOrderByInput = {
  direction: SortOrder;
  field: MerchantBankAccountOrderField;
};

export const MerchantBankAccountOrderField = {
  AccountHolderName: 'ACCOUNT_HOLDER_NAME',
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  Type: 'TYPE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type MerchantBankAccountOrderField = typeof MerchantBankAccountOrderField[keyof typeof MerchantBankAccountOrderField];
/**
 * MerchantBankAccountWhereInput is used for filtering MerchantBankAccount objects.
 * Input was generated by ent.
 */
export type MerchantBankAccountWhereInput = {
  /** account_holder_name field predicates */
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameContains?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameGT?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameGTE?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  accountHolderNameLT?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameLTE?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameNEQ?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** account_number field predicates */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountNumberContains?: InputMaybe<Scalars['String']['input']>;
  accountNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  accountNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  accountNumberGT?: InputMaybe<Scalars['String']['input']>;
  accountNumberGTE?: InputMaybe<Scalars['String']['input']>;
  accountNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  accountNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  accountNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  accountNumberLT?: InputMaybe<Scalars['String']['input']>;
  accountNumberLTE?: InputMaybe<Scalars['String']['input']>;
  accountNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  accountNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<MerchantBankAccountWhereInput>>;
  /** bank_id field predicates */
  bankID?: InputMaybe<Scalars['ID']['input']>;
  bankIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bankIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  bankIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** bank edge predicates */
  hasBank?: InputMaybe<Scalars['Boolean']['input']>;
  hasBankWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<PayoutWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_primary field predicates */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_verified field predicates */
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isVerifiedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<MerchantBankAccountWhereInput>;
  or?: InputMaybe<Array<MerchantBankAccountWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** reject_reason field predicates */
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  rejectReasonContains?: InputMaybe<Scalars['String']['input']>;
  rejectReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  rejectReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  rejectReasonGT?: InputMaybe<Scalars['String']['input']>;
  rejectReasonGTE?: InputMaybe<Scalars['String']['input']>;
  rejectReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  rejectReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  rejectReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  rejectReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rejectReasonLT?: InputMaybe<Scalars['String']['input']>;
  rejectReasonLTE?: InputMaybe<Scalars['String']['input']>;
  rejectReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  rejectReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  rejectReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<BankAccountStatus>;
  statusIn?: InputMaybe<Array<BankAccountStatus>>;
  statusNEQ?: InputMaybe<BankAccountStatus>;
  statusNotIn?: InputMaybe<Array<BankAccountStatus>>;
  /** type field predicates */
  type?: InputMaybe<BankAccountType>;
  typeIn?: InputMaybe<Array<BankAccountType>>;
  typeNEQ?: InputMaybe<BankAccountType>;
  typeNotIn?: InputMaybe<Array<BankAccountType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MerchantDefaultPolicy = {
  organization: Organization;
  policy: PolicyDocument;
  policyType: PolicyType;
  setAt: Scalars['Time']['output'];
};

/**
 * MerchantDefaultPolicyWhereInput is used for filtering MerchantDefaultPolicy objects.
 * Input was generated by ent.
 */
export type MerchantDefaultPolicyWhereInput = {
  and?: InputMaybe<Array<MerchantDefaultPolicyWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** policy edge predicates */
  hasPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyWith?: InputMaybe<Array<PolicyDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<MerchantDefaultPolicyWhereInput>;
  or?: InputMaybe<Array<MerchantDefaultPolicyWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** policy_id field predicates */
  policyID?: InputMaybe<Scalars['ID']['input']>;
  policyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  policyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  policyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** policy_type field predicates */
  policyType?: InputMaybe<PolicyType>;
  policyTypeIn?: InputMaybe<Array<PolicyType>>;
  policyTypeNEQ?: InputMaybe<PolicyType>;
  policyTypeNotIn?: InputMaybe<Array<PolicyType>>;
  /** set_at field predicates */
  setAt?: InputMaybe<Scalars['Time']['input']>;
  setAtGT?: InputMaybe<Scalars['Time']['input']>;
  setAtGTE?: InputMaybe<Scalars['Time']['input']>;
  setAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  setAtLT?: InputMaybe<Scalars['Time']['input']>;
  setAtLTE?: InputMaybe<Scalars['Time']['input']>;
  setAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  setAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MerchantPayoutDashboard = {
  /** One entry per currency the merchant has payouts in */
  items: Array<MerchantPayoutDashboardItem>;
};

export type MerchantPayoutDashboardItem = {
  /** Sum of all PENDING payout amounts (awaiting transfer) */
  availablePayouts: Scalars['Float']['output'];
  /** Count of pending/available payouts */
  availablePayoutsCount: Scalars['Int']['output'];
  /** Currency for this item's amounts */
  currency: Currency;
  /** Sum of all COMPLETED payout amounts (money already transferred to bank) */
  totalPaidOut: Scalars['Float']['output'];
  /** Count of completed payouts */
  totalPaidOutCount: Scalars['Int']['output'];
};

export type MerchantPolicyAcceptance = {
  acceptanceContext: AcceptanceContext;
  acceptedAt: Scalars['Time']['output'];
  acceptedByUser: User;
  bank: Maybe<Organization>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  isCurrent: Scalars['Boolean']['output'];
  organization: Organization;
  policy: PolicyDocument;
  supersededBy: Maybe<MerchantPolicyAcceptance>;
  userAgent: Maybe<Scalars['String']['output']>;
};

export type MerchantPolicyAcceptanceConnection = {
  edges: Array<MerchantPolicyAcceptanceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MerchantPolicyAcceptanceEdge = {
  cursor: Scalars['String']['output'];
  node: MerchantPolicyAcceptance;
};

/**
 * MerchantPolicyAcceptanceWhereInput is used for filtering MerchantPolicyAcceptance objects.
 * Input was generated by ent.
 */
export type MerchantPolicyAcceptanceWhereInput = {
  /** acceptance_context field predicates */
  acceptanceContext?: InputMaybe<AcceptanceContext>;
  acceptanceContextIn?: InputMaybe<Array<AcceptanceContext>>;
  acceptanceContextNEQ?: InputMaybe<AcceptanceContext>;
  acceptanceContextNotIn?: InputMaybe<Array<AcceptanceContext>>;
  /** accepted_at field predicates */
  acceptedAt?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtGT?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  acceptedAtLT?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** accepted_by_user_id field predicates */
  acceptedByUserID?: InputMaybe<Scalars['ID']['input']>;
  acceptedByUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  acceptedByUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  acceptedByUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  and?: InputMaybe<Array<MerchantPolicyAcceptanceWhereInput>>;
  /** bank_id field predicates */
  bankID?: InputMaybe<Scalars['ID']['input']>;
  bankIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bankIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bankIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  bankIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bankIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** accepted_by_user edge predicates */
  hasAcceptedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasAcceptedByUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** bank edge predicates */
  hasBank?: InputMaybe<Scalars['Boolean']['input']>;
  hasBankWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** policy edge predicates */
  hasPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyWith?: InputMaybe<Array<PolicyDocumentWhereInput>>;
  /** superseded_acceptances edge predicates */
  hasSupersededAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededAcceptancesWith?: InputMaybe<Array<MerchantPolicyAcceptanceWhereInput>>;
  /** superseded_by edge predicates */
  hasSupersededBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededByWith?: InputMaybe<Array<MerchantPolicyAcceptanceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ip_address field predicates */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddressContains?: InputMaybe<Scalars['String']['input']>;
  ipAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressGT?: InputMaybe<Scalars['String']['input']>;
  ipAddressGTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ipAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddressLT?: InputMaybe<Scalars['String']['input']>;
  ipAddressLTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  ipAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_current field predicates */
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<MerchantPolicyAcceptanceWhereInput>;
  or?: InputMaybe<Array<MerchantPolicyAcceptanceWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** policy_id field predicates */
  policyID?: InputMaybe<Scalars['ID']['input']>;
  policyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  policyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  policyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** superseded_by_id field predicates */
  supersededByID?: InputMaybe<Scalars['ID']['input']>;
  supersededByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  supersededByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  supersededByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  supersededByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  supersededByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_agent field predicates */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userAgentContains?: InputMaybe<Scalars['String']['input']>;
  userAgentContainsFold?: InputMaybe<Scalars['String']['input']>;
  userAgentEqualFold?: InputMaybe<Scalars['String']['input']>;
  userAgentGT?: InputMaybe<Scalars['String']['input']>;
  userAgentGTE?: InputMaybe<Scalars['String']['input']>;
  userAgentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userAgentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userAgentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userAgentLT?: InputMaybe<Scalars['String']['input']>;
  userAgentLTE?: InputMaybe<Scalars['String']['input']>;
  userAgentNEQ?: InputMaybe<Scalars['String']['input']>;
  userAgentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export const MerchantReportField = {
  Address: 'ADDRESS',
  Code: 'CODE',
  Country: 'COUNTRY',
  CreatedAt: 'CREATED_AT',
  Description: 'DESCRIPTION',
  Email: 'EMAIL',
  Industry: 'INDUSTRY',
  LicenseNumber: 'LICENSE_NUMBER',
  MccCode: 'MCC_CODE',
  MerchantProcessingFee: 'MERCHANT_PROCESSING_FEE',
  Name: 'NAME',
  OtherIndustry: 'OTHER_INDUSTRY',
  PhoneNumber: 'PHONE_NUMBER',
  RefundPolicyTerms: 'REFUND_POLICY_TERMS',
  Status: 'STATUS',
  Type: 'TYPE',
  Website: 'WEBSITE'
} as const;

export type MerchantReportField = typeof MerchantReportField[keyof typeof MerchantReportField];
export type MerchantWebhook = {
  createdAt: Scalars['Time']['output'];
  deliveries: Maybe<Array<WebhookDelivery>>;
  description: Maybe<Scalars['String']['output']>;
  disabledAt: Maybe<Scalars['Time']['output']>;
  failureCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastTriggeredAt: Maybe<Scalars['Time']['output']>;
  metadata: Maybe<Scalars['Map']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationID: Scalars['ID']['output'];
  secret: Scalars['String']['output'];
  status: WebhookStatus;
  subscriptions: Maybe<Array<MerchantWebhookSubscription>>;
  updatedAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
};

export type MerchantWebhookConnection = {
  edges: Array<MerchantWebhookEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MerchantWebhookEdge = {
  cursor: Scalars['String']['output'];
  node: MerchantWebhook;
};

export type MerchantWebhookOrderByInput = {
  direction: SortOrder;
  field: MerchantWebhookOrderField;
};

export const MerchantWebhookOrderField = {
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type MerchantWebhookOrderField = typeof MerchantWebhookOrderField[keyof typeof MerchantWebhookOrderField];
export type MerchantWebhookSubscription = {
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  merchantWebhook: MerchantWebhook;
  merchantWebhookID: Scalars['ID']['output'];
  metadata: Maybe<Scalars['Map']['output']>;
  updatedAt: Scalars['Time']['output'];
  webhookEventType: WebhookEventType;
  webhookEventTypeID: Scalars['ID']['output'];
};

/**
 * MerchantWebhookSubscriptionWhereInput is used for filtering MerchantWebhookSubscription objects.
 * Input was generated by ent.
 */
export type MerchantWebhookSubscriptionWhereInput = {
  and?: InputMaybe<Array<MerchantWebhookSubscriptionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** merchant_webhook edge predicates */
  hasMerchantWebhook?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantWebhookWith?: InputMaybe<Array<MerchantWebhookWhereInput>>;
  /** webhook_event_type edge predicates */
  hasWebhookEventType?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebhookEventTypeWith?: InputMaybe<Array<WebhookEventTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_enabled field predicates */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_webhook_id field predicates */
  merchantWebhookID?: InputMaybe<Scalars['ID']['input']>;
  merchantWebhookIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantWebhookIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  merchantWebhookIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<MerchantWebhookSubscriptionWhereInput>;
  or?: InputMaybe<Array<MerchantWebhookSubscriptionWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** webhook_event_type_id field predicates */
  webhookEventTypeID?: InputMaybe<Scalars['ID']['input']>;
  webhookEventTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  webhookEventTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  webhookEventTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * MerchantWebhookWhereInput is used for filtering MerchantWebhook objects.
 * Input was generated by ent.
 */
export type MerchantWebhookWhereInput = {
  and?: InputMaybe<Array<MerchantWebhookWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled_at field predicates */
  disabledAt?: InputMaybe<Scalars['Time']['input']>;
  disabledAtGT?: InputMaybe<Scalars['Time']['input']>;
  disabledAtGTE?: InputMaybe<Scalars['Time']['input']>;
  disabledAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  disabledAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  disabledAtLT?: InputMaybe<Scalars['Time']['input']>;
  disabledAtLTE?: InputMaybe<Scalars['Time']['input']>;
  disabledAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  disabledAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  disabledAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** failure_count field predicates */
  failureCount?: InputMaybe<Scalars['Int']['input']>;
  failureCountGT?: InputMaybe<Scalars['Int']['input']>;
  failureCountGTE?: InputMaybe<Scalars['Int']['input']>;
  failureCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  failureCountLT?: InputMaybe<Scalars['Int']['input']>;
  failureCountLTE?: InputMaybe<Scalars['Int']['input']>;
  failureCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  failureCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** deliveries edge predicates */
  hasDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeliveriesWith?: InputMaybe<Array<WebhookDeliveryWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** subscriptions edge predicates */
  hasSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubscriptionsWith?: InputMaybe<Array<MerchantWebhookSubscriptionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_triggered_at field predicates */
  lastTriggeredAt?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastTriggeredAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastTriggeredAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastTriggeredAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<MerchantWebhookWhereInput>;
  or?: InputMaybe<Array<MerchantWebhookWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status field predicates */
  status?: InputMaybe<WebhookStatus>;
  statusIn?: InputMaybe<Array<WebhookStatus>>;
  statusNEQ?: InputMaybe<WebhookStatus>;
  statusNotIn?: InputMaybe<Array<WebhookStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MobileCurrencyRangeInput = {
  currency: Currency;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * One currency's header stats. Which money field these aggregate follows the
 * query they came from, so the header always adds up to the rows beneath it:
 * the payer summary uses `amount` (what the payer was charged), the merchant
 * summary uses `netAmount` (what settles to the merchant).
 */
export type MobileCurrencyTotal = {
  currency: Currency;
  /** Largest payment amount in this currency (filter-slider upper bound) */
  max: Scalars['Float']['output'];
  /** Smallest payment amount in this currency (filter-slider lower bound) */
  min: Scalars['Float']['output'];
  /** Sum of SUCCEEDED payments in this currency */
  total: Scalars['Float']['output'];
};

export type MobileCustomerTxnSummary = {
  refundCount: Scalars['Int']['output'];
  totalsByCurrency: Array<MobileCurrencyTotal>;
  transactionCount: Scalars['Int']['output'];
};

/**
 * Flat payload (not the Dispute type): M2M callers carry no org context, so the
 * org-scoped Dispute privacy rules would deny field resolution. Merchant-internal
 * fields (gateway references, evidence, response deadlines) are deliberately
 * excluded from the payer surface.
 */
export type MobileDispute = {
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Scalars['String']['output'];
  disputeAmount: Scalars['Float']['output'];
  disputedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** Merchant the disputed payment was made to */
  merchantName: Scalars['String']['output'];
  paymentId: Scalars['ID']['output'];
  progressStatus: DisputeProgressStatus;
  reason: DisputeReason;
  refundId: Maybe<Scalars['ID']['output']>;
  resolutionDate: Maybe<Scalars['Time']['output']>;
  status: DisputeStatus;
  statusUpdatedAt: Maybe<Scalars['Time']['output']>;
};

export type MobileDonationOrganization = {
  description: Maybe<Scalars['Map']['output']>;
  id: Scalars['ID']['output'];
  industry: Maybe<OrganizationIndustry>;
  name: Scalars['String']['output'];
  quickPayAccessKey: Scalars['String']['output'];
  quickPayCode: Scalars['String']['output'];
};

/** Bucket width for mobileMerchantRevenueSeries. */
export const MobileInsightsBucket = {
  Day: 'DAY',
  Hour: 'HOUR',
  Month: 'MONTH',
  Year: 'YEAR'
} as const;

export type MobileInsightsBucket = typeof MobileInsightsBucket[keyof typeof MobileInsightsBucket];
/** One currency's money total. No FX rates exist in this system, so totals are never converted or summed across currencies. */
export type MobileInsightsCurrencyTotal = {
  currency: Currency;
  total: Scalars['Float']['output'];
};

/** One hour of the day-of-week-agnostic activity profile. */
export type MobileMerchantActivityHour = {
  /** SUCCEEDED payments that fell in this hour, across every day in the window. */
  count: Scalars['Int']['output'];
  /** Hour of day, 0–23, Asia/Thimphu. */
  hour: Scalars['Int']['output'];
};

/**
 * The window and tag scope shared by every insights query.
 *
 * The mobile backend owns the merchant's spot and category tags — they live in
 * its own database and are invisible here — so it resolves them locally to a
 * set of payment IDs and passes them as paymentIds.
 */
export type MobileMerchantInsightsScopeInput = {
  environment?: InputMaybe<PaymentEnvironment>;
  /** Window start, inclusive. Null means unbounded — the org's whole history. */
  from?: InputMaybe<Scalars['Time']['input']>;
  /** The merchant organization. Asserted by the trusted mobile backend from its own validated merchant session. */
  merchantOrgId: Scalars['ID']['input'];
  /**
   * Restrict to these payments. Null or absent means no constraint; an
   * explicitly empty list matches nothing, so a tag filter that resolved to
   * zero payments reports zeros rather than the unfiltered total.
   */
  paymentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Window end, exclusive. Null means unbounded. */
  to?: InputMaybe<Scalars['Time']['input']>;
};

/** Header stats for the merchant Insights screen. */
export type MobileMerchantInsightsSummary = {
  /**
   * Distinct non-null customer_id among those payments. Guest and web payments
   * carry no customer row and are not counted at all, so this is a count of
   * known customer records, not of people.
   */
  customerCount: Scalars['Int']['output'];
  /** REFUNDED refunds settled in the window, in their parent payment's currency. Dated by status_updated_at, falling back to created_at — the same instant the feed shows as a refund entry's occurredAt. */
  refundTotalsByCurrency: Array<MobileInsightsCurrencyTotal>;
  /** Count of SUCCEEDED payments in the window. */
  salesCount: Scalars['Int']['output'];
  /** SUCCEEDED payments in the window, per currency. Gross — refunds are reported separately and never subtracted. */
  totalsByCurrency: Array<MobileInsightsCurrencyTotal>;
};

/** One bucket of the revenue series. */
export type MobileMerchantRevenueBucket = {
  /** Bucket start as an absolute instant. The truncation was performed in Asia/Thimphu, so this lands on a Bhutan-local hour/day/month/year boundary. */
  bucketStart: Scalars['Time']['output'];
  /** SUCCEEDED payments in this bucket. */
  salesCount: Scalars['Int']['output'];
  totalsByCurrency: Array<MobileInsightsCurrencyTotal>;
};

/**
 * Revenue over time. Only buckets holding at least one payment are returned,
 * ascending by bucketStart — gap-filling belongs to the caller, which is the
 * only side that knows whether an empty bucket should be rendered as a zero
 * (a quiet Tuesday) or omitted (a year before the org existed).
 */
export type MobileMerchantRevenueSeries = {
  buckets: Array<MobileMerchantRevenueBucket>;
  /** Grand totals for the window. Equals summing the buckets. */
  totalsByCurrency: Array<MobileInsightsCurrencyTotal>;
};

export type MobileRequestRefundInput = {
  /** Omit for a full refund of the remaining refundable amount */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Mobile backend user UUID — matched against the payment customer's external_id */
  externalId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
  /** Why the payer wants the refund — TipTap doc, rendered in the merchant console */
  reason: Scalars['Map']['input'];
};

/**
 * Flat payload (not the Refund type): M2M callers carry no org context, so the
 * org-scoped Refund privacy rules would deny field resolution.
 */
export type MobileRequestRefundPayload = {
  amount: Maybe<Scalars['Float']['output']>;
  errors: Maybe<Array<Error>>;
  progressStatus: Maybe<RefundProgressStatus>;
  refundCode: Maybe<Scalars['String']['output']>;
  refundId: Maybe<Scalars['ID']['output']>;
  status: Maybe<RefundStatus>;
};

/** A provider-vaulted payment method of a mobile end-user */
export type MobileSavedCard = {
  cardBrand: Maybe<Scalars['String']['output']>;
  cardExpMonth: Maybe<Scalars['Int']['output']>;
  cardExpYear: Maybe<Scalars['Int']['output']>;
  cardLast4: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Time']['output']>;
  isDefault: Scalars['Boolean']['output'];
  /** Provider payment method id (e.g. Hyperswitch pm_...) */
  paymentMethodId: Scalars['String']['output'];
  paymentType: PaymentType;
  /** Wallet subtype when paymentType is WALLET: apple_pay | google_pay */
  walletType: Maybe<Scalars['String']['output']>;
};

/**
 * One row of the feed — a payment or a refund, normalized.
 *
 * Three money fields, because the payer and the merchant are owed different
 * numbers for the same payment. `amount` is what the payer was charged
 * (sale + the fee share they bore); `saleAmount` is what the merchant priced
 * the sale at; `netAmount` is what settles to the merchant once the fee share
 * *they* absorbed is taken off. Payer surfaces render `amount`; merchant
 * surfaces render `netAmount` and explain it with `saleAmount` and
 * `merchantProcessingFee`. They coincide whenever the merchant absorbs
 * nothing (merchantProcessingFee = 0), which is the default.
 */
export type MobileTxnEntry = {
  /** Charged to the payer: saleAmount plus the processing fee share the payer bore */
  amount: Scalars['Float']['output'];
  currency: Currency;
  /** Raw customer display name (merchant feed callers mask it before display) */
  customerName: Maybe<Scalars['String']['output']>;
  entryType: MobileTxnEntryType;
  id: Scalars['ID']['output'];
  merchantId: Scalars['ID']['output'];
  /** The processing fee share the merchant absorbed; deducted from what settles to them */
  merchantProcessingFee: Scalars['Float']['output'];
  /** Settles to the merchant: saleAmount minus merchantProcessingFee */
  netAmount: Scalars['Float']['output'];
  notes: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['Time']['output'];
  /** The payment's code for PAYMENT entries; the refund's code (fallback: payment code) for REFUND entries */
  paymentCode: Scalars['String']['output'];
  paymentMethodLabel: Maybe<Scalars['String']['output']>;
  relatedPaymentCode: Maybe<Scalars['String']['output']>;
  relatedPaymentId: Maybe<Scalars['ID']['output']>;
  /** The merchant's own price for the sale, before any processing fee moved either way */
  saleAmount: Scalars['Float']['output'];
  /** Verbatim sale basket JSON ([{description, unitPrice, quantity}]) from the payment or its invoice items */
  saleItems: Maybe<Array<Scalars['Map']['output']>>;
  status: MobileTxnStatus;
};

export const MobileTxnEntryType = {
  Payment: 'PAYMENT',
  Refund: 'REFUND'
} as const;

export type MobileTxnEntryType = typeof MobileTxnEntryType[keyof typeof MobileTxnEntryType];
export type MobileTxnFilterInput = {
  currencyRanges?: InputMaybe<Array<MobileCurrencyRangeInput>>;
  /** Fetch specific entries by their own IDs (payment or refund IDs) — detail lookups */
  entryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entryTypes?: InputMaybe<Array<MobileTxnEntryType>>;
  environment?: InputMaybe<PaymentEnvironment>;
  /** Drop these payment IDs (mobile's hidden rows); refund entries follow their parent payment */
  excludePaymentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict to these payment IDs (mobile's onlyShared filter) */
  includePaymentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Narrow to specific merchant organizations (mobile resolves category/search chips to these) */
  merchantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free text — matched against payment code and exact amount */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Merchant organizations whose display name matched the search on the mobile
   * side; entries of these merchants match the search too (OR with code/amount).
   * Ignored when search is empty.
   */
  searchMerchantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<MobileTxnStatus>>;
};

/** Offset-paginated page. Offset pagination is deliberate: the feed interleaves two tables. */
export type MobileTxnList = {
  entries: Array<MobileTxnEntry>;
  totalCount: Scalars['Int']['output'];
};

export const MobileTxnOrder = {
  AmountAsc: 'AMOUNT_ASC',
  AmountDesc: 'AMOUNT_DESC',
  MostRecent: 'MOST_RECENT'
} as const;

export type MobileTxnOrder = typeof MobileTxnOrder[keyof typeof MobileTxnOrder];
export const MobileTxnStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Pending: 'PENDING',
  Refunded: 'REFUNDED'
} as const;

export type MobileTxnStatus = typeof MobileTxnStatus[keyof typeof MobileTxnStatus];
export type Mutation = {
  CancelApiPayment: Maybe<CancelApiPaymentPayload>;
  acceptAllRequiredUserPolicies: Maybe<AcceptAllRequiredUserPoliciesPayload>;
  acceptDispute: Maybe<AcceptDisputePayload>;
  acceptInvitation: AcceptInvitationPayload;
  acceptPolicy: Maybe<AcceptPolicyPayload>;
  acceptUserPolicy: Maybe<AcceptUserPolicyPayload>;
  activateAPIKey: Maybe<ActivateApiKeyPayload>;
  activateQuickPay: ActivateQuickPayPayload;
  addCardTypeToProvider: AddCardTypeToProviderPayload;
  addLineItem: AddLineItemPayload;
  addMerchantBankAccount: Maybe<AddMerchantBankAccountPayload>;
  addPaymentTypeToProvider: AddPaymentTypeToProviderPayload;
  addPayoutsToTransfer: Maybe<AddPayoutsToTransferPayload>;
  addServiceAccountWebhookSubscriptions: AddServiceAccountWebhookSubscriptionsPayload;
  addWebhookSubscriptions: AddWebhookSubscriptionsPayload;
  approveBankAccount: Maybe<ApproveBankAccountPayload>;
  approveRefund: Maybe<ApproveRefundPayload>;
  archiveQuickPay: ArchiveQuickPayPayload;
  assignRoleToUser: Maybe<AssignRolePayload>;
  bankApproveRefund: Maybe<BankApproveRefundPayload>;
  bankDenyRefund: Maybe<BankDenyRefundPayload>;
  batchProcessPayouts: Maybe<BatchProcessPayoutsPayload>;
  cancelPayout: Maybe<CancelPayoutPayload>;
  cancelRecurringPayment: Maybe<CancelRecurringPaymentPayload>;
  cancelRecurringPaymentSetup: CancelRecurringPaymentSetupPayload;
  cancelRefund: Maybe<CancelRefundPayload>;
  changePassword: ChangePasswordPayload;
  closeBankAccount: Maybe<CloseBankAccountPayload>;
  completePayouts: Maybe<CompletePayoutPayload>;
  completeTransfer: Maybe<CompleteTransferPayload>;
  createApiPaymentIntent: CreatePaymentIntentPayload;
  createBillingAddress: CreateBillingAddressPayload;
  createDispute: Maybe<CreateDisputePayload>;
  createInvoice: Maybe<CreateInvoicePayload>;
  createMedia: Media;
  createMediaBulk: Array<Media>;
  createMerchantWebhook: CreateMerchantWebhookPayload;
  /** Create a zero-amount setup intent to add a card from the mobile wallet (service-account only) */
  createMobileCardSetupIntent: CreateMobileCardSetupIntentPayload;
  createOrganization: CreateOrganizationPayload;
  createOrganizationPaymentType: CreateOrganizationPaymentTypePayload;
  createPaymentIntent: CreatePaymentIntentPayload;
  /**
   * Generate a secure update session for a recurring payment.
   * Called by merchant dashboard or triggered automatically on payment failure.
   * Requires auth + recurringpayment.manage permission.
   */
  createPaymentMethodUpdateSession: CreatePaymentMethodUpdateSessionPayload;
  createPaymentProvider: CreatePaymentProviderPayload;
  createPolicyDocument: Maybe<CreatePolicyDocumentPayload>;
  createPolicyDocumentVersion: Maybe<CreatePolicyDocumentVersionPayload>;
  createPolicyTemplate: Maybe<CreatePolicyTemplatePayload>;
  createQuickPay: CreateQuickPayPayload;
  createQuickPayPaymentIntent: CreatePaymentIntentPayload;
  createRecurringPayment: CreateRecurringPaymentPayload;
  createRefund: Maybe<CreateRefundPayload>;
  createRole: Maybe<CreateRolePayload>;
  createServiceAccountWebhook: CreateServiceAccountWebhookPayload;
  createSetupIntent: CreateSetupIntentPayload;
  createTransfer: Maybe<CreateTransferPayload>;
  /**
   * Create a setup intent for the update payment method page.
   * No auth required — validated via update_session_id.
   */
  createUpdateSetupIntent: CreateSetupIntentPayload;
  deactivateAPIKey: Maybe<DeactivateApiKeyPayload>;
  /**
   * Returns the organization's default quickpay (backs the merchant's static QR),
   * creating it on first call. Idempotent.
   */
  defaultQuickPay: DefaultQuickPayPayload;
  deleteAPIKey: Maybe<DeleteApiKeyPayload>;
  deleteBankAccount: Maybe<DeleteBankAccountPayload>;
  deleteCardType: DeleteCardTypePayload;
  deleteLineItem: DeleteLineItemPayload;
  deleteMedia: Scalars['Boolean']['output'];
  /** Delete one of a mobile user's saved cards (service-account only) */
  deleteMobileSavedCard: Scalars['Boolean']['output'];
  deleteOrganization: DeleteOrganizationPayload;
  deleteOrganizationPaymentType: DeleteOrganizationPaymentTypePayload;
  deletePaymentProvider: DeletePaymentProviderPayload;
  deletePaymentType: DeletePaymentTypePayload;
  deletePayout: Maybe<DeletePayoutPayload>;
  deletePolicyDocument: DeletePolicyDocumentPayload;
  deletePolicyTemplate: Maybe<DeletePolicyTemplatePayload>;
  deleteRole: Maybe<DeleteRolePayload>;
  deleteTransfer: Maybe<DeleteTransferPayload>;
  deleteUser: DeleteUserPayload;
  denyRefund: Maybe<DenyRefundPayload>;
  deprecatePolicyDocument: DeprecatePolicyDocumentPayload;
  detachPaymentMethod: Scalars['Boolean']['output'];
  downloadPaidApiPaymentReceipt: DownloadPaidApiPaymentReceipt;
  downloadPaidInvoiceReceipt: DownloadPaidInvoiceReceipt;
  downloadTransferReceipt: DownloadTransferReceipt;
  downloadUnpaidApiPaymentReceipt: DownloadUnpaidApiPaymentReceipt;
  downloadUnpaidInvoiceReceipt: DownloadUnpaidInvoiceReceipt;
  expireDispute: Maybe<ExpireDisputePayload>;
  flagPayment: FlagPaymentPayload;
  generateAPIKey: Maybe<GenerateApiKeyPayload>;
  generateInvoicePdf: GenerateInvoicePdfPayload;
  generateTransferPdf: GenerateTransferPdfPayload;
  grantPermissionToRole: Maybe<GrantPermissionPayload>;
  grantPermissionsToRole: Maybe<GrantPermissionsPayload>;
  initQuickPayment: InitQuickPaymentPayload;
  /** Invite a user into a bank organization (platform admin only) */
  inviteBankUser: InviteUserPayload;
  inviteUser: InviteUserPayload;
  login: Maybe<LoginPayload>;
  manualProcessRefund: Maybe<ManualProcessRefundPayload>;
  manuallyApproveInvoice: ManuallyApproveInvoicePayload;
  /** Payer-initiated refund request from the mobile app. Service-account only. */
  mobileRequestRefund: MobileRequestRefundPayload;
  /** Onboard a BANK organization with its owner user (platform admin only) */
  onboardBank: OnboardBankPayload;
  onboardOrganization: CreateOrganizationPayload;
  pauseQuickPay: PauseQuickPayPayload;
  pauseRecurringPayment: Maybe<PauseRecurringPaymentPayload>;
  platformAdminSignIn: Maybe<LoginPayload>;
  processApiPayment: ProcessApiPaymentPayload;
  processInvoicePayment: ProcessInvoicePaymentPayload;
  processQuickPayPayment: ProcessQuickPayPaymentPayload;
  processRefund: Maybe<ProcessRefundPayload>;
  recordDisputeWithdrawal: Maybe<RecordDisputeWithdrawalPayload>;
  refreshToken: Maybe<RefreshTokenPayload>;
  reinstateBankAccount: Maybe<ReinstateBankAccountPayload>;
  rejectBankAccount: Maybe<RejectBankAccountPayload>;
  rejectRefund: Maybe<RejectRefundPayload>;
  removeDefaultPolicy: Maybe<RemoveDefaultPolicyPayload>;
  removePayoutsFromTransfer: Maybe<RemovePayoutsFromTransferPayload>;
  removeServiceAccountWebhookSubscriptions: RemoveServiceAccountWebhookSubscriptionsPayload;
  removeWebhookSubscriptions: RemoveWebhookSubscriptionsPayload;
  reorderLineItems: ReorderLineItemsPayload;
  requestEmailVerificationOTP: RequestOtpPayload;
  requestLoginOTP: RequestOtpPayload;
  requestMagicLink: RequestMagicLinkPayload;
  requestPasswordReset: RequestPasswordResetPayload;
  requestPasswordResetOTP: RequestOtpPayload;
  resendEmailVerification: Maybe<ResendEmailVerificationPayload>;
  resendInvitation: ResendInvitationPayload;
  resetPassword: ResetPasswordPayload;
  resetPasswordWithOTP: AuthPayload;
  resolveDispute: Maybe<ResolveDisputePayload>;
  restoreOrganization: RestoreOrganizationPayload;
  restorePermissionToRole: Maybe<RestorePermissionPayload>;
  resumeRecurringPayment: Maybe<ResumeRecurringPaymentPayload>;
  retryWebhookDelivery: RetryWebhookDeliveryPayload;
  revokePermissionFromRole: Maybe<RevokePermissionPayload>;
  rotateServiceAccountWebhookSecret: RotateServiceAccountWebhookSecretPayload;
  savePaymentMethod: SavePaymentMethodPayload;
  sendDisputeReceivedMerchantNotification: Scalars['Boolean']['output'];
  sendInvoiceEmail: SendInvoiceEmailPayload;
  /**
   * Replaces the payment channels a BANK organization settles. Admin-only;
   * a merchant must never be able to grant its banks new channels.
   */
  setBankSupportedChannels: SetBankSupportedChannelsPayload;
  setDefaultPaymentMethod: PaymentMethod;
  setDefaultPolicy: Maybe<SetDefaultPolicyPayload>;
  /**
   * Toggles whether a MERCHANT organization may be listed as a donation
   * recipient in the payer app. Platform/bank-admin only; a merchant must
   * never be able to grant itself donation eligibility.
   *
   * Enabling guarantees the merchant is payable: their default QuickPay
   * (static QR) is created when missing, gated on an ACTIVE org and an
   * APPROVED bank account — the toggle fails with
   * MERCHANT_BANK_ACCOUNT_NOT_CONFIGURED / FORBIDDEN instead of listing an
   * unpayable merchant.
   */
  setOrganizationDonationEligibility: SetOrganizationDonationEligibilityPayload;
  setPrimaryBankAccount: Maybe<SetPrimaryBankAccountPayload>;
  signUpUser: SignUpUserPayload;
  splitPayout: Maybe<SplitPayoutPayload>;
  submitDisputeEvidence: Maybe<SubmitDisputeEvidencePayload>;
  submitTransfer: Maybe<SubmitTransferPayload>;
  suspendBankAccount: Maybe<SuspendBankAccountPayload>;
  syncRolePermissions: Maybe<SyncRolePermissionsPayload>;
  unassignRoleFromUser: Maybe<UnassignRolePayload>;
  unflagPayment: UnflagPaymentPayload;
  updateAPIKey: Maybe<UpdateApiKeyPayload>;
  updateBankAccountDetails: Maybe<UpdateBankAccountDetailsPayload>;
  updateBillingAddress: UpdateBillingAddressPayload;
  updateBusiness: UpdateOrganizationPayload;
  updateCardType: UpdateCardTypePayload;
  updateDisputeProgress: Maybe<UpdateDisputeProgressPayload>;
  updateInvoice: UpdateInvoicePayload;
  updateLineItem: UpdateLineItemPayload;
  updateMedia: Media;
  updateMerchantWebhook: UpdateMerchantWebhookPayload;
  updateOrganization: UpdateOrganizationPayload;
  updateOrganizationPaymentType: UpdateOrganizationPaymentTypePayload;
  updateOrganizationStatus: UpdateOrganizationStatusPayload;
  updatePaymentProvider: UpdatePaymentProviderPayload;
  updatePaymentType: UpdatePaymentTypePayload;
  updatePermissionGroup: UpdatePermissionGroupPayload;
  updatePolicyDocument: Maybe<UpdatePolicyDocumentPayload>;
  updatePolicyTemplate: Maybe<UpdatePolicyTemplatePayload>;
  updateQuickPay: UpdateQuickPayPayload;
  updateRecurringPayment: UpdateRecurringPaymentPayload;
  /**
   * Save the new payment method and swap it on the recurring payment.
   * No auth required — validated via update_session_id.
   */
  updateRecurringPaymentMethod: UpdateRecurringPaymentMethodPayload;
  updateRefund: Maybe<UpdateRefundPayload>;
  updateRole: Maybe<UpdateRolePayload>;
  updateServiceAccountWebhook: UpdateServiceAccountWebhookPayload;
  updateServiceAccountWebhookSubscription: UpdateServiceAccountWebhookSubscriptionPayload;
  updateTransferNotes: Maybe<UpdateTransferNotesPayload>;
  updateUserProfile: UpdateUserProfilePayload;
  updateUserStatus: UpdateUserStatusPayload;
  updateWebhookSubscription: UpdateWebhookSubscriptionPayload;
  verifyBankAccount: Maybe<VerifyBankAccountPayload>;
  verifyEmail: VerifyEmailPayload;
  verifyEmailWithOTP: AuthPayload;
  verifyLoginOTP: AuthPayload;
  verifyMagicLink: VerifyMagicLinkPayload;
  verifyOTP: VerifyOtpPayload;
  voidInvoice: VoidInvoicePayload;
};


export type MutationCancelApiPaymentArgs = {
  accessKey: Scalars['String']['input'];
};


export type MutationAcceptDisputeArgs = {
  input: AcceptDisputeInput;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAcceptPolicyArgs = {
  input: AcceptPolicyInput;
};


export type MutationAcceptUserPolicyArgs = {
  input: AcceptUserPolicyInput;
};


export type MutationActivateApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateQuickPayArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddCardTypeToProviderArgs = {
  input: AddCardTypeInput;
};


export type MutationAddLineItemArgs = {
  input: AddLineItemInput;
  invoiceId: Scalars['ID']['input'];
};


export type MutationAddMerchantBankAccountArgs = {
  input: AddMerchantBankAccountInput;
};


export type MutationAddPaymentTypeToProviderArgs = {
  input: AddPaymentTypeInput;
};


export type MutationAddPayoutsToTransferArgs = {
  input: AddPayoutsToTransferInput;
};


export type MutationAddServiceAccountWebhookSubscriptionsArgs = {
  input: AddServiceAccountWebhookSubscriptionsInput;
};


export type MutationAddWebhookSubscriptionsArgs = {
  input: AddWebhookSubscriptionsInput;
};


export type MutationApproveBankAccountArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApproveRefundArgs = {
  input: ApproveRefundInput;
};


export type MutationArchiveQuickPayArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignRoleToUserArgs = {
  input: AssignRoleInput;
};


export type MutationBankApproveRefundArgs = {
  input: BankApproveRefundInput;
};


export type MutationBankDenyRefundArgs = {
  input: BankDenyRefundInput;
};


export type MutationBatchProcessPayoutsArgs = {
  input: BatchProcessPayoutsInput;
};


export type MutationCancelPayoutArgs = {
  input: CancelPayoutInput;
};


export type MutationCancelRecurringPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelRecurringPaymentSetupArgs = {
  input: CancelRecurringPaymentSetupInput;
};


export type MutationCancelRefundArgs = {
  input: CancelRefundInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCloseBankAccountArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompletePayoutsArgs = {
  input: CompletePayoutInput;
};


export type MutationCompleteTransferArgs = {
  input: CompleteTransferInput;
};


export type MutationCreateApiPaymentIntentArgs = {
  input: CreateApiPaymentIntentInput;
};


export type MutationCreateBillingAddressArgs = {
  input: CreateBillingAddressInput;
};


export type MutationCreateDisputeArgs = {
  input: CreateDisputeInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateMediaArgs = {
  input: CreateMediaInput;
};


export type MutationCreateMediaBulkArgs = {
  input: Array<CreateMediaInput>;
};


export type MutationCreateMerchantWebhookArgs = {
  input: CreateMerchantWebhookInput;
};


export type MutationCreateMobileCardSetupIntentArgs = {
  input: CreateMobileCardSetupIntentInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationPaymentTypeArgs = {
  input: CreateOrganizationPaymentTypeInput;
};


export type MutationCreatePaymentIntentArgs = {
  input: CreatePaymentIntentInput;
};


export type MutationCreatePaymentMethodUpdateSessionArgs = {
  input: CreatePaymentMethodUpdateSessionInput;
};


export type MutationCreatePaymentProviderArgs = {
  input: CreatePaymentProviderInput;
};


export type MutationCreatePolicyDocumentArgs = {
  input: CreatePolicyDocumentInput;
};


export type MutationCreatePolicyDocumentVersionArgs = {
  input: CreatePolicyDocumentVersionInput;
};


export type MutationCreatePolicyTemplateArgs = {
  input: CreatePolicyTemplateInput;
};


export type MutationCreateQuickPayArgs = {
  input: CreateQuickPayInput;
};


export type MutationCreateQuickPayPaymentIntentArgs = {
  input: CreateQuickPayPaymentIntentInput;
};


export type MutationCreateRecurringPaymentArgs = {
  input: CreateRecurringPaymentInput;
};


export type MutationCreateRefundArgs = {
  input: CreateRefundInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateServiceAccountWebhookArgs = {
  input: CreateServiceAccountWebhookInput;
};


export type MutationCreateSetupIntentArgs = {
  input: CreateSetupIntentInput;
};


export type MutationCreateTransferArgs = {
  input: CreateTransferInput;
};


export type MutationCreateUpdateSetupIntentArgs = {
  input: CreateUpdateSetupIntentInput;
};


export type MutationDeactivateApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCardTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLineItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMediaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMobileSavedCardArgs = {
  customerRef: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationPaymentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePayoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePolicyDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePolicyTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTransferArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDenyRefundArgs = {
  input: DenyRefundInput;
};


export type MutationDeprecatePolicyDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDetachPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDownloadPaidApiPaymentReceiptArgs = {
  accessKey: Scalars['String']['input'];
};


export type MutationDownloadPaidInvoiceReceiptArgs = {
  accessKey: Scalars['String']['input'];
};


export type MutationDownloadTransferReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDownloadUnpaidApiPaymentReceiptArgs = {
  accessKey: Scalars['String']['input'];
};


export type MutationDownloadUnpaidInvoiceReceiptArgs = {
  accessKey: Scalars['String']['input'];
};


export type MutationExpireDisputeArgs = {
  input: ExpireDisputeInput;
};


export type MutationFlagPaymentArgs = {
  input: FlagPaymentInput;
};


export type MutationGenerateApiKeyArgs = {
  input: GenerateApiKeyInput;
};


export type MutationGenerateInvoicePdfArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationGenerateTransferPdfArgs = {
  transferId: Scalars['ID']['input'];
};


export type MutationGrantPermissionToRoleArgs = {
  input: GrantPermissionInput;
};


export type MutationGrantPermissionsToRoleArgs = {
  input: GrantPermissionsInput;
};


export type MutationInitQuickPaymentArgs = {
  input: InitQuickPaymentInput;
};


export type MutationInviteBankUserArgs = {
  input: InviteBankUserInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationManualProcessRefundArgs = {
  input: ManualProcessRefundInput;
};


export type MutationManuallyApproveInvoiceArgs = {
  input: ManuallyApproveInvoiceInput;
};


export type MutationMobileRequestRefundArgs = {
  input: MobileRequestRefundInput;
};


export type MutationOnboardBankArgs = {
  input: OnboardBankInput;
};


export type MutationOnboardOrganizationArgs = {
  input: OnboardOrganizationInput;
};


export type MutationPauseQuickPayArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPauseRecurringPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformAdminSignInArgs = {
  input: LoginInput;
};


export type MutationProcessApiPaymentArgs = {
  input: ProcessApiPaymentInput;
};


export type MutationProcessInvoicePaymentArgs = {
  input: ProcessInvoicePaymentInput;
};


export type MutationProcessQuickPayPaymentArgs = {
  input: ProcessQuickPayPaymentInput;
};


export type MutationProcessRefundArgs = {
  input: ProcessRefundInput;
};


export type MutationRecordDisputeWithdrawalArgs = {
  input: RecordDisputeWithdrawalInput;
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationReinstateBankAccountArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectBankAccountArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectRefundArgs = {
  input: RejectRefundInput;
};


export type MutationRemoveDefaultPolicyArgs = {
  policyType: PolicyType;
};


export type MutationRemovePayoutsFromTransferArgs = {
  input: RemovePayoutsFromTransferInput;
};


export type MutationRemoveServiceAccountWebhookSubscriptionsArgs = {
  input: RemoveServiceAccountWebhookSubscriptionsInput;
};


export type MutationRemoveWebhookSubscriptionsArgs = {
  input: RemoveWebhookSubscriptionsInput;
};


export type MutationReorderLineItemsArgs = {
  input: ReorderLineItemsInput;
};


export type MutationRequestEmailVerificationOtpArgs = {
  input: RequestEmailVerificationOtpInput;
};


export type MutationRequestLoginOtpArgs = {
  input: RequestLoginOtpInput;
};


export type MutationRequestMagicLinkArgs = {
  input: RequestMagicLinkInput;
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestPasswordResetOtpArgs = {
  input: RequestPasswordResetOtpInput;
};


export type MutationResendEmailVerificationArgs = {
  input: ResendEmailVerificationInput;
};


export type MutationResendInvitationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetPasswordWithOtpArgs = {
  input: ResetPasswordWithOtpInput;
};


export type MutationResolveDisputeArgs = {
  input: ResolveDisputeInput;
};


export type MutationRestoreOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestorePermissionToRoleArgs = {
  input: RestorePermissionInput;
};


export type MutationResumeRecurringPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryWebhookDeliveryArgs = {
  input: RetryWebhookDeliveryInput;
};


export type MutationRevokePermissionFromRoleArgs = {
  input: RevokePermissionInput;
};


export type MutationRotateServiceAccountWebhookSecretArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSavePaymentMethodArgs = {
  input: SavePaymentMethodInput;
};


export type MutationSendDisputeReceivedMerchantNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendInvoiceEmailArgs = {
  input: SendInvoiceEmailInput;
};


export type MutationSetBankSupportedChannelsArgs = {
  bankId: Scalars['ID']['input'];
  channels: Array<PaymentChannel>;
};


export type MutationSetDefaultPaymentMethodArgs = {
  customerID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetDefaultPolicyArgs = {
  input: SetDefaultPolicyInput;
};


export type MutationSetOrganizationDonationEligibilityArgs = {
  canReceiveDonation: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationSetPrimaryBankAccountArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationSignUpUserArgs = {
  input: SignUpUserInput;
};


export type MutationSplitPayoutArgs = {
  input: SplitPayoutInput;
};


export type MutationSubmitDisputeEvidenceArgs = {
  input: SubmitDisputeEvidenceInput;
};


export type MutationSubmitTransferArgs = {
  input: SubmitTransferInput;
};


export type MutationSuspendBankAccountArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSyncRolePermissionsArgs = {
  input: SyncRolePermissionsInput;
};


export type MutationUnassignRoleFromUserArgs = {
  input: UnassignRoleInput;
};


export type MutationUnflagPaymentArgs = {
  input: UnflagPaymentInput;
};


export type MutationUpdateApiKeyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateApiKeyInput;
};


export type MutationUpdateBankAccountDetailsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBankAccountDetailsInput;
};


export type MutationUpdateBillingAddressArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBillingAddressInput;
};


export type MutationUpdateBusinessArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateCardTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCardTypeInput;
};


export type MutationUpdateDisputeProgressArgs = {
  input: UpdateDisputeProgressInput;
};


export type MutationUpdateInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInvoiceInput;
};


export type MutationUpdateLineItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLineItemInput;
};


export type MutationUpdateMediaArgs = {
  input: UpdateMediaInput;
};


export type MutationUpdateMerchantWebhookArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMerchantWebhookInput;
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationPaymentTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationPaymentTypeInput;
};


export type MutationUpdateOrganizationStatusArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: OrganizationStatus;
};


export type MutationUpdatePaymentProviderArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePaymentProviderInput;
};


export type MutationUpdatePaymentTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePaymentTypeInput;
};


export type MutationUpdatePermissionGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePermissionGroupInput;
};


export type MutationUpdatePolicyDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePolicyDocumentInput;
};


export type MutationUpdatePolicyTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePolicyTemplateInput;
};


export type MutationUpdateQuickPayArgs = {
  id: Scalars['ID']['input'];
  input: UpdateQuickPayInput;
};


export type MutationUpdateRecurringPaymentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRecurringPaymentInput;
};


export type MutationUpdateRecurringPaymentMethodArgs = {
  input: UpdateRecurringPaymentMethodInput;
};


export type MutationUpdateRefundArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRefundInput;
};


export type MutationUpdateRoleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRoleInput;
};


export type MutationUpdateServiceAccountWebhookArgs = {
  id: Scalars['ID']['input'];
  input: UpdateServiceAccountWebhookInput;
};


export type MutationUpdateServiceAccountWebhookSubscriptionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateServiceAccountWebhookSubscriptionInput;
};


export type MutationUpdateTransferNotesArgs = {
  input: UpdateTransferNotesInput;
};


export type MutationUpdateUserProfileArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserProfileInput;
};


export type MutationUpdateUserStatusArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: UserStatus;
};


export type MutationUpdateWebhookSubscriptionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWebhookSubscriptionInput;
};


export type MutationVerifyBankAccountArgs = {
  input: VerifyBankAccountInput;
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyEmailWithOtpArgs = {
  input: VerifyEmailWithOtpInput;
};


export type MutationVerifyLoginOtpArgs = {
  input: VerifyLoginOtpInput;
};


export type MutationVerifyMagicLinkArgs = {
  input: VerifyMagicLinkInput;
};


export type MutationVerifyOtpArgs = {
  input: VerifyOtpInput;
};


export type MutationVoidInvoiceArgs = {
  id: Scalars['ID']['input'];
};

export const OtpPurpose = {
  EmailVerification: 'EMAIL_VERIFICATION',
  PasswordlessLogin: 'PASSWORDLESS_LOGIN',
  PasswordReset: 'PASSWORD_RESET'
} as const;

export type OtpPurpose = typeof OtpPurpose[keyof typeof OtpPurpose];
export type OnBoardMerchantBankAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  bankId: Scalars['ID']['input'];
  type: BankAccountType;
};

export type OnboardBankInput = {
  address?: InputMaybe<Scalars['Map']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  owner: OnboardBankOwnerInput;
  phoneNumber: Scalars['String']['input'];
  /** Defaults to [WEB, MOBILE] when omitted */
  supportedChannels?: InputMaybe<Array<PaymentChannel>>;
};

/** The bank's first owner user, created during onboarding and invited by email */
export type OnboardBankOwnerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardBankPayload = {
  errors: Maybe<Array<Error>>;
  organization: Maybe<Organization>;
  /** The created owner user (invited by email, IsOwner) */
  owner: Maybe<User>;
};

export type OnboardOrganizationInput = {
  address: Scalars['Map']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  industry?: InputMaybe<OrganizationIndustry>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  mccCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  otherIndustry?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  primaryAccount: OnBoardMerchantBankAccountInput;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type Organization = {
  address: Maybe<Scalars['Map']['output']>;
  canReceiveDonation: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['Map']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  industry: Maybe<OrganizationIndustry>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  logo: Maybe<Media>;
  mccCode: Maybe<Scalars['String']['output']>;
  merchantProcessingFee: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  otherIndustry: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  refundPolicyTerms: OrganizationRefundPolicyTerms;
  status: OrganizationStatus;
  supportedChannels: Array<PaymentChannel>;
  type: OrganizationType;
  updatedAt: Scalars['Time']['output'];
  users: Array<User>;
  website: Maybe<Scalars['String']['output']>;
};

export type OrganizationConnection = {
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationEdge = {
  cursor: Scalars['String']['output'];
  node: Organization;
};

export const OrganizationIndustry = {
  Airlines: 'AIRLINES',
  Bank: 'BANK',
  CsoNgo: 'CSO_NGO',
  ECommerce: 'E_COMMERCE',
  Government: 'GOVERNMENT',
  Hotel: 'HOTEL',
  Other: 'OTHER',
  Retail: 'RETAIL',
  Tourism: 'TOURISM'
} as const;

export type OrganizationIndustry = typeof OrganizationIndustry[keyof typeof OrganizationIndustry];
export type OrganizationOrderByField = {
  direction: SortOrder;
  field: OrganizationOrderField;
};

export const OrganizationOrderField = {
  CreatedAt: 'CREATED_AT',
  Email: 'EMAIL',
  Industry: 'INDUSTRY',
  Name: 'NAME',
  Status: 'STATUS',
  Type: 'TYPE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type OrganizationOrderField = typeof OrganizationOrderField[keyof typeof OrganizationOrderField];
export type OrganizationPaymentType = {
  CreatedAt: Scalars['Time']['output'];
  Enabled: Scalars['Boolean']['output'];
  Organization: Organization;
  OrganizationId: Scalars['ID']['output'];
  PaymentContext: OrganizationPaymentTypeContext;
  PaymentProviderPaymentType: PaymentProviderPaymentType;
  PaymentProviderPaymentTypeId: Scalars['ID']['output'];
  UpdatedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
};

export const OrganizationPaymentTypeContext = {
  Api: 'API',
  Invoice: 'INVOICE',
  Recurring: 'RECURRING'
} as const;

export type OrganizationPaymentTypeContext = typeof OrganizationPaymentTypeContext[keyof typeof OrganizationPaymentTypeContext];
/**
 * OrganizationPaymentTypeWhereInput is used for filtering OrganizationPaymentType objects.
 * Input was generated by ent.
 */
export type OrganizationPaymentTypeWhereInput = {
  and?: InputMaybe<Array<OrganizationPaymentTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** payment_provider_payment_type edge predicates */
  hasPaymentProviderPaymentType?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentProviderPaymentTypeWith?: InputMaybe<Array<PaymentProviderPaymentTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OrganizationPaymentTypeWhereInput>;
  or?: InputMaybe<Array<OrganizationPaymentTypeWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** payment_context field predicates */
  paymentContext?: InputMaybe<OrganizationPaymentTypeContext>;
  paymentContextIn?: InputMaybe<Array<OrganizationPaymentTypeContext>>;
  paymentContextNEQ?: InputMaybe<OrganizationPaymentTypeContext>;
  paymentContextNotIn?: InputMaybe<Array<OrganizationPaymentTypeContext>>;
  /** payment_provider_payment_type_id field predicates */
  paymentProviderPaymentTypeID?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderPaymentTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentProviderPaymentTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderPaymentTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export const OrganizationRefundPolicyTerms = {
  FullRefund: 'FULL_REFUND',
  NoRefund: 'NO_REFUND',
  ProcessingFeeNotRefunded: 'PROCESSING_FEE_NOT_REFUNDED'
} as const;

export type OrganizationRefundPolicyTerms = typeof OrganizationRefundPolicyTerms[keyof typeof OrganizationRefundPolicyTerms];
export type OrganizationSortInput = {
  orderBy: Array<OrganizationOrderByField>;
};

export const OrganizationStatus = {
  Active: 'ACTIVE',
  BankAccountPending: 'BANK_ACCOUNT_PENDING',
  Closed: 'CLOSED',
  Rejected: 'REJECTED',
  Suspended: 'SUSPENDED'
} as const;

export type OrganizationStatus = typeof OrganizationStatus[keyof typeof OrganizationStatus];
export const OrganizationType = {
  Bank: 'BANK',
  Merchant: 'MERCHANT',
  Platform: 'PLATFORM'
} as const;

export type OrganizationType = typeof OrganizationType[keyof typeof OrganizationType];
/**
 * OrganizationWhereInput is used for filtering Organization objects.
 * Input was generated by ent.
 */
export type OrganizationWhereInput = {
  and?: InputMaybe<Array<OrganizationWhereInput>>;
  /** can_receive_donation field predicates */
  canReceiveDonation?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveDonationNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** country field predicates */
  country?: InputMaybe<Scalars['String']['input']>;
  countryContains?: InputMaybe<Scalars['String']['input']>;
  countryContainsFold?: InputMaybe<Scalars['String']['input']>;
  countryEqualFold?: InputMaybe<Scalars['String']['input']>;
  countryGT?: InputMaybe<Scalars['String']['input']>;
  countryGTE?: InputMaybe<Scalars['String']['input']>;
  countryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  countryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  countryLT?: InputMaybe<Scalars['String']['input']>;
  countryLTE?: InputMaybe<Scalars['String']['input']>;
  countryNEQ?: InputMaybe<Scalars['String']['input']>;
  countryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** api_keys edge predicates */
  hasAPIKeys?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPIKeysWith?: InputMaybe<Array<ApiKeyWhereInput>>;
  /** api_logs edge predicates */
  hasAPILogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPILogsWith?: InputMaybe<Array<ApiLogWhereInput>>;
  /** api_payments edge predicates */
  hasAPIPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPIPaymentsWith?: InputMaybe<Array<ApiPaymentWhereInput>>;
  /** bank_policy_acceptances edge predicates */
  hasBankPolicyAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasBankPolicyAcceptancesWith?: InputMaybe<Array<MerchantPolicyAcceptanceWhereInput>>;
  /** created_policies edge predicates */
  hasCreatedPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedPoliciesWith?: InputMaybe<Array<PolicyDocumentWhereInput>>;
  /** customers edge predicates */
  hasCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomersWith?: InputMaybe<Array<CustomerWhereInput>>;
  /** default_policies edge predicates */
  hasDefaultPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasDefaultPoliciesWith?: InputMaybe<Array<MerchantDefaultPolicyWhereInput>>;
  /** disputes edge predicates */
  hasDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  hasDisputesWith?: InputMaybe<Array<DisputeWhereInput>>;
  /** events edge predicates */
  hasEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasEventsWith?: InputMaybe<Array<EventWhereInput>>;
  /** invoices edge predicates */
  hasInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoicesWith?: InputMaybe<Array<InvoiceWhereInput>>;
  /** managed_bank_accounts edge predicates */
  hasManagedBankAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasManagedBankAccountsWith?: InputMaybe<Array<MerchantBankAccountWhereInput>>;
  /** merchant_bank_accounts edge predicates */
  hasMerchantBankAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantBankAccountsWith?: InputMaybe<Array<MerchantBankAccountWhereInput>>;
  /** payment_types edge predicates */
  hasPaymentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentTypesWith?: InputMaybe<Array<OrganizationPaymentTypeWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<PayoutWhereInput>>;
  /** policy_acceptances edge predicates */
  hasPolicyAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyAcceptancesWith?: InputMaybe<Array<MerchantPolicyAcceptanceWhereInput>>;
  /** quick_pays edge predicates */
  hasQuickPays?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuickPaysWith?: InputMaybe<Array<QuickPayWhereInput>>;
  /** recurring_payments edge predicates */
  hasRecurringPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecurringPaymentsWith?: InputMaybe<Array<RecurringPaymentWhereInput>>;
  /** roles edge predicates */
  hasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolesWith?: InputMaybe<Array<RoleWhereInput>>;
  /** transfers edge predicates */
  hasTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  hasTransfersWith?: InputMaybe<Array<TransferWhereInput>>;
  /** users edge predicates */
  hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** webhooks edge predicates */
  hasWebhooks?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebhooksWith?: InputMaybe<Array<MerchantWebhookWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** industry field predicates */
  industry?: InputMaybe<OrganizationIndustry>;
  industryIn?: InputMaybe<Array<OrganizationIndustry>>;
  industryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  industryNEQ?: InputMaybe<OrganizationIndustry>;
  industryNotIn?: InputMaybe<Array<OrganizationIndustry>>;
  industryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** license_number field predicates */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  licenseNumberContains?: InputMaybe<Scalars['String']['input']>;
  licenseNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  licenseNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  licenseNumberGT?: InputMaybe<Scalars['String']['input']>;
  licenseNumberGTE?: InputMaybe<Scalars['String']['input']>;
  licenseNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  licenseNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  licenseNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  licenseNumberLT?: InputMaybe<Scalars['String']['input']>;
  licenseNumberLTE?: InputMaybe<Scalars['String']['input']>;
  licenseNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  licenseNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mcc_code field predicates */
  mccCode?: InputMaybe<Scalars['String']['input']>;
  mccCodeContains?: InputMaybe<Scalars['String']['input']>;
  mccCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  mccCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  mccCodeGT?: InputMaybe<Scalars['String']['input']>;
  mccCodeGTE?: InputMaybe<Scalars['String']['input']>;
  mccCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  mccCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  mccCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mccCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mccCodeLT?: InputMaybe<Scalars['String']['input']>;
  mccCodeLTE?: InputMaybe<Scalars['String']['input']>;
  mccCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  mccCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mccCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<OrganizationWhereInput>;
  or?: InputMaybe<Array<OrganizationWhereInput>>;
  /** other_industry field predicates */
  otherIndustry?: InputMaybe<Scalars['String']['input']>;
  otherIndustryContains?: InputMaybe<Scalars['String']['input']>;
  otherIndustryContainsFold?: InputMaybe<Scalars['String']['input']>;
  otherIndustryEqualFold?: InputMaybe<Scalars['String']['input']>;
  otherIndustryGT?: InputMaybe<Scalars['String']['input']>;
  otherIndustryGTE?: InputMaybe<Scalars['String']['input']>;
  otherIndustryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  otherIndustryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  otherIndustryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  otherIndustryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  otherIndustryLT?: InputMaybe<Scalars['String']['input']>;
  otherIndustryLTE?: InputMaybe<Scalars['String']['input']>;
  otherIndustryNEQ?: InputMaybe<Scalars['String']['input']>;
  otherIndustryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  otherIndustryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** phone_number field predicates */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberContains?: InputMaybe<Scalars['String']['input']>;
  phoneNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberGT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberGTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumberLT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberLTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  phoneNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_policy_terms field predicates */
  refundPolicyTerms?: InputMaybe<OrganizationRefundPolicyTerms>;
  refundPolicyTermsIn?: InputMaybe<Array<OrganizationRefundPolicyTerms>>;
  refundPolicyTermsNEQ?: InputMaybe<OrganizationRefundPolicyTerms>;
  refundPolicyTermsNotIn?: InputMaybe<Array<OrganizationRefundPolicyTerms>>;
  /** status field predicates */
  status?: InputMaybe<OrganizationStatus>;
  statusIn?: InputMaybe<Array<OrganizationStatus>>;
  statusNEQ?: InputMaybe<OrganizationStatus>;
  statusNotIn?: InputMaybe<Array<OrganizationStatus>>;
  /** type field predicates */
  type?: InputMaybe<OrganizationType>;
  typeIn?: InputMaybe<Array<OrganizationType>>;
  typeNEQ?: InputMaybe<OrganizationType>;
  typeNotIn?: InputMaybe<Array<OrganizationType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** website field predicates */
  website?: InputMaybe<Scalars['String']['input']>;
  websiteContains?: InputMaybe<Scalars['String']['input']>;
  websiteContainsFold?: InputMaybe<Scalars['String']['input']>;
  websiteEqualFold?: InputMaybe<Scalars['String']['input']>;
  websiteGT?: InputMaybe<Scalars['String']['input']>;
  websiteGTE?: InputMaybe<Scalars['String']['input']>;
  websiteHasPrefix?: InputMaybe<Scalars['String']['input']>;
  websiteHasSuffix?: InputMaybe<Scalars['String']['input']>;
  websiteIn?: InputMaybe<Array<Scalars['String']['input']>>;
  websiteIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  websiteLT?: InputMaybe<Scalars['String']['input']>;
  websiteLTE?: InputMaybe<Scalars['String']['input']>;
  websiteNEQ?: InputMaybe<Scalars['String']['input']>;
  websiteNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  websiteNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageInfo = {
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PauseQuickPayPayload = {
  errors: Maybe<Array<Error>>;
  quickPay: Maybe<QuickPay>;
};

export type PauseRecurringPaymentPayload = {
  errors: Maybe<Array<Error>>;
  recurringPayment: Maybe<RecurringPayment>;
};

export type Payment = {
  amount: Scalars['Float']['output'];
  apiPayment: Maybe<ApiPayment>;
  cardBrand: Maybe<Scalars['String']['output']>;
  cardLast4: Maybe<Scalars['String']['output']>;
  cardType: Maybe<CardType>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Currency;
  customerEmail: Maybe<Scalars['String']['output']>;
  customerName: Maybe<Scalars['String']['output']>;
  environment: PaymentEnvironment;
  flag_reason: Maybe<Scalars['Map']['output']>;
  id: Scalars['ID']['output'];
  invoice: Maybe<Invoice>;
  is_flagged: Maybe<Scalars['Boolean']['output']>;
  merchantProcessingFee: Scalars['Float']['output'];
  merchantReceives: Scalars['Float']['output'];
  netAmount: Scalars['Float']['output'];
  organization: Maybe<Organization>;
  owner_id: Scalars['ID']['output'];
  paymentMethodType: Maybe<Scalars['String']['output']>;
  paymentProvider: PaymentProvider;
  paymentType: PaymentType;
  platformFee: Scalars['Float']['output'];
  providerCustomerId: Maybe<Scalars['String']['output']>;
  providerDeclineCode: Maybe<Scalars['String']['output']>;
  providerErrorCode: Maybe<Scalars['String']['output']>;
  providerErrorMessage: Maybe<Scalars['String']['output']>;
  providerFee: Maybe<Scalars['Float']['output']>;
  providerMetadata: Scalars['Map']['output'];
  providerPaymentMethodId: Maybe<Scalars['String']['output']>;
  providerTransactionId: Maybe<Scalars['String']['output']>;
  quickPay: Maybe<QuickPay>;
  recurringPayment: Maybe<RecurringPayment>;
  responseCode: Maybe<Scalars['String']['output']>;
  responseCodeDescription: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
  totalFees: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  walletType: Maybe<Scalars['String']['output']>;
};

export type PaymentAnalytics = {
  averageTransactionAmount: Scalars['Float']['output'];
  date: Scalars['Time']['output'];
  failedCount: Scalars['Int']['output'];
  grossRevenue: Scalars['Float']['output'];
  merchantNet: Scalars['Float']['output'];
  period: Scalars['String']['output'];
  platformRevenue: Scalars['Float']['output'];
  processingFees: Scalars['Float']['output'];
  providerFees: Scalars['Float']['output'];
  successRate: Scalars['Float']['output'];
  successfulCount: Scalars['Int']['output'];
  transactionCount: Scalars['Int']['output'];
};

export const PaymentChannel = {
  Mobile: 'MOBILE',
  Web: 'WEB'
} as const;

export type PaymentChannel = typeof PaymentChannel[keyof typeof PaymentChannel];
export type PaymentConnection = {
  edges: Array<PaymentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaymentEdge = {
  cursor: Scalars['String']['output'];
  node: Payment;
};

export const PaymentEnvironment = {
  Live: 'LIVE',
  Test: 'TEST'
} as const;

export type PaymentEnvironment = typeof PaymentEnvironment[keyof typeof PaymentEnvironment];
export type PaymentFailureAnalysis = {
  declineCode: Maybe<Scalars['String']['output']>;
  errorCode: Scalars['String']['output'];
  errorMessage: Maybe<Scalars['String']['output']>;
  occurrenceCount: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type PaymentFeeBreakdown = {
  gatewayFeeAmount: Scalars['Float']['output'];
  gatewayFeeRate: Scalars['Float']['output'];
  gatewayFeeType: Scalars['String']['output'];
  merchantFeeAmount: Scalars['Float']['output'];
  merchantFeePercent: Scalars['Float']['output'];
  platformFeeAmount: Scalars['Float']['output'];
  platformFeePercent: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterMerchant: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type PaymentMethod = {
  cardBrand: Maybe<Scalars['String']['output']>;
  cardExpiryMonth: Maybe<Scalars['Int']['output']>;
  cardExpiryYear: Maybe<Scalars['Int']['output']>;
  cardLast4: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  customer: Customer;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  metadata: Scalars['Map']['output'];
  paymentProvider: PaymentProvider;
  providerCustomerID: Maybe<Scalars['String']['output']>;
  providerPaymentMethodID: Scalars['String']['output'];
  status: PaymentMethodStatus;
  type: PaymentType;
  updatedAt: Scalars['Time']['output'];
};

export type PaymentMethodConnection = {
  edges: Array<PaymentMethodEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaymentMethodEdge = {
  cursor: Scalars['Cursor']['output'];
  node: PaymentMethod;
};

export type PaymentMethodOrderBy = {
  direction: SortOrder;
  field: PaymentMethodOrderField;
};

export const PaymentMethodOrderField = {
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  Type: 'TYPE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PaymentMethodOrderField = typeof PaymentMethodOrderField[keyof typeof PaymentMethodOrderField];
export const PaymentMethodStatus = {
  Active: 'ACTIVE',
  Expired: 'EXPIRED',
  Failed: 'FAILED',
  Removed: 'REMOVED'
} as const;

export type PaymentMethodStatus = typeof PaymentMethodStatus[keyof typeof PaymentMethodStatus];
/**
 * PaymentMethodWhereInput is used for filtering PaymentMethod objects.
 * Input was generated by ent.
 */
export type PaymentMethodWhereInput = {
  and?: InputMaybe<Array<PaymentMethodWhereInput>>;
  /** bank_last4 field predicates */
  bankLast4?: InputMaybe<Scalars['String']['input']>;
  bankLast4Contains?: InputMaybe<Scalars['String']['input']>;
  bankLast4ContainsFold?: InputMaybe<Scalars['String']['input']>;
  bankLast4EqualFold?: InputMaybe<Scalars['String']['input']>;
  bankLast4GT?: InputMaybe<Scalars['String']['input']>;
  bankLast4GTE?: InputMaybe<Scalars['String']['input']>;
  bankLast4HasPrefix?: InputMaybe<Scalars['String']['input']>;
  bankLast4HasSuffix?: InputMaybe<Scalars['String']['input']>;
  bankLast4In?: InputMaybe<Array<Scalars['String']['input']>>;
  bankLast4IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bankLast4LT?: InputMaybe<Scalars['String']['input']>;
  bankLast4LTE?: InputMaybe<Scalars['String']['input']>;
  bankLast4NEQ?: InputMaybe<Scalars['String']['input']>;
  bankLast4NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bankLast4NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bank_name field predicates */
  bankName?: InputMaybe<Scalars['String']['input']>;
  bankNameContains?: InputMaybe<Scalars['String']['input']>;
  bankNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  bankNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  bankNameGT?: InputMaybe<Scalars['String']['input']>;
  bankNameGTE?: InputMaybe<Scalars['String']['input']>;
  bankNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bankNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bankNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bankNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bankNameLT?: InputMaybe<Scalars['String']['input']>;
  bankNameLTE?: InputMaybe<Scalars['String']['input']>;
  bankNameNEQ?: InputMaybe<Scalars['String']['input']>;
  bankNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bankNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** card_brand field predicates */
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardBrandContains?: InputMaybe<Scalars['String']['input']>;
  cardBrandContainsFold?: InputMaybe<Scalars['String']['input']>;
  cardBrandEqualFold?: InputMaybe<Scalars['String']['input']>;
  cardBrandGT?: InputMaybe<Scalars['String']['input']>;
  cardBrandGTE?: InputMaybe<Scalars['String']['input']>;
  cardBrandHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cardBrandHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cardBrandIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cardBrandIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cardBrandLT?: InputMaybe<Scalars['String']['input']>;
  cardBrandLTE?: InputMaybe<Scalars['String']['input']>;
  cardBrandNEQ?: InputMaybe<Scalars['String']['input']>;
  cardBrandNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cardBrandNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** card_exp_month field predicates */
  cardExpMonth?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthGT?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthGTE?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  cardExpMonthIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cardExpMonthLT?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthLTE?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthNEQ?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  cardExpMonthNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** card_exp_year field predicates */
  cardExpYear?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearGT?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearGTE?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  cardExpYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cardExpYearLT?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearLTE?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  cardExpYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** card_last4 field predicates */
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  cardLast4Contains?: InputMaybe<Scalars['String']['input']>;
  cardLast4ContainsFold?: InputMaybe<Scalars['String']['input']>;
  cardLast4EqualFold?: InputMaybe<Scalars['String']['input']>;
  cardLast4GT?: InputMaybe<Scalars['String']['input']>;
  cardLast4GTE?: InputMaybe<Scalars['String']['input']>;
  cardLast4HasPrefix?: InputMaybe<Scalars['String']['input']>;
  cardLast4HasSuffix?: InputMaybe<Scalars['String']['input']>;
  cardLast4In?: InputMaybe<Array<Scalars['String']['input']>>;
  cardLast4IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cardLast4LT?: InputMaybe<Scalars['String']['input']>;
  cardLast4LTE?: InputMaybe<Scalars['String']['input']>;
  cardLast4NEQ?: InputMaybe<Scalars['String']['input']>;
  cardLast4NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cardLast4NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** customer_id field predicates */
  customerID?: InputMaybe<Scalars['ID']['input']>;
  customerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  customerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** customer edge predicates */
  hasCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomerWith?: InputMaybe<Array<CustomerWhereInput>>;
  /** payment_provider edge predicates */
  hasPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentProviderWith?: InputMaybe<Array<PaymentProviderWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** recurring_payments edge predicates */
  hasRecurringPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecurringPaymentsWith?: InputMaybe<Array<RecurringPaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_default field predicates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PaymentMethodWhereInput>;
  or?: InputMaybe<Array<PaymentMethodWhereInput>>;
  /** payment_provider_id field predicates */
  paymentProviderID?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentProviderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** provider_customer_id field predicates */
  providerCustomerID?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDContains?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDGT?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCustomerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerCustomerIDLT?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCustomerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_payment_method_id field predicates */
  providerPaymentMethodID?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDContains?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDGT?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerPaymentMethodIDLT?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** status field predicates */
  status?: InputMaybe<PaymentMethodStatus>;
  statusIn?: InputMaybe<Array<PaymentMethodStatus>>;
  statusNEQ?: InputMaybe<PaymentMethodStatus>;
  statusNotIn?: InputMaybe<Array<PaymentMethodStatus>>;
  /** type field predicates */
  type?: InputMaybe<PaymentType>;
  typeIn?: InputMaybe<Array<PaymentType>>;
  typeNEQ?: InputMaybe<PaymentType>;
  typeNotIn?: InputMaybe<Array<PaymentType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentOrderBy = {
  direction: SortOrder;
  field: PaymentOrderField;
};

export const PaymentOrderField = {
  Amount: 'AMOUNT',
  CreatedAt: 'CREATED_AT',
  CustomerEmail: 'CUSTOMER_EMAIL',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PaymentOrderField = typeof PaymentOrderField[keyof typeof PaymentOrderField];
export type PaymentProvider = {
  apiLoginId: Maybe<Scalars['String']['output']>;
  cardTypes: Array<PaymentProviderCardType>;
  configProfile: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['Map']['output']>;
  environment: PaymentEnvironment;
  id: Scalars['ID']['output'];
  isAutoRefundSupported: Scalars['Boolean']['output'];
  logoMedia: Maybe<Media>;
  name: Scalars['String']['output'];
  paymentTypes: Array<PaymentProviderPaymentType>;
  priority: Scalars['Int']['output'];
  publicKey: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: ProviderStatus;
  /** Client channels this provider serves; routing skips it for other channels */
  supportedChannels: Array<PaymentChannel>;
  supportedCurrencies: Array<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type PaymentProviderCardType = {
  createdAt: Scalars['Time']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentProvider: PaymentProvider;
  paymentProviderId: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  type: CardType;
  updatedAt: Scalars['Time']['output'];
};

/**
 * PaymentProviderCardTypeWhereInput is used for filtering PaymentProviderCardType objects.
 * Input was generated by ent.
 */
export type PaymentProviderCardTypeWhereInput = {
  and?: InputMaybe<Array<PaymentProviderCardTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** payment_provider edge predicates */
  hasPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentProviderWith?: InputMaybe<Array<PaymentProviderWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<PaymentProviderCardTypeWhereInput>;
  or?: InputMaybe<Array<PaymentProviderCardTypeWhereInput>>;
  /** payment_provider_id field predicates */
  paymentProviderID?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentProviderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** priority field predicates */
  priority?: InputMaybe<Scalars['Int']['input']>;
  priorityGT?: InputMaybe<Scalars['Int']['input']>;
  priorityGTE?: InputMaybe<Scalars['Int']['input']>;
  priorityIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  priorityLT?: InputMaybe<Scalars['Int']['input']>;
  priorityLTE?: InputMaybe<Scalars['Int']['input']>;
  priorityNEQ?: InputMaybe<Scalars['Int']['input']>;
  priorityNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** type field predicates */
  type?: InputMaybe<CardType>;
  typeIn?: InputMaybe<Array<CardType>>;
  typeNEQ?: InputMaybe<CardType>;
  typeNotIn?: InputMaybe<Array<CardType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentProviderConnection = {
  edges: Array<PaymentProviderEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaymentProviderEdge = {
  cursor: Scalars['String']['output'];
  node: PaymentProvider;
};

export type PaymentProviderOrderByField = {
  direction: SortOrder;
  field: PaymentProviderOrderField;
};

export const PaymentProviderOrderField = {
  CreatedAt: 'CREATED_AT',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PaymentProviderOrderField = typeof PaymentProviderOrderField[keyof typeof PaymentProviderOrderField];
export type PaymentProviderPaymentType = {
  createdAt: Scalars['Time']['output'];
  enabled: Scalars['Boolean']['output'];
  gatewayFeeType: FeeType;
  gatewayFees: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentProvider: PaymentProvider;
  paymentProviderId: Scalars['ID']['output'];
  platformFeeType: FeeType;
  platformFees: Scalars['Float']['output'];
  supportedCurrencies: Array<Scalars['String']['output']>;
  type: PaymentType;
  updatedAt: Scalars['Time']['output'];
};

/**
 * PaymentProviderPaymentTypeWhereInput is used for filtering PaymentProviderPaymentType objects.
 * Input was generated by ent.
 */
export type PaymentProviderPaymentTypeWhereInput = {
  and?: InputMaybe<Array<PaymentProviderPaymentTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** gateway_fee_type field predicates */
  gatewayFeeType?: InputMaybe<FeeType>;
  gatewayFeeTypeIn?: InputMaybe<Array<FeeType>>;
  gatewayFeeTypeNEQ?: InputMaybe<FeeType>;
  gatewayFeeTypeNotIn?: InputMaybe<Array<FeeType>>;
  /** gateway_fees field predicates */
  gatewayFees?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesGT?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesGTE?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  gatewayFeesLT?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesLTE?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesNEQ?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** organization_payment_types edge predicates */
  hasOrganizationPaymentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationPaymentTypesWith?: InputMaybe<Array<OrganizationPaymentTypeWhereInput>>;
  /** payment_provider edge predicates */
  hasPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentProviderWith?: InputMaybe<Array<PaymentProviderWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<PaymentProviderPaymentTypeWhereInput>;
  or?: InputMaybe<Array<PaymentProviderPaymentTypeWhereInput>>;
  /** payment_provider_id field predicates */
  paymentProviderID?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentProviderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** platform_fee_type field predicates */
  platformFeeType?: InputMaybe<FeeType>;
  platformFeeTypeIn?: InputMaybe<Array<FeeType>>;
  platformFeeTypeNEQ?: InputMaybe<FeeType>;
  platformFeeTypeNotIn?: InputMaybe<Array<FeeType>>;
  /** platform_fees field predicates */
  platformFees?: InputMaybe<Scalars['Float']['input']>;
  platformFeesGT?: InputMaybe<Scalars['Float']['input']>;
  platformFeesGTE?: InputMaybe<Scalars['Float']['input']>;
  platformFeesIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  platformFeesLT?: InputMaybe<Scalars['Float']['input']>;
  platformFeesLTE?: InputMaybe<Scalars['Float']['input']>;
  platformFeesNEQ?: InputMaybe<Scalars['Float']['input']>;
  platformFeesNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** supports_recurring field predicates */
  supportsRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRecurringNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** type field predicates */
  type?: InputMaybe<PaymentType>;
  typeIn?: InputMaybe<Array<PaymentType>>;
  typeNEQ?: InputMaybe<PaymentType>;
  typeNotIn?: InputMaybe<Array<PaymentType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentProviderSortInput = {
  orderBy: Array<PaymentProviderOrderByField>;
};

/**
 * PaymentProviderWhereInput is used for filtering PaymentProvider objects.
 * Input was generated by ent.
 */
export type PaymentProviderWhereInput = {
  and?: InputMaybe<Array<PaymentProviderWhereInput>>;
  /** config_profile field predicates */
  configProfile?: InputMaybe<Scalars['String']['input']>;
  configProfileContains?: InputMaybe<Scalars['String']['input']>;
  configProfileContainsFold?: InputMaybe<Scalars['String']['input']>;
  configProfileEqualFold?: InputMaybe<Scalars['String']['input']>;
  configProfileGT?: InputMaybe<Scalars['String']['input']>;
  configProfileGTE?: InputMaybe<Scalars['String']['input']>;
  configProfileHasPrefix?: InputMaybe<Scalars['String']['input']>;
  configProfileHasSuffix?: InputMaybe<Scalars['String']['input']>;
  configProfileIn?: InputMaybe<Array<Scalars['String']['input']>>;
  configProfileLT?: InputMaybe<Scalars['String']['input']>;
  configProfileLTE?: InputMaybe<Scalars['String']['input']>;
  configProfileNEQ?: InputMaybe<Scalars['String']['input']>;
  configProfileNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** card_types edge predicates */
  hasCardTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasCardTypesWith?: InputMaybe<Array<PaymentProviderCardTypeWhereInput>>;
  /** logo_media edge predicates */
  hasLogoMedia?: InputMaybe<Scalars['Boolean']['input']>;
  hasLogoMediaWith?: InputMaybe<Array<MediaWhereInput>>;
  /** payment_methods edge predicates */
  hasPaymentMethods?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentMethodsWith?: InputMaybe<Array<PaymentMethodWhereInput>>;
  /** payment_types edge predicates */
  hasPaymentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentTypesWith?: InputMaybe<Array<PaymentProviderPaymentTypeWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_auto_refund_supported field predicates */
  isAutoRefundSupported?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRefundSupportedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** logo_media_id field predicates */
  logoMediaID?: InputMaybe<Scalars['ID']['input']>;
  logoMediaIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  logoMediaIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  logoMediaIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  logoMediaIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  logoMediaIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<PaymentProviderWhereInput>;
  or?: InputMaybe<Array<PaymentProviderWhereInput>>;
  /** priority field predicates */
  priority?: InputMaybe<Scalars['Int']['input']>;
  priorityGT?: InputMaybe<Scalars['Int']['input']>;
  priorityGTE?: InputMaybe<Scalars['Int']['input']>;
  priorityIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  priorityLT?: InputMaybe<Scalars['Int']['input']>;
  priorityLTE?: InputMaybe<Scalars['Int']['input']>;
  priorityNEQ?: InputMaybe<Scalars['Int']['input']>;
  priorityNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** slug field predicates */
  slug?: InputMaybe<Scalars['String']['input']>;
  slugContains?: InputMaybe<Scalars['String']['input']>;
  slugContainsFold?: InputMaybe<Scalars['String']['input']>;
  slugEqualFold?: InputMaybe<Scalars['String']['input']>;
  slugGT?: InputMaybe<Scalars['String']['input']>;
  slugGTE?: InputMaybe<Scalars['String']['input']>;
  slugHasPrefix?: InputMaybe<Scalars['String']['input']>;
  slugHasSuffix?: InputMaybe<Scalars['String']['input']>;
  slugIn?: InputMaybe<Array<Scalars['String']['input']>>;
  slugLT?: InputMaybe<Scalars['String']['input']>;
  slugLTE?: InputMaybe<Scalars['String']['input']>;
  slugNEQ?: InputMaybe<Scalars['String']['input']>;
  slugNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** status field predicates */
  status?: InputMaybe<ProviderStatus>;
  statusIn?: InputMaybe<Array<ProviderStatus>>;
  statusNEQ?: InputMaybe<ProviderStatus>;
  statusNotIn?: InputMaybe<Array<ProviderStatus>>;
  /** supports_recurring_payments field predicates */
  supportsRecurringPayments?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRecurringPaymentsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export const PaymentReportField = {
  CardNumber: 'CARD_NUMBER',
  CardScheme: 'CARD_SCHEME',
  CreatedAt: 'CREATED_AT',
  Currency: 'CURRENCY',
  CustomerEmail: 'CUSTOMER_EMAIL',
  CustomerName: 'CUSTOMER_NAME',
  Environment: 'ENVIRONMENT',
  MerchantCode: 'MERCHANT_CODE',
  MerchantProcessingFee: 'MERCHANT_PROCESSING_FEE',
  OrganizationCode: 'ORGANIZATION_CODE',
  OrganizationName: 'ORGANIZATION_NAME',
  PaymentCode: 'PAYMENT_CODE',
  PaymentType: 'PAYMENT_TYPE',
  PlatformFee: 'PLATFORM_FEE',
  ProviderDeclineCode: 'PROVIDER_DECLINE_CODE',
  ProviderErrorCode: 'PROVIDER_ERROR_CODE',
  ProviderErrorMessage: 'PROVIDER_ERROR_MESSAGE',
  ProviderFee: 'PROVIDER_FEE',
  ProviderTransactionId: 'PROVIDER_TRANSACTION_ID',
  ResponseCode: 'RESPONSE_CODE',
  ResponseCodeDescription: 'RESPONSE_CODE_DESCRIPTION',
  Status: 'STATUS',
  TransactionAmount: 'TRANSACTION_AMOUNT',
  TransactionTimestamp: 'TRANSACTION_TIMESTAMP'
} as const;

export type PaymentReportField = typeof PaymentReportField[keyof typeof PaymentReportField];
export const PaymentStatus = {
  Failed: 'FAILED',
  Pending: 'PENDING',
  Succeeded: 'SUCCEEDED'
} as const;

export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];
export type PaymentSummary = {
  averageAmount: Scalars['Float']['output'];
  failedCount: Scalars['Int']['output'];
  failureRate: Scalars['Float']['output'];
  pendingCount: Scalars['Int']['output'];
  succeededCount: Scalars['Int']['output'];
  successRate: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalMerchantFees: Scalars['Float']['output'];
  totalPayments: Scalars['Int']['output'];
  totalPlatformFees: Scalars['Float']['output'];
  totalProviderFees: Scalars['Float']['output'];
};

export const PaymentType = {
  Ach: 'ACH',
  Bank: 'BANK',
  Card: 'CARD',
  Other: 'OTHER',
  Wallet: 'WALLET'
} as const;

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];
export type PaymentTypeFilter = {
  maxGatewayFees?: InputMaybe<Scalars['Float']['input']>;
  maxPlatformFees?: InputMaybe<Scalars['Float']['input']>;
  minGatewayFees?: InputMaybe<Scalars['Float']['input']>;
  minPlatformFees?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<PaymentType>;
};

/**
 * PaymentWhereInput is used for filtering Payment objects.
 * Input was generated by ent.
 */
export type PaymentWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<PaymentWhereInput>>;
  /** api_payment_id field predicates */
  apiPaymentID?: InputMaybe<Scalars['ID']['input']>;
  apiPaymentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  apiPaymentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiPaymentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  apiPaymentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  apiPaymentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** card_type field predicates */
  cardType?: InputMaybe<CardType>;
  cardTypeIn?: InputMaybe<Array<CardType>>;
  cardTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cardTypeNEQ?: InputMaybe<CardType>;
  cardTypeNotIn?: InputMaybe<Array<CardType>>;
  cardTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Currency>;
  currencyIn?: InputMaybe<Array<Currency>>;
  currencyNEQ?: InputMaybe<Currency>;
  currencyNotIn?: InputMaybe<Array<Currency>>;
  /** customer_email field predicates */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerEmailContains?: InputMaybe<Scalars['String']['input']>;
  customerEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerEmailGT?: InputMaybe<Scalars['String']['input']>;
  customerEmailGTE?: InputMaybe<Scalars['String']['input']>;
  customerEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerEmailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerEmailLT?: InputMaybe<Scalars['String']['input']>;
  customerEmailLTE?: InputMaybe<Scalars['String']['input']>;
  customerEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  customerEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerEmailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_id field predicates */
  customerID?: InputMaybe<Scalars['ID']['input']>;
  customerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  customerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_name field predicates */
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerNameContains?: InputMaybe<Scalars['String']['input']>;
  customerNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerNameGT?: InputMaybe<Scalars['String']['input']>;
  customerNameGTE?: InputMaybe<Scalars['String']['input']>;
  customerNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerNameLT?: InputMaybe<Scalars['String']['input']>;
  customerNameLTE?: InputMaybe<Scalars['String']['input']>;
  customerNameNEQ?: InputMaybe<Scalars['String']['input']>;
  customerNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** api_payment edge predicates */
  hasAPIPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPIPaymentWith?: InputMaybe<Array<ApiPaymentWhereInput>>;
  /** customer edge predicates */
  hasCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomerWith?: InputMaybe<Array<CustomerWhereInput>>;
  /** disputes edge predicates */
  hasDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  hasDisputesWith?: InputMaybe<Array<DisputeWhereInput>>;
  /** invoice edge predicates */
  hasInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoiceWith?: InputMaybe<Array<InvoiceWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** payment_method edge predicates */
  hasPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentMethodWith?: InputMaybe<Array<PaymentMethodWhereInput>>;
  /** payment_provider edge predicates */
  hasPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentProviderWith?: InputMaybe<Array<PaymentProviderWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<PayoutWhereInput>>;
  /** quick_pay edge predicates */
  hasQuickPay?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuickPayWith?: InputMaybe<Array<QuickPayWhereInput>>;
  /** recurring_payment edge predicates */
  hasRecurringPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecurringPaymentWith?: InputMaybe<Array<RecurringPaymentWhereInput>>;
  /** refunds edge predicates */
  hasRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefundsWith?: InputMaybe<Array<RefundWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** idempotency_key field predicates */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyContains?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyGT?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyGTE?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotencyKeyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  idempotencyKeyLT?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyLTE?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotencyKeyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** invoice_id field predicates */
  invoiceID?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_flagged field predicates */
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  isFlaggedIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  isFlaggedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  isFlaggedNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  not?: InputMaybe<PaymentWhereInput>;
  or?: InputMaybe<Array<PaymentWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** payment_method_id field predicates */
  paymentMethodID?: InputMaybe<Scalars['ID']['input']>;
  paymentMethodIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentMethodIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentMethodIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentMethodIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** payment_provider_id field predicates */
  paymentProviderID?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentProviderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** payment_type field predicates */
  paymentType?: InputMaybe<PaymentType>;
  paymentTypeIn?: InputMaybe<Array<PaymentType>>;
  paymentTypeNEQ?: InputMaybe<PaymentType>;
  paymentTypeNotIn?: InputMaybe<Array<PaymentType>>;
  /** platform_fee field predicates */
  platformFee?: InputMaybe<Scalars['Float']['input']>;
  platformFeeGT?: InputMaybe<Scalars['Float']['input']>;
  platformFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  platformFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  platformFeeLT?: InputMaybe<Scalars['Float']['input']>;
  platformFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  platformFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  platformFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** provider_charge_id field predicates */
  providerChargeID?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDContains?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDGT?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerChargeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerChargeIDLT?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerChargeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_charged_processing_fee field predicates */
  providerChargedProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  providerChargedProcessingFeeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerChargedProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  providerChargedProcessingFeeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_customer_id field predicates */
  providerCustomerID?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDContains?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDGT?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCustomerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerCustomerIDLT?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCustomerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_decline_code field predicates */
  providerDeclineCode?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeContains?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeGT?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeGTE?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerDeclineCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerDeclineCodeLT?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeLTE?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerDeclineCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_error_code field predicates */
  providerErrorCode?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeContains?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeGT?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeGTE?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerErrorCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerErrorCodeLT?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeLTE?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerErrorCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_error_message field predicates */
  providerErrorMessage?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageContains?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageGT?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageGTE?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerErrorMessageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerErrorMessageLT?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageLTE?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageNEQ?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerErrorMessageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_fee field predicates */
  providerFee?: InputMaybe<Scalars['Float']['input']>;
  providerFeeGT?: InputMaybe<Scalars['Float']['input']>;
  providerFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  providerFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  providerFeeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerFeeLT?: InputMaybe<Scalars['Float']['input']>;
  providerFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  providerFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  providerFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  providerFeeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_payment_method_id field predicates */
  providerPaymentMethodID?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDContains?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDGT?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerPaymentMethodIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerPaymentMethodIDLT?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerPaymentMethodIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_transaction_id field predicates */
  providerTransactionID?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDContains?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDGT?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerTransactionIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerTransactionIDLT?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerTransactionIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** quick_pay_id field predicates */
  quickPayID?: InputMaybe<Scalars['ID']['input']>;
  quickPayIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  quickPayIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  quickPayIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  quickPayIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  quickPayIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** recurring_payment_id field predicates */
  recurringPaymentID?: InputMaybe<Scalars['ID']['input']>;
  recurringPaymentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  recurringPaymentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recurringPaymentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  recurringPaymentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  recurringPaymentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** response_code field predicates */
  responseCode?: InputMaybe<Scalars['String']['input']>;
  responseCodeContains?: InputMaybe<Scalars['String']['input']>;
  responseCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  /** response_code_description field predicates */
  responseCodeDescription?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseCodeDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseCodeDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseCodeDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseCodeGT?: InputMaybe<Scalars['String']['input']>;
  responseCodeGTE?: InputMaybe<Scalars['String']['input']>;
  responseCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseCodeLT?: InputMaybe<Scalars['String']['input']>;
  responseCodeLTE?: InputMaybe<Scalars['String']['input']>;
  responseCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  responseCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<PaymentStatus>;
  statusIn?: InputMaybe<Array<PaymentStatus>>;
  statusNEQ?: InputMaybe<PaymentStatus>;
  statusNotIn?: InputMaybe<Array<PaymentStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Payout = {
  amount: Scalars['Float']['output'];
  bankAccount: Maybe<MerchantBankAccount>;
  bankAccountId: Maybe<Scalars['ID']['output']>;
  code: Scalars['String']['output'];
  completedAt: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  currency: Currency;
  dispute: Maybe<Dispute>;
  disputeId: Maybe<Scalars['ID']['output']>;
  estimatedSettlementAt: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isSplit: Scalars['Boolean']['output'];
  notes: Maybe<Scalars['Map']['output']>;
  ownerId: Scalars['ID']['output'];
  parent_payout_id: Maybe<Scalars['ID']['output']>;
  payment: Payment;
  paymentId: Scalars['ID']['output'];
  payoutType: PayoutType;
  processedAt: Maybe<Scalars['Time']['output']>;
  receipt: Maybe<Media>;
  receiverMerchant: Organization;
  receivingMerchantId: Scalars['ID']['output'];
  refund: Maybe<Refund>;
  refundId: Maybe<Scalars['ID']['output']>;
  splitCount: Scalars['Int']['output'];
  status: PayoutStatus;
  transferCode: Maybe<Scalars['String']['output']>;
  transferId: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type PayoutBatchError = {
  error: Scalars['String']['output'];
  payoutCode: Scalars['String']['output'];
  payoutId: Scalars['ID']['output'];
};

export type PayoutConnection = {
  edges: Array<PayoutEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PayoutEdge = {
  cursor: Scalars['String']['output'];
  node: Payout;
};

export const PayoutHealthStatus = {
  Delayed: 'DELAYED',
  OnTrack: 'ON_TRACK',
  Stuck: 'STUCK'
} as const;

export type PayoutHealthStatus = typeof PayoutHealthStatus[keyof typeof PayoutHealthStatus];
export type PayoutOperationError = {
  code: Scalars['String']['output'];
  error: Scalars['String']['output'];
  payoutCode: Maybe<Scalars['String']['output']>;
  payoutId: Scalars['ID']['output'];
};

export type PayoutOrderByInput = {
  direction: SortOrder;
  field: PayoutOrderField;
};

export const PayoutOrderField = {
  Amount: 'AMOUNT',
  Code: 'CODE',
  CompletedAt: 'COMPLETED_AT',
  CreatedAt: 'CREATED_AT',
  ProcessedAt: 'PROCESSED_AT',
  Status: 'STATUS'
} as const;

export type PayoutOrderField = typeof PayoutOrderField[keyof typeof PayoutOrderField];
export type PayoutOverview = {
  /** Per-currency breakdown for hover popups */
  currencyBreakdown: Array<PayoutOverviewCurrencyBreakdown>;
  /** Primary currency used for card 3 display */
  primaryCurrency: Currency;
  /** Total COMPLETED payouts across all currencies (card 2 main number) */
  totalCompletedPayouts: Scalars['Int']['output'];
  /** Total PENDING payouts across all currencies (card 1 main number) */
  totalIncomingPayouts: Scalars['Int']['output'];
  /** Total COMPLETED payout amount in primary currency (card 3 main number) */
  totalPayoutAmount: Scalars['Float']['output'];
};

export type PayoutOverviewCurrencyBreakdown = {
  /** Sum of COMPLETED payout amounts for this currency */
  completedPayoutAmount: Scalars['Float']['output'];
  /** COMPLETED payout count for this currency */
  completedPayoutsCount: Scalars['Int']['output'];
  /** COMPLETED transfer count for this currency */
  completedTransferCount: Scalars['Int']['output'];
  currency: Currency;
  /** PENDING payout count for this currency */
  incomingPayoutsCount: Scalars['Int']['output'];
};

export type PayoutProcessingMetrics = {
  averageBankProcessingHours: Scalars['Float']['output'];
  averageHoursToComplete: Scalars['Float']['output'];
  averageHoursToProcess: Scalars['Float']['output'];
  completedCount: Scalars['Int']['output'];
  period: Scalars['String']['output'];
};

export const PayoutReportField = {
  Amount: 'AMOUNT',
  BankAccountId: 'BANK_ACCOUNT_ID',
  Code: 'CODE',
  CompletedAt: 'COMPLETED_AT',
  CreatedAt: 'CREATED_AT',
  Currency: 'CURRENCY',
  DisputeId: 'DISPUTE_ID',
  EstimatedSettlementAt: 'ESTIMATED_SETTLEMENT_AT',
  Notes: 'NOTES',
  ParentPayoutId: 'PARENT_PAYOUT_ID',
  PaymentId: 'PAYMENT_ID',
  PayoutType: 'PAYOUT_TYPE',
  ProcessedAt: 'PROCESSED_AT',
  ReceiverMerchantId: 'RECEIVER_MERCHANT_ID',
  RefundId: 'REFUND_ID',
  Status: 'STATUS',
  TransferId: 'TRANSFER_ID'
} as const;

export type PayoutReportField = typeof PayoutReportField[keyof typeof PayoutReportField];
export type PayoutSplitInput = {
  amount: Scalars['Float']['input'];
  bankAccountId: Scalars['ID']['input'];
  merchantId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export const PayoutStatus = {
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  Pending: 'PENDING',
  Processing: 'PROCESSING'
} as const;

export type PayoutStatus = typeof PayoutStatus[keyof typeof PayoutStatus];
export type PayoutSummary = {
  count: Scalars['Int']['output'];
  currency: Currency;
  newestPayoutDate: Maybe<Scalars['Time']['output']>;
  oldestPayoutDate: Maybe<Scalars['Time']['output']>;
  status: PayoutStatus;
  totalAmount: Scalars['Float']['output'];
};

export const PayoutType = {
  Adjustment: 'ADJUSTMENT',
  DisputeReceived: 'DISPUTE_RECEIVED',
  DisputeRelease: 'DISPUTE_RELEASE',
  Payment: 'PAYMENT',
  RefundDeduction: 'REFUND_DEDUCTION',
  Split: 'SPLIT'
} as const;

export type PayoutType = typeof PayoutType[keyof typeof PayoutType];
/**
 * PayoutWhereInput is used for filtering Payout objects.
 * Input was generated by ent.
 */
export type PayoutWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<PayoutWhereInput>>;
  /** bank_account_id field predicates */
  bankAccountID?: InputMaybe<Scalars['ID']['input']>;
  bankAccountIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bankAccountIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bankAccountIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  bankAccountIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bankAccountIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** completed_at field predicates */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedAtGT?: InputMaybe<Scalars['Time']['input']>;
  completedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  completedAtLT?: InputMaybe<Scalars['Time']['input']>;
  completedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  completedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Currency>;
  currencyIn?: InputMaybe<Array<Currency>>;
  currencyNEQ?: InputMaybe<Currency>;
  currencyNotIn?: InputMaybe<Array<Currency>>;
  /** dispute_id field predicates */
  disputeID?: InputMaybe<Scalars['ID']['input']>;
  disputeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  disputeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  disputeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  disputeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  disputeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** estimated_settlement_at field predicates */
  estimatedSettlementAt?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtGT?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtGTE?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  estimatedSettlementAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  estimatedSettlementAtLT?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtLTE?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  estimatedSettlementAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bank_account edge predicates */
  hasBankAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasBankAccountWith?: InputMaybe<Array<MerchantBankAccountWhereInput>>;
  /** dispute edge predicates */
  hasDispute?: InputMaybe<Scalars['Boolean']['input']>;
  hasDisputeWith?: InputMaybe<Array<DisputeWhereInput>>;
  /** parent_payout edge predicates */
  hasParentPayout?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentPayoutWith?: InputMaybe<Array<PayoutWhereInput>>;
  /** payment edge predicates */
  hasPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** receiver_merchant edge predicates */
  hasReceiverMerchant?: InputMaybe<Scalars['Boolean']['input']>;
  hasReceiverMerchantWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** refund edge predicates */
  hasRefund?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefundWith?: InputMaybe<Array<RefundWhereInput>>;
  /** split_payouts edge predicates */
  hasSplitPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasSplitPayoutsWith?: InputMaybe<Array<PayoutWhereInput>>;
  /** transfer edge predicates */
  hasTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  hasTransferWith?: InputMaybe<Array<TransferWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PayoutWhereInput>;
  or?: InputMaybe<Array<PayoutWhereInput>>;
  /** parent_payout_id field predicates */
  parentPayoutID?: InputMaybe<Scalars['ID']['input']>;
  parentPayoutIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentPayoutIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentPayoutIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentPayoutIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentPayoutIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** payment_id field predicates */
  paymentID?: InputMaybe<Scalars['ID']['input']>;
  paymentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** payout_type field predicates */
  payoutType?: InputMaybe<PayoutType>;
  payoutTypeIn?: InputMaybe<Array<PayoutType>>;
  payoutTypeNEQ?: InputMaybe<PayoutType>;
  payoutTypeNotIn?: InputMaybe<Array<PayoutType>>;
  /** processed_at field predicates */
  processedAt?: InputMaybe<Scalars['Time']['input']>;
  processedAtGT?: InputMaybe<Scalars['Time']['input']>;
  processedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  processedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  processedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  processedAtLT?: InputMaybe<Scalars['Time']['input']>;
  processedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  processedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  processedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  processedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** receiver_merchant_id field predicates */
  receiverMerchantID?: InputMaybe<Scalars['ID']['input']>;
  receiverMerchantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  receiverMerchantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  receiverMerchantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** refund_id field predicates */
  refundID?: InputMaybe<Scalars['ID']['input']>;
  refundIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  refundIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  refundIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  refundIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<PayoutStatus>;
  statusIn?: InputMaybe<Array<PayoutStatus>>;
  statusNEQ?: InputMaybe<PayoutStatus>;
  statusNotIn?: InputMaybe<Array<PayoutStatus>>;
  /** transfer_id field predicates */
  transferID?: InputMaybe<Scalars['ID']['input']>;
  transferIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  transferIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  transferIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  transferIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  transferIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Permission = {
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['Map']['output']>;
  group: Maybe<PermissionGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissionFor: Maybe<Array<Maybe<PermissionFor>>>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type PermissionCheckResult = {
  contextMatches: Maybe<Scalars['Boolean']['output']>;
  grantedThrough: Maybe<Array<RolePermissionGrant>>;
  hasPermission: Scalars['Boolean']['output'];
  organizationType: Maybe<OrganizationType>;
};

export type PermissionConnection = {
  edges: Array<PermissionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionEdge = {
  cursor: Scalars['String']['output'];
  node: Permission;
};

export const PermissionFor = {
  Bank: 'BANK',
  Merchant: 'MERCHANT',
  Platform: 'PLATFORM'
} as const;

export type PermissionFor = typeof PermissionFor[keyof typeof PermissionFor];
export type PermissionGroup = {
  activePermissionCount: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['Map']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissionCount: Scalars['Int']['output'];
  permissionFor: Maybe<Array<Maybe<PermissionFor>>>;
  permissions: Array<Permission>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type PermissionGroupConnection = {
  edges: Array<PermissionGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionGroupEdge = {
  cursor: Scalars['String']['output'];
  node: PermissionGroup;
};

export type PermissionGroupOrderByField = {
  direction: SortOrder;
  field: PermissionGroupOrderField;
};

export const PermissionGroupOrderField = {
  CreatedAt: 'CREATED_AT',
  Name: 'NAME',
  Slug: 'SLUG',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PermissionGroupOrderField = typeof PermissionGroupOrderField[keyof typeof PermissionGroupOrderField];
export type PermissionGroupSortInput = {
  orderBy: Array<PermissionGroupOrderByField>;
};

/**
 * PermissionGroupWhereInput is used for filtering PermissionGroup objects.
 * Input was generated by ent.
 */
export type PermissionGroupWhereInput = {
  and?: InputMaybe<Array<PermissionGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** permissions edge predicates */
  hasPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermissionsWith?: InputMaybe<Array<PermissionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<PermissionGroupWhereInput>;
  or?: InputMaybe<Array<PermissionGroupWhereInput>>;
  /** Filter permission groups that contain this specific permission level */
  permissionForContains?: InputMaybe<PermissionFor>;
  /** Filter permission groups that contain ALL of the specified permission levels */
  permissionForHasAll?: InputMaybe<Array<PermissionFor>>;
  /** Filter permission groups that contain ANY of the specified permission levels */
  permissionForHasAny?: InputMaybe<Array<PermissionFor>>;
  /** Filter permission groups that do NOT contain this specific permission level */
  permissionForNotContains?: InputMaybe<PermissionFor>;
  /** slug field predicates */
  slug?: InputMaybe<Scalars['String']['input']>;
  slugContains?: InputMaybe<Scalars['String']['input']>;
  slugContainsFold?: InputMaybe<Scalars['String']['input']>;
  slugEqualFold?: InputMaybe<Scalars['String']['input']>;
  slugGT?: InputMaybe<Scalars['String']['input']>;
  slugGTE?: InputMaybe<Scalars['String']['input']>;
  slugHasPrefix?: InputMaybe<Scalars['String']['input']>;
  slugHasSuffix?: InputMaybe<Scalars['String']['input']>;
  slugIn?: InputMaybe<Array<Scalars['String']['input']>>;
  slugLT?: InputMaybe<Scalars['String']['input']>;
  slugLTE?: InputMaybe<Scalars['String']['input']>;
  slugNEQ?: InputMaybe<Scalars['String']['input']>;
  slugNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PermissionOrderByField = {
  direction: SortOrder;
  field: PermissionOrderField;
};

export const PermissionOrderField = {
  CreatedAt: 'CREATED_AT',
  GroupId: 'GROUP_ID',
  Name: 'NAME',
  PermissionFor: 'PERMISSION_FOR',
  Slug: 'SLUG',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PermissionOrderField = typeof PermissionOrderField[keyof typeof PermissionOrderField];
export type PermissionRole = {
  grantedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  permission: Permission;
  revokedAt: Maybe<Scalars['Time']['output']>;
  role: Role;
};

export type PermissionRoleConnection = {
  edges: Array<PermissionRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionRoleEdge = {
  cursor: Scalars['String']['output'];
  node: PermissionRole;
};

/**
 * PermissionRoleWhereInput is used for filtering PermissionRole objects.
 * Input was generated by ent.
 */
export type PermissionRoleWhereInput = {
  and?: InputMaybe<Array<PermissionRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PermissionRoleWhereInput>;
  or?: InputMaybe<Array<PermissionRoleWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PermissionSortInput = {
  orderBy: Array<PermissionOrderByField>;
};

/**
 * PermissionWhereInput is used for filtering Permission objects.
 * Input was generated by ent.
 */
export type PermissionWhereInput = {
  and?: InputMaybe<Array<PermissionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** group_id field predicates */
  groupID?: InputMaybe<Scalars['ID']['input']>;
  groupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  groupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  groupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** group edge predicates */
  hasGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasGroupWith?: InputMaybe<Array<PermissionGroupWhereInput>>;
  /** permission_roles edge predicates */
  hasPermissionRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermissionRolesWith?: InputMaybe<Array<PermissionRoleWhereInput>>;
  /** roles edge predicates */
  hasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolesWith?: InputMaybe<Array<RoleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<PermissionWhereInput>;
  or?: InputMaybe<Array<PermissionWhereInput>>;
  /** Filter permission groups that contain this specific permission level */
  permissionForContains?: InputMaybe<PermissionFor>;
  /** Filter permission groups that contain ALL of the specified permission levels */
  permissionForHasAll?: InputMaybe<Array<PermissionFor>>;
  /** Filter permission groups that contain ANY of the specified permission levels */
  permissionForHasAny?: InputMaybe<Array<PermissionFor>>;
  /** Filter permission groups that do NOT contain this specific permission level */
  permissionForNotContains?: InputMaybe<PermissionFor>;
  /** slug field predicates */
  slug?: InputMaybe<Scalars['String']['input']>;
  slugContains?: InputMaybe<Scalars['String']['input']>;
  slugContainsFold?: InputMaybe<Scalars['String']['input']>;
  slugEqualFold?: InputMaybe<Scalars['String']['input']>;
  slugGT?: InputMaybe<Scalars['String']['input']>;
  slugGTE?: InputMaybe<Scalars['String']['input']>;
  slugHasPrefix?: InputMaybe<Scalars['String']['input']>;
  slugHasSuffix?: InputMaybe<Scalars['String']['input']>;
  slugIn?: InputMaybe<Array<Scalars['String']['input']>>;
  slugLT?: InputMaybe<Scalars['String']['input']>;
  slugLTE?: InputMaybe<Scalars['String']['input']>;
  slugNEQ?: InputMaybe<Scalars['String']['input']>;
  slugNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PolicyDocument = {
  acceptanceCount: Scalars['Int']['output'];
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  content: Scalars['Map']['output'];
  createdAt: Scalars['Time']['output'];
  createdByOrg: Maybe<Organization>;
  createdByOrgType: OrganizationType;
  deprecatedAt: Maybe<Scalars['Time']['output']>;
  effectiveDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  parentPolicy: Maybe<PolicyDocument>;
  policyTarget: PolicyTarget;
  policyType: PolicyType;
  template: Maybe<PolicyTemplate>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  version: Scalars['String']['output'];
};

export type PolicyDocumentConnection = {
  edges: Array<PolicyDocumentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PolicyDocumentEdge = {
  cursor: Scalars['String']['output'];
  node: PolicyDocument;
};

/**
 * PolicyDocumentWhereInput is used for filtering PolicyDocument objects.
 * Input was generated by ent.
 */
export type PolicyDocumentWhereInput = {
  and?: InputMaybe<Array<PolicyDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_org_id field predicates */
  createdByOrgID?: InputMaybe<Scalars['ID']['input']>;
  createdByOrgIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByOrgIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByOrgIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByOrgIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByOrgIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by_org_type field predicates */
  createdByOrgType?: InputMaybe<OrganizationType>;
  createdByOrgTypeIn?: InputMaybe<Array<OrganizationType>>;
  createdByOrgTypeNEQ?: InputMaybe<OrganizationType>;
  createdByOrgTypeNotIn?: InputMaybe<Array<OrganizationType>>;
  /** deprecated_at field predicates */
  deprecatedAt?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deprecatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deprecatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** child_policies edge predicates */
  hasChildPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildPoliciesWith?: InputMaybe<Array<PolicyDocumentWhereInput>>;
  /** created_by_organization edge predicates */
  hasCreatedByOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** merchant_acceptances edge predicates */
  hasMerchantAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantAcceptancesWith?: InputMaybe<Array<MerchantPolicyAcceptanceWhereInput>>;
  /** merchant_defaults edge predicates */
  hasMerchantDefaults?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantDefaultsWith?: InputMaybe<Array<MerchantDefaultPolicyWhereInput>>;
  /** parent_policy edge predicates */
  hasParentPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentPolicyWith?: InputMaybe<Array<PolicyDocumentWhereInput>>;
  /** template edge predicates */
  hasTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemplateWith?: InputMaybe<Array<PolicyTemplateWhereInput>>;
  /** user_acceptances edge predicates */
  hasUserAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserAcceptancesWith?: InputMaybe<Array<UserPolicyAcceptanceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_current field predicates */
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PolicyDocumentWhereInput>;
  or?: InputMaybe<Array<PolicyDocumentWhereInput>>;
  /** parent_policy_id field predicates */
  parentPolicyID?: InputMaybe<Scalars['ID']['input']>;
  parentPolicyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentPolicyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentPolicyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentPolicyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentPolicyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** policy_target field predicates */
  policyTarget?: InputMaybe<PolicyTarget>;
  policyTargetIn?: InputMaybe<Array<PolicyTarget>>;
  policyTargetNEQ?: InputMaybe<PolicyTarget>;
  policyTargetNotIn?: InputMaybe<Array<PolicyTarget>>;
  /** policy_type field predicates */
  policyType?: InputMaybe<PolicyType>;
  policyTypeIn?: InputMaybe<Array<PolicyType>>;
  policyTypeNEQ?: InputMaybe<PolicyType>;
  policyTypeNotIn?: InputMaybe<Array<PolicyType>>;
  /** template_id field predicates */
  templateID?: InputMaybe<Scalars['ID']['input']>;
  templateIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  templateIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  templateIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** version field predicates */
  version?: InputMaybe<Scalars['String']['input']>;
  versionContains?: InputMaybe<Scalars['String']['input']>;
  versionContainsFold?: InputMaybe<Scalars['String']['input']>;
  versionEqualFold?: InputMaybe<Scalars['String']['input']>;
  versionGT?: InputMaybe<Scalars['String']['input']>;
  versionGTE?: InputMaybe<Scalars['String']['input']>;
  versionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  versionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  versionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  versionLT?: InputMaybe<Scalars['String']['input']>;
  versionLTE?: InputMaybe<Scalars['String']['input']>;
  versionNEQ?: InputMaybe<Scalars['String']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export const PolicyTarget = {
  Customer: 'CUSTOMER',
  EndUser: 'END_USER',
  Merchant: 'MERCHANT'
} as const;

export type PolicyTarget = typeof PolicyTarget[keyof typeof PolicyTarget];
export type PolicyTemplate = {
  canEdit: Scalars['Boolean']['output'];
  content: Scalars['Map']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  policyType: PolicyType;
  updatedAt: Scalars['Time']['output'];
  usageCount: Scalars['Int']['output'];
};

export type PolicyTemplateConnection = {
  edges: Array<PolicyTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PolicyTemplateEdge = {
  cursor: Scalars['String']['output'];
  node: PolicyTemplate;
};

/**
 * PolicyTemplateWhereInput is used for filtering PolicyTemplate objects.
 * Input was generated by ent.
 */
export type PolicyTemplateWhereInput = {
  and?: InputMaybe<Array<PolicyTemplateWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** policies_created edge predicates */
  hasPoliciesCreated?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesCreatedWith?: InputMaybe<Array<PolicyDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<PolicyTemplateWhereInput>;
  or?: InputMaybe<Array<PolicyTemplateWhereInput>>;
  /** policy_type field predicates */
  policyType?: InputMaybe<PolicyType>;
  policyTypeIn?: InputMaybe<Array<PolicyType>>;
  policyTypeNEQ?: InputMaybe<PolicyType>;
  policyTypeNotIn?: InputMaybe<Array<PolicyType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export const PolicyType = {
  BankTermsOfService: 'BANK_TERMS_OF_SERVICE',
  CancellationPolicy: 'CANCELLATION_POLICY',
  PaymentTerms: 'PAYMENT_TERMS',
  PlatformPrivacyPolicy: 'PLATFORM_PRIVACY_POLICY',
  PlatformTermsAndConditions: 'PLATFORM_TERMS_AND_CONDITIONS',
  PlatformTermsOfService: 'PLATFORM_TERMS_OF_SERVICE',
  RefundPolicy: 'REFUND_POLICY'
} as const;

export type PolicyType = typeof PolicyType[keyof typeof PolicyType];
export type ProcessApiPaymentInput = {
  apiPaymentAccessKey: Scalars['String']['input'];
  cardType?: InputMaybe<CardType>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  paymentMethodToken: Scalars['String']['input'];
  paymentType: PaymentType;
};

export type ProcessApiPaymentPayload = {
  alreadyProcessed: Scalars['Boolean']['output'];
  apiPayment: Maybe<ApiPayment>;
  errors: Maybe<Array<Error>>;
  feeBreakdown: Maybe<PaymentFeeBreakdown>;
  payment: Maybe<Payment>;
};

export type ProcessInvoicePaymentInput = {
  cardType?: InputMaybe<CardType>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  invoiceAccessKey: Scalars['String']['input'];
  paymentMethodToken: Scalars['String']['input'];
  paymentType: PaymentType;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessInvoicePaymentPayload = {
  alreadyProcessed: Scalars['Boolean']['output'];
  errors: Maybe<Array<Error>>;
  feeBreakdown: Maybe<PaymentFeeBreakdown>;
  invoice: Maybe<Invoice>;
  payment: Maybe<Payment>;
};

export type ProcessQuickPayPaymentInput = {
  amount: Scalars['Float']['input'];
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<CardType>;
  customerEmail: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  paymentMethodToken: Scalars['String']['input'];
  paymentType: PaymentType;
  quickPayAccessKey: Scalars['String']['input'];
};

export type ProcessQuickPayPaymentPayload = {
  alreadyProcessed: Scalars['Boolean']['output'];
  errors: Maybe<Array<Error>>;
  feeBreakdown: Maybe<PaymentFeeBreakdown>;
  payment: Maybe<Payment>;
  quickPay: Maybe<QuickPay>;
};

export type ProcessRefundInput = {
  id: Scalars['ID']['input'];
};

export type ProcessRefundPayload = {
  errors: Maybe<Array<Error>>;
  refund: Maybe<Refund>;
};

export const ProductServiceType = {
  DigitalGoods: 'DIGITAL_GOODS',
  Other: 'OTHER',
  PhysicalGoods: 'PHYSICAL_GOODS',
  Services: 'SERVICES',
  Subscription: 'SUBSCRIPTION'
} as const;

export type ProductServiceType = typeof ProductServiceType[keyof typeof ProductServiceType];
export type ProviderDoc = {
  Name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: DownloadUrl;
};

export type ProviderPerformance = {
  averageAmount: Scalars['Float']['output'];
  failedPayments: Scalars['Int']['output'];
  provider: PaymentProvider;
  successRate: Scalars['Float']['output'];
  successfulPayments: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Int']['output'];
  totalProviderFees: Scalars['Float']['output'];
};

export const ProviderStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Maintenance: 'MAINTENANCE'
} as const;

export type ProviderStatus = typeof ProviderStatus[keyof typeof ProviderStatus];
export const QrCodeFormat = {
  Png: 'PNG',
  Svg: 'SVG'
} as const;

export type QrCodeFormat = typeof QrCodeFormat[keyof typeof QrCodeFormat];
export type QrCodePayload = {
  /** Format of the generated QR code */
  format: QrCodeFormat;
  /** Size of the generated QR code */
  size: QrCodeSize;
  /** CDN URL for the generated QR code image */
  url: Scalars['String']['output'];
};

export const QrCodeSize = {
  Large: 'LARGE',
  Medium: 'MEDIUM',
  Small: 'SMALL'
} as const;

export type QrCodeSize = typeof QrCodeSize[keyof typeof QrCodeSize];
export type Query = {
  DownloadDisputeReport: Maybe<DownloadDisputeReportPayload>;
  /** All merchant bank accounts pending bank admin action, across every bank (platform admin only) */
  allBanksPendingApprovals: Maybe<MerchantBankAccountConnection>;
  apiKey: Maybe<ApiKey>;
  apiKeys: Maybe<ApiKeyConnection>;
  apiLog: Maybe<ApiLog>;
  apiLogs: Maybe<ApiLogConnection>;
  apiPayment: Maybe<ApiPayment>;
  apiPaymentByAccessKey: Maybe<ApiPayment>;
  apiPaymentStats: Maybe<ApiPaymentStatistics>;
  apiPayments: Maybe<ApiPaymentConnection>;
  authContext: AuthContext;
  availablePayoutsForTransfer: Maybe<PayoutConnection>;
  /**
   * Get available payment types that support recurring/subscription payments.
   * Used on hosted checkout page to show customers which payment methods they can use for subscriptions.
   * Filters by active providers and enabled payment types that have supports_recurring = true.
   */
  availableRecurringPaymentTypes: Array<PaymentProviderPaymentType>;
  bankManagedAccounts: Maybe<MerchantBankAccountConnection>;
  bankPendingApprovals: Maybe<MerchantBankAccountConnection>;
  bankPendingRefunds: Maybe<RefundConnection>;
  bankTransfers: Maybe<TransferConnection>;
  /**
   * Paginated bank organizations (platform admin only). The type filter is
   * forced to BANK server-side regardless of the caller's where input. Unlike
   * the public getBanks picker, this is the management listing.
   */
  banks: Maybe<OrganizationConnection>;
  billingAddress: Maybe<BillingAddress>;
  billingAddresses: Maybe<BillingAddressConnection>;
  checkBankCompliance: Maybe<ComplianceStatus>;
  checkMerchantCompliance: Maybe<ComplianceStatus>;
  checkUserCompliance: UserComplianceStatus;
  checkUserPermission: Maybe<PermissionCheckResult>;
  currentBankPolicies: Maybe<Array<PolicyDocument>>;
  currentOrganization: Maybe<Organization>;
  currentPlatformPolicies: Maybe<Array<PolicyDocument>>;
  customerPaymentHistory: Maybe<CustomerPaymentHistory>;
  defaultQuickPay: QuickPay;
  dispute: Maybe<Dispute>;
  disputes: Maybe<DisputeConnection>;
  downloadDailyPaymentReport: Maybe<DownloadDailyReportPayload>;
  downloadMerchantReport: Maybe<DownloadMerchantReportPayload>;
  downloadPaymentReceipt: Maybe<DownloadPaymentReceiptPayload>;
  downloadPaymentReport: Maybe<DownloadPaymentReportPayload>;
  downloadPayoutReport: Maybe<DownloadPayoutReportPayload>;
  downloadRefundReport: Maybe<DownloadRefundReportPayload>;
  downloadTransferReport: Maybe<DownloadTransferReportPayload>;
  effectivePolicyForInvoice: Maybe<PolicyDocument>;
  entityHistory: Maybe<EventConnection>;
  event: Maybe<Event>;
  events: Maybe<EventConnection>;
  getApiPaymentSuccessResponseUrl: Maybe<ApiPaymentSuccessResponseUrlPayload>;
  getAvailableRefundAmount: Maybe<Scalars['Float']['output']>;
  getBanks: Maybe<Array<Maybe<Organization>>>;
  getRecurringPaymentByCheckoutSession: RecurringPayment;
  /**
   * Get recurring payment details for the update payment method page.
   * No auth — validated via update_session_id.
   */
  getRecurringPaymentByUpdateSession: RecurringPayment;
  getUploadPresignUrl: UploadUrl;
  introspectToken: IntrospectTokenPayload;
  invoice: Maybe<Invoice>;
  invoiceByAccessKey: Maybe<Invoice>;
  /**
   * Generate/retrieve QR code for a paylink by access key.
   * Unauthenticated — access gated by knowledge of UUID access key.
   */
  invoiceQRCode: QrCodePayload;
  invoiceSummary: Maybe<InvoiceSummary>;
  invoices: Maybe<InvoiceConnection>;
  manuallyPaidInvoicesWithoutPayout: Maybe<InvoiceConnection>;
  me: Maybe<User>;
  media: Maybe<Media>;
  merchantBankAccount: Maybe<MerchantBankAccount>;
  merchantBankAccounts: Maybe<MerchantBankAccountConnection>;
  merchantBankAccountsList: Maybe<MerchantBankAccountConnection>;
  merchantDefaultPolicies: Maybe<Array<MerchantDefaultPolicy>>;
  merchantDisputes: Maybe<DisputeConnection>;
  merchantInvoices: Maybe<InvoiceConnection>;
  merchantPayments: Maybe<PaymentConnection>;
  /**
   * Merchant payout summary cards — Total Paid Out and Available Payouts.
   * Returns one item per currency. Optionally filter to specific currencies.
   */
  merchantPayoutDashboard: MerchantPayoutDashboard;
  merchantPayouts: Maybe<PayoutConnection>;
  merchantPolicyAcceptances: Maybe<MerchantPolicyAcceptanceConnection>;
  merchantPrimaryBankAccount: Maybe<MerchantBankAccount>;
  merchantQuickPays: QuickPayConnection;
  merchantRefunds: Maybe<RefundConnection>;
  merchantWebhook: Maybe<MerchantWebhook>;
  merchantWebhooks: Maybe<MerchantWebhookConnection>;
  merchantpermissions: PermissionConnection;
  /** All disputes on the payer's payments, newest first. Service-account only. */
  mobileCustomerDisputes: Array<MobileDispute>;
  /** Header stats + filter-sheet bounds for the payer. Service-account only. */
  mobileCustomerTransactionSummary: MobileCustomerTxnSummary;
  /**
   * The payer's transaction feed across every merchant, resolved by the
   * customer external_id (= mobile backend user ID). Service-account only.
   */
  mobileCustomerTransactions: MobileTxnList;
  /**
   * ACTIVE merchants with canReceiveDonation enabled, a payable default
   * QuickPay, and an APPROVED bank account at a bank that settles the given
   * payment channel (the mobile backend passes MOBILE).
   */
  mobileDonationOrganizations: Array<MobileDonationOrganization>;
  /**
   * The window collapsed into a single 24-hour profile, answering "when is the
   * shop busy". Always exactly 24 rows, hour 0 through 23, zeros included:
   * the domain is fixed, so completing it here saves every caller the padding.
   * Service-account only.
   */
  mobileMerchantActivityByHour: Array<MobileMerchantActivityHour>;
  /** Merchant Insights header: revenue, sales, known customers, refunds. Service-account only. */
  mobileMerchantInsightsSummary: MobileMerchantInsightsSummary;
  /**
   * Revenue bucketed by hour/day/month/year in Asia/Thimphu. Sparse — see
   * MobileMerchantRevenueSeries. Service-account only.
   */
  mobileMerchantRevenueSeries: MobileMerchantRevenueSeries;
  /** Header stats + filter bounds for a merchant org. Service-account only. */
  mobileMerchantTransactionSummary: MobileCustomerTxnSummary;
  /**
   * A merchant organization's received feed (payments in, refunds out). The org
   * ID is asserted by the trusted mobile backend from its own validated merchant
   * session. Service-account only.
   */
  mobileMerchantTransactions: MobileTxnList;
  mobileOrganization: Maybe<Organization>;
  /**
   * Signed download URL for a succeeded payment's receipt PDF, generated and
   * cached on first request. Null while the payment is not succeeded. The
   * payment ID is asserted by the trusted mobile backend from an entry it
   * already fetched for the requesting user. Service-account only.
   */
  mobilePaymentReceipt: Maybe<DownloadUrl>;
  /** List a mobile user's saved cards (service-account only) */
  mobileSavedCards: Array<MobileSavedCard>;
  myDefaultPolicies: Maybe<Array<MerchantDefaultPolicy>>;
  myMerchantPolicies: Maybe<Array<PolicyDocument>>;
  myOrganizationAcceptances: Maybe<Array<MerchantPolicyAcceptance>>;
  myPolicyAcceptances: Maybe<Array<UserPolicyAcceptance>>;
  organization: Maybe<Organization>;
  organizationAPIKeys: Maybe<ApiKeyConnection>;
  organizationAPIPayments: Maybe<ApiPaymentConnection>;
  organizationAuditLog: Maybe<EventConnection>;
  organizationPaymentType: Maybe<OrganizationPaymentType>;
  organizationPaymentTypes: Array<OrganizationPaymentType>;
  organizationRoles: Maybe<RoleConnection>;
  organizationUsers: UserConnection;
  organizations: Maybe<OrganizationConnection>;
  overdueInvoices: Maybe<InvoiceConnection>;
  payment: Maybe<Payment>;
  paymentAnalytics: Maybe<Array<PaymentAnalytics>>;
  paymentFailureAnalysis: Maybe<Array<PaymentFailureAnalysis>>;
  paymentPayouts: Maybe<Array<Payout>>;
  paymentProvider: Maybe<PaymentProvider>;
  /**
   * Get the highest priority active payment provider that supports the specified card type and payment type.
   * Optionally filter by currency. Returns null if no matching provider is found.
   * This query is typically used during checkout to determine the appropriate gateway for a specific card.
   */
  paymentProviderByCardType: Maybe<PaymentProvider>;
  paymentProviderCardType: Maybe<PaymentProviderCardType>;
  paymentProviderCardTypes: Array<PaymentProviderCardType>;
  paymentProviderPaymentType: Maybe<PaymentProviderPaymentType>;
  paymentProviderPaymentTypes: Array<PaymentProviderPaymentType>;
  paymentProviders: PaymentProviderConnection;
  paymentProvidersByType: Array<PaymentProvider>;
  paymentSummary: Maybe<PaymentSummary>;
  payments: Maybe<PaymentConnection>;
  payout: Maybe<Payout>;
  payoutOrganizations: Maybe<OrganizationConnection>;
  /**
   * Optional bankId filter — bank users pass their bank org ID to scope
   * payouts/transfers to their bank only. Platform admins omit for global view.
   */
  payoutOverview: PayoutOverview;
  payoutProcessingMetrics: Maybe<PayoutProcessingMetrics>;
  payoutSummary: Maybe<Array<PayoutSummary>>;
  payouts: Maybe<PayoutConnection>;
  permission: Maybe<Permission>;
  permissionGroup: Maybe<PermissionGroup>;
  permissionGroupBySlug: Maybe<PermissionGroup>;
  permissionGroups: PermissionGroupConnection;
  permissions: Maybe<PermissionConnection>;
  platformPendingRefunds: Maybe<RefundConnection>;
  policyDocument: Maybe<PolicyDocument>;
  policyDocumentVersionHistory: Maybe<Array<PolicyDocument>>;
  policyDocuments: Maybe<PolicyDocumentConnection>;
  policyTemplate: Maybe<PolicyTemplate>;
  policyTemplates: Maybe<PolicyTemplateConnection>;
  providerPerformance: Maybe<Array<ProviderPerformance>>;
  quickPay: QuickPay;
  quickPayByAccessKey: QuickPayPublic;
  /** Manual-entry fallback: resolve the human-readable code printed next to the QR */
  quickPayByCode: QuickPayPublic;
  quickPayFeeEstimate: QuickPayFeeEstimate;
  quickPays: QuickPayConnection;
  recentActivity: Array<Event>;
  recurringPayment: RecurringPayment;
  recurringPayments: RecurringPaymentConnection;
  refund: Maybe<Refund>;
  refundAnalytics: Maybe<RefundAnalytics>;
  refundSummary: Maybe<RefundSummary>;
  refunds: Maybe<RefundConnection>;
  revenueDashboard: Maybe<RevenueDashboard>;
  role: Maybe<Role>;
  rolePermissions: Maybe<PermissionRoleConnection>;
  roles: Maybe<RoleConnection>;
  searchPayments: Maybe<PaymentConnection>;
  serviceAccountWebhook: Maybe<ServiceAccountWebhook>;
  serviceAccountWebhooks: Maybe<ServiceAccountWebhookConnection>;
  /**
   * Lists all service accounts. Platform only — used by the admin dashboard to
   * pick a service account to attach a webhook to.
   */
  serviceAccounts: Array<ServiceAccount>;
  splitPayments: Maybe<SplitPaymentConnection>;
  transfer: Maybe<Transfer>;
  transferByCode: Maybe<Transfer>;
  transferSummary: Maybe<Array<TransferSummary>>;
  transfers: Maybe<TransferConnection>;
  user: Maybe<User>;
  userActivity: Maybe<EventConnection>;
  userPermissions: Maybe<PermissionConnection>;
  userPolicyAcceptances: Maybe<UserPolicyAcceptanceConnection>;
  userRoles: Maybe<UserRoleConnection>;
  users: UserConnection;
  verifyAccessToken: Maybe<SuccessPayload>;
  webhookDeliveries: WebhookDeliveryConnection;
  webhookDelivery: Maybe<WebhookDelivery>;
  webhookEventType: Maybe<WebhookEventType>;
  webhookEventTypes: Array<WebhookEventType>;
};


export type QueryDownloadDisputeReportArgs = {
  fields: Array<DisputeReportField>;
  where?: InputMaybe<DisputeWhereInput>;
};


export type QueryAllBanksPendingApprovalsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiKeysArgs = {
  orderBy?: InputMaybe<ApiKeyOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ApiKeyWhereInput>;
};


export type QueryApiLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiLogsArgs = {
  orderBy?: InputMaybe<ApiLogOrderByInput>;
  pagination: PaginationInput;
  where?: InputMaybe<ApiLogWhereInput>;
};


export type QueryApiPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiPaymentByAccessKeyArgs = {
  accessKey: Scalars['String']['input'];
};


export type QueryApiPaymentStatsArgs = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryApiPaymentsArgs = {
  orderBy?: InputMaybe<ApiPaymentOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<ApiPaymentWhereInput>;
};


export type QueryAvailablePayoutsForTransferArgs = {
  bankId: Scalars['ID']['input'];
  currency: Currency;
  orderBy?: InputMaybe<PayoutOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAvailableRecurringPaymentTypesArgs = {
  currency: Scalars['String']['input'];
  environment?: InputMaybe<PaymentEnvironment>;
};


export type QueryBankManagedAccountsArgs = {
  bankId: Scalars['ID']['input'];
  orderBy?: InputMaybe<MerchantBankAccountOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MerchantBankAccountWhereInput>;
};


export type QueryBankPendingApprovalsArgs = {
  bankId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBankPendingRefundsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBankTransfersArgs = {
  bankId: Scalars['ID']['input'];
  currency?: InputMaybe<Array<Currency>>;
  orderBy?: InputMaybe<TransferOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Array<TransferStatus>>;
};


export type QueryBanksArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<OrganizationSortInput>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type QueryBillingAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillingAddressesArgs = {
  orderBy?: InputMaybe<BillingAddressOrderByInput>;
  pagination: PaginationInput;
  where?: InputMaybe<BillingAddressWhereInput>;
};


export type QueryCheckBankComplianceArgs = {
  bankId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryCheckMerchantComplianceArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCheckUserPermissionArgs = {
  matchContext?: InputMaybe<Scalars['Boolean']['input']>;
  permissionSlug: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryCurrentBankPoliciesArgs = {
  bankId: Scalars['ID']['input'];
};


export type QueryCurrentPlatformPoliciesArgs = {
  target: PolicyTarget;
};


export type QueryCustomerPaymentHistoryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  customerEmail: Scalars['String']['input'];
  environment?: InputMaybe<PaymentEnvironment>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDisputeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDisputesArgs = {
  orderBy?: InputMaybe<DisputeOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<DisputeWhereInput>;
};


export type QueryDownloadDailyPaymentReportArgs = {
  date: Scalars['Time']['input'];
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryDownloadMerchantReportArgs = {
  fields: Array<MerchantReportField>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type QueryDownloadPaymentReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDownloadPaymentReportArgs = {
  fields: Array<PaymentReportField>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryDownloadPayoutReportArgs = {
  fields: Array<PayoutReportField>;
  where?: InputMaybe<PayoutWhereInput>;
};


export type QueryDownloadRefundReportArgs = {
  fields: Array<RefundReportField>;
  where?: InputMaybe<RefundWhereInput>;
};


export type QueryDownloadTransferReportArgs = {
  fields: Array<TransferReportField>;
  where?: InputMaybe<TransferWhereInput>;
};


export type QueryEffectivePolicyForInvoiceArgs = {
  organizationId: Scalars['ID']['input'];
  policyType: PolicyType;
};


export type QueryEntityHistoryArgs = {
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  orderBy?: InputMaybe<EventOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventsArgs = {
  orderBy?: InputMaybe<EventOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryGetApiPaymentSuccessResponseUrlArgs = {
  accessKey: Scalars['String']['input'];
};


export type QueryGetAvailableRefundAmountArgs = {
  paymentId: Scalars['ID']['input'];
};


export type QueryGetBanksArgs = {
  channel?: InputMaybe<PaymentChannel>;
};


export type QueryGetRecurringPaymentByCheckoutSessionArgs = {
  checkoutSessionID: Scalars['String']['input'];
};


export type QueryGetRecurringPaymentByUpdateSessionArgs = {
  updateSessionID: Scalars['String']['input'];
};


export type QueryGetUploadPresignUrlArgs = {
  input: GenerateUploadUrlInput;
};


export type QueryIntrospectTokenArgs = {
  input: IntrospectTokenInput;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceByAccessKeyArgs = {
  accessKey: Scalars['String']['input'];
};


export type QueryInvoiceQrCodeArgs = {
  accessKey: Scalars['String']['input'];
  format?: InputMaybe<QrCodeFormat>;
  size?: InputMaybe<QrCodeSize>;
};


export type QueryInvoiceSummaryArgs = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryInvoicesArgs = {
  orderBy?: InputMaybe<InvoiceOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<InvoiceWhereInput>;
};


export type QueryManuallyPaidInvoicesWithoutPayoutArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMediaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantBankAccountsArgs = {
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<BankAccountStatus>;
};


export type QueryMerchantBankAccountsListArgs = {
  orderBy?: InputMaybe<MerchantBankAccountOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MerchantBankAccountWhereInput>;
};


export type QueryMerchantDefaultPoliciesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryMerchantDisputesArgs = {
  orderBy?: InputMaybe<DisputeOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<DisputeWhereInput>;
};


export type QueryMerchantInvoicesArgs = {
  orderBy?: InputMaybe<InvoiceOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<InvoiceWhereInput>;
};


export type QueryMerchantPaymentsArgs = {
  orderBy?: InputMaybe<PaymentOrderBy>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryMerchantPayoutDashboardArgs = {
  currencies?: InputMaybe<Array<Currency>>;
};


export type QueryMerchantPayoutsArgs = {
  merchantId: Scalars['ID']['input'];
  orderBy?: InputMaybe<PayoutOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PayoutWhereInput>;
};


export type QueryMerchantPolicyAcceptancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  policyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMerchantPrimaryBankAccountArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryMerchantQuickPaysArgs = {
  orderBy?: InputMaybe<QuickPayOrderByInput>;
  organizationId: Scalars['ID']['input'];
  pagination: PaginationInput;
  where?: InputMaybe<QuickPayWhereInput>;
};


export type QueryMerchantRefundsArgs = {
  orderBy?: InputMaybe<RefundOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<RefundWhereInput>;
};


export type QueryMerchantWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantWebhooksArgs = {
  orderBy?: InputMaybe<MerchantWebhookOrderByInput>;
  pagination: PaginationInput;
  where?: InputMaybe<MerchantWebhookWhereInput>;
};


export type QueryMerchantpermissionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchquery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMobileCustomerDisputesArgs = {
  externalId: Scalars['ID']['input'];
};


export type QueryMobileCustomerTransactionSummaryArgs = {
  environment?: InputMaybe<PaymentEnvironment>;
  externalId: Scalars['ID']['input'];
};


export type QueryMobileCustomerTransactionsArgs = {
  externalId: Scalars['ID']['input'];
  filter?: InputMaybe<MobileTxnFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<MobileTxnOrder>;
};


export type QueryMobileDonationOrganizationsArgs = {
  channel: PaymentChannel;
};


export type QueryMobileMerchantActivityByHourArgs = {
  scope: MobileMerchantInsightsScopeInput;
};


export type QueryMobileMerchantInsightsSummaryArgs = {
  scope: MobileMerchantInsightsScopeInput;
};


export type QueryMobileMerchantRevenueSeriesArgs = {
  bucket: MobileInsightsBucket;
  scope: MobileMerchantInsightsScopeInput;
};


export type QueryMobileMerchantTransactionSummaryArgs = {
  environment?: InputMaybe<PaymentEnvironment>;
  merchantOrgId: Scalars['ID']['input'];
};


export type QueryMobileMerchantTransactionsArgs = {
  filter?: InputMaybe<MobileTxnFilterInput>;
  limit: Scalars['Int']['input'];
  merchantOrgId: Scalars['ID']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<MobileTxnOrder>;
};


export type QueryMobileOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMobilePaymentReceiptArgs = {
  paymentId: Scalars['ID']['input'];
};


export type QueryMobileSavedCardsArgs = {
  customerRef: Scalars['ID']['input'];
};


export type QueryMyMerchantPoliciesArgs = {
  where?: InputMaybe<PolicyDocumentWhereInput>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationApiKeysArgs = {
  orderBy?: InputMaybe<ApiKeyOrderByInput>;
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOrganizationApiPaymentsArgs = {
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<ApiPaymentsStatus>;
};


export type QueryOrganizationAuditLogArgs = {
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  eventActions?: InputMaybe<Array<EventAction>>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<EventOrderByInput>;
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOrganizationPaymentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationPaymentTypesArgs = {
  organizationId: Scalars['ID']['input'];
  paymentContext?: InputMaybe<OrganizationPaymentTypeContext>;
};


export type QueryOrganizationRolesArgs = {
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QueryOrganizationUsersArgs = {
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<UserSortInput>;
  status?: InputMaybe<UserStatus>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryOrganizationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<OrganizationSortInput>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type QueryOverdueInvoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentAnalyticsArgs = {
  endDate: Scalars['Time']['input'];
  environment: PaymentEnvironment;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  period: AnalyticsPeriod;
  startDate: Scalars['Time']['input'];
};


export type QueryPaymentFailureAnalysisArgs = {
  endDate: Scalars['Time']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Time']['input'];
};


export type QueryPaymentPayoutsArgs = {
  paymentId: Scalars['ID']['input'];
};


export type QueryPaymentProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentProviderByCardTypeArgs = {
  cardType: CardType;
  currency?: InputMaybe<Scalars['String']['input']>;
  paymentType: PaymentType;
};


export type QueryPaymentProviderCardTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentProviderCardTypesArgs = {
  filter?: InputMaybe<CardTypeFilter>;
  paymentProviderId: Scalars['ID']['input'];
};


export type QueryPaymentProviderPaymentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentProviderPaymentTypesArgs = {
  filter?: InputMaybe<PaymentTypeFilter>;
  paymentProviderId: Scalars['ID']['input'];
};


export type QueryPaymentProvidersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<PaymentProviderSortInput>;
  where?: InputMaybe<PaymentProviderWhereInput>;
};


export type QueryPaymentProvidersByTypeArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  paymentType: PaymentType;
  supportsRecurring?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentSummaryArgs = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  environment?: InputMaybe<PaymentEnvironment>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<PaymentStatus>;
};


export type QueryPaymentsArgs = {
  orderBy?: InputMaybe<PaymentOrderBy>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayoutOrganizationsArgs = {
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPayoutOverviewArgs = {
  bankId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPayoutProcessingMetricsArgs = {
  bankId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom: Scalars['Time']['input'];
  dateTo: Scalars['Time']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPayoutSummaryArgs = {
  currency?: InputMaybe<Currency>;
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PayoutStatus>;
};


export type QueryPayoutsArgs = {
  orderBy?: InputMaybe<PayoutOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PayoutWhereInput>;
};


export type QueryPermissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionGroupBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPermissionGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<PermissionGroupSortInput>;
  where?: InputMaybe<PermissionGroupWhereInput>;
};


export type QueryPermissionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<PermissionSortInput>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryPlatformPendingRefundsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPolicyDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPolicyDocumentVersionHistoryArgs = {
  policyId: Scalars['ID']['input'];
};


export type QueryPolicyDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PolicyDocumentWhereInput>;
};


export type QueryPolicyTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPolicyTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  policyType?: InputMaybe<PolicyType>;
};


export type QueryProviderPerformanceArgs = {
  endDate: Scalars['Time']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Time']['input'];
};


export type QueryQuickPayArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuickPayByAccessKeyArgs = {
  accessKey: Scalars['String']['input'];
};


export type QueryQuickPayByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryQuickPayFeeEstimateArgs = {
  accessKey: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  cardType?: InputMaybe<CardType>;
  channel?: InputMaybe<PaymentChannel>;
  currency: Currency;
  paymentType: PaymentType;
};


export type QueryQuickPaysArgs = {
  orderBy?: InputMaybe<QuickPayOrderByInput>;
  pagination: PaginationInput;
  where?: InputMaybe<QuickPayWhereInput>;
};


export type QueryRecentActivityArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRecurringPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecurringPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RecurringPaymentOrderBy>;
  where?: InputMaybe<RecurringPaymentWhereInput>;
};


export type QueryRefundArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRefundAnalyticsArgs = {
  dateRange: DateRangeInput;
  environment?: InputMaybe<PaymentEnvironment>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRefundSummaryArgs = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryRefundsArgs = {
  orderBy?: InputMaybe<RefundOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<RefundWhereInput>;
};


export type QueryRevenueDashboardArgs = {
  endDate: Scalars['Time']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Time']['input'];
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolePermissionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  roleId: Scalars['ID']['input'];
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryRolesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<RoleSortInput>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QuerySearchPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  environment?: InputMaybe<PaymentEnvironment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryServiceAccountWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceAccountWebhooksArgs = {
  orderBy?: InputMaybe<ServiceAccountWebhookOrderByInput>;
  pagination: PaginationInput;
  where?: InputMaybe<ServiceAccountWebhookWhereInput>;
};


export type QuerySplitPaymentsArgs = {
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryTransferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransferByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryTransferSummaryArgs = {
  bankId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Currency>;
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<TransferStatus>;
};


export type QueryTransfersArgs = {
  orderBy?: InputMaybe<TransferOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<TransferWhereInput>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserActivityArgs = {
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  orderBy?: InputMaybe<EventOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['ID']['input'];
};


export type QueryUserPermissionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['ID']['input'];
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryUserPolicyAcceptancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  policyId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserRolesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<UserSortInput>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryWebhookDeliveriesArgs = {
  orderBy?: InputMaybe<WebhookDeliveryOrderByInput>;
  pagination: PaginationInput;
  where?: InputMaybe<WebhookDeliveryWhereInput>;
};


export type QueryWebhookDeliveryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWebhookEventTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWebhookEventTypesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuickPay = {
  accessKey: Scalars['String']['output'];
  amountType: QuickPayAmountType;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Currency;
  customFields: Scalars['Map']['output'];
  description: Maybe<Scalars['Map']['output']>;
  environment: PaymentEnvironment;
  expiresAt: Maybe<Scalars['Time']['output']>;
  fixedAmount: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  /** Optional sale basket for dynamic QRs ([{description, unitPrice, quantity}]) */
  lineItems: Maybe<Array<Scalars['Map']['output']>>;
  maxAmount: Maybe<Scalars['Float']['output']>;
  merchantProcessingFee: Scalars['Float']['output'];
  minAmount: Maybe<Scalars['Float']['output']>;
  owner: Organization;
  ownerId: Scalars['ID']['output'];
  paymentCount: Scalars['Int']['output'];
  paymentOptions: Array<PaymentType>;
  paymentURL: Scalars['String']['output'];
  payments: PaymentConnection;
  presetAmounts: Maybe<Array<Scalars['Float']['output']>>;
  qrCode: QrCodePayload;
  refundPolicyTerms: QuickPayRefundPolicyTerms;
  status: QuickPayStatus;
  title: Scalars['String']['output'];
  totalPaymentAmount: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type QuickPayPaymentsArgs = {
  orderBy?: InputMaybe<PaymentOrderBy>;
  pagination: PaginationInput;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QuickPayQrCodeArgs = {
  format?: InputMaybe<QrCodeFormat>;
  size?: InputMaybe<QrCodeSize>;
};

export const QuickPayAmountType = {
  Fixed: 'FIXED',
  Flexible: 'FLEXIBLE',
  PresetOptions: 'PRESET_OPTIONS'
} as const;

export type QuickPayAmountType = typeof QuickPayAmountType[keyof typeof QuickPayAmountType];
export type QuickPayConnection = {
  edges: Array<QuickPayEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuickPayEdge = {
  cursor: Scalars['String']['output'];
  node: QuickPay;
};

export type QuickPayFeeEstimate = {
  gatewayFeeAmount: Scalars['Float']['output'];
  gatewayFeeRate: Scalars['Float']['output'];
  gatewayFeeType: Scalars['String']['output'];
  merchantFeeAmount: Scalars['Float']['output'];
  merchantFeePercent: Scalars['Float']['output'];
  platformFeeAmount: Scalars['Float']['output'];
  platformFeePercent: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type QuickPayOrderByField = {
  direction: SortOrder;
  field: QuickPaySortField;
};

export type QuickPayOrderByInput = {
  orderBy: Array<QuickPayOrderByField>;
};

export type QuickPayPublic = {
  /** Pay-by-code callers use this to proceed to payment (the QR embeds it; the code substitutes for scanning) */
  accessKey: Scalars['ID']['output'];
  amountType: QuickPayAmountType;
  /** Human-readable pay-by-code identifier (printed next to the QR) */
  code: Scalars['String']['output'];
  currency: Currency;
  description: Maybe<Scalars['Map']['output']>;
  fixedAmount: Maybe<Scalars['Float']['output']>;
  isExpired: Scalars['Boolean']['output'];
  /** Itemized basket shown on the pay screen, when the QR carries one */
  lineItems: Maybe<Array<Scalars['Map']['output']>>;
  maxAmount: Maybe<Scalars['Float']['output']>;
  merchantLogo: Maybe<Scalars['String']['output']>;
  merchantName: Scalars['String']['output'];
  minAmount: Maybe<Scalars['Float']['output']>;
  paymentOptions: Array<PaymentType>;
  presetAmounts: Maybe<Array<Scalars['Float']['output']>>;
  refundPolicyTerms: QuickPayRefundPolicyTerms;
  status: QuickPayStatus;
  title: Scalars['String']['output'];
};

export const QuickPayRefundPolicyTerms = {
  FullRefund: 'FULL_REFUND',
  ProcessingFeeNotRefunded: 'PROCESSING_FEE_NOT_REFUNDED'
} as const;

export type QuickPayRefundPolicyTerms = typeof QuickPayRefundPolicyTerms[keyof typeof QuickPayRefundPolicyTerms];
export const QuickPaySortField = {
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  Title: 'TITLE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type QuickPaySortField = typeof QuickPaySortField[keyof typeof QuickPaySortField];
export const QuickPayStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Paused: 'PAUSED'
} as const;

export type QuickPayStatus = typeof QuickPayStatus[keyof typeof QuickPayStatus];
/**
 * QuickPayWhereInput is used for filtering QuickPay objects.
 * Input was generated by ent.
 */
export type QuickPayWhereInput = {
  /** access_key field predicates */
  accessKey?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  accessKeyLT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyLTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNEQ?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** amount_type field predicates */
  amountType?: InputMaybe<QuickPayAmountType>;
  amountTypeContains?: InputMaybe<QuickPayAmountType>;
  amountTypeContainsFold?: InputMaybe<QuickPayAmountType>;
  amountTypeEqualFold?: InputMaybe<QuickPayAmountType>;
  amountTypeGT?: InputMaybe<QuickPayAmountType>;
  amountTypeGTE?: InputMaybe<QuickPayAmountType>;
  amountTypeHasPrefix?: InputMaybe<QuickPayAmountType>;
  amountTypeHasSuffix?: InputMaybe<QuickPayAmountType>;
  amountTypeIn?: InputMaybe<Array<QuickPayAmountType>>;
  amountTypeLT?: InputMaybe<QuickPayAmountType>;
  amountTypeLTE?: InputMaybe<QuickPayAmountType>;
  amountTypeNEQ?: InputMaybe<QuickPayAmountType>;
  amountTypeNotIn?: InputMaybe<Array<QuickPayAmountType>>;
  and?: InputMaybe<Array<QuickPayWhereInput>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Currency>;
  currencyIn?: InputMaybe<Array<Currency>>;
  currencyNEQ?: InputMaybe<Currency>;
  currencyNotIn?: InputMaybe<Array<Currency>>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** expires_at field predicates */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** fixed_amount field predicates */
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountGT?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  fixedAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fixedAmountLT?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  fixedAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_default field predicates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** max_amount field predicates */
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  maxAmountGT?: InputMaybe<Scalars['Float']['input']>;
  maxAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  maxAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  maxAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmountLT?: InputMaybe<Scalars['Float']['input']>;
  maxAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  maxAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  maxAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  maxAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** min_amount field predicates */
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  minAmountGT?: InputMaybe<Scalars['Float']['input']>;
  minAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  minAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  minAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  minAmountLT?: InputMaybe<Scalars['Float']['input']>;
  minAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  minAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  minAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  minAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<QuickPayWhereInput>;
  or?: InputMaybe<Array<QuickPayWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** refund_policy_terms field predicates */
  refundPolicyTerms?: InputMaybe<QuickPayRefundPolicyTerms>;
  refundPolicyTermsIn?: InputMaybe<Array<QuickPayRefundPolicyTerms>>;
  refundPolicyTermsNEQ?: InputMaybe<QuickPayRefundPolicyTerms>;
  refundPolicyTermsNotIn?: InputMaybe<Array<QuickPayRefundPolicyTerms>>;
  /** status field predicates */
  status?: InputMaybe<QuickPayStatus>;
  statusContains?: InputMaybe<QuickPayStatus>;
  statusContainsFold?: InputMaybe<QuickPayStatus>;
  statusEqualFold?: InputMaybe<QuickPayStatus>;
  statusGT?: InputMaybe<QuickPayStatus>;
  statusGTE?: InputMaybe<QuickPayStatus>;
  statusHasPrefix?: InputMaybe<QuickPayStatus>;
  statusHasSuffix?: InputMaybe<QuickPayStatus>;
  statusIn?: InputMaybe<Array<QuickPayStatus>>;
  statusLT?: InputMaybe<QuickPayStatus>;
  statusLTE?: InputMaybe<QuickPayStatus>;
  statusNEQ?: InputMaybe<QuickPayStatus>;
  statusNotIn?: InputMaybe<Array<QuickPayStatus>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordDisputeWithdrawalInput = {
  id: Scalars['ID']['input'];
  withdrawalDate: Scalars['Time']['input'];
};

export type RecordDisputeWithdrawalPayload = {
  dispute: Maybe<Dispute>;
  errors: Maybe<Array<Error>>;
};

export const RecurringInterval = {
  Daily: 'DAILY',
  Monthly: 'MONTHLY',
  Weekly: 'WEEKLY',
  Yearly: 'YEARLY'
} as const;

export type RecurringInterval = typeof RecurringInterval[keyof typeof RecurringInterval];
export type RecurringPayment = {
  activePaymentMethod: Maybe<PaymentMethod>;
  amount: Scalars['Float']['output'];
  cancelURL: Maybe<Scalars['String']['output']>;
  chargeImmediately: Scalars['Boolean']['output'];
  chargesCount: Scalars['Int']['output'];
  checkoutExpiresAt: Maybe<Scalars['Time']['output']>;
  checkoutSessionID: Scalars['String']['output'];
  code: Scalars['String']['output'];
  consecutiveFailures: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Currency;
  customer: Customer;
  description: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['Time']['output']>;
  externalID: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interval: RecurringInterval;
  intervalCount: Scalars['Int']['output'];
  lastChargeDate: Maybe<Scalars['Time']['output']>;
  lastChargeStatus: Maybe<PaymentStatus>;
  maxCharges: Maybe<Scalars['Int']['output']>;
  maxRetries: Scalars['Int']['output'];
  merchantProcessingFee: Scalars['Float']['output'];
  metadata: Scalars['Map']['output'];
  nextChargeDate: Maybe<Scalars['Time']['output']>;
  owner: Organization;
  paymentOptions: Array<PaymentType>;
  refundPolicyTerms: RecurringPaymentRefundPolicyTerms;
  setupStatus: RecurringPaymentSetupStatus;
  startDate: Scalars['Time']['output'];
  status: RecurringPaymentStatus;
  successURL: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type RecurringPaymentConnection = {
  edges: Array<RecurringPaymentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecurringPaymentEdge = {
  cursor: Scalars['Cursor']['output'];
  node: RecurringPayment;
};

export type RecurringPaymentOrderBy = {
  direction: SortOrder;
  field: RecurringPaymentOrderField;
};

export const RecurringPaymentOrderField = {
  Amount: 'AMOUNT',
  CreatedAt: 'CREATED_AT',
  Interval: 'INTERVAL',
  NextChargeDate: 'NEXT_CHARGE_DATE',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type RecurringPaymentOrderField = typeof RecurringPaymentOrderField[keyof typeof RecurringPaymentOrderField];
export const RecurringPaymentRefundPolicyTerms = {
  FullRefund: 'FULL_REFUND',
  ProcessingFeeNotRefunded: 'PROCESSING_FEE_NOT_REFUNDED'
} as const;

export type RecurringPaymentRefundPolicyTerms = typeof RecurringPaymentRefundPolicyTerms[keyof typeof RecurringPaymentRefundPolicyTerms];
export const RecurringPaymentSetupStatus = {
  Completed: 'COMPLETED',
  Expired: 'EXPIRED',
  Pending: 'PENDING'
} as const;

export type RecurringPaymentSetupStatus = typeof RecurringPaymentSetupStatus[keyof typeof RecurringPaymentSetupStatus];
export const RecurringPaymentStatus = {
  Active: 'ACTIVE',
  Canceled: 'CANCELED',
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Paused: 'PAUSED'
} as const;

export type RecurringPaymentStatus = typeof RecurringPaymentStatus[keyof typeof RecurringPaymentStatus];
/**
 * RecurringPaymentWhereInput is used for filtering RecurringPayment objects.
 * Input was generated by ent.
 */
export type RecurringPaymentWhereInput = {
  /** active_payment_method_id field predicates */
  activePaymentMethodID?: InputMaybe<Scalars['ID']['input']>;
  activePaymentMethodIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  activePaymentMethodIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activePaymentMethodIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  activePaymentMethodIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  activePaymentMethodIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountGT?: InputMaybe<Scalars['Int']['input']>;
  amountGTE?: InputMaybe<Scalars['Int']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  amountLT?: InputMaybe<Scalars['Int']['input']>;
  amountLTE?: InputMaybe<Scalars['Int']['input']>;
  amountNEQ?: InputMaybe<Scalars['Int']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<RecurringPaymentWhereInput>>;
  /** api_key field predicates */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKeyContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cancel_url field predicates */
  cancelURL?: InputMaybe<Scalars['String']['input']>;
  cancelURLContains?: InputMaybe<Scalars['String']['input']>;
  cancelURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  cancelURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  cancelURLGT?: InputMaybe<Scalars['String']['input']>;
  cancelURLGTE?: InputMaybe<Scalars['String']['input']>;
  cancelURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cancelURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cancelURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cancelURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cancelURLLT?: InputMaybe<Scalars['String']['input']>;
  cancelURLLTE?: InputMaybe<Scalars['String']['input']>;
  cancelURLNEQ?: InputMaybe<Scalars['String']['input']>;
  cancelURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cancelURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** charge_immediately field predicates */
  chargeImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  chargeImmediatelyNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** charges_count field predicates */
  chargesCount?: InputMaybe<Scalars['Int']['input']>;
  chargesCountGT?: InputMaybe<Scalars['Int']['input']>;
  chargesCountGTE?: InputMaybe<Scalars['Int']['input']>;
  chargesCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  chargesCountLT?: InputMaybe<Scalars['Int']['input']>;
  chargesCountLTE?: InputMaybe<Scalars['Int']['input']>;
  chargesCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  chargesCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** checkout_expires_at field predicates */
  checkoutExpiresAt?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutExpiresAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutExpiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutExpiresAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** checkout_session_id field predicates */
  checkoutSessionID?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDContains?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDGT?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDGTE?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkoutSessionIDLT?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDLTE?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDNEQ?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** consecutive_failures field predicates */
  consecutiveFailures?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresGT?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresGTE?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  consecutiveFailuresLT?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresLTE?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresNEQ?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyContains?: InputMaybe<Scalars['String']['input']>;
  currencyContainsFold?: InputMaybe<Scalars['String']['input']>;
  currencyEqualFold?: InputMaybe<Scalars['String']['input']>;
  currencyGT?: InputMaybe<Scalars['String']['input']>;
  currencyGTE?: InputMaybe<Scalars['String']['input']>;
  currencyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  currencyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  currencyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyLT?: InputMaybe<Scalars['String']['input']>;
  currencyLTE?: InputMaybe<Scalars['String']['input']>;
  currencyNEQ?: InputMaybe<Scalars['String']['input']>;
  currencyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** customer_id field predicates */
  customerID?: InputMaybe<Scalars['ID']['input']>;
  customerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  customerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ends_at field predicates */
  endsAt?: InputMaybe<Scalars['Time']['input']>;
  endsAtGT?: InputMaybe<Scalars['Time']['input']>;
  endsAtGTE?: InputMaybe<Scalars['Time']['input']>;
  endsAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endsAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endsAtLT?: InputMaybe<Scalars['Time']['input']>;
  endsAtLTE?: InputMaybe<Scalars['Time']['input']>;
  endsAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  endsAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endsAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** active_payment_method edge predicates */
  hasActivePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  hasActivePaymentMethodWith?: InputMaybe<Array<PaymentMethodWhereInput>>;
  /** customer edge predicates */
  hasCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomerWith?: InputMaybe<Array<CustomerWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** interval field predicates */
  interval?: InputMaybe<RecurringInterval>;
  /** interval_count field predicates */
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  intervalCountGT?: InputMaybe<Scalars['Int']['input']>;
  intervalCountGTE?: InputMaybe<Scalars['Int']['input']>;
  intervalCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  intervalCountLT?: InputMaybe<Scalars['Int']['input']>;
  intervalCountLTE?: InputMaybe<Scalars['Int']['input']>;
  intervalCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  intervalCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  intervalIn?: InputMaybe<Array<RecurringInterval>>;
  intervalNEQ?: InputMaybe<RecurringInterval>;
  intervalNotIn?: InputMaybe<Array<RecurringInterval>>;
  /** last_charge_attempt_at field predicates */
  lastChargeAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastChargeAttemptAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastChargeAttemptAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastChargeAttemptAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** max_charges field predicates */
  maxCharges?: InputMaybe<Scalars['Int']['input']>;
  maxChargesGT?: InputMaybe<Scalars['Int']['input']>;
  maxChargesGTE?: InputMaybe<Scalars['Int']['input']>;
  maxChargesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxChargesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  maxChargesLT?: InputMaybe<Scalars['Int']['input']>;
  maxChargesLTE?: InputMaybe<Scalars['Int']['input']>;
  maxChargesNEQ?: InputMaybe<Scalars['Int']['input']>;
  maxChargesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxChargesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** max_retries field predicates */
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesGT?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesGTE?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxRetriesLT?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesLTE?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesNEQ?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** next_charge_date field predicates */
  nextChargeDate?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateGT?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateGTE?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextChargeDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextChargeDateLT?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateLTE?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextChargeDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<RecurringPaymentWhereInput>;
  or?: InputMaybe<Array<RecurringPaymentWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** refund_policy_terms field predicates */
  refundPolicyTerms?: InputMaybe<RecurringPaymentRefundPolicyTerms>;
  refundPolicyTermsIn?: InputMaybe<Array<RecurringPaymentRefundPolicyTerms>>;
  refundPolicyTermsNEQ?: InputMaybe<RecurringPaymentRefundPolicyTerms>;
  refundPolicyTermsNotIn?: InputMaybe<Array<RecurringPaymentRefundPolicyTerms>>;
  /** setup_status field predicates */
  setupStatus?: InputMaybe<RecurringPaymentSetupStatus>;
  setupStatusIn?: InputMaybe<Array<RecurringPaymentSetupStatus>>;
  setupStatusNEQ?: InputMaybe<RecurringPaymentSetupStatus>;
  setupStatusNotIn?: InputMaybe<Array<RecurringPaymentSetupStatus>>;
  /** starts_at field predicates */
  startsAt?: InputMaybe<Scalars['Time']['input']>;
  startsAtGT?: InputMaybe<Scalars['Time']['input']>;
  startsAtGTE?: InputMaybe<Scalars['Time']['input']>;
  startsAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startsAtLT?: InputMaybe<Scalars['Time']['input']>;
  startsAtLTE?: InputMaybe<Scalars['Time']['input']>;
  startsAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  startsAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** status field predicates */
  status?: InputMaybe<RecurringPaymentStatus>;
  statusIn?: InputMaybe<Array<RecurringPaymentStatus>>;
  statusNEQ?: InputMaybe<RecurringPaymentStatus>;
  statusNotIn?: InputMaybe<Array<RecurringPaymentStatus>>;
  /** success_url field predicates */
  successURL?: InputMaybe<Scalars['String']['input']>;
  successURLContains?: InputMaybe<Scalars['String']['input']>;
  successURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  successURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  successURLGT?: InputMaybe<Scalars['String']['input']>;
  successURLGTE?: InputMaybe<Scalars['String']['input']>;
  successURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  successURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  successURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  successURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  successURLLT?: InputMaybe<Scalars['String']['input']>;
  successURLLTE?: InputMaybe<Scalars['String']['input']>;
  successURLNEQ?: InputMaybe<Scalars['String']['input']>;
  successURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  successURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type RefreshTokenPayload = {
  accessToken: Scalars['String']['output'];
  errors: Maybe<Array<Maybe<AuthenticationError>>>;
  refreshToken: Scalars['String']['output'];
};

export type Refund = {
  amount: Scalars['Float']['output'];
  bankDeclineReason: Maybe<Scalars['Map']['output']>;
  closedDate: Maybe<Scalars['Time']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Maybe<User>;
  createdById: Scalars['ID']['output'];
  denialReason: Maybe<Scalars['Map']['output']>;
  environment: PaymentEnvironment;
  extendedCancellationPolicyText: Maybe<Scalars['String']['output']>;
  hasCancelPolicyExtended: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  merchantDeclineReason: Maybe<RefundMerchantDeclineReason>;
  notes: Maybe<Scalars['Map']['output']>;
  ownerId: Maybe<Scalars['ID']['output']>;
  payment: Payment;
  paymentId: Scalars['String']['output'];
  pointOfContact: RefundPointOfContact;
  progressStatus: RefundProgressStatus;
  providerRefundId: Maybe<Scalars['String']['output']>;
  reason: Maybe<Scalars['Map']['output']>;
  receipts: Maybe<Array<Maybe<Media>>>;
  refundAlreadyPaid: RefundAlreadyPaid;
  refundAlreadyPaidAmount: Maybe<Scalars['Float']['output']>;
  status: RefundStatus;
  statusUpdatedAt: Maybe<Scalars['Time']['output']>;
  subReason: Maybe<Scalars['Map']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export const RefundAlreadyPaid = {
  PaidInCash: 'PAID_IN_CASH',
  PaidViaPaymentGateway: 'PAID_VIA_PAYMENT_GATEWAY',
  PaidViaWireTransfer: 'PAID_VIA_WIRE_TRANSFER'
} as const;

export type RefundAlreadyPaid = typeof RefundAlreadyPaid[keyof typeof RefundAlreadyPaid];
export type RefundAnalytics = {
  averageRefundAmount: Scalars['Float']['output'];
  averageResolutionHours: Scalars['Float']['output'];
  declinedRefunds: Scalars['Int']['output'];
  medianResolutionHours: Scalars['Float']['output'];
  pendingRefunds: Scalars['Int']['output'];
  period: DateRange;
  successRate: Scalars['Float']['output'];
  successfulRefunds: Scalars['Int']['output'];
  totalDeclinedAmount: Scalars['Float']['output'];
  totalRefundedAmount: Scalars['Float']['output'];
  totalRequests: Scalars['Int']['output'];
};

export type RefundConnection = {
  edges: Array<RefundEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundEdge = {
  cursor: Scalars['String']['output'];
  node: Refund;
};

export const RefundMerchantDeclineReason = {
  OutsideCancellationPolicy: 'OUTSIDE_CANCELLATION_POLICY',
  RefundAlreadyPaid: 'REFUND_ALREADY_PAID',
  ServiceWasProvided: 'SERVICE_WAS_PROVIDED'
} as const;

export type RefundMerchantDeclineReason = typeof RefundMerchantDeclineReason[keyof typeof RefundMerchantDeclineReason];
export type RefundOrderByInput = {
  direction: SortOrder;
  field: RefundOrderField;
};

export const RefundOrderField = {
  Amount: 'AMOUNT',
  ClosedDate: 'CLOSED_DATE',
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  ProgressStatus: 'PROGRESS_STATUS',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type RefundOrderField = typeof RefundOrderField[keyof typeof RefundOrderField];
export const RefundPointOfContact = {
  Merchant: 'MERCHANT',
  Platform: 'PLATFORM'
} as const;

export type RefundPointOfContact = typeof RefundPointOfContact[keyof typeof RefundPointOfContact];
export const RefundProgressStatus = {
  BankApproved: 'BANK_APPROVED',
  BankDenied: 'BANK_DENIED',
  Initiated: 'INITIATED',
  MerchantApproved: 'MERCHANT_APPROVED',
  MerchantDenied: 'MERCHANT_DENIED',
  NotRefunded: 'NOT_REFUNDED',
  Refunded: 'REFUNDED'
} as const;

export type RefundProgressStatus = typeof RefundProgressStatus[keyof typeof RefundProgressStatus];
export const RefundReportField = {
  Amount: 'AMOUNT',
  BankDeclineReason: 'BANK_DECLINE_REASON',
  ClosedDate: 'CLOSED_DATE',
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  CreatedById: 'CREATED_BY_ID',
  DenialReason: 'DENIAL_REASON',
  Environment: 'ENVIRONMENT',
  ExtendedCancellationPolicyText: 'EXTENDED_CANCELLATION_POLICY_TEXT',
  HasCancelPolicyExtended: 'HAS_CANCEL_POLICY_EXTENDED',
  MerchantDeclineExplanation: 'MERCHANT_DECLINE_EXPLANATION',
  MerchantDeclineReason: 'MERCHANT_DECLINE_REASON',
  MerchantDeclineSubReason: 'MERCHANT_DECLINE_SUB_REASON',
  Notes: 'NOTES',
  PaymentId: 'PAYMENT_ID',
  PointOfContact: 'POINT_OF_CONTACT',
  ProgressStatus: 'PROGRESS_STATUS',
  ProviderRefundId: 'PROVIDER_REFUND_ID',
  Reason: 'REASON',
  RefundAlreadyPaid: 'REFUND_ALREADY_PAID',
  RefundAlreadyPaidAmount: 'REFUND_ALREADY_PAID_AMOUNT',
  Status: 'STATUS',
  StatusUpdatedAt: 'STATUS_UPDATED_AT',
  SubReason: 'SUB_REASON'
} as const;

export type RefundReportField = typeof RefundReportField[keyof typeof RefundReportField];
export const RefundStatus = {
  Closed: 'CLOSED',
  InReview: 'IN_REVIEW',
  Open: 'OPEN',
  Resolved: 'RESOLVED'
} as const;

export type RefundStatus = typeof RefundStatus[keyof typeof RefundStatus];
export type RefundSummary = {
  approvedCount: Scalars['Int']['output'];
  deniedCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  refundedCount: Scalars['Int']['output'];
  successRate: Scalars['Float']['output'];
  totalPendingAmount: Scalars['Float']['output'];
  totalRefundedAmount: Scalars['Float']['output'];
  totalRefunds: Scalars['Int']['output'];
};

/**
 * RefundWhereInput is used for filtering Refund objects.
 * Input was generated by ent.
 */
export type RefundWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<RefundWhereInput>>;
  /** closed_date field predicates */
  closedDate?: InputMaybe<Scalars['Time']['input']>;
  closedDateGT?: InputMaybe<Scalars['Time']['input']>;
  closedDateGTE?: InputMaybe<Scalars['Time']['input']>;
  closedDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  closedDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  closedDateLT?: InputMaybe<Scalars['Time']['input']>;
  closedDateLTE?: InputMaybe<Scalars['Time']['input']>;
  closedDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  closedDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  closedDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_id field predicates */
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  createdByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** extended_cancellation_policy_text field predicates */
  extendedCancellationPolicyText?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextContains?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextContainsFold?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextEqualFold?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextGT?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextGTE?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextHasPrefix?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextHasSuffix?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextIn?: InputMaybe<Array<Scalars['String']['input']>>;
  extendedCancellationPolicyTextIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  extendedCancellationPolicyTextLT?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextLTE?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextNEQ?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  extendedCancellationPolicyTextNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** has_cancel_policy_extended field predicates */
  hasCancelPolicyExtended?: InputMaybe<Scalars['Boolean']['input']>;
  hasCancelPolicyExtendedIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  hasCancelPolicyExtendedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  hasCancelPolicyExtendedNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** disputes edge predicates */
  hasDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  hasDisputesWith?: InputMaybe<Array<DisputeWhereInput>>;
  /** payment edge predicates */
  hasPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentWith?: InputMaybe<Array<PaymentWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<PayoutWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** merchant_decline_explanation field predicates */
  merchantDeclineExplanation?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationContains?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationContainsFold?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationEqualFold?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationGT?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationGTE?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantDeclineExplanationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  merchantDeclineExplanationLT?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationLTE?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationNEQ?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantDeclineExplanationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_decline_reason field predicates */
  merchantDeclineReason?: InputMaybe<RefundMerchantDeclineReason>;
  merchantDeclineReasonIn?: InputMaybe<Array<RefundMerchantDeclineReason>>;
  merchantDeclineReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  merchantDeclineReasonNEQ?: InputMaybe<RefundMerchantDeclineReason>;
  merchantDeclineReasonNotIn?: InputMaybe<Array<RefundMerchantDeclineReason>>;
  merchantDeclineReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<RefundWhereInput>;
  or?: InputMaybe<Array<RefundWhereInput>>;
  /** payment_id field predicates */
  paymentID?: InputMaybe<Scalars['ID']['input']>;
  paymentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** point_of_contact field predicates */
  pointOfContact?: InputMaybe<RefundPointOfContact>;
  pointOfContactIn?: InputMaybe<Array<RefundPointOfContact>>;
  pointOfContactNEQ?: InputMaybe<RefundPointOfContact>;
  pointOfContactNotIn?: InputMaybe<Array<RefundPointOfContact>>;
  /** progress_status field predicates */
  progressStatus?: InputMaybe<RefundProgressStatus>;
  progressStatusIn?: InputMaybe<Array<RefundProgressStatus>>;
  progressStatusNEQ?: InputMaybe<RefundProgressStatus>;
  progressStatusNotIn?: InputMaybe<Array<RefundProgressStatus>>;
  /** provider_refund_id field predicates */
  providerRefundID?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDContains?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDGT?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerRefundIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerRefundIDLT?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerRefundIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_already_paid field predicates */
  refundAlreadyPaid?: InputMaybe<RefundAlreadyPaid>;
  /** refund_already_paid_amount field predicates */
  refundAlreadyPaidAmount?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountGT?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundAlreadyPaidAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundAlreadyPaidAmountLT?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundAlreadyPaidAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundAlreadyPaidIn?: InputMaybe<Array<RefundAlreadyPaid>>;
  refundAlreadyPaidNEQ?: InputMaybe<RefundAlreadyPaid>;
  refundAlreadyPaidNotIn?: InputMaybe<Array<RefundAlreadyPaid>>;
  /** status field predicates */
  status?: InputMaybe<RefundStatus>;
  statusIn?: InputMaybe<Array<RefundStatus>>;
  statusNEQ?: InputMaybe<RefundStatus>;
  statusNotIn?: InputMaybe<Array<RefundStatus>>;
  /** status_updated_at field predicates */
  statusUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusUpdatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReinstateBankAccountPayload = {
  errors: Maybe<Array<Error>>;
  merchantBankAccount: Maybe<MerchantBankAccount>;
  statusChange: Maybe<BankAccountStatusChangeRecord>;
};

export type RejectBankAccountPayload = {
  errors: Maybe<Array<Error>>;
  merchantBankAccount: Maybe<MerchantBankAccount>;
  statusChange: Maybe<BankAccountStatusChangeRecord>;
};

export type RejectRefundInput = {
  declineReason: Scalars['Map']['input'];
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export type RejectRefundPayload = {
  errors: Maybe<Array<Error>>;
  refund: Maybe<Refund>;
};

export type RemoveDefaultPolicyPayload = {
  errors: Maybe<Array<Error>>;
  policyType: Maybe<PolicyType>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type RemovePayoutsFromTransferInput = {
  payoutIds: Array<Scalars['ID']['input']>;
  transferId: Scalars['ID']['input'];
};

export type RemovePayoutsFromTransferPayload = {
  errors: Maybe<Array<Error>>;
  removedPayoutIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  transfer: Maybe<Transfer>;
};

export type RemoveServiceAccountWebhookSubscriptionsInput = {
  eventTypeIds: Array<Scalars['ID']['input']>;
  webhookId: Scalars['ID']['input'];
};

export type RemoveServiceAccountWebhookSubscriptionsPayload = {
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type RemoveWebhookSubscriptionsInput = {
  eventTypeIds: Array<Scalars['ID']['input']>;
  webhookId: Scalars['ID']['input'];
};

export type RemoveWebhookSubscriptionsPayload = {
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type ReorderLineItemsInput = {
  invoiceId: Scalars['ID']['input'];
  lineItemIds: Array<Scalars['ID']['input']>;
};

export type ReorderLineItemsPayload = {
  errors: Maybe<Array<Error>>;
  lineItems: Maybe<Array<InvoiceLineItem>>;
};

export type RequestEmailVerificationOtpInput = {
  email: Scalars['String']['input'];
};

export type RequestLoginOtpInput = {
  email: Scalars['String']['input'];
};

export type RequestMagicLinkInput = {
  email: Scalars['String']['input'];
};

export type RequestMagicLinkPayload = {
  emailSent: Scalars['Boolean']['output'];
  errors: Maybe<Array<AuthenticationError>>;
  message: Scalars['String']['output'];
};

export type RequestOtpPayload = {
  emailSent: Scalars['Boolean']['output'];
  errors: Maybe<Array<Error>>;
  message: Scalars['String']['output'];
};

export type RequestPasswordResetOtpInput = {
  email: Scalars['String']['input'];
};

export type RequestPasswordResetPayload = {
  emailSent: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type ResendEmailVerificationInput = {
  email: Scalars['String']['input'];
};

export type ResendEmailVerificationPayload = {
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type ResendInvitationPayload = {
  emailSent: Scalars['Boolean']['output'];
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResetPasswordPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordWithOtpInput = {
  newPassword: Scalars['String']['input'];
  verificationToken: Scalars['String']['input'];
};

export type ResolveDisputeInput = {
  evidenceReason?: InputMaybe<DisputeEvidenceReason>;
  id: Scalars['ID']['input'];
  status: DisputeStatus;
};

export type ResolveDisputePayload = {
  dispute: Maybe<Dispute>;
  errors: Maybe<Array<Error>>;
};

export type RestoreOrganizationPayload = {
  errors: Maybe<Array<Error>>;
  organization: Maybe<Organization>;
};

export type RestorePermissionInput = {
  permissionId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type RestorePermissionPayload = {
  errors: Maybe<Array<Error>>;
  permissionRole: Maybe<PermissionRole>;
};

export type ResumeRecurringPaymentPayload = {
  errors: Maybe<Array<Error>>;
  recurringPayment: Maybe<RecurringPayment>;
};

export type RetryWebhookDeliveryInput = {
  deliveryId: Scalars['ID']['input'];
};

export type RetryWebhookDeliveryPayload = {
  delivery: Maybe<WebhookDelivery>;
  errors: Maybe<Array<Error>>;
};

export type RevenueDashboard = {
  analytics: Array<PaymentAnalytics>;
  failedPayments: Array<Payment>;
  providerBreakdown: Array<ProviderPerformance>;
  recentPayments: Array<Payment>;
  summary: PaymentSummary;
  topCustomers: Array<CustomerPaymentHistory>;
};

export type RevokePermissionInput = {
  permissionId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type RevokePermissionPayload = {
  errors: Maybe<Array<Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type Role = {
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['Map']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  permissionCount: Scalars['Int']['output'];
  permissions: PermissionConnection;
  updatedAt: Scalars['Time']['output'];
  userCount: Scalars['Int']['output'];
  users: Array<Maybe<User>>;
};


export type RolePermissionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<PermissionWhereInput>;
};

export type RoleConnection = {
  edges: Array<RoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoleEdge = {
  cursor: Scalars['String']['output'];
  node: Role;
};

export type RoleOrderByField = {
  direction: SortOrder;
  field: RoleOrderField;
};

export const RoleOrderField = {
  CreatedAt: 'CREATED_AT',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type RoleOrderField = typeof RoleOrderField[keyof typeof RoleOrderField];
export type RolePermissionGrant = {
  permission: Permission;
  permissionFor: Maybe<PermissionFor>;
  role: Role;
};

export type RoleSortInput = {
  orderBy: Array<RoleOrderByField>;
};

/**
 * RoleWhereInput is used for filtering Role objects.
 * Input was generated by ent.
 */
export type RoleWhereInput = {
  and?: InputMaybe<Array<RoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** permissions edge predicates */
  hasPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermissionsWith?: InputMaybe<Array<PermissionWhereInput>>;
  /** role_permissions edge predicates */
  hasRolePermissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolePermissionsWith?: InputMaybe<Array<PermissionRoleWhereInput>>;
  /** role_users edge predicates */
  hasRoleUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoleUsersWith?: InputMaybe<Array<UserRoleWhereInput>>;
  /** users edge predicates */
  hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<RoleWhereInput>;
  or?: InputMaybe<Array<RoleWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RotateServiceAccountWebhookSecretPayload = {
  errors: Maybe<Array<Error>>;
  /**
   * The new signing secret. Returned only here. The previous secret stops working
   * immediately.
   */
  secret: Maybe<Scalars['String']['output']>;
  serviceAccountWebhook: Maybe<ServiceAccountWebhook>;
};

export type SavePaymentMethodInput = {
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardExpiryMonth?: InputMaybe<Scalars['Int']['input']>;
  cardExpiryYear?: InputMaybe<Scalars['Int']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionID: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['Map']['input']>;
  providerCustomerID?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodID: Scalars['String']['input'];
  type: PaymentType;
};

export type SavePaymentMethodPayload = {
  errors: Maybe<Array<Error>>;
  paymentMethod: Maybe<PaymentMethod>;
  successResponseUrl: Scalars['String']['output'];
};

export type SendInvoiceEmailInput = {
  cc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
  to: Scalars['String']['input'];
};

export type SendInvoiceEmailPayload = {
  errors: Maybe<Array<Error>>;
  sentAt: Maybe<Scalars['Time']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ServiceAccount = {
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/**
 * ServiceAccountAuditLogWhereInput is used for filtering ServiceAccountAuditLog objects.
 * Input was generated by ent.
 */
export type ServiceAccountAuditLogWhereInput = {
  /** acting_user_id field predicates */
  actingUserID?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDGT?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  actingUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  actingUserIDLT?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  actingUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<ServiceAccountAuditLogWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** error_reason field predicates */
  errorReason?: InputMaybe<Scalars['String']['input']>;
  errorReasonContains?: InputMaybe<Scalars['String']['input']>;
  errorReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorReasonGT?: InputMaybe<Scalars['String']['input']>;
  errorReasonGTE?: InputMaybe<Scalars['String']['input']>;
  errorReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorReasonLT?: InputMaybe<Scalars['String']['input']>;
  errorReasonLTE?: InputMaybe<Scalars['String']['input']>;
  errorReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  errorReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** service_account edge predicates */
  hasServiceAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceAccountWith?: InputMaybe<Array<ServiceAccountWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** jti field predicates */
  jti?: InputMaybe<Scalars['String']['input']>;
  jtiContains?: InputMaybe<Scalars['String']['input']>;
  jtiContainsFold?: InputMaybe<Scalars['String']['input']>;
  jtiEqualFold?: InputMaybe<Scalars['String']['input']>;
  jtiGT?: InputMaybe<Scalars['String']['input']>;
  jtiGTE?: InputMaybe<Scalars['String']['input']>;
  jtiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  jtiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  jtiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  jtiLT?: InputMaybe<Scalars['String']['input']>;
  jtiLTE?: InputMaybe<Scalars['String']['input']>;
  jtiNEQ?: InputMaybe<Scalars['String']['input']>;
  jtiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ServiceAccountAuditLogWhereInput>;
  /** operation_name field predicates */
  operationName?: InputMaybe<Scalars['String']['input']>;
  operationNameContains?: InputMaybe<Scalars['String']['input']>;
  operationNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  operationNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  operationNameGT?: InputMaybe<Scalars['String']['input']>;
  operationNameGTE?: InputMaybe<Scalars['String']['input']>;
  operationNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  operationNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  operationNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  operationNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  operationNameLT?: InputMaybe<Scalars['String']['input']>;
  operationNameLTE?: InputMaybe<Scalars['String']['input']>;
  operationNameNEQ?: InputMaybe<Scalars['String']['input']>;
  operationNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  operationNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<ServiceAccountAuditLogWhereInput>>;
  /** request_ip field predicates */
  requestIP?: InputMaybe<Scalars['String']['input']>;
  requestIPContains?: InputMaybe<Scalars['String']['input']>;
  requestIPContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestIPEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestIPGT?: InputMaybe<Scalars['String']['input']>;
  requestIPGTE?: InputMaybe<Scalars['String']['input']>;
  requestIPHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestIPHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestIPIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestIPIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requestIPLT?: InputMaybe<Scalars['String']['input']>;
  requestIPLTE?: InputMaybe<Scalars['String']['input']>;
  requestIPNEQ?: InputMaybe<Scalars['String']['input']>;
  requestIPNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestIPNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_user_agent field predicates */
  requestUserAgent?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentContains?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentGT?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentGTE?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestUserAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requestUserAgentLT?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentLTE?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentNEQ?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestUserAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** service_account_id field predicates */
  serviceAccountID?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** succeeded field predicates */
  succeeded?: InputMaybe<Scalars['Boolean']['input']>;
  succeededNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * ServiceAccountKeyWhereInput is used for filtering ServiceAccountKey objects.
 * Input was generated by ent.
 */
export type ServiceAccountKeyWhereInput = {
  /** algorithm field predicates */
  algorithm?: InputMaybe<Scalars['String']['input']>;
  algorithmContains?: InputMaybe<Scalars['String']['input']>;
  algorithmContainsFold?: InputMaybe<Scalars['String']['input']>;
  algorithmEqualFold?: InputMaybe<Scalars['String']['input']>;
  algorithmGT?: InputMaybe<Scalars['String']['input']>;
  algorithmGTE?: InputMaybe<Scalars['String']['input']>;
  algorithmHasPrefix?: InputMaybe<Scalars['String']['input']>;
  algorithmHasSuffix?: InputMaybe<Scalars['String']['input']>;
  algorithmIn?: InputMaybe<Array<Scalars['String']['input']>>;
  algorithmLT?: InputMaybe<Scalars['String']['input']>;
  algorithmLTE?: InputMaybe<Scalars['String']['input']>;
  algorithmNEQ?: InputMaybe<Scalars['String']['input']>;
  algorithmNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<ServiceAccountKeyWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** expires_at field predicates */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** service_account edge predicates */
  hasServiceAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceAccountWith?: InputMaybe<Array<ServiceAccountWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** kid field predicates */
  kid?: InputMaybe<Scalars['String']['input']>;
  kidContains?: InputMaybe<Scalars['String']['input']>;
  kidContainsFold?: InputMaybe<Scalars['String']['input']>;
  kidEqualFold?: InputMaybe<Scalars['String']['input']>;
  kidGT?: InputMaybe<Scalars['String']['input']>;
  kidGTE?: InputMaybe<Scalars['String']['input']>;
  kidHasPrefix?: InputMaybe<Scalars['String']['input']>;
  kidHasSuffix?: InputMaybe<Scalars['String']['input']>;
  kidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  kidLT?: InputMaybe<Scalars['String']['input']>;
  kidLTE?: InputMaybe<Scalars['String']['input']>;
  kidNEQ?: InputMaybe<Scalars['String']['input']>;
  kidNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ServiceAccountKeyWhereInput>;
  or?: InputMaybe<Array<ServiceAccountKeyWhereInput>>;
  /** public_key field predicates */
  publicKey?: InputMaybe<Scalars['String']['input']>;
  publicKeyContains?: InputMaybe<Scalars['String']['input']>;
  publicKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  publicKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  publicKeyGT?: InputMaybe<Scalars['String']['input']>;
  publicKeyGTE?: InputMaybe<Scalars['String']['input']>;
  publicKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  publicKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  publicKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  publicKeyLT?: InputMaybe<Scalars['String']['input']>;
  publicKeyLTE?: InputMaybe<Scalars['String']['input']>;
  publicKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  publicKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** service_account_id field predicates */
  serviceAccountID?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A webhook endpoint owned by a service account. Unlike a MerchantWebhook it has
 * no owning organization and receives matching events across all organizations.
 *
 * The signing secret is deliberately absent from this type — it is returned only
 * when the webhook is created or its secret is rotated.
 */
export type ServiceAccountWebhook = {
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['String']['output']>;
  disabledAt: Maybe<Scalars['Time']['output']>;
  failureCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastTriggeredAt: Maybe<Scalars['Time']['output']>;
  metadata: Maybe<Scalars['Map']['output']>;
  name: Scalars['String']['output'];
  serviceAccount: ServiceAccount;
  serviceAccountID: Scalars['ID']['output'];
  status: WebhookStatus;
  subscriptions: Maybe<Array<ServiceAccountWebhookSubscription>>;
  updatedAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
};

export type ServiceAccountWebhookConnection = {
  edges: Array<ServiceAccountWebhookEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ServiceAccountWebhookEdge = {
  cursor: Scalars['String']['output'];
  node: ServiceAccountWebhook;
};

export type ServiceAccountWebhookOrderByInput = {
  direction: SortOrder;
  field: ServiceAccountWebhookOrderField;
};

export const ServiceAccountWebhookOrderField = {
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ServiceAccountWebhookOrderField = typeof ServiceAccountWebhookOrderField[keyof typeof ServiceAccountWebhookOrderField];
export type ServiceAccountWebhookSubscription = {
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  metadata: Maybe<Scalars['Map']['output']>;
  serviceAccountWebhook: ServiceAccountWebhook;
  serviceAccountWebhookID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  webhookEventType: WebhookEventType;
  webhookEventTypeID: Scalars['ID']['output'];
};

/**
 * ServiceAccountWebhookSubscriptionWhereInput is used for filtering ServiceAccountWebhookSubscription objects.
 * Input was generated by ent.
 */
export type ServiceAccountWebhookSubscriptionWhereInput = {
  and?: InputMaybe<Array<ServiceAccountWebhookSubscriptionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** service_account_webhook edge predicates */
  hasServiceAccountWebhook?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceAccountWebhookWith?: InputMaybe<Array<ServiceAccountWebhookWhereInput>>;
  /** webhook_event_type edge predicates */
  hasWebhookEventType?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebhookEventTypeWith?: InputMaybe<Array<WebhookEventTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_enabled field predicates */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ServiceAccountWebhookSubscriptionWhereInput>;
  or?: InputMaybe<Array<ServiceAccountWebhookSubscriptionWhereInput>>;
  /** service_account_webhook_id field predicates */
  serviceAccountWebhookID?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountWebhookIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountWebhookIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountWebhookIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** webhook_event_type_id field predicates */
  webhookEventTypeID?: InputMaybe<Scalars['ID']['input']>;
  webhookEventTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  webhookEventTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  webhookEventTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * ServiceAccountWebhookWhereInput is used for filtering ServiceAccountWebhook objects.
 * Input was generated by ent.
 */
export type ServiceAccountWebhookWhereInput = {
  and?: InputMaybe<Array<ServiceAccountWebhookWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled_at field predicates */
  disabledAt?: InputMaybe<Scalars['Time']['input']>;
  disabledAtGT?: InputMaybe<Scalars['Time']['input']>;
  disabledAtGTE?: InputMaybe<Scalars['Time']['input']>;
  disabledAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  disabledAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  disabledAtLT?: InputMaybe<Scalars['Time']['input']>;
  disabledAtLTE?: InputMaybe<Scalars['Time']['input']>;
  disabledAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  disabledAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  disabledAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** failure_count field predicates */
  failureCount?: InputMaybe<Scalars['Int']['input']>;
  failureCountGT?: InputMaybe<Scalars['Int']['input']>;
  failureCountGTE?: InputMaybe<Scalars['Int']['input']>;
  failureCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  failureCountLT?: InputMaybe<Scalars['Int']['input']>;
  failureCountLTE?: InputMaybe<Scalars['Int']['input']>;
  failureCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  failureCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** deliveries edge predicates */
  hasDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeliveriesWith?: InputMaybe<Array<WebhookDeliveryWhereInput>>;
  /** service_account edge predicates */
  hasServiceAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceAccountWith?: InputMaybe<Array<ServiceAccountWhereInput>>;
  /** subscriptions edge predicates */
  hasSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubscriptionsWith?: InputMaybe<Array<ServiceAccountWebhookSubscriptionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_triggered_at field predicates */
  lastTriggeredAt?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastTriggeredAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastTriggeredAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastTriggeredAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ServiceAccountWebhookWhereInput>;
  or?: InputMaybe<Array<ServiceAccountWebhookWhereInput>>;
  /** service_account_id field predicates */
  serviceAccountID?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status field predicates */
  status?: InputMaybe<WebhookStatus>;
  statusIn?: InputMaybe<Array<WebhookStatus>>;
  statusNEQ?: InputMaybe<WebhookStatus>;
  statusNotIn?: InputMaybe<Array<WebhookStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * ServiceAccountWhereInput is used for filtering ServiceAccount objects.
 * Input was generated by ent.
 */
export type ServiceAccountWhereInput = {
  and?: InputMaybe<Array<ServiceAccountWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** audit_logs edge predicates */
  hasAuditLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasAuditLogsWith?: InputMaybe<Array<ServiceAccountAuditLogWhereInput>>;
  /** keys edge predicates */
  hasKeys?: InputMaybe<Scalars['Boolean']['input']>;
  hasKeysWith?: InputMaybe<Array<ServiceAccountKeyWhereInput>>;
  /** webhooks edge predicates */
  hasWebhooks?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebhooksWith?: InputMaybe<Array<ServiceAccountWebhookWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ServiceAccountWhereInput>;
  or?: InputMaybe<Array<ServiceAccountWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetBankSupportedChannelsPayload = {
  errors: Maybe<Array<Error>>;
  organization: Maybe<Organization>;
};

export type SetDefaultPolicyInput = {
  policyId: Scalars['ID']['input'];
  policyType: PolicyType;
};

export type SetDefaultPolicyPayload = {
  defaultPolicy: Maybe<MerchantDefaultPolicy>;
  errors: Maybe<Array<Error>>;
};

export type SetOrganizationDonationEligibilityPayload = {
  errors: Maybe<Array<Error>>;
  organization: Maybe<Organization>;
};

export type SetPrimaryBankAccountPayload = {
  errors: Maybe<Array<Error>>;
  merchantBankAccount: Maybe<MerchantBankAccount>;
  previousPrimaryAccount: Maybe<MerchantBankAccount>;
};

export type SignUpUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  isTermsAccepted: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type SignUpUserPayload = {
  errors: Maybe<Array<Error>>;
  user: Maybe<User>;
};

export const SortOrder = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export type SplitPaymentConnection = {
  edges: Array<SplitPaymentEdge>;
  pageInfo: PageInfo;
};

export type SplitPaymentEdge = {
  cursor: Scalars['String']['output'];
  node: SplitPaymentInfo;
};

export type SplitPaymentInfo = {
  currency: Currency;
  payment: Payment;
  payoutCount: Scalars['Int']['output'];
  payouts: Array<Payout>;
  totalSplitAmount: Scalars['Float']['output'];
};

export type SplitPayoutInput = {
  originalPayoutId: Scalars['ID']['input'];
  splits: Array<PayoutSplitInput>;
};

export type SplitPayoutPayload = {
  errors: Maybe<Array<Error>>;
  newPayouts: Maybe<Array<Payout>>;
  originalPayout: Maybe<Payout>;
};

export type StatusChangeRecord = {
  changedAt: Scalars['Time']['output'];
  changedBy: User;
  fromStatus: UserStatus;
  id: Scalars['ID']['output'];
  reason: Maybe<Scalars['String']['output']>;
  toStatus: UserStatus;
  userId: Scalars['ID']['output'];
};

export type SubmitDisputeEvidenceInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDate?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDescription?: InputMaybe<Scalars['String']['input']>;
  creditVoucherAmount?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherDescription?: InputMaybe<Scalars['String']['input']>;
  creditVoucherGivenDate?: InputMaybe<Scalars['Time']['input']>;
  customerAlreadyRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  evidenceReason: DisputeEvidenceReason;
  id: Scalars['ID']['input'];
  otherReasonDescription?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetails?: InputMaybe<Scalars['String']['input']>;
  productServiceType?: InputMaybe<ProductServiceType>;
  refundAmount?: InputMaybe<Scalars['Float']['input']>;
  refundDate?: InputMaybe<Scalars['Time']['input']>;
  refundDescription?: InputMaybe<Scalars['String']['input']>;
  refundId?: InputMaybe<Scalars['ID']['input']>;
  withdrawalDateByCustomer?: InputMaybe<Scalars['Time']['input']>;
};

export type SubmitDisputeEvidencePayload = {
  dispute: Maybe<Dispute>;
  errors: Maybe<Array<Error>>;
};

export type SubmitTransferInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export type SubmitTransferPayload = {
  errors: Maybe<Array<Error>>;
  transfer: Maybe<Transfer>;
};

export type SuccessPayload = {
  success: Maybe<Scalars['Boolean']['output']>;
};

export type SuspendBankAccountPayload = {
  errors: Maybe<Array<Error>>;
  merchantBankAccount: Maybe<MerchantBankAccount>;
  statusChange: Maybe<BankAccountStatusChangeRecord>;
};

export type SyncRolePermissionsInput = {
  permissionIds: Array<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
};

export type SyncRolePermissionsPayload = {
  added: Array<Permission>;
  errors: Maybe<Array<Error>>;
  removed: Array<Permission>;
  role: Role;
};

export type Transfer = {
  beyulTransferCode: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: User;
  createdById: Scalars['ID']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notes: Maybe<Scalars['Map']['output']>;
  payoutCount: Scalars['Int']['output'];
  payouts: PayoutConnection;
  status: TransferStatus;
  statusUpdatedAt: Maybe<Scalars['Time']['output']>;
  totalAmount: Scalars['Float']['output'];
  transferredToBank: Organization;
  transferredToBankId: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type TransferPayoutsArgs = {
  orderBy?: InputMaybe<PayoutOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type TransferConnection = {
  edges: Array<TransferEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TransferEdge = {
  cursor: Scalars['String']['output'];
  node: Transfer;
};

export type TransferOrderByInput = {
  direction: SortOrder;
  field: TransferOrderField;
};

export const TransferOrderField = {
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  Currency: 'CURRENCY',
  Status: 'STATUS',
  StatusUpdatedAt: 'STATUS_UPDATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type TransferOrderField = typeof TransferOrderField[keyof typeof TransferOrderField];
export const TransferReportField = {
  BeyulTransferCode: 'BEYUL_TRANSFER_CODE',
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  CreatedBy: 'CREATED_BY',
  Currency: 'CURRENCY',
  Notes: 'NOTES',
  Status: 'STATUS',
  StatusUpdatedAt: 'STATUS_UPDATED_AT',
  TransferredToBankId: 'TRANSFERRED_TO_BANK_ID'
} as const;

export type TransferReportField = typeof TransferReportField[keyof typeof TransferReportField];
export const TransferStatus = {
  Completed: 'COMPLETED',
  Draft: 'DRAFT',
  Submitted: 'SUBMITTED'
} as const;

export type TransferStatus = typeof TransferStatus[keyof typeof TransferStatus];
export type TransferSummary = {
  count: Scalars['Int']['output'];
  currency: Currency;
  payoutCount: Scalars['Int']['output'];
  status: TransferStatus;
  totalAmount: Scalars['Float']['output'];
};

/**
 * TransferWhereInput is used for filtering Transfer objects.
 * Input was generated by ent.
 */
export type TransferWhereInput = {
  and?: InputMaybe<Array<TransferWhereInput>>;
  /** beyul_transfer_code field predicates */
  beyulTransferCode?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeContains?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeGT?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeGTE?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  beyulTransferCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  beyulTransferCodeLT?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeLTE?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  beyulTransferCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Currency>;
  currencyIn?: InputMaybe<Array<Currency>>;
  currencyNEQ?: InputMaybe<Currency>;
  currencyNotIn?: InputMaybe<Array<Currency>>;
  /** bank edge predicates */
  hasBank?: InputMaybe<Scalars['Boolean']['input']>;
  hasBankWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<PayoutWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TransferWhereInput>;
  or?: InputMaybe<Array<TransferWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<TransferStatus>;
  statusIn?: InputMaybe<Array<TransferStatus>>;
  statusNEQ?: InputMaybe<TransferStatus>;
  statusNotIn?: InputMaybe<Array<TransferStatus>>;
  /** status_updated_at field predicates */
  statusUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusUpdatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** transferred_to_bank_id field predicates */
  transferredToBankID?: InputMaybe<Scalars['ID']['input']>;
  transferredToBankIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  transferredToBankIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  transferredToBankIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UnassignRoleInput = {
  roleId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type UnassignRolePayload = {
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

export type UnflagPaymentInput = {
  paymentId: Scalars['ID']['input'];
};

export type UnflagPaymentPayload = {
  errors: Maybe<Array<Error>>;
  payment: Maybe<Payment>;
};

export type UpdateApiKeyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApiKeyPayload = {
  apiKey: Maybe<ApiKey>;
  errors: Maybe<Array<Error>>;
};

export type UpdateBankAccountDetailsInput = {
  accountHolderName: Scalars['String']['input'];
};

export type UpdateBankAccountDetailsPayload = {
  errors: Maybe<Array<Error>>;
  merchantBankAccount: Maybe<MerchantBankAccount>;
  requiresReVerification: Scalars['Boolean']['output'];
};

export type UpdateBillingAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBillingAddressPayload = {
  billingAddress: Maybe<BillingAddress>;
  errors: Maybe<Array<Error>>;
};

export type UpdateCardTypeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<CardType>;
};

export type UpdateCardTypePayload = {
  cardType: PaymentProviderCardType;
  errors: Maybe<Array<Error>>;
};

export type UpdateDisputeProgressInput = {
  id: Scalars['ID']['input'];
  progressStatus: DisputeProgressStatus;
};

export type UpdateDisputeProgressPayload = {
  dispute: Maybe<Dispute>;
  errors: Maybe<Array<Error>>;
};

export type UpdateInvoiceInput = {
  dueDate?: InputMaybe<Scalars['Time']['input']>;
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  paymentOptions?: InputMaybe<Array<PaymentType>>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  refundPolicyTerms?: InputMaybe<InvoiceRefundPolicyTerms>;
};

export type UpdateInvoicePayload = {
  errors: Maybe<Array<Error>>;
  invoice: Maybe<Invoice>;
};

export type UpdateLineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLineItemPayload = {
  errors: Maybe<Array<Error>>;
  lineItem: Maybe<InvoiceLineItem>;
};

export type UpdateMediaInput = {
  id: Scalars['ID']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMerchantWebhookInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WebhookStatus>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMerchantWebhookPayload = {
  errors: Maybe<Array<Error>>;
  merchantWebhook: Maybe<MerchantWebhook>;
};

export type UpdateOrganizationInput = {
  address?: InputMaybe<Scalars['Map']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['Map']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<OrganizationIndustry>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  mccCode?: InputMaybe<Scalars['String']['input']>;
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherIndustry?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  refundPolicyTerms?: InputMaybe<OrganizationRefundPolicyTerms>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationPayload = {
  errors: Maybe<Array<Error>>;
  organization: Maybe<Organization>;
};

export type UpdateOrganizationPaymentTypeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganizationPaymentTypePayload = {
  errors: Maybe<Array<Error>>;
  organizationPaymentType: Maybe<OrganizationPaymentType>;
};

export type UpdateOrganizationStatusPayload = {
  errors: Maybe<Array<Error>>;
  organization: Maybe<Organization>;
};

export type UpdatePaymentProviderInput = {
  configProfile?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['Map']['input']>;
  environment?: InputMaybe<PaymentEnvironment>;
  logoMediaId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProviderStatus>;
  /** Must be non-empty when provided — an empty list would make the provider unroutable */
  supportedChannels?: InputMaybe<Array<PaymentChannel>>;
  supportedCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePaymentProviderPayload = {
  errors: Maybe<Array<Error>>;
  paymentProvider: PaymentProvider;
};

export type UpdatePaymentTypeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayFeeType?: InputMaybe<FeeType>;
  gatewayFees?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformFeeType?: InputMaybe<FeeType>;
  platformFees?: InputMaybe<Scalars['Float']['input']>;
  supportedCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<PaymentType>;
};

export type UpdatePaymentTypePayload = {
  errors: Maybe<Array<Error>>;
  paymentType: PaymentProviderPaymentType;
};

export type UpdatePermissionGroupInput = {
  description?: InputMaybe<Scalars['Map']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePermissionGroupPayload = {
  errors: Maybe<Array<Error>>;
  permissionGroup: Maybe<PermissionGroup>;
};

export type UpdatePolicyDocumentInput = {
  content?: InputMaybe<Scalars['Map']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePolicyDocumentPayload = {
  errors: Maybe<Array<Error>>;
  policy: Maybe<PolicyDocument>;
};

export type UpdatePolicyTemplateInput = {
  content?: InputMaybe<Scalars['Map']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePolicyTemplatePayload = {
  errors: Maybe<Array<Error>>;
  template: Maybe<PolicyTemplate>;
};

export type UpdateQuickPayInput = {
  amountType?: InputMaybe<QuickPayAmountType>;
  customFields?: InputMaybe<Scalars['Map']['input']>;
  description?: InputMaybe<Scalars['Map']['input']>;
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Optional sale basket, stored verbatim; replaces the existing basket when provided */
  lineItems?: InputMaybe<Array<Scalars['Map']['input']>>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentOptions?: InputMaybe<Array<PaymentType>>;
  presetAmounts?: InputMaybe<Array<Scalars['Float']['input']>>;
  status?: InputMaybe<QuickPayStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuickPayPayload = {
  errors: Maybe<Array<Error>>;
  quickPay: Maybe<QuickPay>;
};

export type UpdateRecurringPaymentInput = {
  amount?: InputMaybe<Scalars['Int64']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  maxCharges?: InputMaybe<Scalars['Int']['input']>;
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Map']['input']>;
};

export type UpdateRecurringPaymentMethodInput = {
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardExpiryMonth?: InputMaybe<Scalars['Int']['input']>;
  cardExpiryYear?: InputMaybe<Scalars['Int']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Map']['input']>;
  providerCustomerID?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodID: Scalars['String']['input'];
  type: PaymentType;
  /** The update session ID */
  updateSessionID: Scalars['String']['input'];
};

export type UpdateRecurringPaymentMethodPayload = {
  errors: Maybe<Array<Error>>;
  paymentMethod: Maybe<PaymentMethod>;
  recurringPayment: Maybe<RecurringPayment>;
  /** Redirect URL after success (the recurring payment's success_url) */
  successURL: Scalars['String']['output'];
};

export type UpdateRecurringPaymentPayload = {
  errors: Maybe<Array<Error>>;
  recurringPayment: Maybe<RecurringPayment>;
};

export type UpdateRefundInput = {
  extendedCancellationPolicyText?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['Map']['input']>;
  subReason?: InputMaybe<Scalars['Map']['input']>;
};

export type UpdateRefundPayload = {
  errors: Maybe<Array<Error>>;
  refund: Maybe<Refund>;
};

export type UpdateRoleInput = {
  description?: InputMaybe<Scalars['Map']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRolePayload = {
  errors: Maybe<Array<Error>>;
  role: Role;
};

export type UpdateServiceAccountWebhookInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WebhookStatus>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceAccountWebhookPayload = {
  errors: Maybe<Array<Error>>;
  serviceAccountWebhook: Maybe<ServiceAccountWebhook>;
};

export type UpdateServiceAccountWebhookSubscriptionInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateServiceAccountWebhookSubscriptionPayload = {
  errors: Maybe<Array<Error>>;
  subscription: Maybe<ServiceAccountWebhookSubscription>;
};

export type UpdateTransferNotesInput = {
  id: Scalars['ID']['input'];
  notes: Scalars['Map']['input'];
};

export type UpdateTransferNotesPayload = {
  errors: Maybe<Array<Error>>;
  transfer: Maybe<Transfer>;
};

export type UpdateUserProfileInput = {
  description?: InputMaybe<Scalars['Map']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProfilePayload = {
  errors: Maybe<Array<Error>>;
  user: Maybe<User>;
};

export type UpdateUserStatusPayload = {
  errors: Maybe<Array<Error>>;
  statusChange: StatusChangeRecord;
  user: Maybe<User>;
};

export type UpdateWebhookSubscriptionInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWebhookSubscriptionPayload = {
  errors: Maybe<Array<Error>>;
  subscription: Maybe<MerchantWebhookSubscription>;
};

export type UploadUrl = {
  expiresIn: Scalars['Int64']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type User = {
  avatar: Maybe<Media>;
  createdAt: Scalars['Time']['output'];
  deletedAt: Maybe<Scalars['Time']['output']>;
  description: Maybe<Scalars['Map']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  isOwner: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt: Maybe<Scalars['Time']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  organization: Maybe<Organization>;
  organizationId: Maybe<Scalars['ID']['output']>;
  permissions: Array<Permission>;
  roles: Maybe<Array<Role>>;
  status: UserStatus;
  updatedAt: Scalars['Time']['output'];
  userRoles: Maybe<Array<UserRole>>;
};

export type UserComplianceStatus = {
  acceptedPolicies: Array<UserPolicyAcceptance>;
  isCompliant: Scalars['Boolean']['output'];
  pendingPolicies: Array<PolicyDocument>;
};

export type UserConnection = {
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserEdge = {
  cursor: Scalars['String']['output'];
  node: User;
};

/**
 * UserOTPWhereInput is used for filtering UserOTP objects.
 * Input was generated by ent.
 */
export type UserOtpWhereInput = {
  and?: InputMaybe<Array<UserOtpWhereInput>>;
  /** attempts field predicates */
  attempts?: InputMaybe<Scalars['Int']['input']>;
  attemptsGT?: InputMaybe<Scalars['Int']['input']>;
  attemptsGTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  attemptsLT?: InputMaybe<Scalars['Int']['input']>;
  attemptsLTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsNEQ?: InputMaybe<Scalars['Int']['input']>;
  attemptsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** consumed_at field predicates */
  consumedAt?: InputMaybe<Scalars['Time']['input']>;
  consumedAtGT?: InputMaybe<Scalars['Time']['input']>;
  consumedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  consumedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  consumedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  consumedAtLT?: InputMaybe<Scalars['Time']['input']>;
  consumedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  consumedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  consumedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  consumedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** expires_at field predicates */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UserOtpWhereInput>;
  or?: InputMaybe<Array<UserOtpWhereInput>>;
  /** purpose field predicates */
  purpose?: InputMaybe<OtpPurpose>;
  purposeIn?: InputMaybe<Array<OtpPurpose>>;
  purposeNEQ?: InputMaybe<OtpPurpose>;
  purposeNotIn?: InputMaybe<Array<OtpPurpose>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserOrderByField = {
  direction: SortOrder;
  field: UserOrderField;
};

export const UserOrderField = {
  CreatedAt: 'CREATED_AT',
  Email: 'EMAIL',
  FirstName: 'FIRST_NAME',
  LastLoginAt: 'LAST_LOGIN_AT',
  LastName: 'LAST_NAME',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type UserOrderField = typeof UserOrderField[keyof typeof UserOrderField];
export type UserPolicyAcceptance = {
  acceptedAt: Scalars['Time']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  isCurrent: Scalars['Boolean']['output'];
  policy: PolicyDocument;
  supersededBy: Maybe<UserPolicyAcceptance>;
  user: User;
  userAgent: Maybe<Scalars['String']['output']>;
};

export type UserPolicyAcceptanceConnection = {
  edges: Array<UserPolicyAcceptanceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserPolicyAcceptanceEdge = {
  cursor: Scalars['String']['output'];
  node: UserPolicyAcceptance;
};

/**
 * UserPolicyAcceptanceWhereInput is used for filtering UserPolicyAcceptance objects.
 * Input was generated by ent.
 */
export type UserPolicyAcceptanceWhereInput = {
  /** accepted_at field predicates */
  acceptedAt?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtGT?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  acceptedAtLT?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  and?: InputMaybe<Array<UserPolicyAcceptanceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** policy edge predicates */
  hasPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyWith?: InputMaybe<Array<PolicyDocumentWhereInput>>;
  /** superseded_acceptances edge predicates */
  hasSupersededAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededAcceptancesWith?: InputMaybe<Array<UserPolicyAcceptanceWhereInput>>;
  /** superseded_by edge predicates */
  hasSupersededBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededByWith?: InputMaybe<Array<UserPolicyAcceptanceWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ip_address field predicates */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddressContains?: InputMaybe<Scalars['String']['input']>;
  ipAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressGT?: InputMaybe<Scalars['String']['input']>;
  ipAddressGTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ipAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddressLT?: InputMaybe<Scalars['String']['input']>;
  ipAddressLTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  ipAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_current field predicates */
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<UserPolicyAcceptanceWhereInput>;
  or?: InputMaybe<Array<UserPolicyAcceptanceWhereInput>>;
  /** policy_id field predicates */
  policyID?: InputMaybe<Scalars['ID']['input']>;
  policyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  policyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  policyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** superseded_by_id field predicates */
  supersededByID?: InputMaybe<Scalars['ID']['input']>;
  supersededByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  supersededByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  supersededByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  supersededByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  supersededByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_agent field predicates */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userAgentContains?: InputMaybe<Scalars['String']['input']>;
  userAgentContainsFold?: InputMaybe<Scalars['String']['input']>;
  userAgentEqualFold?: InputMaybe<Scalars['String']['input']>;
  userAgentGT?: InputMaybe<Scalars['String']['input']>;
  userAgentGTE?: InputMaybe<Scalars['String']['input']>;
  userAgentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userAgentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userAgentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userAgentLT?: InputMaybe<Scalars['String']['input']>;
  userAgentLTE?: InputMaybe<Scalars['String']['input']>;
  userAgentNEQ?: InputMaybe<Scalars['String']['input']>;
  userAgentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserRole = {
  assignedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  role: Role;
  roleId: Scalars['ID']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type UserRoleConnection = {
  edges: Array<UserRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserRoleEdge = {
  cursor: Scalars['String']['output'];
  node: UserRole;
};

/**
 * UserRoleWhereInput is used for filtering UserRole objects.
 * Input was generated by ent.
 */
export type UserRoleWhereInput = {
  and?: InputMaybe<Array<UserRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UserRoleWhereInput>;
  or?: InputMaybe<Array<UserRoleWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSortInput = {
  orderBy: Array<UserOrderByField>;
};

export const UserStatus = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Pending: 'PENDING',
  Suspended: 'SUSPENDED'
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];
/**
 * UserWhereInput is used for filtering User objects.
 * Input was generated by ent.
 */
export type UserWhereInput = {
  and?: InputMaybe<Array<UserWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** email_verification_token field predicates */
  emailVerificationToken?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenContains?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenGT?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenGTE?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailVerificationTokenIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerificationTokenLT?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenLTE?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailVerificationTokenNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** first_name field predicates */
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameContains?: InputMaybe<Scalars['String']['input']>;
  firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  firstNameGT?: InputMaybe<Scalars['String']['input']>;
  firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameLT?: InputMaybe<Scalars['String']['input']>;
  firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** events edge predicates */
  hasEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasEventsWith?: InputMaybe<Array<EventWhereInput>>;
  /** generated_api_keys edge predicates */
  hasGeneratedAPIKeys?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeneratedAPIKeysWith?: InputMaybe<Array<ApiKeyWhereInput>>;
  /** invoices edge predicates */
  hasInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoicesWith?: InputMaybe<Array<InvoiceWhereInput>>;
  /** manually_approved_invoices edge predicates */
  hasManuallyApprovedInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  hasManuallyApprovedInvoicesWith?: InputMaybe<Array<InvoiceWhereInput>>;
  /** media edge predicates */
  hasMedia?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediaWith?: InputMaybe<Array<MediaWhereInput>>;
  /** merchant_policy_acceptances edge predicates */
  hasMerchantPolicyAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantPolicyAcceptancesWith?: InputMaybe<Array<MerchantPolicyAcceptanceWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<OrganizationWhereInput>>;
  /** otps edge predicates */
  hasOtps?: InputMaybe<Scalars['Boolean']['input']>;
  hasOtpsWith?: InputMaybe<Array<UserOtpWhereInput>>;
  /** policy_acceptances edge predicates */
  hasPolicyAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyAcceptancesWith?: InputMaybe<Array<UserPolicyAcceptanceWhereInput>>;
  /** refunds edge predicates */
  hasRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefundsWith?: InputMaybe<Array<RefundWhereInput>>;
  /** roles edge predicates */
  hasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolesWith?: InputMaybe<Array<RoleWhereInput>>;
  /** transfers edge predicates */
  hasTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  hasTransfersWith?: InputMaybe<Array<TransferWhereInput>>;
  /** user_roles edge predicates */
  hasUserRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserRolesWith?: InputMaybe<Array<UserRoleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_email_verified field predicates */
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerifiedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_owner field predicates */
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isOwnerIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  isOwnerNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  isOwnerNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_login_at field predicates */
  lastLoginAt?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastLoginAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastLoginAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_name field predicates */
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameContains?: InputMaybe<Scalars['String']['input']>;
  lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastNameGT?: InputMaybe<Scalars['String']['input']>;
  lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameLT?: InputMaybe<Scalars['String']['input']>;
  lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** magic_link_token_expiry field predicates */
  magicLinkTokenExpiry?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  magicLinkTokenExpiryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  magicLinkTokenExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  magicLinkTokenExpiryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<UserWhereInput>;
  or?: InputMaybe<Array<UserWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** password_reset_token_expiry field predicates */
  passwordResetTokenExpiry?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  passwordResetTokenExpiryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  passwordResetTokenExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  passwordResetTokenExpiryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<UserStatus>;
  statusContains?: InputMaybe<UserStatus>;
  statusContainsFold?: InputMaybe<UserStatus>;
  statusEqualFold?: InputMaybe<UserStatus>;
  statusGT?: InputMaybe<UserStatus>;
  statusGTE?: InputMaybe<UserStatus>;
  statusHasPrefix?: InputMaybe<UserStatus>;
  statusHasSuffix?: InputMaybe<UserStatus>;
  statusIn?: InputMaybe<Array<UserStatus>>;
  statusLT?: InputMaybe<UserStatus>;
  statusLTE?: InputMaybe<UserStatus>;
  statusNEQ?: InputMaybe<UserStatus>;
  statusNotIn?: InputMaybe<Array<UserStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerifyBankAccountInput = {
  accountId: Scalars['ID']['input'];
  amount1: Scalars['Int']['input'];
  amount2: Scalars['Int']['input'];
};

export type VerifyBankAccountPayload = {
  errors: Maybe<Array<Error>>;
  merchantBankAccount: Maybe<MerchantBankAccount>;
  verified: Scalars['Boolean']['output'];
};

export type VerifyEmailInput = {
  token: Scalars['String']['input'];
};

export type VerifyEmailPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type VerifyEmailWithOtpInput = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};

export type VerifyLoginOtpInput = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};

export type VerifyMagicLinkInput = {
  token: Scalars['String']['input'];
};

export type VerifyMagicLinkPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<AuthenticationError>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type VerifyOtpInput = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  purpose: OtpPurpose;
};

export type VerifyOtpPayload = {
  errors: Maybe<Array<AuthenticationError>>;
  expiresAt: Maybe<Scalars['Time']['output']>;
  verificationToken: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type VoidInvoicePayload = {
  errors: Maybe<Array<Error>>;
  invoice: Maybe<Invoice>;
};

export const WebPaymentsRefundPolicyTerms = {
  FullRefund: 'FULL_REFUND',
  NoRefund: 'NO_REFUND',
  ProcessingFeeNotRefunded: 'PROCESSING_FEE_NOT_REFUNDED'
} as const;

export type WebPaymentsRefundPolicyTerms = typeof WebPaymentsRefundPolicyTerms[keyof typeof WebPaymentsRefundPolicyTerms];
export type WebhookDelivery = {
  attemptNumber: Scalars['Int']['output'];
  completedAt: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  durationMs: Maybe<Scalars['Int']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  eventID: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idempotencyKey: Scalars['String']['output'];
  maxAttempts: Scalars['Int']['output'];
  nextRetryAt: Maybe<Scalars['Time']['output']>;
  organizationID: Maybe<Scalars['ID']['output']>;
  requestBody: Scalars['String']['output'];
  requestHeaders: Scalars['Map']['output'];
  requestURL: Scalars['String']['output'];
  responseBody: Maybe<Scalars['String']['output']>;
  responseHeaders: Maybe<Scalars['Map']['output']>;
  responseStatusCode: Maybe<Scalars['Int']['output']>;
  serviceAccountWebhookID: Maybe<Scalars['ID']['output']>;
  status: WebhookDeliveryStatus;
  triggeredAt: Scalars['Time']['output'];
  updatedAt: Scalars['Time']['output'];
  webhook: Maybe<MerchantWebhook>;
  webhookID: Maybe<Scalars['ID']['output']>;
};

export type WebhookDeliveryConnection = {
  edges: Array<WebhookDeliveryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WebhookDeliveryEdge = {
  cursor: Scalars['String']['output'];
  node: WebhookDelivery;
};

export type WebhookDeliveryOrderByInput = {
  direction: SortOrder;
  field: WebhookDeliveryOrderField;
};

export const WebhookDeliveryOrderField = {
  EventType: 'EVENT_TYPE',
  Status: 'STATUS',
  TriggeredAt: 'TRIGGERED_AT'
} as const;

export type WebhookDeliveryOrderField = typeof WebhookDeliveryOrderField[keyof typeof WebhookDeliveryOrderField];
export const WebhookDeliveryStatus = {
  Failed: 'FAILED',
  Pending: 'PENDING',
  Success: 'SUCCESS',
  Trying: 'TRYING'
} as const;

export type WebhookDeliveryStatus = typeof WebhookDeliveryStatus[keyof typeof WebhookDeliveryStatus];
/**
 * WebhookDeliveryWhereInput is used for filtering WebhookDelivery objects.
 * Input was generated by ent.
 */
export type WebhookDeliveryWhereInput = {
  and?: InputMaybe<Array<WebhookDeliveryWhereInput>>;
  /** attempt_number field predicates */
  attemptNumber?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberGT?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  attemptNumberLT?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** completed_at field predicates */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedAtGT?: InputMaybe<Scalars['Time']['input']>;
  completedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  completedAtLT?: InputMaybe<Scalars['Time']['input']>;
  completedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  completedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** duration_ms field predicates */
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  durationMsGT?: InputMaybe<Scalars['Int']['input']>;
  durationMsGTE?: InputMaybe<Scalars['Int']['input']>;
  durationMsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  durationMsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  durationMsLT?: InputMaybe<Scalars['Int']['input']>;
  durationMsLTE?: InputMaybe<Scalars['Int']['input']>;
  durationMsNEQ?: InputMaybe<Scalars['Int']['input']>;
  durationMsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  durationMsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** error_code field predicates */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorCodeContains?: InputMaybe<Scalars['String']['input']>;
  errorCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorCodeGT?: InputMaybe<Scalars['String']['input']>;
  errorCodeGTE?: InputMaybe<Scalars['String']['input']>;
  errorCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorCodeLT?: InputMaybe<Scalars['String']['input']>;
  errorCodeLTE?: InputMaybe<Scalars['String']['input']>;
  errorCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  errorCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** error_message field predicates */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorMessageContains?: InputMaybe<Scalars['String']['input']>;
  errorMessageContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorMessageEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorMessageGT?: InputMaybe<Scalars['String']['input']>;
  errorMessageGTE?: InputMaybe<Scalars['String']['input']>;
  errorMessageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorMessageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorMessageIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMessageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorMessageLT?: InputMaybe<Scalars['String']['input']>;
  errorMessageLTE?: InputMaybe<Scalars['String']['input']>;
  errorMessageNEQ?: InputMaybe<Scalars['String']['input']>;
  errorMessageNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMessageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** event_id field predicates */
  eventID?: InputMaybe<Scalars['String']['input']>;
  eventIDContains?: InputMaybe<Scalars['String']['input']>;
  eventIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventIDGT?: InputMaybe<Scalars['String']['input']>;
  eventIDGTE?: InputMaybe<Scalars['String']['input']>;
  eventIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventIDLT?: InputMaybe<Scalars['String']['input']>;
  eventIDLTE?: InputMaybe<Scalars['String']['input']>;
  eventIDNEQ?: InputMaybe<Scalars['String']['input']>;
  eventIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** event_type field predicates */
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventTypeContains?: InputMaybe<Scalars['String']['input']>;
  eventTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeGT?: InputMaybe<Scalars['String']['input']>;
  eventTypeGTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventTypeLT?: InputMaybe<Scalars['String']['input']>;
  eventTypeLTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  eventTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** service_account_webhook edge predicates */
  hasServiceAccountWebhook?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceAccountWebhookWith?: InputMaybe<Array<ServiceAccountWebhookWhereInput>>;
  /** webhook edge predicates */
  hasWebhook?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebhookWith?: InputMaybe<Array<MerchantWebhookWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** idempotency_key field predicates */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyContains?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyGT?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyGTE?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotencyKeyLT?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyLTE?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** max_attempts field predicates */
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsGT?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsGTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxAttemptsLT?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsLTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsNEQ?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** next_retry_at field predicates */
  nextRetryAt?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtGT?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtGTE?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextRetryAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextRetryAtLT?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtLTE?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextRetryAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<WebhookDeliveryWhereInput>;
  or?: InputMaybe<Array<WebhookDeliveryWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDGT?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  organizationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIDLT?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  organizationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_body field predicates */
  requestBody?: InputMaybe<Scalars['String']['input']>;
  requestBodyContains?: InputMaybe<Scalars['String']['input']>;
  requestBodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestBodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestBodyGT?: InputMaybe<Scalars['String']['input']>;
  requestBodyGTE?: InputMaybe<Scalars['String']['input']>;
  requestBodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestBodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestBodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestBodyLT?: InputMaybe<Scalars['String']['input']>;
  requestBodyLTE?: InputMaybe<Scalars['String']['input']>;
  requestBodyNEQ?: InputMaybe<Scalars['String']['input']>;
  requestBodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** request_url field predicates */
  requestURL?: InputMaybe<Scalars['String']['input']>;
  requestURLContains?: InputMaybe<Scalars['String']['input']>;
  requestURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestURLGT?: InputMaybe<Scalars['String']['input']>;
  requestURLGTE?: InputMaybe<Scalars['String']['input']>;
  requestURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestURLLT?: InputMaybe<Scalars['String']['input']>;
  requestURLLTE?: InputMaybe<Scalars['String']['input']>;
  requestURLNEQ?: InputMaybe<Scalars['String']['input']>;
  requestURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** response_body field predicates */
  responseBody?: InputMaybe<Scalars['String']['input']>;
  responseBodyContains?: InputMaybe<Scalars['String']['input']>;
  responseBodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  responseBodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseBodyGT?: InputMaybe<Scalars['String']['input']>;
  responseBodyGTE?: InputMaybe<Scalars['String']['input']>;
  responseBodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseBodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseBodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseBodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseBodyLT?: InputMaybe<Scalars['String']['input']>;
  responseBodyLTE?: InputMaybe<Scalars['String']['input']>;
  responseBodyNEQ?: InputMaybe<Scalars['String']['input']>;
  responseBodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseBodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** response_status_code field predicates */
  responseStatusCode?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeGT?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeGTE?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseStatusCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseStatusCodeLT?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeLTE?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeNEQ?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseStatusCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** service_account_webhook_id field predicates */
  serviceAccountWebhookID?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountWebhookIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountWebhookIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  serviceAccountWebhookIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountWebhookIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountWebhookIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<WebhookDeliveryStatus>;
  statusIn?: InputMaybe<Array<WebhookDeliveryStatus>>;
  statusNEQ?: InputMaybe<WebhookDeliveryStatus>;
  statusNotIn?: InputMaybe<Array<WebhookDeliveryStatus>>;
  /** triggered_at field predicates */
  triggeredAt?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtGT?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  triggeredAtLT?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** webhook_id field predicates */
  webhookID?: InputMaybe<Scalars['ID']['input']>;
  webhookIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  webhookIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  webhookIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  webhookIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  webhookIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WebhookEventType = {
  category: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  deprecatedMessage: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeprecated: Scalars['Boolean']['output'];
  payloadExample: Maybe<Scalars['Map']['output']>;
  replacesEventType: Maybe<Scalars['String']['output']>;
  subscriptions: Maybe<Array<MerchantWebhookSubscription>>;
  updatedAt: Scalars['Time']['output'];
};

/**
 * WebhookEventTypeWhereInput is used for filtering WebhookEventType objects.
 * Input was generated by ent.
 */
export type WebhookEventTypeWhereInput = {
  and?: InputMaybe<Array<WebhookEventTypeWhereInput>>;
  /** category field predicates */
  category?: InputMaybe<Scalars['String']['input']>;
  categoryContains?: InputMaybe<Scalars['String']['input']>;
  categoryContainsFold?: InputMaybe<Scalars['String']['input']>;
  categoryEqualFold?: InputMaybe<Scalars['String']['input']>;
  categoryGT?: InputMaybe<Scalars['String']['input']>;
  categoryGTE?: InputMaybe<Scalars['String']['input']>;
  categoryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  categoryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  categoryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryLT?: InputMaybe<Scalars['String']['input']>;
  categoryLTE?: InputMaybe<Scalars['String']['input']>;
  categoryNEQ?: InputMaybe<Scalars['String']['input']>;
  categoryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deprecated_message field predicates */
  deprecatedMessage?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageContains?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageContainsFold?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageEqualFold?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageGT?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageGTE?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deprecatedMessageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedMessageLT?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageLTE?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageNEQ?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deprecatedMessageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  displayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  displayNameGT?: InputMaybe<Scalars['String']['input']>;
  displayNameGTE?: InputMaybe<Scalars['String']['input']>;
  displayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  displayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  displayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameLT?: InputMaybe<Scalars['String']['input']>;
  displayNameLTE?: InputMaybe<Scalars['String']['input']>;
  displayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  displayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** event_type field predicates */
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventTypeContains?: InputMaybe<Scalars['String']['input']>;
  eventTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeGT?: InputMaybe<Scalars['String']['input']>;
  eventTypeGTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventTypeLT?: InputMaybe<Scalars['String']['input']>;
  eventTypeLTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  eventTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sa_subscriptions edge predicates */
  hasSaSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSaSubscriptionsWith?: InputMaybe<Array<ServiceAccountWebhookSubscriptionWhereInput>>;
  /** subscriptions edge predicates */
  hasSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubscriptionsWith?: InputMaybe<Array<MerchantWebhookSubscriptionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_deprecated field predicates */
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecatedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<WebhookEventTypeWhereInput>;
  or?: InputMaybe<Array<WebhookEventTypeWhereInput>>;
  /** replaces_event_type field predicates */
  replacesEventType?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeContains?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeGT?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeGTE?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  replacesEventTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  replacesEventTypeLT?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeLTE?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  replacesEventTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export const WebhookStatus = {
  Active: 'ACTIVE',
  Disabled: 'DISABLED',
  Paused: 'PAUSED'
} as const;

export type WebhookStatus = typeof WebhookStatus[keyof typeof WebhookStatus];
export type ApiKeyFieldsFragment = { id: string, ownerId: string, apiKey: string, name: string, isActive: boolean, generatedBy: string, createdAt: string, updatedAt: string, maskedApiKey: string, ageInDays: number };

export type ApiKeyWithOwnerFieldsFragment = { id: string, ownerId: string, apiKey: string, name: string, isActive: boolean, generatedBy: string, createdAt: string, updatedAt: string, maskedApiKey: string, ageInDays: number, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType, status: OrganizationStatus }, generator: { id: string, firstName: string, lastName: string | null, email: string, fullName: string } };

export type ApiPaymentFieldsFragment = { id: string, code: string, accessKey: string, status: ApiPaymentsStatus, merchantProcessingFee: number, ownerId: string, amount: number, currency: string, orderId: string, responseUrl: string, cancelUrl: string, metadata: any, apiKey: string | null, paymentOptions: Array<PaymentType>, refundPolicyTerms: WebPaymentsRefundPolicyTerms, createdAt: string, updatedAt: string, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null };

export type ApiPaymentOverviewFieldsFragment = { id: string, code: string, orderId: string, amount: number, currency: string, status: ApiPaymentsStatus, merchantProcessingFee: number, createdAt: string, updatedAt: string, metadata: any, owner: { name: string }, fees: { paymentType: PaymentType | null } | null };

export type BankFieldsFragment = { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, users: Array<{ description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null }> };

export type BankOverviewFieldsFragment = { id: string, name: string, email: string, status: OrganizationStatus, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null };

export type DisputeOverviewFieldsFragment = { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchant: { name: string }, payment: { customerName: string | null } };

export type DisputeFieldsFragment = { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchantResponseDueDate: string, createdAt: string, updatedAt: string, additionalInformation: string | null, cancellationDelayDate: string | null, cancellationDelayDescription: string | null, creditVoucherAmount: number | null, creditVoucherDescription: string | null, creditVoucherGivenDate: string | null, customerAlreadyRefunded: boolean, environment: PaymentEnvironment, evidenceReason: DisputeEvidenceReason | null, gatewayDisputeId: string | null, gatewayName: string | null, otherReasonDescription: string | null, productOrServiceDetails: string | null, productServiceType: ProductServiceType | null, reason: DisputeReason, refundAmount: number | null, refundDate: string | null, refundDescription: string | null, resolutionDate: string | null, statusUpdatedAt: string | null, withdrawalDateByCustomer: string | null, merchant: { id: string, name: string, email: string, phoneNumber: string | null }, payment: { id: string, code: string, amount: number, currency: Currency, customerName: string | null, customerEmail: string | null, createdAt: string, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, invoice: { id: string, code: string, accessKey: string, subtotal: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, createdAt: string, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number }>, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null }, refund: { id: string, code: string, amount: number, status: RefundStatus, createdAt: string } | null, evidenceDocumentUrl: Array<{ url: string, expiresIn: any }> | null, providerDocs: Array<{ id: string, Name: string, url: { url: string, expiresIn: any } }> | null };

export type AuthenticationErrorFieldsFragment = { code: ErrorCode, field: string | null, message: string };

export type InvoiceOverviewFieldsFragment = { id: string, code: string, status: InvoiceStatus, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, subtotal: number, merchantProcessingFee: number, createdAt: string };

export type InvoiceLineItemFieldsFragment = { id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string };

export type InvoiceFieldsFragment = { id: string, code: string, accessKey: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, createdById: string, receipt: { url: string, expiresIn: any } | null, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string }> };

export type InvoiceFieldsForListingFragment = { id: string, code: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, fees: { paymentType: PaymentType | null } | null };

export type InvoiceWithItemsForListingFieldsFragment = { id: string, code: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string }>, fees: { paymentType: PaymentType | null } | null };

export type BasicMeFieldsFragment = { id: string, email: string, firstName: string, lastName: string | null, fullName: string, description: any | null, isEmailVerified: boolean, status: UserStatus, createdAt: string, updatedAt: string };

export type MeFieldsFragment = { id: string, email: string, firstName: string, lastName: string | null, fullName: string, description: any | null, isEmailVerified: boolean, status: UserStatus, createdAt: string, updatedAt: string, organizationId: string | null, lastLoginAt: string | null, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null, permissions: Array<{ id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null }> };

export type MeOrganizationFieldsFragment = { id: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null };

export type MediaAvatarFieldsFragment = { id: string, name: string, imgixUrl: string | null };

export type MediaFieldsFragment = { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } };

export type MediaWithUserFragment = { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string } | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } };

export type MerchantBankAccountOverviewFieldsFragment = { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumberMasked: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string };

export type MerchantBankAccountFieldsFragment = { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string }, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } };

export type MerchantWebhookFieldsFragment = { id: string, organizationID: string, name: string, url: string, status: WebhookStatus, description: string | null, failureCount: number, lastTriggeredAt: string | null, disabledAt: string | null, metadata: any | null, secret: string, createdAt: string, updatedAt: string, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } };

export type MerchantWebhookOverviewFieldsFragment = { id: string, organizationID: string, name: string, url: string, status: WebhookStatus, description: string | null, failureCount: number, lastTriggeredAt: string | null, disabledAt: string | null, metadata: any | null, createdAt: string, updatedAt: string, subscriptions: Array<{ id: string }> | null, deliveries: Array<{ id: string, durationMs: number | null, triggeredAt: string, status: WebhookDeliveryStatus }> | null };

export type ErrorFieldsFragment = { code: ErrorCode, field: string | null, message: string };

export type OrganizationOverviewFieldsFragment = { id: string, name: string, code: string, description: any | null, mccCode: string | null, createdAt: string, status: OrganizationStatus, users: Array<{ id: string }> };

export type OrganizationFieldsFragment = { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null };

export type OrganizationMeFieldsFragment = { id: string, name: string, description: any | null, mccCode: string | null, createdAt: string };

export type BankListOverviewFieldsFragment = { id: string, name: string, code: string, email: string, phoneNumber: string | null, country: string | null, status: OrganizationStatus, supportedChannels: Array<PaymentChannel>, createdAt: string, users: Array<{ id: string }> };

export type PageInfoFieldsFragment = { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null };

export type PaymentOverviewFieldsFragment = { id: string, code: string, netAmount: number, amount: number, currency: Currency, status: PaymentStatus, customerName: string | null, customerEmail: string | null, createdAt: string, is_flagged: boolean | null, flag_reason: any | null, paymentType: PaymentType, paymentProvider: { id: string, name: string, slug: string }, invoice: { fees: { paymentType: PaymentType | null } | null, billingAddresses: Array<{ id: string, label: string | null, line1: string, line2: string | null, postalCode: string | null, state: string | null, city: string, country: string } | null> | null } | null, apiPayment: { fees: { paymentType: PaymentType | null } | null } | null };

export type PaymentFieldsFragment = { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string };

export type PaymentMethodFieldsFragment = { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } };

export type PaymentProviderCardTypeFieldsFragment = { id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string };

export type PaymentProviderOverviewFieldsFragment = { id: string, name: string, createdAt: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, supportedChannels: Array<PaymentChannel>, updatedAt: string };

export type PaymentProviderFieldsFragment = { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> };

export type PaymentProviderPaymentTypeFieldsFragment = { id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } };

export type PayoutListFieldsFragment = { id: string, code: string, amount: number, currency: Currency, status: PayoutStatus, createdAt: string, completedAt: string | null, processedAt: string | null, payment: { id: string, code: string, owner_id: string, paymentProvider: { id: string, name: string, slug: string }, invoice: { id: string, code: string } | null }, receiverMerchant: { name: string } };

export type PayoutDetailFieldsFragment = { id: string, code: string, paymentId: string, payoutType: PayoutType, status: PayoutStatus, currency: Currency, amount: number, processedAt: string | null, completedAt: string | null, isSplit: boolean, splitCount: number, parent_payout_id: string | null, bankAccountId: string | null, transferId: string | null, transferCode: string | null, receiverMerchant: { id: string, name: string, email: string }, bankAccount: { id: string, accountHolderName: string, accountNumberMasked: string, type: BankAccountType, bank: { id: string, name: string } } | null, payment: { id: string, code: string, owner_id: string, amount: number, netAmount: number, currency: Currency, customerName: string | null, customerEmail: string | null, paymentProvider: { id: string, name: string, slug: string }, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, invoice: { id: string, code: string, payoutAmount: number, subtotal: number } | null, recurringPayment: { id: string, code: string } | null, quickPay: { id: string, code: string } | null, apiPayment: { id: string, code: string } | null } };

export type AvailablePayoutsForTransferFieldsFragment = { id: string, code: string, paymentId: string, receivingMerchantId: string, bankAccountId: string | null, refundId: string | null, disputeId: string | null, parent_payout_id: string | null, amount: number, currency: Currency, status: PayoutStatus, payoutType: PayoutType, processedAt: string | null, completedAt: string | null, notes: any | null, createdAt: string, updatedAt: string, isSplit: boolean, splitCount: number, payment: { id: string, code: string }, receiverMerchant: { id: string, name: string }, bankAccount: { id: string, accountHolderName: string, accountNumberMasked: string } | null, refund: { id: string } | null, dispute: { id: string } | null };

export type PermissionFieldsFragment = { id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null };

export type PresignUrlFragment = { url: string, key: string, expiresIn: any };

export type QuickPayFieldsForListingFragment = { id: string, code: string, title: string, status: QuickPayStatus, isDefault: boolean, amountType: QuickPayAmountType, currency: Currency, paymentURL: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string } };

export type QuickPayFieldsForDetailFragment = { accessKey: string, description: any | null, customFields: any, expiresAt: string | null, fixedAmount: number | null, minAmount: number | null, maxAmount: number | null, presetAmounts: Array<number> | null, merchantProcessingFee: number, refundPolicyTerms: QuickPayRefundPolicyTerms, paymentOptions: Array<PaymentType>, id: string, code: string, title: string, status: QuickPayStatus, isDefault: boolean, amountType: QuickPayAmountType, currency: Currency, paymentURL: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, qrCode: { url: string, format: QrCodeFormat, size: QrCodeSize } };

export type RecurringPaymentFieldsFragment = { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null };

export type RecurringPaymentOverviewFieldsFragment = { id: string, code: string, amount: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, nextChargeDate: string | null, chargesCount: number, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, chargeImmediately: boolean, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string } };

export type RefundCreatedByFieldsFragment = { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string };

export type RefundFieldsFragment = { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null };

export type RefundOverviewFieldsFragment = { id: string, code: string, amount: number, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, reason: any | null, environment: PaymentEnvironment, paymentId: string, createdAt: string, updatedAt: string, payment: { id: string, amount: number, status: PaymentStatus, customerName: string | null, customerEmail: string | null } };

export type RoleFieldsFragment = { id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string };

export type RoleWithPermissionsFieldsFragment = { id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string, userCount: number, permissionCount: number, permissions: { totalCount: number, edges: Array<{ node: { id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } }, users: Array<{ id: string, organizationId: string | null, firstName: string, lastName: string | null, email: string, description: any | null, status: UserStatus, isEmailVerified: boolean, isOwner: boolean | null, lastLoginAt: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, fullName: string } | null> };

export type TransferFieldsFragment = { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } };

export type TransferOverviewFieldsFragment = { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, name: string } };

export type UserBasicFieldsFragment = { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string };

export type UserFieldsFragment = { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null };

export type UserDetailFieldsFragment = { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null, userRoles: Array<{ id: string, userId: string, roleId: string, role: { name: string } }> | null, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null };

export type UserRoleFieldsFragment = { id: string, userId: string, roleId: string, role: { name: string } };

export type UserOverviewFieldsFragment = { id: string, email: string, firstName: string, lastName: string | null, fullName: string, isEmailVerified: boolean, status: UserStatus, createdAt: string, updatedAt: string, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, avatar: { id: string, name: string, imgixUrl: string | null } | null, userRoles: Array<{ id: string, userId: string, roleId: string, role: { name: string } }> | null };

export type WebhookDeliveryFieldsFragment = { id: string, webhookID: string | null, organizationID: string | null, eventID: string, eventType: string, idempotencyKey: string, requestURL: string, requestHeaders: any, requestBody: string, responseStatusCode: number | null, responseHeaders: any | null, responseBody: string | null, durationMs: number | null, triggeredAt: string, completedAt: string | null, status: WebhookDeliveryStatus, attemptNumber: number, maxAttempts: number, nextRetryAt: string | null, errorMessage: string | null, errorCode: string | null, createdAt: string, updatedAt: string };

export type WebhookEventTypeFieldsFragment = { id: string, eventType: string, category: string, displayName: string, description: string | null, payloadExample: any | null, isActive: boolean, isDeprecated: boolean, deprecatedMessage: string | null, replacesEventType: string | null, createdAt: string, updatedAt: string };

export type WebhookSubscriptionFieldsFragment = { id: string, merchantWebhookID: string, webhookEventTypeID: string, isEnabled: boolean, metadata: any | null, createdAt: string, updatedAt: string, webhookEventType: { id: string, eventType: string, category: string, displayName: string, description: string | null, payloadExample: any | null, isActive: boolean, isDeprecated: boolean, deprecatedMessage: string | null, replacesEventType: string | null, createdAt: string, updatedAt: string } };

export type ActivateApiKeyMutationVariables = Exact<{
  activateApiKeyId: Scalars['ID']['input'];
}>;


export type ActivateApiKeyMutation = { activateAPIKey: { apiKey: { id: string, ownerId: string, apiKey: string, name: string, isActive: boolean, generatedBy: string, createdAt: string, updatedAt: string, maskedApiKey: string, ageInDays: number, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType, status: OrganizationStatus }, generator: { id: string, firstName: string, lastName: string | null, email: string, fullName: string } } | null, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } | null };

export type DeactivateApiKeyMutationVariables = Exact<{
  deactivateApiKeyId: Scalars['ID']['input'];
}>;


export type DeactivateApiKeyMutation = { deactivateAPIKey: { apiKey: { id: string, ownerId: string, apiKey: string, name: string, isActive: boolean, generatedBy: string, createdAt: string, updatedAt: string, maskedApiKey: string, ageInDays: number, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType, status: OrganizationStatus }, generator: { id: string, firstName: string, lastName: string | null, email: string, fullName: string } } | null, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } | null };

export type DeleteApiKeyMutationVariables = Exact<{
  deleteApiKeyId: Scalars['ID']['input'];
}>;


export type DeleteApiKeyMutation = { deleteAPIKey: { success: boolean | null, deletedKeyId: string | null, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } | null };

export type GenerateApiKeyMutationVariables = Exact<{
  input: GenerateApiKeyInput;
}>;


export type GenerateApiKeyMutation = { generateAPIKey: { secretKey: string | null, apiKey: { id: string, ownerId: string, apiKey: string, name: string, isActive: boolean, generatedBy: string, createdAt: string, updatedAt: string, maskedApiKey: string, ageInDays: number, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType, status: OrganizationStatus }, generator: { id: string, firstName: string, lastName: string | null, email: string, fullName: string } } | null, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } | null };

export type UpdateApiKeyMutationVariables = Exact<{
  updateApiKeyId: Scalars['ID']['input'];
  input: UpdateApiKeyInput;
}>;


export type UpdateApiKeyMutation = { updateAPIKey: { apiKey: { id: string, ownerId: string, apiKey: string, name: string, isActive: boolean, generatedBy: string, createdAt: string, updatedAt: string, maskedApiKey: string, ageInDays: number, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType, status: OrganizationStatus }, generator: { id: string, firstName: string, lastName: string | null, email: string, fullName: string } } | null, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } | null };

export type CancelApiPaymentMutationVariables = Exact<{
  accessKey: Scalars['String']['input'];
}>;


export type CancelApiPaymentMutation = { CancelApiPayment: { cancelResponseUrl: string } | null };

export type CreateApiPaymentIntentMutationVariables = Exact<{
  input: CreateApiPaymentIntentInput;
}>;


export type CreateApiPaymentIntentMutation = { createApiPaymentIntent: { clientSecret: string, paymentIntentId: string, errors: Array<{ field: string | null, message: string }> | null } };

export type DownloadPaidApiPaymentReceiptMutationVariables = Exact<{
  accessKey: Scalars['String']['input'];
}>;


export type DownloadPaidApiPaymentReceiptMutation = { downloadPaidApiPaymentReceipt: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type DownloadUnpaidApiPaymentReceiptMutationVariables = Exact<{
  accessKey: Scalars['String']['input'];
}>;


export type DownloadUnpaidApiPaymentReceiptMutation = { downloadUnpaidApiPaymentReceipt: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type ProcessApiPaymentMutationVariables = Exact<{
  input: ProcessApiPaymentInput;
}>;


export type ProcessApiPaymentMutation = { processApiPayment: { alreadyProcessed: boolean, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string } | null, apiPayment: { id: string, code: string, accessKey: string, status: ApiPaymentsStatus, merchantProcessingFee: number, ownerId: string, amount: number, currency: string, orderId: string, responseUrl: string, cancelUrl: string, metadata: any, apiKey: string | null, paymentOptions: Array<PaymentType>, refundPolicyTerms: WebPaymentsRefundPolicyTerms, createdAt: string, updatedAt: string, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null, errors: Array<{ field: string | null, message: string }> | null } };

export type OnboardBankMutationVariables = Exact<{
  input: OnboardBankInput;
}>;


export type OnboardBankMutation = { onboardBank: { organization: { supportedChannels: Array<PaymentChannel>, id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null, owner: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type InviteBankUserMutationVariables = Exact<{
  input: InviteBankUserInput;
}>;


export type InviteBankUserMutation = { inviteBankUser: { invitationSent: boolean, user: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type SetBankSupportedChannelsMutationVariables = Exact<{
  bankId: Scalars['ID']['input'];
  channels: Array<PaymentChannel> | PaymentChannel;
}>;


export type SetBankSupportedChannelsMutation = { setBankSupportedChannels: { organization: { supportedChannels: Array<PaymentChannel>, id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateBankStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: OrganizationStatus;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateBankStatusMutation = { updateOrganizationStatus: { organization: { supportedChannels: Array<PaymentChannel>, id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type CreatePaymentIntentMutationVariables = Exact<{
  input: CreatePaymentIntentInput;
}>;


export type CreatePaymentIntentMutation = { createPaymentIntent: { clientSecret: string, paymentIntentId: string, errors: Array<{ field: string | null, message: string }> | null } };

export type DownloadPaidInvoiceReceiptMutationVariables = Exact<{
  accessKey: Scalars['String']['input'];
}>;


export type DownloadPaidInvoiceReceiptMutation = { downloadPaidInvoiceReceipt: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type DownloadUnpaidInvoiceReceiptMutationVariables = Exact<{
  accessKey: Scalars['String']['input'];
}>;


export type DownloadUnpaidInvoiceReceiptMutation = { downloadUnpaidInvoiceReceipt: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type ProcessInvoicePaymentMutationVariables = Exact<{
  input: ProcessInvoicePaymentInput;
}>;


export type ProcessInvoicePaymentMutation = { processInvoicePayment: { alreadyProcessed: boolean, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string } | null, invoice: { id: string, code: string, accessKey: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, createdById: string, receipt: { url: string, expiresIn: any } | null, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string }> } | null, errors: Array<{ field: string | null, message: string }> | null } };

export type AcceptDisputeMutationVariables = Exact<{
  input: AcceptDisputeInput;
}>;


export type AcceptDisputeMutation = { acceptDispute: { dispute: { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchantResponseDueDate: string, createdAt: string, updatedAt: string, additionalInformation: string | null, cancellationDelayDate: string | null, cancellationDelayDescription: string | null, creditVoucherAmount: number | null, creditVoucherDescription: string | null, creditVoucherGivenDate: string | null, customerAlreadyRefunded: boolean, environment: PaymentEnvironment, evidenceReason: DisputeEvidenceReason | null, gatewayDisputeId: string | null, gatewayName: string | null, otherReasonDescription: string | null, productOrServiceDetails: string | null, productServiceType: ProductServiceType | null, reason: DisputeReason, refundAmount: number | null, refundDate: string | null, refundDescription: string | null, resolutionDate: string | null, statusUpdatedAt: string | null, withdrawalDateByCustomer: string | null, merchant: { id: string, name: string, email: string, phoneNumber: string | null }, payment: { id: string, code: string, amount: number, currency: Currency, customerName: string | null, customerEmail: string | null, createdAt: string, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, invoice: { id: string, code: string, accessKey: string, subtotal: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, createdAt: string, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number }>, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null }, refund: { id: string, code: string, amount: number, status: RefundStatus, createdAt: string } | null, evidenceDocumentUrl: Array<{ url: string, expiresIn: any }> | null, providerDocs: Array<{ id: string, Name: string, url: { url: string, expiresIn: any } }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type CreateDisputeMutationVariables = Exact<{
  input: CreateDisputeInput;
}>;


export type CreateDisputeMutation = { createDispute: { dispute: { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchantResponseDueDate: string, createdAt: string, updatedAt: string, additionalInformation: string | null, cancellationDelayDate: string | null, cancellationDelayDescription: string | null, creditVoucherAmount: number | null, creditVoucherDescription: string | null, creditVoucherGivenDate: string | null, customerAlreadyRefunded: boolean, environment: PaymentEnvironment, evidenceReason: DisputeEvidenceReason | null, gatewayDisputeId: string | null, gatewayName: string | null, otherReasonDescription: string | null, productOrServiceDetails: string | null, productServiceType: ProductServiceType | null, reason: DisputeReason, refundAmount: number | null, refundDate: string | null, refundDescription: string | null, resolutionDate: string | null, statusUpdatedAt: string | null, withdrawalDateByCustomer: string | null, merchant: { id: string, name: string, email: string, phoneNumber: string | null }, payment: { id: string, code: string, amount: number, currency: Currency, customerName: string | null, customerEmail: string | null, createdAt: string, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, invoice: { id: string, code: string, accessKey: string, subtotal: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, createdAt: string, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number }>, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null }, refund: { id: string, code: string, amount: number, status: RefundStatus, createdAt: string } | null, evidenceDocumentUrl: Array<{ url: string, expiresIn: any }> | null, providerDocs: Array<{ id: string, Name: string, url: { url: string, expiresIn: any } }> | null } | null, errors: Array<{ message: string }> | null } | null };

export type ExpireDisputeMutationVariables = Exact<{
  input: ExpireDisputeInput;
}>;


export type ExpireDisputeMutation = { expireDispute: { dispute: { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchantResponseDueDate: string, createdAt: string, updatedAt: string, additionalInformation: string | null, cancellationDelayDate: string | null, cancellationDelayDescription: string | null, creditVoucherAmount: number | null, creditVoucherDescription: string | null, creditVoucherGivenDate: string | null, customerAlreadyRefunded: boolean, environment: PaymentEnvironment, evidenceReason: DisputeEvidenceReason | null, gatewayDisputeId: string | null, gatewayName: string | null, otherReasonDescription: string | null, productOrServiceDetails: string | null, productServiceType: ProductServiceType | null, reason: DisputeReason, refundAmount: number | null, refundDate: string | null, refundDescription: string | null, resolutionDate: string | null, statusUpdatedAt: string | null, withdrawalDateByCustomer: string | null, merchant: { id: string, name: string, email: string, phoneNumber: string | null }, payment: { id: string, code: string, amount: number, currency: Currency, customerName: string | null, customerEmail: string | null, createdAt: string, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, invoice: { id: string, code: string, accessKey: string, subtotal: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, createdAt: string, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number }>, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null }, refund: { id: string, code: string, amount: number, status: RefundStatus, createdAt: string } | null, evidenceDocumentUrl: Array<{ url: string, expiresIn: any }> | null, providerDocs: Array<{ id: string, Name: string, url: { url: string, expiresIn: any } }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type RecordDisputeWithdrawalMutationVariables = Exact<{
  input: RecordDisputeWithdrawalInput;
}>;


export type RecordDisputeWithdrawalMutation = { recordDisputeWithdrawal: { dispute: { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchantResponseDueDate: string, createdAt: string, updatedAt: string, additionalInformation: string | null, cancellationDelayDate: string | null, cancellationDelayDescription: string | null, creditVoucherAmount: number | null, creditVoucherDescription: string | null, creditVoucherGivenDate: string | null, customerAlreadyRefunded: boolean, environment: PaymentEnvironment, evidenceReason: DisputeEvidenceReason | null, gatewayDisputeId: string | null, gatewayName: string | null, otherReasonDescription: string | null, productOrServiceDetails: string | null, productServiceType: ProductServiceType | null, reason: DisputeReason, refundAmount: number | null, refundDate: string | null, refundDescription: string | null, resolutionDate: string | null, statusUpdatedAt: string | null, withdrawalDateByCustomer: string | null, merchant: { id: string, name: string, email: string, phoneNumber: string | null }, payment: { id: string, code: string, amount: number, currency: Currency, customerName: string | null, customerEmail: string | null, createdAt: string, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, invoice: { id: string, code: string, accessKey: string, subtotal: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, createdAt: string, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number }>, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null }, refund: { id: string, code: string, amount: number, status: RefundStatus, createdAt: string } | null, evidenceDocumentUrl: Array<{ url: string, expiresIn: any }> | null, providerDocs: Array<{ id: string, Name: string, url: { url: string, expiresIn: any } }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type ResolveDisputeMutationVariables = Exact<{
  input: ResolveDisputeInput;
}>;


export type ResolveDisputeMutation = { resolveDispute: { dispute: { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchantResponseDueDate: string, createdAt: string, updatedAt: string, additionalInformation: string | null, cancellationDelayDate: string | null, cancellationDelayDescription: string | null, creditVoucherAmount: number | null, creditVoucherDescription: string | null, creditVoucherGivenDate: string | null, customerAlreadyRefunded: boolean, environment: PaymentEnvironment, evidenceReason: DisputeEvidenceReason | null, gatewayDisputeId: string | null, gatewayName: string | null, otherReasonDescription: string | null, productOrServiceDetails: string | null, productServiceType: ProductServiceType | null, reason: DisputeReason, refundAmount: number | null, refundDate: string | null, refundDescription: string | null, resolutionDate: string | null, statusUpdatedAt: string | null, withdrawalDateByCustomer: string | null, merchant: { id: string, name: string, email: string, phoneNumber: string | null }, payment: { id: string, code: string, amount: number, currency: Currency, customerName: string | null, customerEmail: string | null, createdAt: string, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, invoice: { id: string, code: string, accessKey: string, subtotal: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, createdAt: string, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number }>, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null }, refund: { id: string, code: string, amount: number, status: RefundStatus, createdAt: string } | null, evidenceDocumentUrl: Array<{ url: string, expiresIn: any }> | null, providerDocs: Array<{ id: string, Name: string, url: { url: string, expiresIn: any } }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type SubmitDisputeEvidenceMutationVariables = Exact<{
  input: SubmitDisputeEvidenceInput;
}>;


export type SubmitDisputeEvidenceMutation = { submitDisputeEvidence: { dispute: { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchantResponseDueDate: string, createdAt: string, updatedAt: string, additionalInformation: string | null, cancellationDelayDate: string | null, cancellationDelayDescription: string | null, creditVoucherAmount: number | null, creditVoucherDescription: string | null, creditVoucherGivenDate: string | null, customerAlreadyRefunded: boolean, environment: PaymentEnvironment, evidenceReason: DisputeEvidenceReason | null, gatewayDisputeId: string | null, gatewayName: string | null, otherReasonDescription: string | null, productOrServiceDetails: string | null, productServiceType: ProductServiceType | null, reason: DisputeReason, refundAmount: number | null, refundDate: string | null, refundDescription: string | null, resolutionDate: string | null, statusUpdatedAt: string | null, withdrawalDateByCustomer: string | null, merchant: { id: string, name: string, email: string, phoneNumber: string | null }, payment: { id: string, code: string, amount: number, currency: Currency, customerName: string | null, customerEmail: string | null, createdAt: string, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, invoice: { id: string, code: string, accessKey: string, subtotal: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, createdAt: string, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number }>, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null }, refund: { id: string, code: string, amount: number, status: RefundStatus, createdAt: string } | null, evidenceDocumentUrl: Array<{ url: string, expiresIn: any }> | null, providerDocs: Array<{ id: string, Name: string, url: { url: string, expiresIn: any } }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type UpdateDisputeProgressMutationVariables = Exact<{
  input: UpdateDisputeProgressInput;
}>;


export type UpdateDisputeProgressMutation = { updateDisputeProgress: { dispute: { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchantResponseDueDate: string, createdAt: string, updatedAt: string, additionalInformation: string | null, cancellationDelayDate: string | null, cancellationDelayDescription: string | null, creditVoucherAmount: number | null, creditVoucherDescription: string | null, creditVoucherGivenDate: string | null, customerAlreadyRefunded: boolean, environment: PaymentEnvironment, evidenceReason: DisputeEvidenceReason | null, gatewayDisputeId: string | null, gatewayName: string | null, otherReasonDescription: string | null, productOrServiceDetails: string | null, productServiceType: ProductServiceType | null, reason: DisputeReason, refundAmount: number | null, refundDate: string | null, refundDescription: string | null, resolutionDate: string | null, statusUpdatedAt: string | null, withdrawalDateByCustomer: string | null, merchant: { id: string, name: string, email: string, phoneNumber: string | null }, payment: { id: string, code: string, amount: number, currency: Currency, customerName: string | null, customerEmail: string | null, createdAt: string, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, invoice: { id: string, code: string, accessKey: string, subtotal: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, createdAt: string, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number }>, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null }, refund: { id: string, code: string, amount: number, status: RefundStatus, createdAt: string } | null, evidenceDocumentUrl: Array<{ url: string, expiresIn: any }> | null, providerDocs: Array<{ id: string, Name: string, url: { url: string, expiresIn: any } }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type AddLineItemMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  input: AddLineItemInput;
}>;


export type AddLineItemMutation = { addLineItem: { lineItem: { id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type CreateInvoiceMutationVariables = Exact<{
  input: CreateInvoiceInput;
}>;


export type CreateInvoiceMutation = { createInvoice: { invoice: { id: string, code: string, accessKey: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, createdById: string, receipt: { url: string, expiresIn: any } | null, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string }> } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type DeleteLineItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLineItemMutation = { deleteLineItem: { deletedLineItemId: string | null, success: boolean | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type SendInvoiceEmailMutationVariables = Exact<{
  input: SendInvoiceEmailInput;
}>;


export type SendInvoiceEmailMutation = { sendInvoiceEmail: { success: boolean, sentAt: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateInvoiceMutationVariables = Exact<{
  updateInvoiceId: Scalars['ID']['input'];
  input: UpdateInvoiceInput;
}>;


export type UpdateInvoiceMutation = { updateInvoice: { invoice: { id: string, code: string, accessKey: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, createdById: string, receipt: { url: string, expiresIn: any } | null, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string }> } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateLineItemMutationVariables = Exact<{
  updateLineItemId: Scalars['ID']['input'];
  input: UpdateLineItemInput;
}>;


export type UpdateLineItemMutation = { updateLineItem: { lineItem: { id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type VoidInvoiceMutationVariables = Exact<{
  voidInvoiceId: Scalars['ID']['input'];
}>;


export type VoidInvoiceMutation = { voidInvoice: { invoice: { id: string, code: string, accessKey: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, createdById: string, receipt: { url: string, expiresIn: any } | null, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string }> } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateUserProfileMutationVariables = Exact<{
  updateUserProfileId: Scalars['ID']['input'];
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { updateUserProfile: { user: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null } | null } };

export type AddMerchantBankAccountMutationVariables = Exact<{
  input: AddMerchantBankAccountInput;
}>;


export type AddMerchantBankAccountMutation = { addMerchantBankAccount: { notificationSent: boolean, merchantBankAccount: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string }, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type ApproveBankAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApproveBankAccountMutation = { approveBankAccount: { verificationInitiated: boolean, merchantBankAccount: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string }, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, statusChange: { id: string, fromStatus: BankAccountStatus, toStatus: BankAccountStatus, reason: string | null, changedAt: string, changedBy: { id: string, firstName: string, lastName: string | null, email: string } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type CloseBankAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CloseBankAccountMutation = { closeBankAccount: { merchantBankAccount: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string }, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, statusChange: { id: string, fromStatus: BankAccountStatus, toStatus: BankAccountStatus, reason: string | null, changedAt: string } | null, newPrimaryAccount: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string }, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type DeleteBankAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBankAccountMutation = { deleteBankAccount: { success: boolean, deletedAccountId: string | null, newPrimaryAccount: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string }, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type ReinstateBankAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReinstateBankAccountMutation = { reinstateBankAccount: { merchantBankAccount: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string }, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, statusChange: { id: string, fromStatus: BankAccountStatus, toStatus: BankAccountStatus, reason: string | null, changedAt: string } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type RejectBankAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type RejectBankAccountMutation = { rejectBankAccount: { merchantBankAccount: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string }, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, statusChange: { id: string, fromStatus: BankAccountStatus, toStatus: BankAccountStatus, reason: string | null, changedAt: string } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type SetPrimaryBankAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SetPrimaryBankAccountMutation = { setPrimaryBankAccount: { merchantBankAccount: { id: string, isPrimary: boolean } | null, previousPrimaryAccount: { id: string, isPrimary: boolean } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type SuspendBankAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type SuspendBankAccountMutation = { suspendBankAccount: { merchantBankAccount: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string }, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, statusChange: { id: string, fromStatus: BankAccountStatus, toStatus: BankAccountStatus, reason: string | null, changedAt: string } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type VerifyBankAccountMutationVariables = Exact<{
  input: VerifyBankAccountInput;
}>;


export type VerifyBankAccountMutation = { verifyBankAccount: { verified: boolean, merchantBankAccount: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string }, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type CreateMediaMutationVariables = Exact<{
  input: CreateMediaInput;
}>;


export type CreateMediaMutation = { createMedia: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } };

export type DeleteMediaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMediaMutation = { deleteMedia: boolean };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { createOrganization: { organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null } };

export type OnboardOrganizationMutationVariables = Exact<{
  input: OnboardOrganizationInput;
}>;


export type OnboardOrganizationMutation = { onboardOrganization: { organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  updateOrganizationId: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { updateOrganization: { organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateBusinessMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateBusinessMutation = { updateBusiness: { organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateOrganizationPaymentTypeMutationVariables = Exact<{
  updateOrganizationPaymentTypeId: Scalars['ID']['input'];
  input: UpdateOrganizationPaymentTypeInput;
}>;


export type UpdateOrganizationPaymentTypeMutation = { updateOrganizationPaymentType: { organizationPaymentType: { id: string, OrganizationId: string, Enabled: boolean, PaymentProviderPaymentTypeId: string, PaymentContext: OrganizationPaymentTypeContext, CreatedAt: string, UpdatedAt: string, Organization: { id: string }, PaymentProviderPaymentType: { id: string, name: string, type: PaymentType, enabled: boolean } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type FlagPaymentMutationVariables = Exact<{
  input: FlagPaymentInput;
}>;


export type FlagPaymentMutation = { flagPayment: { payment: { id: string, code: string, netAmount: number, amount: number, currency: Currency, status: PaymentStatus, customerName: string | null, customerEmail: string | null, createdAt: string, is_flagged: boolean | null, flag_reason: any | null, paymentType: PaymentType, paymentProvider: { id: string, name: string, slug: string }, invoice: { fees: { paymentType: PaymentType | null } | null, billingAddresses: Array<{ id: string, label: string | null, line1: string, line2: string | null, postalCode: string | null, state: string | null, city: string, country: string } | null> | null } | null, apiPayment: { fees: { paymentType: PaymentType | null } | null } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UnflagPaymentMutationVariables = Exact<{
  input: UnflagPaymentInput;
}>;


export type UnflagPaymentMutation = { unflagPayment: { payment: { id: string, code: string, netAmount: number, amount: number, currency: Currency, status: PaymentStatus, customerName: string | null, customerEmail: string | null, createdAt: string, is_flagged: boolean | null, flag_reason: any | null, paymentType: PaymentType, paymentProvider: { id: string, name: string, slug: string }, invoice: { fees: { paymentType: PaymentType | null } | null, billingAddresses: Array<{ id: string, label: string | null, line1: string, line2: string | null, postalCode: string | null, state: string | null, city: string, country: string } | null> | null } | null, apiPayment: { fees: { paymentType: PaymentType | null } | null } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type SavePaymentMethodMutationVariables = Exact<{
  input: SavePaymentMethodInput;
}>;


export type SavePaymentMethodMutation = { savePaymentMethod: { successResponseUrl: string, paymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdatePaymentProviderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePaymentProviderInput;
}>;


export type UpdatePaymentProviderMutation = { updatePaymentProvider: { paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> }, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type AddPaymentProviderCardTypeMutationVariables = Exact<{
  input: AddCardTypeInput;
}>;


export type AddPaymentProviderCardTypeMutation = { addCardTypeToProvider: { errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type DeletePaymentProviderCardTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePaymentProviderCardTypeMutation = { deleteCardType: { success: boolean, deletedCardTypeId: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdatePaymentProviderCardTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCardTypeInput;
}>;


export type UpdatePaymentProviderCardTypeMutation = { updateCardType: { cardType: { id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type AddPaymentProviderPaymentTypeMutationVariables = Exact<{
  input: AddPaymentTypeInput;
}>;


export type AddPaymentProviderPaymentTypeMutation = { addPaymentTypeToProvider: { paymentType: { id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type DeletePaymentProviderPaymentTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePaymentProviderPaymentTypeMutation = { deletePaymentType: { success: boolean, deletedPaymentTypeId: string | null } };

export type UpdatePaymentProviderPaymentTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePaymentTypeInput;
}>;


export type UpdatePaymentProviderPaymentTypeMutation = { updatePaymentType: { paymentType: { id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type CancelPayoutMutationVariables = Exact<{
  input: CancelPayoutInput;
}>;


export type CancelPayoutMutation = { cancelPayout: { payout: { id: string, code: string, paymentId: string, payoutType: PayoutType, status: PayoutStatus, currency: Currency, amount: number, processedAt: string | null, completedAt: string | null, isSplit: boolean, splitCount: number, parent_payout_id: string | null, bankAccountId: string | null, transferId: string | null, transferCode: string | null, receiverMerchant: { id: string, name: string, email: string }, bankAccount: { id: string, accountHolderName: string, accountNumberMasked: string, type: BankAccountType, bank: { id: string, name: string } } | null, payment: { id: string, code: string, owner_id: string, amount: number, netAmount: number, currency: Currency, customerName: string | null, customerEmail: string | null, paymentProvider: { id: string, name: string, slug: string }, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, invoice: { id: string, code: string, payoutAmount: number, subtotal: number } | null, recurringPayment: { id: string, code: string } | null, quickPay: { id: string, code: string } | null, apiPayment: { id: string, code: string } | null } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type DeletePayoutMutationVariables = Exact<{
  deletePayoutId: Scalars['ID']['input'];
}>;


export type DeletePayoutMutation = { deletePayout: { success: boolean, deletedPayoutId: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type SplitPayoutMutationVariables = Exact<{
  input: SplitPayoutInput;
}>;


export type SplitPayoutMutation = { splitPayout: { originalPayout: { id: string, code: string, paymentId: string, payoutType: PayoutType, status: PayoutStatus, currency: Currency, amount: number, processedAt: string | null, completedAt: string | null, isSplit: boolean, splitCount: number, parent_payout_id: string | null, bankAccountId: string | null, transferId: string | null, transferCode: string | null, receiverMerchant: { id: string, name: string, email: string }, bankAccount: { id: string, accountHolderName: string, accountNumberMasked: string, type: BankAccountType, bank: { id: string, name: string } } | null, payment: { id: string, code: string, owner_id: string, amount: number, netAmount: number, currency: Currency, customerName: string | null, customerEmail: string | null, paymentProvider: { id: string, name: string, slug: string }, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, invoice: { id: string, code: string, payoutAmount: number, subtotal: number } | null, recurringPayment: { id: string, code: string } | null, quickPay: { id: string, code: string } | null, apiPayment: { id: string, code: string } | null } } | null, newPayouts: Array<{ id: string, code: string, paymentId: string, payoutType: PayoutType, status: PayoutStatus, currency: Currency, amount: number, processedAt: string | null, completedAt: string | null, isSplit: boolean, splitCount: number, parent_payout_id: string | null, bankAccountId: string | null, transferId: string | null, transferCode: string | null, receiverMerchant: { id: string, name: string, email: string }, bankAccount: { id: string, accountHolderName: string, accountNumberMasked: string, type: BankAccountType, bank: { id: string, name: string } } | null, payment: { id: string, code: string, owner_id: string, amount: number, netAmount: number, currency: Currency, customerName: string | null, customerEmail: string | null, paymentProvider: { id: string, name: string, slug: string }, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, invoice: { id: string, code: string, payoutAmount: number, subtotal: number } | null, recurringPayment: { id: string, code: string } | null, quickPay: { id: string, code: string } | null, apiPayment: { id: string, code: string } | null } }> | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type ActivateQuickPayMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivateQuickPayMutation = { activateQuickPay: { quickPay: { accessKey: string, description: any | null, customFields: any, expiresAt: string | null, fixedAmount: number | null, minAmount: number | null, maxAmount: number | null, presetAmounts: Array<number> | null, merchantProcessingFee: number, refundPolicyTerms: QuickPayRefundPolicyTerms, paymentOptions: Array<PaymentType>, id: string, code: string, title: string, status: QuickPayStatus, isDefault: boolean, amountType: QuickPayAmountType, currency: Currency, paymentURL: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, qrCode: { url: string, format: QrCodeFormat, size: QrCodeSize } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type ArchiveQuickPayMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveQuickPayMutation = { archiveQuickPay: { quickPay: { accessKey: string, description: any | null, customFields: any, expiresAt: string | null, fixedAmount: number | null, minAmount: number | null, maxAmount: number | null, presetAmounts: Array<number> | null, merchantProcessingFee: number, refundPolicyTerms: QuickPayRefundPolicyTerms, paymentOptions: Array<PaymentType>, id: string, code: string, title: string, status: QuickPayStatus, isDefault: boolean, amountType: QuickPayAmountType, currency: Currency, paymentURL: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, qrCode: { url: string, format: QrCodeFormat, size: QrCodeSize } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type CreateQuickPayMutationVariables = Exact<{
  input: CreateQuickPayInput;
}>;


export type CreateQuickPayMutation = { createQuickPay: { quickPay: { id: string } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type CreateQuickPayPaymentIntentMutationVariables = Exact<{
  input: CreateQuickPayPaymentIntentInput;
}>;


export type CreateQuickPayPaymentIntentMutation = { createQuickPayPaymentIntent: { clientSecret: string, paymentIntentId: string, amount: number, currency: Currency, publishableKey: string, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type InitQuickPaymentMutationVariables = Exact<{
  input: InitQuickPaymentInput;
}>;


export type InitQuickPaymentMutation = { initQuickPayment: { clientSecret: string, paymentIntentId: string, amount: number, currency: Currency, publishableKey: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type PauseQuickPayMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PauseQuickPayMutation = { pauseQuickPay: { quickPay: { accessKey: string, description: any | null, customFields: any, expiresAt: string | null, fixedAmount: number | null, minAmount: number | null, maxAmount: number | null, presetAmounts: Array<number> | null, merchantProcessingFee: number, refundPolicyTerms: QuickPayRefundPolicyTerms, paymentOptions: Array<PaymentType>, id: string, code: string, title: string, status: QuickPayStatus, isDefault: boolean, amountType: QuickPayAmountType, currency: Currency, paymentURL: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, qrCode: { url: string, format: QrCodeFormat, size: QrCodeSize } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateQuickPayMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateQuickPayInput;
}>;


export type UpdateQuickPayMutation = { updateQuickPay: { quickPay: { accessKey: string, description: any | null, customFields: any, expiresAt: string | null, fixedAmount: number | null, minAmount: number | null, maxAmount: number | null, presetAmounts: Array<number> | null, merchantProcessingFee: number, refundPolicyTerms: QuickPayRefundPolicyTerms, paymentOptions: Array<PaymentType>, id: string, code: string, title: string, status: QuickPayStatus, isDefault: boolean, amountType: QuickPayAmountType, currency: Currency, paymentURL: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, qrCode: { url: string, format: QrCodeFormat, size: QrCodeSize } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type CancelRecurringPaymentMutationVariables = Exact<{
  cancelRecurringPaymentId: Scalars['ID']['input'];
}>;


export type CancelRecurringPaymentMutation = { cancelRecurringPayment: { recurringPayment: { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type CancelRecurringPaymentSetupMutationVariables = Exact<{
  input: CancelRecurringPaymentSetupInput;
}>;


export type CancelRecurringPaymentSetupMutation = { cancelRecurringPaymentSetup: { cancelResponseUrl: string } };

export type CreatePaymentMethodUpdateSessionMutationVariables = Exact<{
  input: CreatePaymentMethodUpdateSessionInput;
}>;


export type CreatePaymentMethodUpdateSessionMutation = { createPaymentMethodUpdateSession: { updateURL: string, expiresAt: string, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type CreateRecurringPaymentMutationVariables = Exact<{
  input: CreateRecurringPaymentInput;
}>;


export type CreateRecurringPaymentMutation = { createRecurringPayment: { recurringPayment: { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type PauseRecurringPaymentMutationVariables = Exact<{
  pauseRecurringPaymentId: Scalars['ID']['input'];
}>;


export type PauseRecurringPaymentMutation = { pauseRecurringPayment: { recurringPayment: { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type ResumeRecurringPaymentMutationVariables = Exact<{
  resumeRecurringPaymentId: Scalars['ID']['input'];
}>;


export type ResumeRecurringPaymentMutation = { resumeRecurringPayment: { recurringPayment: { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type UpdateRecurringPaymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateRecurringPaymentInput;
}>;


export type UpdateRecurringPaymentMutation = { updateRecurringPayment: { recurringPayment: { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateRecurringPaymentMethodMutationVariables = Exact<{
  input: UpdateRecurringPaymentMethodInput;
}>;


export type UpdateRecurringPaymentMethodMutation = { updateRecurringPaymentMethod: { successURL: string, recurringPayment: { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null } | null, paymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type CreateSetupIntentMutationVariables = Exact<{
  input: CreateSetupIntentInput;
}>;


export type CreateSetupIntentMutation = { createSetupIntent: { clientSecret: string, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type CreateUpdateSetupIntentMutationVariables = Exact<{
  input: CreateUpdateSetupIntentInput;
}>;


export type CreateUpdateSetupIntentMutation = { createUpdateSetupIntent: { clientSecret: string, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type ApproveRefundMutationVariables = Exact<{
  input: ApproveRefundInput;
}>;


export type ApproveRefundMutation = { approveRefund: { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type BankApproveRefundMutationVariables = Exact<{
  input: BankApproveRefundInput;
}>;


export type BankApproveRefundMutation = { bankApproveRefund: { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type BankDenyRefundMutationVariables = Exact<{
  input: BankDenyRefundInput;
}>;


export type BankDenyRefundMutation = { bankDenyRefund: { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type CancelRefundMutationVariables = Exact<{
  input: CancelRefundInput;
}>;


export type CancelRefundMutation = { cancelRefund: { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type CreateRefundMutationVariables = Exact<{
  input: CreateRefundInput;
}>;


export type CreateRefundMutation = { createRefund: { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type DenyRefundMutationVariables = Exact<{
  input: DenyRefundInput;
}>;


export type DenyRefundMutation = { denyRefund: { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type ManualProcessRefundMutationVariables = Exact<{
  input: ManualProcessRefundInput;
}>;


export type ManualProcessRefundMutation = { manualProcessRefund: { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdById: string, ownerId: string | null, createdAt: string, updatedAt: string } | null, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } | null };

export type ProcessRefundMutationVariables = Exact<{
  input: ProcessRefundInput;
}>;


export type ProcessRefundMutation = { processRefund: { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type RejectRefundMutationVariables = Exact<{
  input: RejectRefundInput;
}>;


export type RejectRefundMutation = { rejectRefund: { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type UpdateRefundMutationVariables = Exact<{
  updateRefundId: Scalars['ID']['input'];
  input: UpdateRefundInput;
}>;


export type UpdateRefundMutation = { updateRefund: { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type AssignRoleToUserMutationVariables = Exact<{
  input: AssignRoleInput;
}>;


export type AssignRoleToUserMutation = { assignRoleToUser: { userRole: { id: string, assignedAt: string, user: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null }, role: { id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string } } | null, errors: Array<{ message: string, field: string | null }> | null } | null };

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput;
}>;


export type CreateRoleMutation = { createRole: { role: { id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string, userCount: number, permissionCount: number, permissions: { totalCount: number, edges: Array<{ node: { id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } }, users: Array<{ id: string, organizationId: string | null, firstName: string, lastName: string | null, email: string, description: any | null, status: UserStatus, isEmailVerified: boolean, isOwner: boolean | null, lastLoginAt: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, fullName: string } | null> } | null, errors: Array<{ message: string, field: string | null }> | null } | null };

export type DeleteRoleMutationVariables = Exact<{
  deleteRoleId: Scalars['ID']['input'];
}>;


export type DeleteRoleMutation = { deleteRole: { deletedRoleId: string | null, success: boolean, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } | null };

export type GrantPermissionToRoleMutationVariables = Exact<{
  input: GrantPermissionInput;
}>;


export type GrantPermissionToRoleMutation = { grantPermissionToRole: { permissionRole: { id: string, permission: { id: string }, role: { id: string } } | null, errors: Array<{ message: string, field: string | null }> | null } | null };

export type RevokePermissionFromRoleMutationVariables = Exact<{
  input: RevokePermissionInput;
}>;


export type RevokePermissionFromRoleMutation = { revokePermissionFromRole: { success: boolean | null, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } | null };

export type UnAssignRoleFromUserMutationVariables = Exact<{
  input: UnassignRoleInput;
}>;


export type UnAssignRoleFromUserMutation = { unassignRoleFromUser: { success: boolean, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } | null };

export type UpdateRoleMutationVariables = Exact<{
  updateRoleId: Scalars['ID']['input'];
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { updateRole: { role: { id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string, userCount: number, permissionCount: number, permissions: { totalCount: number, edges: Array<{ node: { id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } }, users: Array<{ id: string, organizationId: string | null, firstName: string, lastName: string | null, email: string, description: any | null, status: UserStatus, isEmailVerified: boolean, isOwner: boolean | null, lastLoginAt: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, fullName: string } | null> }, errors: Array<{ message: string, field: string | null }> | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { changePassword: { success: boolean, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { login: { accessToken: string | null, refreshToken: string | null, user: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, description: any | null, isEmailVerified: boolean, status: UserStatus, createdAt: string, updatedAt: string, organizationId: string | null, lastLoginAt: string | null, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null, permissions: Array<{ id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null }> } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type RequestMagicLinkMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestMagicLinkMutation = { requestMagicLink: { emailSent: boolean, message: string, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } };

export type VerifyMagicLinkMutationVariables = Exact<{
  input: VerifyMagicLinkInput;
}>;


export type VerifyMagicLinkMutation = { verifyMagicLink: { accessToken: string | null, refreshToken: string | null, user: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null } | null, errors: Array<{ code: ErrorCode, message: string, field: string | null }> | null } };

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { refreshToken: { accessToken: string, refreshToken: string, errors: Array<{ code: ErrorCode, field: string | null, message: string } | null> | null } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { requestPasswordReset: { emailSent: boolean, message: string } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { resetPassword: { accessToken: string | null, refreshToken: string | null, success: boolean, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type VerifyEmailMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { verifyEmail: { accessToken: string | null, refreshToken: string | null, user: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type AddPayoutsToTransferMutationVariables = Exact<{
  input: AddPayoutsToTransferInput;
}>;


export type AddPayoutsToTransferMutation = { addPayoutsToTransfer: { transfer: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } } | null, addedPayouts: Array<{ id: string, code: string, amount: number, status: PayoutStatus }> | null, failedPayouts: Array<{ payoutId: string, payoutCode: string | null, error: string, code: string }> | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type CompleteTransferMutationVariables = Exact<{
  input: CompleteTransferInput;
}>;


export type CompleteTransferMutation = { completeTransfer: { transfer: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } } | null, completedPayouts: Array<{ id: string, code: string, amount: number, status: PayoutStatus }> | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type CreateTransferMutationVariables = Exact<{
  input: CreateTransferInput;
}>;


export type CreateTransferMutation = { createTransfer: { transfer: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type DeleteTransferMutationVariables = Exact<{
  deleteTransferId: Scalars['ID']['input'];
}>;


export type DeleteTransferMutation = { deleteTransfer: { success: boolean, deletedTransferId: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type GenerateTransferPdfMutationVariables = Exact<{
  transferId: Scalars['ID']['input'];
}>;


export type GenerateTransferPdfMutation = { generateTransferPdf: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type RemovePayoutsFromTransferMutationVariables = Exact<{
  input: RemovePayoutsFromTransferInput;
}>;


export type RemovePayoutsFromTransferMutation = { removePayoutsFromTransfer: { removedPayoutIds: Array<string | null> | null, transfer: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type SubmitTransferMutationVariables = Exact<{
  input: SubmitTransferInput;
}>;


export type SubmitTransferMutation = { submitTransfer: { transfer: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type UpdateTransferNotesMutationVariables = Exact<{
  input: UpdateTransferNotesInput;
}>;


export type UpdateTransferNotesMutation = { updateTransferNotes: { transfer: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUserMutation = { inviteUser: { invitationSent: boolean, user: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type AcceptInvitationMutationVariables = Exact<{
  input: AcceptInvitationInput;
}>;


export type AcceptInvitationMutation = { acceptInvitation: { accessToken: string | null, refreshToken: string | null, user: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type ResendEmailVerificationMutationVariables = Exact<{
  input: ResendEmailVerificationInput;
}>;


export type ResendEmailVerificationMutation = { resendEmailVerification: { success: boolean, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type SignUpUserMutationVariables = Exact<{
  input: SignUpUserInput;
}>;


export type SignUpUserMutation = { signUpUser: { user: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, status: UserStatus, createdAt: string, updatedAt: string, isEmailVerified: boolean, description: any | null, organizationId: string | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateUserStatusMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  status: UserStatus;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserStatusMutation = { updateUserStatus: { user: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, status: UserStatus, createdAt: string, updatedAt: string, isEmailVerified: boolean, description: any | null } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type ResendInvitationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ResendInvitationMutation = { resendInvitation: { success: boolean, emailSent: boolean, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type AddWebhookSubscriptionsMutationVariables = Exact<{
  input: AddWebhookSubscriptionsInput;
}>;


export type AddWebhookSubscriptionsMutation = { addWebhookSubscriptions: { subscriptions: Array<{ id: string, merchantWebhookID: string, webhookEventTypeID: string, isEnabled: boolean, metadata: any | null, createdAt: string, updatedAt: string, webhookEventType: { id: string, eventType: string, category: string, displayName: string, description: string | null, payloadExample: any | null, isActive: boolean, isDeprecated: boolean, deprecatedMessage: string | null, replacesEventType: string | null, createdAt: string, updatedAt: string } }> | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type CreateMerchantWebhookMutationVariables = Exact<{
  input: CreateMerchantWebhookInput;
}>;


export type CreateMerchantWebhookMutation = { createMerchantWebhook: { merchantWebhook: { id: string, organizationID: string, name: string, url: string, status: WebhookStatus, description: string | null, failureCount: number, lastTriggeredAt: string | null, disabledAt: string | null, metadata: any | null, secret: string, createdAt: string, updatedAt: string, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type RemoveWebhookSubscriptionsMutationVariables = Exact<{
  input: RemoveWebhookSubscriptionsInput;
}>;


export type RemoveWebhookSubscriptionsMutation = { removeWebhookSubscriptions: { success: boolean, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type RetryWebhookDeliveryMutationVariables = Exact<{
  input: RetryWebhookDeliveryInput;
}>;


export type RetryWebhookDeliveryMutation = { retryWebhookDelivery: { delivery: { id: string, webhookID: string | null, organizationID: string | null, eventID: string, eventType: string, idempotencyKey: string, requestURL: string, requestHeaders: any, requestBody: string, responseStatusCode: number | null, responseHeaders: any | null, responseBody: string | null, durationMs: number | null, triggeredAt: string, completedAt: string | null, status: WebhookDeliveryStatus, attemptNumber: number, maxAttempts: number, nextRetryAt: string | null, errorMessage: string | null, errorCode: string | null, createdAt: string, updatedAt: string } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateMerchantWebhookMutationVariables = Exact<{
  updateMerchantWebhookId: Scalars['ID']['input'];
  input: UpdateMerchantWebhookInput;
}>;


export type UpdateMerchantWebhookMutation = { updateMerchantWebhook: { merchantWebhook: { id: string, organizationID: string, name: string, url: string, status: WebhookStatus, description: string | null, failureCount: number, lastTriggeredAt: string | null, disabledAt: string | null, metadata: any | null, secret: string, createdAt: string, updatedAt: string, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type UpdateWebhookSubscriptionMutationVariables = Exact<{
  updateWebhookSubscriptionId: Scalars['ID']['input'];
  input: UpdateWebhookSubscriptionInput;
}>;


export type UpdateWebhookSubscriptionMutation = { updateWebhookSubscription: { subscription: { id: string, merchantWebhookID: string, webhookEventTypeID: string, isEnabled: boolean, metadata: any | null, createdAt: string, updatedAt: string, webhookEventType: { id: string, eventType: string, category: string, displayName: string, description: string | null, payloadExample: any | null, isActive: boolean, isDeprecated: boolean, deprecatedMessage: string | null, replacesEventType: string | null, createdAt: string, updatedAt: string } } | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } };

export type OrganizationApiKeysQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  orderBy?: InputMaybe<ApiKeyOrderByInput>;
}>;


export type OrganizationApiKeysQuery = { organizationAPIKeys: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, ownerId: string, apiKey: string, name: string, isActive: boolean, generatedBy: string, createdAt: string, updatedAt: string, maskedApiKey: string, ageInDays: number } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type GetApiPaymentByAccessKeyQueryVariables = Exact<{
  accessKey: Scalars['String']['input'];
}>;


export type GetApiPaymentByAccessKeyQuery = { apiPaymentByAccessKey: { id: string, code: string, accessKey: string, status: ApiPaymentsStatus, merchantProcessingFee: number, ownerId: string, amount: number, currency: string, orderId: string, responseUrl: string, cancelUrl: string, metadata: any, apiKey: string | null, paymentOptions: Array<PaymentType>, refundPolicyTerms: WebPaymentsRefundPolicyTerms, createdAt: string, updatedAt: string, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null };

export type GetApiPaymentByIdQueryVariables = Exact<{
  apiPaymentId: Scalars['ID']['input'];
}>;


export type GetApiPaymentByIdQuery = { apiPayment: { id: string, code: string, accessKey: string, status: ApiPaymentsStatus, merchantProcessingFee: number, ownerId: string, amount: number, currency: string, orderId: string, responseUrl: string, cancelUrl: string, metadata: any, apiKey: string | null, paymentOptions: Array<PaymentType>, refundPolicyTerms: WebPaymentsRefundPolicyTerms, createdAt: string, updatedAt: string, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null };

export type GetApiPaymentSuccessResponseUrlQueryVariables = Exact<{
  accessKey: Scalars['String']['input'];
}>;


export type GetApiPaymentSuccessResponseUrlQuery = { getApiPaymentSuccessResponseUrl: { successResponseUrl: string } | null };

export type GetPaymentProviderByCardTypeQueryVariables = Exact<{
  cardType: CardType;
  paymentType: PaymentType;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaymentProviderByCardTypeQuery = { paymentProviderByCardType: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } | null };

export type GetPaymentProvidersByTypeQueryVariables = Exact<{
  paymentType: PaymentType;
  currency?: InputMaybe<Scalars['String']['input']>;
  supportsRecurring?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPaymentProvidersByTypeQuery = { paymentProvidersByType: Array<{ id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> }> };

export type GetInvoiceByAccessKeyQueryVariables = Exact<{
  accessKey: Scalars['String']['input'];
}>;


export type GetInvoiceByAccessKeyQuery = { invoiceByAccessKey: { id: string, code: string, accessKey: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, createdById: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, receipt: { url: string, expiresIn: any } | null, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string }> } | null };

export type InvoiceQrCodeQueryVariables = Exact<{
  accessKey: Scalars['String']['input'];
}>;


export type InvoiceQrCodeQuery = { invoiceQRCode: { url: string, size: QrCodeSize, format: QrCodeFormat } };

export type GetInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type GetInvoiceQuery = { invoice: { id: string, code: string, accessKey: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, createdById: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, createdBy: { id: string, firstName: string, lastName: string | null, email: string } | null, receipt: { url: string, expiresIn: any } | null, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string }> } | null };

export type GetInvoiceSummaryQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Time']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetInvoiceSummaryQuery = { invoiceSummary: { totalInvoices: number, paidCount: number, unpaidCount: number, voidCount: number, overdueCount: number, totalPaidAmount: number, totalUnpaidAmount: number } | null };

export type GetInvoicesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  orderBy?: InputMaybe<InvoiceOrderByInput>;
  where?: InputMaybe<InvoiceWhereInput>;
}>;


export type GetInvoicesQuery = { invoices: { totalCount: number, edges: Array<{ node: { id: string, code: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, fees: { paymentType: PaymentType | null } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type GetMerchantInvoicesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  orderBy?: InputMaybe<InvoiceOrderByInput>;
  where?: InputMaybe<InvoiceWhereInput>;
}>;


export type GetMerchantInvoicesQuery = { merchantInvoices: { totalCount: number, edges: Array<{ node: { id: string, code: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, fees: { paymentType: PaymentType | null } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type GetOverdueInvoicesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetOverdueInvoicesQuery = { overdueInvoices: { totalCount: number, edges: Array<{ node: { id: string, code: string, status: InvoiceStatus, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, subtotal: number, merchantProcessingFee: number, createdAt: string } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type GetPresingUrlQueryVariables = Exact<{
  input: GenerateUploadUrlInput;
}>;


export type GetPresingUrlQuery = { getUploadPresignUrl: { url: string, key: string, expiresIn: any } };

export type BankPendingApprovalsQueryVariables = Exact<{
  bankId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type BankPendingApprovalsQuery = { bankPendingApprovals: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumberMasked: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, bank: { id: string, name: string }, organization: { id: string, name: string } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type AllBanksPendingApprovalsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type AllBanksPendingApprovalsQuery = { allBanksPendingApprovals: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumberMasked: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, bank: { id: string, name: string }, organization: { id: string, name: string } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type MerchantBankAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MerchantBankAccountQuery = { merchantBankAccount: { id: string, organizationId: string, bankId: string, type: BankAccountType, accountNumber: string, accountHolderName: string, status: BankAccountStatus, isPrimary: boolean, isVerified: boolean, createdAt: string, updatedAt: string, accountNumberMasked: string, bank: { id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string, logo: { imgixUrl: string | null, cloudFrontUrl: { url: string } } | null }, organization: { id: string, name: string, email: string, phoneNumber: string | null, address: any | null, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, description: any | null, status: OrganizationStatus, type: OrganizationType, logo: { imgixUrl: string | null, cloudFrontUrl: { url: string } } | null } } | null };

export type MerchantBankAccountsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<BankAccountStatus>;
}>;


export type MerchantBankAccountsQuery = { merchantBankAccounts: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, type: BankAccountType, isPrimary: boolean, status: BankAccountStatus, bank: { name: string, logo: { imgixUrl: string | null, cloudFrontUrl: { url: string } } | null } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type GetBanksOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBanksOverviewQuery = { getBanks: Array<{ id: string, name: string } | null> | null };

export type GetBanksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBanksQuery = { getBanks: Array<{ id: string, name: string, email: string, description: any | null, type: OrganizationType, status: OrganizationStatus, industry: OrganizationIndustry | null, otherIndustry: string | null, mccCode: string | null, licenseNumber: string | null, website: string | null, merchantProcessingFee: number, refundPolicyTerms: OrganizationRefundPolicyTerms, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, users: Array<{ description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null }> } | null> | null };

export type GetOrganizationPaymentTypesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  paymentContext?: InputMaybe<OrganizationPaymentTypeContext>;
}>;


export type GetOrganizationPaymentTypesQuery = { organizationPaymentTypes: Array<{ id: string, Enabled: boolean, PaymentContext: OrganizationPaymentTypeContext, PaymentProviderPaymentType: { id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } } }> };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganizationQuery = { organization: { id: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null };

export type PayoutOrganizationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination: PaginationInput;
}>;


export type PayoutOrganizationsQuery = { payoutOrganizations: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type ApiKeyDetailPageQueryVariables = Exact<{
  apiKeyId: Scalars['ID']['input'];
}>;


export type ApiKeyDetailPageQuery = { apiKey: { id: string, ownerId: string, apiKey: string, name: string, isActive: boolean, generatedBy: string, createdAt: string, updatedAt: string, maskedApiKey: string, ageInDays: number, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType, status: OrganizationStatus }, generator: { id: string, firstName: string, lastName: string | null, email: string, fullName: string } } | null };

export type ApiKeyListPageQueryVariables = Exact<{
  where?: InputMaybe<ApiKeyWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
  orderBy?: InputMaybe<ApiKeyOrderByInput>;
}>;


export type ApiKeyListPageQuery = { apiKeys: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, ownerId: string, apiKey: string, name: string, isActive: boolean, generatedBy: string, createdAt: string, updatedAt: string, maskedApiKey: string, ageInDays: number } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type ApiLogQueryVariables = Exact<{
  apiLogId: Scalars['ID']['input'];
}>;


export type ApiLogQuery = { apiLog: { id: string, createdAt: string, updatedAt: string, ownerID: string, method: string, path: string, requestBody: string | null, requestHeaders: any | null, queryParams: string | null, statusCode: number, responseBody: string | null, responseHeaders: any | null, latencyMs: any, ipAddress: string | null, userAgent: string | null, requestID: string | null, apiKeyID: string | null, errorCode: string | null, errorMessage: string | null, apiKey: { id: string, name: string, maskedApiKey: string, createdAt: string } | null } | null };

export type ApiLogsPageQueryVariables = Exact<{
  where?: InputMaybe<ApiLogWhereInput>;
  orderBy?: InputMaybe<ApiLogOrderByInput>;
  pagination: PaginationInput;
}>;


export type ApiLogsPageQuery = { apiLogs: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, createdAt: string, updatedAt: string, ownerID: string, method: string, path: string, statusCode: number, latencyMs: any, ipAddress: string | null, userAgent: string | null, requestID: string | null, apiKeyID: string | null, errorCode: string | null, errorMessage: string | null, apiKey: { id: string, name: string, maskedApiKey: string } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type BankDetailPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BankDetailPageQuery = { organization: { supportedChannels: Array<PaymentChannel>, id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null };

export type BankListPageQueryVariables = Exact<{
  sort?: InputMaybe<OrganizationSortInput>;
  where?: InputMaybe<OrganizationWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type BankListPageQuery = { banks: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, name: string, code: string, email: string, phoneNumber: string | null, country: string | null, status: OrganizationStatus, supportedChannels: Array<PaymentChannel>, createdAt: string, users: Array<{ id: string }> } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type CheckoutPaymentsHistoryQueryVariables = Exact<{
  apiPaymentId: Scalars['ID']['input'];
  paymentsFirst?: InputMaybe<Scalars['Int']['input']>;
  paymentsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CheckoutPaymentsHistoryQuery = { merchantPayments: { edges: Array<{ node: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type CheckoutPaymentsHistoryPlatformQueryVariables = Exact<{
  apiPaymentId: Scalars['ID']['input'];
  paymentsFirst?: InputMaybe<Scalars['Int']['input']>;
  paymentsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CheckoutPaymentsHistoryPlatformQuery = { payments: { edges: Array<{ node: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type CheckoutsListPageQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  orderBy?: InputMaybe<ApiPaymentOrderByInput>;
  where?: InputMaybe<ApiPaymentWhereInput>;
}>;


export type CheckoutsListPageQuery = { apiPayments: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, orderId: string, amount: number, currency: string, status: ApiPaymentsStatus, merchantProcessingFee: number, createdAt: string, updatedAt: string, metadata: any, owner: { name: string }, fees: { paymentType: PaymentType | null } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type DisputeDetailPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisputeDetailPageQuery = { dispute: { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchantResponseDueDate: string, createdAt: string, updatedAt: string, additionalInformation: string | null, cancellationDelayDate: string | null, cancellationDelayDescription: string | null, creditVoucherAmount: number | null, creditVoucherDescription: string | null, creditVoucherGivenDate: string | null, customerAlreadyRefunded: boolean, environment: PaymentEnvironment, evidenceReason: DisputeEvidenceReason | null, gatewayDisputeId: string | null, gatewayName: string | null, otherReasonDescription: string | null, productOrServiceDetails: string | null, productServiceType: ProductServiceType | null, reason: DisputeReason, refundAmount: number | null, refundDate: string | null, refundDescription: string | null, resolutionDate: string | null, statusUpdatedAt: string | null, withdrawalDateByCustomer: string | null, merchant: { id: string, name: string, email: string, phoneNumber: string | null }, payment: { id: string, code: string, amount: number, currency: Currency, customerName: string | null, customerEmail: string | null, createdAt: string, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, invoice: { id: string, code: string, accessKey: string, subtotal: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, createdAt: string, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number }>, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null }, refund: { id: string, code: string, amount: number, status: RefundStatus, createdAt: string } | null, evidenceDocumentUrl: Array<{ url: string, expiresIn: any }> | null, providerDocs: Array<{ id: string, Name: string, url: { url: string, expiresIn: any } }> | null } | null };

export type PaymentPayoutsQueryVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type PaymentPayoutsQuery = { paymentPayouts: Array<{ id: string, code: string, amount: number, currency: Currency, status: PayoutStatus, createdAt: string }> | null };

export type DisputeEventsHistoryQueryVariables = Exact<{
  disputeId: Scalars['ID']['input'];
  historyFirst?: InputMaybe<Scalars['Int']['input']>;
  historyAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type DisputeEventsHistoryQuery = { entityHistory: { edges: Array<{ node: { id: string, eventAction: EventAction, eventType: string, metadata: any | null, createdAt: string, user: { id: string, firstName: string, lastName: string | null, email: string } | null } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type DisputesListPageQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  orderBy?: InputMaybe<DisputeOrderByInput>;
  where?: InputMaybe<DisputeWhereInput>;
}>;


export type DisputesListPageQuery = { disputes: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchant: { name: string }, payment: { customerName: string | null } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type InviteUserPageQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  where?: InputMaybe<RoleWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type InviteUserPageQuery = { organizationRoles: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type MerchantDetailPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MerchantDetailPageQuery = { organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null };

export type MerchantDisputesListPageQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  orderBy?: InputMaybe<DisputeOrderByInput>;
  where?: InputMaybe<DisputeWhereInput>;
}>;


export type MerchantDisputesListPageQuery = { merchantDisputes: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, status: DisputeStatus, progressStatus: DisputeProgressStatus, disputeAmount: number, currency: string, disputedAt: string, merchant: { name: string }, payment: { customerName: string | null } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type MerchantListPageQueryVariables = Exact<{
  sort?: InputMaybe<OrganizationSortInput>;
  where?: InputMaybe<OrganizationWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type MerchantListPageQuery = { organizations: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, name: string, code: string, description: any | null, mccCode: string | null, createdAt: string, status: OrganizationStatus, users: Array<{ id: string }> } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type MerchantPaymentsQueryVariables = Exact<{
  where?: InputMaybe<PaymentWhereInput>;
  orderBy?: InputMaybe<PaymentOrderBy>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type MerchantPaymentsQuery = { merchantPayments: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, netAmount: number, amount: number, currency: Currency, status: PaymentStatus, customerName: string | null, customerEmail: string | null, createdAt: string, is_flagged: boolean | null, flag_reason: any | null, paymentType: PaymentType, paymentProvider: { id: string, name: string, slug: string }, invoice: { fees: { paymentType: PaymentType | null } | null, billingAddresses: Array<{ id: string, label: string | null, line1: string, line2: string | null, postalCode: string | null, state: string | null, city: string, country: string } | null> | null } | null, apiPayment: { fees: { paymentType: PaymentType | null } | null } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type OrganizationUsersQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationUsersQuery = { organizationUsers: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, isEmailVerified: boolean, status: UserStatus, createdAt: string, updatedAt: string, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, avatar: { id: string, name: string, imgixUrl: string | null } | null, userRoles: Array<{ id: string, userId: string, roleId: string, role: { name: string } }> | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type PaylinksDetailPageQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type PaylinksDetailPageQuery = { merchantInvoices: { edges: Array<{ node: { id: string, code: string, accessKey: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, createdById: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, createdBy: { id: string, firstName: string, lastName: string | null, email: string } | null, receipt: { url: string, expiresIn: any } | null, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null, lineItems: Array<{ id: string, description: string, quantity: number, price: number, sort: number, createdAt: string, updatedAt: string }> } }> } | null };

export type PaylinksEventsHistoryQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  eventsFirst?: InputMaybe<Scalars['Int']['input']>;
  eventsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PaylinksEventsHistoryQuery = { entityHistory: { edges: Array<{ node: { id: string, eventAction: EventAction, eventType: string, metadata: any | null, createdAt: string, user: { id: string, firstName: string, lastName: string | null, email: string } | null } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type PaylinksListPageQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  orderBy?: InputMaybe<InvoiceOrderByInput>;
  where?: InputMaybe<InvoiceWhereInput>;
}>;


export type PaylinksListPageQuery = { merchantInvoices: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, status: InvoiceStatus, previousStatus: InvoiceStatus, subtotal: number, merchantProcessingFee: number, recipientName: string | null, recipientEmail: string | null, dueDate: string | null, customFields: any, paymentOptions: Array<PaymentType>, refundPolicyTerms: InvoiceRefundPolicyTerms, guestAccessUrl: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, fees: { paymentType: PaymentType | null } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type PaylinksPaymentsHistoryQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  paymentsFirst?: InputMaybe<Scalars['Int']['input']>;
  paymentsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PaylinksPaymentsHistoryQuery = { merchantPayments: { edges: Array<{ node: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type PaylinksPaymentsHistoryPlatformQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  paymentsFirst?: InputMaybe<Scalars['Int']['input']>;
  paymentsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PaylinksPaymentsHistoryPlatformQuery = { payments: { edges: Array<{ node: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type PaymentDetailPageQueryVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type PaymentDetailPageQuery = { payment: { paymentType: PaymentType, cardType: CardType | null, responseCode: string | null, responseCodeDescription: string | null, id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, invoice: { id: string, code: string, dueDate: string | null, subtotal: number, paymentOptions: Array<PaymentType>, merchantProcessingFee: number, refundPolicyTerms: InvoiceRefundPolicyTerms, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null, owner: { id: string, name: string, email: string, phoneNumber: string | null } } | null, apiPayment: { id: string, code: string, accessKey: string, fees: { paymentType: PaymentType | null, processingFees: number | null, merchantProcessingFee: number | null, customerProcessingFee: number | null } | null } | null, recurringPayment: { id: string, code: string } | null, quickPay: { id: string, code: string } | null, paymentProvider: { id: string, name: string, slug: string }, organization: { id: string, name: string, email: string } | null } | null, paymentPayouts: Array<{ id: string, code: string, amount: number }> | null };

export type PaymentProviderDetailPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PaymentProviderDetailPageQuery = { paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } | null };

export type PaymentProviderListPageQueryVariables = Exact<{
  where?: InputMaybe<PaymentProviderWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<PaymentProviderSortInput>;
}>;


export type PaymentProviderListPageQuery = { paymentProviders: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, name: string, createdAt: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, supportedChannels: Array<PaymentChannel>, updatedAt: string } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type PaymentsQueryVariables = Exact<{
  where?: InputMaybe<PaymentWhereInput>;
  orderBy?: InputMaybe<PaymentOrderBy>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type PaymentsQuery = { payments: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, netAmount: number, amount: number, currency: Currency, status: PaymentStatus, customerName: string | null, customerEmail: string | null, createdAt: string, is_flagged: boolean | null, flag_reason: any | null, paymentType: PaymentType, paymentProvider: { id: string, name: string, slug: string }, invoice: { fees: { paymentType: PaymentType | null } | null, billingAddresses: Array<{ id: string, label: string | null, line1: string, line2: string | null, postalCode: string | null, state: string | null, city: string, country: string } | null> | null } | null, apiPayment: { fees: { paymentType: PaymentType | null } | null } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type PayoutDetailPageQueryVariables = Exact<{
  payoutId: Scalars['ID']['input'];
}>;


export type PayoutDetailPageQuery = { payout: { id: string, code: string, paymentId: string, payoutType: PayoutType, status: PayoutStatus, currency: Currency, amount: number, processedAt: string | null, completedAt: string | null, isSplit: boolean, splitCount: number, parent_payout_id: string | null, bankAccountId: string | null, transferId: string | null, transferCode: string | null, receiverMerchant: { id: string, name: string, email: string }, bankAccount: { id: string, accountHolderName: string, accountNumberMasked: string, type: BankAccountType, bank: { id: string, name: string } } | null, payment: { id: string, code: string, owner_id: string, amount: number, netAmount: number, currency: Currency, customerName: string | null, customerEmail: string | null, paymentProvider: { id: string, name: string, slug: string }, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, invoice: { id: string, code: string, payoutAmount: number, subtotal: number } | null, recurringPayment: { id: string, code: string } | null, quickPay: { id: string, code: string } | null, apiPayment: { id: string, code: string } | null } } | null };

export type PayoutReferenceCodesByPaymentQueryVariables = Exact<{
  paymentId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type PayoutReferenceCodesByPaymentQuery = { refunds: { edges: Array<{ node: { id: string, code: string } }> } | null, disputes: { edges: Array<{ node: { id: string, code: string } }> } | null };

export type RecurringPaymentDetailQueryVariables = Exact<{
  recurringPaymentId: Scalars['ID']['input'];
}>;


export type RecurringPaymentDetailQuery = { recurringPayment: { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null } };

export type RecurringPaymentListPageQueryVariables = Exact<{
  where?: InputMaybe<RecurringPaymentWhereInput>;
  orderBy?: InputMaybe<RecurringPaymentOrderBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type RecurringPaymentListPageQuery = { recurringPayments: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type RefundDetailPageQueryVariables = Exact<{
  refundId: Scalars['ID']['input'];
}>;


export type RefundDetailPageQuery = { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null };

export type RefundEventsHistoryQueryVariables = Exact<{
  refundId: Scalars['ID']['input'];
  eventsFirst?: InputMaybe<Scalars['Int']['input']>;
  eventsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type RefundEventsHistoryQuery = { entityHistory: { edges: Array<{ node: { id: string, eventAction: EventAction, eventType: string, metadata: any | null, createdAt: string, user: { id: string, firstName: string, lastName: string | null, email: string } | null } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type RefundListPageQueryVariables = Exact<{
  where?: InputMaybe<RefundWhereInput>;
  orderBy?: InputMaybe<RefundOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type RefundListPageQuery = { refunds: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, amount: number, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, reason: any | null, environment: PaymentEnvironment, paymentId: string, createdAt: string, updatedAt: string, payment: { id: string, amount: number, status: PaymentStatus, customerName: string | null, customerEmail: string | null } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type TransferDetailPageQueryVariables = Exact<{
  transferId: Scalars['ID']['input'];
  payoutsFirst?: InputMaybe<Scalars['Int']['input']>;
  payoutsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type TransferDetailPageQuery = { transfer: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, payouts: { edges: Array<{ node: { id: string, code: string, amount: number, currency: Currency, status: PayoutStatus, createdAt: string, receiverMerchant: { id: string, name: string }, bankAccount: { id: string, accountNumberMasked: string, type: BankAccountType } | null } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } }, transferredToBank: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } } | null };

export type TransferEventsHistoryQueryVariables = Exact<{
  transferId: Scalars['ID']['input'];
  eventsFirst?: InputMaybe<Scalars['Int']['input']>;
  eventsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type TransferEventsHistoryQuery = { entityHistory: { edges: Array<{ node: { id: string, eventAction: EventAction, eventType: string, metadata: any | null, createdAt: string, user: { id: string, firstName: string, lastName: string | null, email: string } | null } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type TransferListPageQueryVariables = Exact<{
  where?: InputMaybe<TransferWhereInput>;
  orderBy?: InputMaybe<TransferOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type TransferListPageQuery = { transfers: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, name: string } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type UserDetailPageQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserDetailPageQuery = { user: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null, userRoles: Array<{ id: string, userId: string, roleId: string, role: { name: string } }> | null, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null };

export type UserListPageQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<UserSortInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserWhereInput>;
}>;


export type UserListPageQuery = { organizationUsers: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, isEmailVerified: boolean, status: UserStatus, createdAt: string, updatedAt: string, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, avatar: { id: string, name: string, imgixUrl: string | null } | null, userRoles: Array<{ id: string, userId: string, roleId: string, role: { name: string } }> | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type WebhookDetailPageQueryVariables = Exact<{
  merchantWebhookId: Scalars['ID']['input'];
}>;


export type WebhookDetailPageQuery = { merchantWebhook: { id: string, organizationID: string, name: string, url: string, status: WebhookStatus, description: string | null, failureCount: number, lastTriggeredAt: string | null, disabledAt: string | null, metadata: any | null, secret: string, createdAt: string, updatedAt: string, subscriptions: Array<{ id: string, merchantWebhookID: string, webhookEventTypeID: string, isEnabled: boolean, metadata: any | null, createdAt: string, updatedAt: string, webhookEventType: { id: string, eventType: string, category: string, displayName: string, description: string | null, payloadExample: any | null, isActive: boolean, isDeprecated: boolean, deprecatedMessage: string | null, replacesEventType: string | null, createdAt: string, updatedAt: string } }> | null, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null };

export type WebhookListPageQueryVariables = Exact<{
  pagination: PaginationInput;
  where?: InputMaybe<MerchantWebhookWhereInput>;
  orderBy?: InputMaybe<MerchantWebhookOrderByInput>;
}>;


export type WebhookListPageQuery = { merchantWebhooks: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, organizationID: string, name: string, url: string, status: WebhookStatus, description: string | null, failureCount: number, lastTriggeredAt: string | null, disabledAt: string | null, metadata: any | null, createdAt: string, updatedAt: string, subscriptions: Array<{ id: string }> | null, deliveries: Array<{ id: string, durationMs: number | null, triggeredAt: string, status: WebhookDeliveryStatus }> | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type DownloadPaymentReceiptQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DownloadPaymentReceiptQuery = { downloadPaymentReceipt: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type GetMerchantPaymentByApiPaymentIdQueryVariables = Exact<{
  apiPaymentId: Scalars['ID']['input'];
}>;


export type GetMerchantPaymentByApiPaymentIdQuery = { merchantPayments: { edges: Array<{ node: { id: string, code: string, paymentMethodType: string | null, cardType: CardType | null, cardLast4: string | null } }> } | null };

export type GetPaymentByApiPaymentIdQueryVariables = Exact<{
  apiPaymentId: Scalars['ID']['input'];
}>;


export type GetPaymentByApiPaymentIdQuery = { payments: { edges: Array<{ node: { id: string, code: string, paymentMethodType: string | null, cardType: CardType | null, cardLast4: string | null } }> } | null };

export type GetPaymentHistoryQueryVariables = Exact<{
  paymentId: Scalars['ID']['input'];
  historyFirst?: InputMaybe<Scalars['Int']['input']>;
  historyAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetPaymentHistoryQuery = { entityHistory: { edges: Array<{ node: { id: string, eventAction: EventAction, eventType: string, metadata: any | null, createdAt: string, user: { id: string, firstName: string, lastName: string | null, email: string } | null } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type GetMerchantPaymentByInvoiceIdQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type GetMerchantPaymentByInvoiceIdQuery = { merchantPayments: { edges: Array<{ node: { id: string, code: string, paymentMethodType: string | null, cardType: CardType | null, cardLast4: string | null } }> } | null };

export type GetPaymentByInvoiceIdQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type GetPaymentByInvoiceIdQuery = { payments: { edges: Array<{ node: { id: string, code: string, paymentMethodType: string | null, cardType: CardType | null, cardLast4: string | null } }> } | null };

export type DashboardPayoutSummaryQueryVariables = Exact<{
  merchantId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DashboardPayoutSummaryQuery = { completedPayouts: Array<{ totalAmount: number, currency: Currency, count: number }> | null, pendingPayouts: Array<{ totalAmount: number, currency: Currency, count: number }> | null, processingPayouts: Array<{ totalAmount: number, currency: Currency, count: number }> | null };

export type GetMerchantPayoutsQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  where?: InputMaybe<PayoutWhereInput>;
  orderBy?: InputMaybe<PayoutOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetMerchantPayoutsQuery = { merchantPayouts: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, amount: number, currency: Currency, status: PayoutStatus, createdAt: string, completedAt: string | null, processedAt: string | null, payment: { id: string, code: string, owner_id: string, paymentProvider: { id: string, name: string, slug: string }, invoice: { id: string, code: string } | null }, receiverMerchant: { name: string } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type GetPayoutsQueryVariables = Exact<{
  where?: InputMaybe<PayoutWhereInput>;
  orderBy?: InputMaybe<PayoutOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetPayoutsQuery = { payouts: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, amount: number, currency: Currency, status: PayoutStatus, createdAt: string, completedAt: string | null, processedAt: string | null, payment: { id: string, code: string, owner_id: string, paymentProvider: { id: string, name: string, slug: string }, invoice: { id: string, code: string } | null }, receiverMerchant: { name: string } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type QuickPayDetailPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuickPayDetailPageQuery = { quickPay: { accessKey: string, description: any | null, customFields: any, expiresAt: string | null, fixedAmount: number | null, minAmount: number | null, maxAmount: number | null, presetAmounts: Array<number> | null, merchantProcessingFee: number, refundPolicyTerms: QuickPayRefundPolicyTerms, paymentOptions: Array<PaymentType>, id: string, code: string, title: string, status: QuickPayStatus, isDefault: boolean, amountType: QuickPayAmountType, currency: Currency, paymentURL: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string, phoneNumber: string | null }, qrCode: { url: string, format: QrCodeFormat, size: QrCodeSize } } };

export type QuickPayEventsHistoryQueryVariables = Exact<{
  quickPayId: Scalars['ID']['input'];
  eventsFirst?: InputMaybe<Scalars['Int']['input']>;
  eventsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type QuickPayEventsHistoryQuery = { entityHistory: { edges: Array<{ node: { id: string, eventAction: EventAction, eventType: string, metadata: any | null, createdAt: string, user: { id: string, firstName: string, lastName: string | null, email: string } | null } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type QuickPayFeeEstimateQueryVariables = Exact<{
  accessKey: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  paymentType: PaymentType;
  currency: Currency;
  cardType?: InputMaybe<CardType>;
}>;


export type QuickPayFeeEstimateQuery = { quickPayFeeEstimate: { subtotal: number, gatewayFeeType: string, gatewayFeeRate: number, gatewayFeeAmount: number, platformFeePercent: number, platformFeeAmount: number, merchantFeePercent: number, merchantFeeAmount: number, totalAmount: number } };

export type QuickPayPaymentForSuccessFieldsFragment = { id: string, code: string, amount: number, netAmount: number, currency: Currency, totalFees: number, merchantProcessingFee: number, platformFee: number, updatedAt: string, status: PaymentStatus, paymentMethodType: string | null, cardType: CardType | null, cardLast4: string | null, quickPay: { id: string, code: string } | null };

export type QuickPayPaymentForSuccessMerchantQueryVariables = Exact<{
  accessKey: Scalars['UUID']['input'];
  providerTransactionId: Scalars['String']['input'];
}>;


export type QuickPayPaymentForSuccessMerchantQuery = { merchantPayments: { edges: Array<{ node: { id: string, code: string, amount: number, netAmount: number, currency: Currency, totalFees: number, merchantProcessingFee: number, platformFee: number, updatedAt: string, status: PaymentStatus, paymentMethodType: string | null, cardType: CardType | null, cardLast4: string | null, quickPay: { id: string, code: string } | null } }> } | null };

export type QuickPayPaymentForSuccessPlatformQueryVariables = Exact<{
  accessKey: Scalars['UUID']['input'];
  providerTransactionId: Scalars['String']['input'];
}>;


export type QuickPayPaymentForSuccessPlatformQuery = { payments: { edges: Array<{ node: { id: string, code: string, amount: number, netAmount: number, currency: Currency, totalFees: number, merchantProcessingFee: number, platformFee: number, updatedAt: string, status: PaymentStatus, paymentMethodType: string | null, cardType: CardType | null, cardLast4: string | null, quickPay: { id: string, code: string } | null } }> } | null };

export type QuickPayPaymentForSuccessMerchantByIdQueryVariables = Exact<{
  accessKey: Scalars['UUID']['input'];
  paymentId: Scalars['ID']['input'];
}>;


export type QuickPayPaymentForSuccessMerchantByIdQuery = { merchantPayments: { edges: Array<{ node: { id: string, code: string, amount: number, netAmount: number, currency: Currency, totalFees: number, merchantProcessingFee: number, platformFee: number, updatedAt: string, status: PaymentStatus, paymentMethodType: string | null, cardType: CardType | null, cardLast4: string | null, quickPay: { id: string, code: string } | null } }> } | null };

export type QuickPayPaymentForSuccessPlatformByIdQueryVariables = Exact<{
  accessKey: Scalars['UUID']['input'];
  paymentId: Scalars['ID']['input'];
}>;


export type QuickPayPaymentForSuccessPlatformByIdQuery = { payments: { edges: Array<{ node: { id: string, code: string, amount: number, netAmount: number, currency: Currency, totalFees: number, merchantProcessingFee: number, platformFee: number, updatedAt: string, status: PaymentStatus, paymentMethodType: string | null, cardType: CardType | null, cardLast4: string | null, quickPay: { id: string, code: string } | null } }> } | null };

export type QuickPayPaymentsHistoryQueryVariables = Exact<{
  quickPayId: Scalars['ID']['input'];
  paymentsFirst?: InputMaybe<Scalars['Int']['input']>;
  paymentsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type QuickPayPaymentsHistoryQuery = { merchantPayments: { edges: Array<{ node: { id: string, code: string, amount: number, status: PaymentStatus, customerName: string | null, customerEmail: string | null, createdAt: string } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type QuickPayPaymentsHistoryPlatformQueryVariables = Exact<{
  quickPayId: Scalars['ID']['input'];
  paymentsFirst?: InputMaybe<Scalars['Int']['input']>;
  paymentsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type QuickPayPaymentsHistoryPlatformQuery = { payments: { edges: Array<{ node: { id: string, code: string, amount: number, status: PaymentStatus, customerName: string | null, customerEmail: string | null, createdAt: string } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type QuickPayPublicByAccessKeyQueryVariables = Exact<{
  accessKey: Scalars['String']['input'];
}>;


export type QuickPayPublicByAccessKeyQuery = { quickPayByAccessKey: { title: string, code: string, description: any | null, amountType: QuickPayAmountType, currency: Currency, fixedAmount: number | null, minAmount: number | null, maxAmount: number | null, presetAmounts: Array<number> | null, paymentOptions: Array<PaymentType>, refundPolicyTerms: QuickPayRefundPolicyTerms, merchantName: string, merchantLogo: string | null, isExpired: boolean, status: QuickPayStatus } };

export type QuickPayListPageQueryVariables = Exact<{
  pagination: PaginationInput;
  orderBy?: InputMaybe<QuickPayOrderByInput>;
  where?: InputMaybe<QuickPayWhereInput>;
}>;


export type QuickPayListPageQuery = { quickPays: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, title: string, status: QuickPayStatus, isDefault: boolean, amountType: QuickPayAmountType, currency: Currency, paymentURL: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type MerchantQuickPayListPageQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  pagination: PaginationInput;
  orderBy?: InputMaybe<QuickPayOrderByInput>;
  where?: InputMaybe<QuickPayWhereInput>;
}>;


export type MerchantQuickPayListPageQuery = { merchantQuickPays: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, title: string, status: QuickPayStatus, isDefault: boolean, amountType: QuickPayAmountType, currency: Currency, paymentURL: string, createdAt: string, updatedAt: string, ownerId: string, owner: { id: string, name: string, email: string } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type GetRecurringPaymentByCheckoutSessionQueryVariables = Exact<{
  checkoutSessionID: Scalars['String']['input'];
}>;


export type GetRecurringPaymentByCheckoutSessionQuery = { getRecurringPaymentByCheckoutSession: { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null } };

export type GetRecurringPaymentByUpdateSessionQueryVariables = Exact<{
  updateSessionID: Scalars['String']['input'];
}>;


export type GetRecurringPaymentByUpdateSessionQuery = { getRecurringPaymentByUpdateSession: { id: string, code: string, checkoutSessionID: string, externalID: string | null, amount: number, merchantProcessingFee: number, currency: Currency, description: string | null, interval: RecurringInterval, intervalCount: number, startDate: string, endDate: string | null, nextChargeDate: string | null, paymentOptions: Array<PaymentType>, maxCharges: number | null, maxRetries: number, chargesCount: number, consecutiveFailures: number, lastChargeDate: string | null, lastChargeStatus: PaymentStatus | null, status: RecurringPaymentStatus, setupStatus: RecurringPaymentSetupStatus, checkoutExpiresAt: string | null, chargeImmediately: boolean, successURL: string | null, cancelURL: string | null, refundPolicyTerms: RecurringPaymentRefundPolicyTerms, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string, phone: string | null }, owner: { id: string, name: string, email: string, phoneNumber: string | null, type: OrganizationType }, activePaymentMethod: { id: string, type: PaymentType, cardBrand: string | null, cardLast4: string | null, cardExpiryMonth: number | null, cardExpiryYear: number | null, providerPaymentMethodID: string, providerCustomerID: string | null, status: PaymentMethodStatus, isDefault: boolean, metadata: any, createdAt: string, updatedAt: string, customer: { id: string, name: string | null, email: string }, paymentProvider: { id: string, name: string, description: any | null, configProfile: string, slug: string, status: ProviderStatus, environment: PaymentEnvironment, priority: number, publicKey: string, supportedCurrencies: Array<string>, supportedChannels: Array<PaymentChannel>, apiLoginId: string | null, createdAt: string, updatedAt: string, cardTypes: Array<{ id: string, paymentProviderId: string, priority: number, enabled: boolean, name: string, type: CardType, createdAt: string, updatedAt: string }>, paymentTypes: Array<{ id: string, name: string, paymentProviderId: string, type: PaymentType, enabled: boolean, supportedCurrencies: Array<string>, gatewayFees: number, gatewayFeeType: FeeType, platformFees: number, platformFeeType: FeeType, createdAt: string, updatedAt: string, paymentProvider: { id: string, description: any | null } }> } } | null } };

export type RecurringPaymentChargesHistoryQueryVariables = Exact<{
  recurringPaymentId: Scalars['ID']['input'];
  paymentsFirst?: InputMaybe<Scalars['Int']['input']>;
  paymentsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type RecurringPaymentChargesHistoryQuery = { merchantPayments: { edges: Array<{ node: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type RecurringPaymentChargesHistoryPlatformQueryVariables = Exact<{
  recurringPaymentId: Scalars['ID']['input'];
  paymentsFirst?: InputMaybe<Scalars['Int']['input']>;
  paymentsAfter?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type RecurringPaymentChargesHistoryPlatformQuery = { payments: { edges: Array<{ node: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } | null };

export type BankPendingRefundsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type BankPendingRefundsQuery = { bankPendingRefunds: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, amount: number, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, reason: any | null, environment: PaymentEnvironment, paymentId: string, createdAt: string, updatedAt: string, payment: { id: string, amount: number, status: PaymentStatus, customerName: string | null, customerEmail: string | null } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type GetAvailableRefundAmountQueryVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type GetAvailableRefundAmountQuery = { getAvailableRefundAmount: number | null };

export type MerchantRefundsQueryVariables = Exact<{
  where?: InputMaybe<RefundWhereInput>;
  orderBy?: InputMaybe<RefundOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type MerchantRefundsQuery = { merchantRefunds: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, amount: number, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, reason: any | null, environment: PaymentEnvironment, paymentId: string, createdAt: string, updatedAt: string, payment: { id: string, amount: number, status: PaymentStatus, customerName: string | null, customerEmail: string | null } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type PlatformPendingRefundsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type PlatformPendingRefundsQuery = { platformPendingRefunds: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, amount: number, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, reason: any | null, environment: PaymentEnvironment, paymentId: string, createdAt: string, updatedAt: string, payment: { id: string, amount: number, status: PaymentStatus, customerName: string | null, customerEmail: string | null } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type RefundSummaryQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
}>;


export type RefundSummaryQuery = { refundSummary: { totalRefunds: number, pendingCount: number, approvedCount: number, refundedCount: number, deniedCount: number, totalRefundedAmount: number, totalPendingAmount: number, successRate: number } | null };

export type RefundAnalyticsQueryVariables = Exact<{
  dateRange: DateRangeInput;
  environment?: InputMaybe<PaymentEnvironment>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RefundAnalyticsQuery = { refundAnalytics: { totalRequests: number, successfulRefunds: number, declinedRefunds: number, pendingRefunds: number, totalRefundedAmount: number, totalDeclinedAmount: number, averageRefundAmount: number, successRate: number, averageResolutionHours: number, medianResolutionHours: number, period: { startDate: string | null, endDate: string | null } } | null };

export type RefundQueryVariables = Exact<{
  refundId: Scalars['ID']['input'];
}>;


export type RefundQuery = { refund: { id: string, code: string, providerRefundId: string | null, paymentId: string, amount: number, refundAlreadyPaidAmount: number | null, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, closedDate: string | null, reason: any | null, subReason: any | null, notes: any | null, denialReason: any | null, environment: PaymentEnvironment, pointOfContact: RefundPointOfContact, refundAlreadyPaid: RefundAlreadyPaid, merchantDeclineReason: RefundMerchantDeclineReason | null, bankDeclineReason: any | null, hasCancelPolicyExtended: boolean | null, extendedCancellationPolicyText: string | null, createdAt: string, updatedAt: string, payment: { id: string, code: string, owner_id: string, amount: number, platformFee: number, merchantProcessingFee: number, providerFee: number | null, netAmount: number, totalFees: number, merchantReceives: number, status: PaymentStatus, environment: PaymentEnvironment, customerName: string | null, customerEmail: string | null, providerTransactionId: string | null, providerCustomerId: string | null, providerPaymentMethodId: string | null, providerErrorCode: string | null, providerDeclineCode: string | null, providerErrorMessage: string | null, cardBrand: string | null, cardLast4: string | null, paymentMethodType: string | null, createdAt: string, updatedAt: string, organization: { id: string, name: string, email: string, phoneNumber: string | null } | null, paymentProvider: { slug: string } }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } | null, receipts: Array<{ id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null> | null } | null };

export type RefundsQueryVariables = Exact<{
  where?: InputMaybe<RefundWhereInput>;
  orderBy?: InputMaybe<RefundOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type RefundsQuery = { refunds: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, amount: number, status: RefundStatus, progressStatus: RefundProgressStatus, statusUpdatedAt: string | null, reason: any | null, environment: PaymentEnvironment, paymentId: string, createdAt: string, updatedAt: string, payment: { id: string, amount: number, status: PaymentStatus, customerName: string | null, customerEmail: string | null } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type DownloadDailyPaymentReportQueryVariables = Exact<{
  date: Scalars['Time']['input'];
  where?: InputMaybe<PaymentWhereInput>;
}>;


export type DownloadDailyPaymentReportQuery = { downloadDailyPaymentReport: { successBase64: string | null, failureBase64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type DownloadDisputeReportQueryVariables = Exact<{
  fields: Array<DisputeReportField> | DisputeReportField;
  where?: InputMaybe<DisputeWhereInput>;
}>;


export type DownloadDisputeReportQuery = { DownloadDisputeReport: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type DownloadMerchantReportQueryVariables = Exact<{
  fields: Array<MerchantReportField> | MerchantReportField;
  where?: InputMaybe<OrganizationWhereInput>;
}>;


export type DownloadMerchantReportQuery = { downloadMerchantReport: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string } | null> | null } | null };

export type DownloadPaymentReportQueryVariables = Exact<{
  fields: Array<PaymentReportField> | PaymentReportField;
  where?: InputMaybe<PaymentWhereInput>;
}>;


export type DownloadPaymentReportQuery = { downloadPaymentReport: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type DownloadPayoutReportQueryVariables = Exact<{
  fields: Array<PayoutReportField> | PayoutReportField;
  where?: InputMaybe<PayoutWhereInput>;
}>;


export type DownloadPayoutReportQuery = { downloadPayoutReport: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type DownloadRefundReportQueryVariables = Exact<{
  fields: Array<RefundReportField> | RefundReportField;
  where?: InputMaybe<RefundWhereInput>;
}>;


export type DownloadRefundReportQuery = { downloadRefundReport: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type DownloadTransferReportQueryVariables = Exact<{
  fields: Array<TransferReportField> | TransferReportField;
  where?: InputMaybe<TransferWhereInput>;
}>;


export type DownloadTransferReportQuery = { downloadTransferReport: { base64: string | null, errors: Array<{ code: ErrorCode, field: string | null, message: string }> | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, description: any | null, isEmailVerified: boolean, status: UserStatus, createdAt: string, updatedAt: string, organizationId: string | null, lastLoginAt: string | null, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null, permissions: Array<{ id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null }> } | null };

export type VerifyAccessTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type VerifyAccessTokenQuery = { verifyAccessToken: { success: boolean | null } | null };

export type AvailablePayoutsForTransferQueryVariables = Exact<{
  bankId: Scalars['ID']['input'];
  currency: Currency;
}>;


export type AvailablePayoutsForTransferQuery = { availablePayoutsForTransfer: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, paymentId: string, receivingMerchantId: string, bankAccountId: string | null, refundId: string | null, disputeId: string | null, parent_payout_id: string | null, amount: number, currency: Currency, status: PayoutStatus, payoutType: PayoutType, processedAt: string | null, completedAt: string | null, notes: any | null, createdAt: string, updatedAt: string, isSplit: boolean, splitCount: number, payment: { id: string, code: string }, receiverMerchant: { id: string, name: string }, bankAccount: { id: string, accountHolderName: string, accountNumberMasked: string } | null, refund: { id: string } | null, dispute: { id: string } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type BankTransfersQueryVariables = Exact<{
  bankId: Scalars['ID']['input'];
  status?: InputMaybe<Array<TransferStatus> | TransferStatus>;
  currency?: InputMaybe<Array<Currency> | Currency>;
  orderBy?: InputMaybe<TransferOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type BankTransfersQuery = { bankTransfers: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, name: string } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type TransferQueryVariables = Exact<{
  transferId: Scalars['ID']['input'];
}>;


export type TransferQuery = { transfer: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } } | null };

export type TransferBalanceSummaryQueryVariables = Exact<{
  merchantId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TransferBalanceSummaryQuery = { incomingPayouts: Array<{ count: number }> | null, completedPayouts: Array<{ count: number }> | null, totalPayoutAmount: Array<{ totalAmount: number, currency: Currency }> | null };

export type TransferByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type TransferByCodeQuery = { transferByCode: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null }, createdBy: { id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string } } | null };

export type TransferChartDataQueryVariables = Exact<{
  where?: InputMaybe<TransferWhereInput>;
  orderBy?: InputMaybe<TransferOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type TransferChartDataQuery = { transfers: { totalCount: number, edges: Array<{ node: { id: string, transferredToBankId: string, status: TransferStatus, totalAmount: number, currency: string, payoutCount: number, createdAt: string } }> } | null };

export type TransferDailyAmountsQueryVariables = Exact<{
  where?: InputMaybe<TransferWhereInput>;
  orderBy?: InputMaybe<TransferOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type TransferDailyAmountsQuery = { transfers: { totalCount: number, edges: Array<{ node: { id: string, totalAmount: number, currency: string, createdAt: string } }> } | null };

export type TransferSummaryQueryVariables = Exact<{
  bankId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<TransferStatus>;
  currency?: InputMaybe<Currency>;
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
}>;


export type TransferSummaryQuery = { transferSummary: Array<{ totalAmount: number, currency: Currency, count: number, status: TransferStatus, payoutCount: number }> | null };

export type TransfersQueryVariables = Exact<{
  where?: InputMaybe<TransferWhereInput>;
  orderBy?: InputMaybe<TransferOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type TransfersQuery = { transfers: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, status: TransferStatus, currency: string, transferredToBankId: string, totalAmount: number, payoutCount: number, notes: any | null, createdById: string, statusUpdatedAt: string | null, createdAt: string, updatedAt: string, transferredToBank: { id: string, name: string } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type OrganizationsQueryVariables = Exact<{
  sort?: InputMaybe<OrganizationSortInput>;
  where?: InputMaybe<OrganizationWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type OrganizationsQuery = { organizations: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type RoleQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;


export type RoleQuery = { role: { id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string, userCount: number, permissionCount: number, permissions: { totalCount: number, edges: Array<{ node: { id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } }, users: Array<{ id: string, organizationId: string | null, firstName: string, lastName: string | null, email: string, description: any | null, status: UserStatus, isEmailVerified: boolean, isOwner: boolean | null, lastLoginAt: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, fullName: string } | null> } | null };

export type RolesQueryVariables = Exact<{
  where?: InputMaybe<RoleWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<RoleSortInput>;
}>;


export type RolesQuery = { roles: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string, userCount: number, permissionCount: number, permissions: { totalCount: number, edges: Array<{ node: { id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } }, users: Array<{ id: string, organizationId: string | null, firstName: string, lastName: string | null, email: string, description: any | null, status: UserStatus, isEmailVerified: boolean, isOwner: boolean | null, lastLoginAt: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, fullName: string } | null> } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type OrganizationRolesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  where?: InputMaybe<RoleWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type OrganizationRolesQuery = { organizationRoles: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string, userCount: number, permissionCount: number, permissions: { totalCount: number, edges: Array<{ node: { id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } }, users: Array<{ id: string, organizationId: string | null, firstName: string, lastName: string | null, email: string, description: any | null, status: UserStatus, isEmailVerified: boolean, isOwner: boolean | null, lastLoginAt: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, fullName: string } | null> } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type RolePermissionsQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
  where?: InputMaybe<PermissionWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type RolePermissionsQuery = { rolePermissions: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, grantedAt: string, revokedAt: string | null, isActive: boolean, permission: { id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null } } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type MerchantPermissionsQueryVariables = Exact<{
  searchquery?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type MerchantPermissionsQuery = { merchantpermissions: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, name: string, slug: string, description: any | null, permissionFor: Array<PermissionFor | null> | null, group: { id: string, name: string, slug: string } | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type UsersQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<UserSortInput>;
}>;


export type UsersQuery = { users: { totalCount: number, edges: Array<{ cursor: string, node: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type UserDetailQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserDetailQuery = { user: { description: any | null, isEmailVerified: boolean, status: UserStatus, deletedAt: string | null, organizationId: string | null, lastLoginAt: string | null, id: string, email: string, firstName: string, lastName: string | null, fullName: string, createdAt: string, updatedAt: string, roles: Array<{ id: string, name: string, description: any | null, organizationId: string, createdAt: string, updatedAt: string }> | null, userRoles: Array<{ id: string, userId: string, roleId: string, role: { name: string } }> | null, avatar: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } | null };

export type MerchantWebhookQueryVariables = Exact<{
  merchantWebhookId: Scalars['ID']['input'];
}>;


export type MerchantWebhookQuery = { merchantWebhook: { id: string, organizationID: string, name: string, url: string, status: WebhookStatus, description: string | null, failureCount: number, lastTriggeredAt: string | null, disabledAt: string | null, metadata: any | null, secret: string, createdAt: string, updatedAt: string, subscriptions: Array<{ id: string, merchantWebhookID: string, webhookEventTypeID: string, isEnabled: boolean, metadata: any | null, createdAt: string, updatedAt: string, webhookEventType: { id: string, eventType: string, category: string, displayName: string, description: string | null, payloadExample: any | null, isActive: boolean, isDeprecated: boolean, deprecatedMessage: string | null, replacesEventType: string | null, createdAt: string, updatedAt: string } }> | null, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null };

export type MerchantWebhooksQueryVariables = Exact<{
  pagination: PaginationInput;
  where?: InputMaybe<MerchantWebhookWhereInput>;
  orderBy?: InputMaybe<MerchantWebhookOrderByInput>;
}>;


export type MerchantWebhooksQuery = { merchantWebhooks: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, organizationID: string, name: string, url: string, status: WebhookStatus, description: string | null, failureCount: number, lastTriggeredAt: string | null, disabledAt: string | null, metadata: any | null, createdAt: string, updatedAt: string, subscriptions: Array<{ id: string }> | null, deliveries: Array<{ id: string, durationMs: number | null, triggeredAt: string, status: WebhookDeliveryStatus }> | null } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type WebhookDeliveriesQueryVariables = Exact<{
  pagination: PaginationInput;
  where?: InputMaybe<WebhookDeliveryWhereInput>;
}>;


export type WebhookDeliveriesQuery = { webhookDeliveries: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, webhookID: string | null, organizationID: string | null, eventID: string, eventType: string, idempotencyKey: string, requestURL: string, requestHeaders: any, requestBody: string, responseStatusCode: number | null, responseHeaders: any | null, responseBody: string | null, durationMs: number | null, triggeredAt: string, completedAt: string | null, status: WebhookDeliveryStatus, attemptNumber: number, maxAttempts: number, nextRetryAt: string | null, errorMessage: string | null, errorCode: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type WebhookDeliveryQueryVariables = Exact<{
  webhookDeliveryId: Scalars['ID']['input'];
}>;


export type WebhookDeliveryQuery = { webhookDelivery: { id: string, webhookID: string | null, organizationID: string | null, eventID: string, eventType: string, idempotencyKey: string, requestURL: string, requestHeaders: any, requestBody: string, responseStatusCode: number | null, responseHeaders: any | null, responseBody: string | null, durationMs: number | null, triggeredAt: string, completedAt: string | null, status: WebhookDeliveryStatus, attemptNumber: number, maxAttempts: number, nextRetryAt: string | null, errorMessage: string | null, errorCode: string | null, createdAt: string, updatedAt: string, webhook: { id: string, organizationID: string, name: string, url: string, status: WebhookStatus, description: string | null, failureCount: number, lastTriggeredAt: string | null, disabledAt: string | null, metadata: any | null, secret: string, createdAt: string, updatedAt: string, organization: { id: string, code: string, name: string, email: string, description: any | null, status: OrganizationStatus, mccCode: string | null, licenseNumber: string | null, type: OrganizationType, website: string | null, industry: OrganizationIndustry | null, otherIndustry: string | null, refundPolicyTerms: OrganizationRefundPolicyTerms, merchantProcessingFee: number, address: any | null, phoneNumber: string | null, createdAt: string, updatedAt: string, logo: { id: string, name: string, path: string, type: string, mimeType: string, createdAt: string, updatedAt: string, entityId: string | null, entityType: MediaEntityType | null, imgixUrl: string | null, url: { url: string, expiresIn: any }, cloudFrontUrl: { url: string, expiresIn: any } } | null } } | null } | null };

export type WebhookEventTypeQueryVariables = Exact<{
  webhookEventTypeId: Scalars['ID']['input'];
}>;


export type WebhookEventTypeQuery = { webhookEventType: { id: string, eventType: string, category: string, displayName: string, description: string | null, payloadExample: any | null, isActive: boolean, isDeprecated: boolean, deprecatedMessage: string | null, replacesEventType: string | null, createdAt: string, updatedAt: string, subscriptions: Array<{ id: string, merchantWebhookID: string, webhookEventTypeID: string, isEnabled: boolean, metadata: any | null, createdAt: string, updatedAt: string, webhookEventType: { id: string, eventType: string, category: string, displayName: string, description: string | null, payloadExample: any | null, isActive: boolean, isDeprecated: boolean, deprecatedMessage: string | null, replacesEventType: string | null, createdAt: string, updatedAt: string } }> | null } | null };

export type WebhookEventTypesQueryVariables = Exact<{
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WebhookEventTypesQuery = { webhookEventTypes: Array<{ id: string, eventType: string, category: string, displayName: string, description: string | null, payloadExample: any | null, isActive: boolean, isDeprecated: boolean, deprecatedMessage: string | null, replacesEventType: string | null, createdAt: string, updatedAt: string }> };
